webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(319);
	module.exports = __webpack_require__(2);


/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(11);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	var _angularFilter = __webpack_require__(10);
	
	var _angularFilter2 = _interopRequireDefault(_angularFilter);
	
	var _common = __webpack_require__(5);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _modules = __webpack_require__(6);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _ui = __webpack_require__(7);
	
	var _ui2 = _interopRequireDefault(_ui);
	
	__webpack_require__(27);
	
	__webpack_require__(17);
	
	__webpack_require__(19);
	
	__webpack_require__(21);
	
	__webpack_require__(23);
	
	var _uiSelect = __webpack_require__(12);
	
	var _uiSelect2 = _interopRequireDefault(_uiSelect);
	
	var _auth = __webpack_require__(15);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _layout = __webpack_require__(16);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	__webpack_require__(25);
	
	var _angularLoadingBar = __webpack_require__(13);
	
	var _angularLoadingBar2 = _interopRequireDefault(_angularLoadingBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	console.log(_angularLoadingBar2.default);
	_angular2.default.module('app', [_angularUiRouter2.default, _common2.default, _modules2.default, _ui2.default, 'ngStorage', _angularUiBootstrap2.default, _angularFilter2.default, _uiSelect2.default, _angularLoadingBar2.default])
	// .constant("APPLICATION_URL", 'http://localhost:8000')
	// .constant("API_URL", 'http://localhost:4000')
	.constant("APPLICATION_URL", 'https://signlabs.se').constant("API_URL", 'http://46.101.182.153:4000')
	
	// Pacsoft ==> Unifaun
	.constant("UNIFAUN_ID", 'N4N5DFXWY7HNGAVI').constant("UNIFAUN_SECRET", 'DQMJEM5ORXAPXIJR2XZC2WJC')
	
	// Unifaun Test Account
	// .constant("UNIFAUN_ID", 'ZRIUPEMMDWR656B7')
	// .constant("UNIFAUN_SECRET", 'ZAKOJ6ALCA5JED5WSUCAEY6U')
	
	.config(["$locationProvider", "$stateProvider", "$urlRouterProvider", function ($locationProvider, $stateProvider, $urlRouterProvider) {
	  "ngInject";
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	
	  $locationProvider.html5Mode(true).hashPrefix('!');
	
	  $stateProvider.state('auth', {
	    url: '/auth',
	    abstract: true,
	    template: _auth2.default
	  });
	  $stateProvider.state('auth.login', {
	    url: '/login',
	    template: '<loginform>',
	    data: {
	      noLogin: true
	    }
	  });
	
	  $stateProvider.state('app', {
	    template: _layout2.default,
	    url: '/',
	    resolve: {
	      data: ["ProductsDataProvider", "ProductPartsDataProvider", "$q", function data(ProductsDataProvider, ProductPartsDataProvider, $q) {
	        "ngInject";
	
	        return $q.all([ProductsDataProvider.loadProducts(), ProductPartsDataProvider.loadShapes(), ProductPartsDataProvider.loadColors(), ProductPartsDataProvider.loadFixmethods()]);
	      }]
	    },
	    controller: ["$scope", "data", "AuthService", "$state", function controller($scope, data, AuthService, $state) {
	      $scope.products = data[0];
	      $scope.logout = function ($event) {
	        $event.preventDefault();
	        AuthService.logout();
	        $state.go('auth.login');
	      };
	    }]
	  });
	
	  $urlRouterProvider.otherwise(function ($injector, $location) {
	    var $state = $injector.get("$state");
	    $state.go("app");
	  });
	}]).run(["$rootScope", "$state", "AuthService", function ($rootScope, $state, AuthService) {
	  "ngInject";
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, fromState) {
	    //return;
	    if (!('data' in next) || true !== next.data.noLogin) {
	      if (!AuthService.getCurrentUser()) {
	        event.preventDefault();
	        $state.go('auth.login');
	      }
	    }
	  });
	}]);
	
	// WEBPACK FOOTER //

/***/ },
/* 3 */,
/* 4 */,
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _user = __webpack_require__(228);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _auth = __webpack_require__(229);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _loki = __webpack_require__(230);
	
	var _loki2 = _interopRequireDefault(_loki);
	
	var _api = __webpack_require__(231);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = _angular2.default.module('app.common', [_user2.default, _auth2.default]).factory('db', _loki2.default).service("Api", _api2.default).name;
	
	exports.default = commonModule;
	
	// WEBPACK FOOTER //

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dashboard = __webpack_require__(237);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _products = __webpack_require__(238);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _productParts = __webpack_require__(239);
	
	var _productParts2 = _interopRequireDefault(_productParts);
	
	var _productPage = __webpack_require__(240);
	
	var _productPage2 = _interopRequireDefault(_productPage);
	
	var _orders = __webpack_require__(236);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	var _coupons = __webpack_require__(241);
	
	var _coupons2 = _interopRequireDefault(_coupons);
	
	var _newsletter = __webpack_require__(242);
	
	var _newsletter2 = _interopRequireDefault(_newsletter);
	
	var _users = __webpack_require__(243);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _images = __webpack_require__(244);
	
	var _images2 = _interopRequireDefault(_images);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module('app.modules', [_dashboard2.default, _products2.default, _productParts2.default, _productPage2.default, _orders2.default, _coupons2.default, _newsletter2.default, _users2.default, _images2.default]).name;
	
	exports.default = componentModule;
	
	// WEBPACK FOOTER //

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tabs = __webpack_require__(245);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _flipper = __webpack_require__(246);
	
	var _flipper2 = _interopRequireDefault(_flipper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.ui', [_tabs2.default, _flipper2.default]).name;
	
	// WEBPACK FOOTER //

/***/ },
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"login-box\">\r\n  <div class=\"login-logo\">\r\n    <a><b>Sign</b>Labs</a>\r\n  </div>\r\n  <!-- /.login-logo -->\r\n  <div class=\"login-box-body\">\r\n    <p class=\"login-box-msg\">Sign in to start your session</p>\r\n    <div ui-view></div>\r\n  </div>\r\n\r\n"

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"wrapper\">\r\n  <header class=\"main-header\">\r\n    <a href=\"/\" class=\"logo\">\r\n      <!-- mini logo for sidebar mini 50x50 pixels -->\r\n      <span class=\"logo-mini\"><b>S</b>L</span>\r\n      <!-- logo for regular state and mobile devices -->\r\n      <span class=\"logo-lg\"><b>Sign</b>Labs</span>\r\n    </a>\r\n    <nav class=\"navbar navbar-static-top\">\r\n      <a ng-click=\"isOpen = !isOpen\" href=\"javascript:void(0);\" class=\"sidebar-toggle\" data-toggle=\"offcanvas\"\r\n         role=\"button\">\r\n        <span class=\"sr-only\">Toggle navigation</span>\r\n      </a>\r\n      <div class=\"navbar-custom-menu\">\r\n        <ul class=\"nav navbar-nav\">\r\n          <li class=\"dropdown user user-menu\">\r\n            <a href=\"javascript:void(0);\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" aria-expanded=\"false\">\r\n              <img src=\"dist/img/user2-160x160.jpg\" class=\"user-image\" alt=\"User Image\">\r\n              <span class=\"hidden-xs\">Administrator</span>\r\n            </a>\r\n          </li>\r\n          <li>\r\n            <a ng-click=\"logout($event)\"><i class=\"fa fa-sign-out\" aria-hidden=\"true\"></i>Logout</a>\r\n          </li>\r\n        </ul>\r\n\r\n      </div>\r\n    </nav>\r\n  </header>\r\n  <aside class=\"main-sidebar\" ng-class=\"isOpen?'open-side':''\">\r\n    <section class=\"sidebar\">\r\n      <ul class=\"sidebar-menu\">\r\n        <li ui-sref-active=\"active\">\r\n          <a ui-sref=\"app.dashboard\">\r\n            <i class=\"fa fa-dashboard\"></i> <span>Dashboard</span>\r\n            <span class=\"pull-right-container\">\r\n              <i class=\"fa fa-angle-left pull-right\"></i>\r\n            </span>\r\n          </a>\r\n        </li>\r\n        <li class=\"header\">\r\n          Product Spec\r\n        </li>\r\n        <li ui-sref-active=\"active\" ng-repeat=\"product in products\">\r\n          <a ui-sref=\"app.product({product: product.slug})\">\r\n            {{product.name}}\r\n          </a>\r\n        </li>\r\n        <li class=\"header\">\r\n          Other Spec\r\n        </li>\r\n        <li ui-sref-active=\"active\">\r\n          <a ui-sref=\"app.categoryList\">\r\n            <i class=\"fa fa-sitemap\" aria-hidden=\"true\"></i> <span>Categories</span>\r\n          </a>\r\n        </li>\r\n        <li ui-sref-active=\"active\">\r\n          <a ui-sref=\"app.subCategoryList({parentId:'all'})\">\r\n            <i class=\"fa fa-sitemap\" aria-hidden=\"true\"></i> <span>Sub Categories</span>\r\n          </a>\r\n        </li>\r\n        <li ui-sref-active=\"active\">\r\n          <a ui-sref=\"app.productPagelisting\">\r\n            <i class=\"fa fa-product-hunt\" aria-hidden=\"true\"></i> <span>Product Pages</span>\r\n          </a>\r\n        </li>\r\n        <li ui-sref-active=\"active\">\r\n          <a ui-sref=\"app.orderlisting\">\r\n            <i class=\"fa fa-shopping-cart\" aria-hidden=\"true\"></i> <span>Orders</span>\r\n          </a>\r\n        </li>\r\n        <li ui-sref-active=\"active\">\r\n          <a ui-sref=\"app.couponlisting\">\r\n            <i class=\"fa fa-tags\" aria-hidden=\"true\"></i> <span>Coupons</span>\r\n          </a>\r\n        </li>\r\n        <li ui-sref-active=\"active\">\r\n          <a ui-sref=\"app.subscriberListing\">\r\n            <i class=\"fa fa-newspaper-o\" aria-hidden=\"true\"></i> <span>Newsletter</span>\r\n          </a>\r\n        </li>\r\n        <li ui-sref-active=\"active\">\r\n          <a ui-sref=\"app.userListing\">\r\n            <i class=\"fa fa-users\" aria-hidden=\"true\"></i> <span>Users</span>\r\n          </a>\r\n        </li>\r\n        <li ui-sref-active=\"active\">\r\n          <a ui-sref=\"app.imageCategories\">\r\n            <i class=\"fa fa-bars\" aria-hidden=\"true\"></i> <span>Image Categories</span>\r\n          </a>\r\n        </li>\r\n        <li ui-sref-active=\"active\">\r\n          <a ui-sref=\"app.images({parentId:'0'})\">\r\n            <i class=\"fa fa-picture-o\" aria-hidden=\"true\"></i> <span>Images</span>\r\n          </a>\r\n        </li>\r\n      </ul>\r\n    </section>\r\n  </aside>\r\n  <div class=\"content-wrapper\">\r\n    <section class=\"content-header\"></section>\r\n    <section ui-view class=\"content\">\r\n\r\n    </section>\r\n  </div>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(18);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(232)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./AdminLTE.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./AdminLTE.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(250)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700,300italic,400italic,600italic);", ""]);
	
	// module
	exports.push([module.id, "/*!\\n *   AdminLTE v2.3.6\\n *   Author: Almsaeed Studio\\n *\\t Website: Almsaeed Studio <http://almsaeedstudio.com>\\n *   License: Open source - MIT\\n *           Please visit http://opensource.org/licenses/MIT for more information\\n!*/.layout-boxed body,.layout-boxed html,body,html{height:100%}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Source Sans Pro,Helvetica Neue,Helvetica,Arial,sans-serif;font-weight:400;overflow-x:hidden;overflow-y:auto}.wrapper{height:100%;position:relative;overflow:hidden}.wrapper:after,.wrapper:before{content:\\\" \\\";display:table}.wrapper:after{clear:both}.layout-boxed .wrapper{max-width:1250px;margin:0 auto;min-height:100%;box-shadow:0 0 8px rgba(0,0,0,.5);position:relative}.content-wrapper,.main-footer,.right-side{transition:transform .3s ease-in-out,margin .3s ease-in-out;margin-left:230px;z-index:820}.layout-top-nav .content-wrapper,.layout-top-nav .main-footer,.layout-top-nav .right-side{margin-left:0}@media (max-width:767px){.content-wrapper,.main-footer,.right-side{margin-left:0}}@media (min-width:768px){.sidebar-collapse .content-wrapper,.sidebar-collapse .main-footer,.sidebar-collapse .right-side{margin-left:0}}@media (max-width:767px){.sidebar-open .content-wrapper,.sidebar-open .main-footer,.sidebar-open .right-side{transform:translate(230px)}}.content-wrapper,.right-side{min-height:calc(100% + 60px);background-color:#ecf0f5;z-index:800}.main-footer{background:#fff;padding:15px;color:#444;border-top:1px solid #d2d6de}.fixed .left-side,.fixed .main-header,.fixed .main-sidebar{position:fixed}.fixed .main-header{top:0;right:0;left:0}.fixed .content-wrapper,.fixed .right-side{padding-top:50px}@media (max-width:767px){.fixed .content-wrapper,.fixed .right-side{padding-top:100px}}.fixed.layout-boxed .wrapper{max-width:100%}body.hold-transition .content-wrapper,body.hold-transition .left-side,body.hold-transition .main-footer,body.hold-transition .main-header .logo,body.hold-transition .main-header .navbar,body.hold-transition .main-sidebar,body.hold-transition .right-side{transition:none}.content{min-height:250px;padding:15px;margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:Source Sans Pro,sans-serif}a{color:#3c8dbc}a:active,a:focus,a:hover{outline:none;text-decoration:none;color:#72afd2}.page-header{margin:10px 0 20px;font-size:22px}.page-header>small{color:#666;display:block;margin-top:5px}.main-header{position:relative;max-height:100px;z-index:1030}.main-header .navbar{transition:margin-left .3s ease-in-out;margin-bottom:0;margin-left:230px;border:none;min-height:50px;border-radius:0}.layout-top-nav .main-header .navbar{margin-left:0}.main-header #navbar-search-input.form-control{background:hsla(0,0%,100%,.2);border-color:transparent}.main-header #navbar-search-input.form-control:active,.main-header #navbar-search-input.form-control:focus{border-color:rgba(0,0,0,.1);background:hsla(0,0%,100%,.9)}.main-header #navbar-search-input.form-control::-moz-placeholder{color:#ccc;opacity:1}.main-header #navbar-search-input.form-control:-ms-input-placeholder{color:#ccc}.main-header #navbar-search-input.form-control::-webkit-input-placeholder{color:#ccc}.main-header .navbar-custom-menu,.main-header .navbar-right{float:right}@media (max-width:991px){.main-header .navbar-custom-menu a,.main-header .navbar-right a{color:inherit;background:transparent}}@media (max-width:767px){.main-header .navbar-right{float:none}.navbar-collapse .main-header .navbar-right{margin:7.5px -15px}.main-header .navbar-right>li{color:inherit;border:0}}.main-header .sidebar-toggle{float:left;background-color:transparent;background-image:none;padding:15px;font-family:fontAwesome}.main-header .sidebar-toggle:before{content:\\\"\\\\F0C9\\\"}.main-header .sidebar-toggle:hover{color:#fff}.main-header .sidebar-toggle:active,.main-header .sidebar-toggle:focus{background:transparent}.main-header .sidebar-toggle .icon-bar{display:none}.main-header .navbar .nav>li.user>a>.fa,.main-header .navbar .nav>li.user>a>.glyphicon,.main-header .navbar .nav>li.user>a>.ion{margin-right:5px}.main-header .navbar .nav>li>a>.label{position:absolute;top:9px;right:7px;text-align:center;font-size:9px;padding:2px 3px;line-height:.9}.main-header .logo{transition:width .3s ease-in-out;display:block;float:left;height:50px;font-size:20px;line-height:50px;text-align:center;width:230px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;padding:0 15px;font-weight:300;overflow:hidden}.main-header .logo .logo-lg{display:block}.main-header .logo .logo-mini{display:none}.main-header .navbar-brand{color:#fff}.content-header{position:relative;padding:15px 15px 0}.content-header>h1{margin:0;font-size:24px}.content-header>h1>small{font-size:15px;display:inline-block;padding-left:4px;font-weight:300}.content-header>.breadcrumb{float:right;background:transparent;margin-top:0;margin-bottom:0;font-size:12px;padding:7px 5px;position:absolute;top:15px;right:10px;border-radius:2px}.content-header>.breadcrumb>li>a{color:#444;text-decoration:none;display:inline-block}.content-header>.breadcrumb>li>a>.fa,.content-header>.breadcrumb>li>a>.glyphicon,.content-header>.breadcrumb>li>a>.ion{margin-right:5px}.content-header>.breadcrumb>li+li:before{content:\\\" > \\\\A0\\\"}@media (max-width:991px){.content-header>.breadcrumb{position:relative;margin-top:5px;top:0;right:0;float:none;background:#d2d6de;padding-left:10px}.content-header>.breadcrumb li:before{color:#97a0b3}}.navbar-toggle{color:#fff;border:0;margin:0;padding:15px}@media (max-width:991px){.navbar-custom-menu .navbar-nav>li{float:left}.navbar-custom-menu .navbar-nav{margin:0;float:left}.navbar-custom-menu .navbar-nav>li>a{padding-top:15px;padding-bottom:15px;line-height:20px}}@media (max-width:767px){.main-header{position:relative}.main-header .logo,.main-header .navbar{width:100%;float:none}.main-header .navbar{margin:0}.main-header .navbar-custom-menu{float:right}}@media (max-width:991px){.navbar-collapse.pull-left{float:none!important}.navbar-collapse.pull-left+.navbar-custom-menu{display:block;position:absolute;top:0;right:40px}}.left-side,.main-sidebar{position:absolute;top:0;left:0;padding-top:50px;min-height:100%;width:230px;z-index:810;transition:transform .3s ease-in-out,width .3s ease-in-out}@media (max-width:767px){.left-side,.main-sidebar{padding-top:100px;transform:translate(-230px)}}@media (min-width:768px){.sidebar-collapse .left-side,.sidebar-collapse .main-sidebar{transform:translate(-230px)}}@media (max-width:767px){.sidebar-open .left-side,.sidebar-open .main-sidebar{transform:translate(0)}}.sidebar{padding-bottom:10px}.sidebar-form input:focus{border-color:transparent}.user-panel{position:relative;width:100%;padding:10px;overflow:hidden}.user-panel:after,.user-panel:before{content:\\\" \\\";display:table}.user-panel:after{clear:both}.user-panel>.image>img{width:100%;max-width:45px;height:auto}.user-panel>.info{padding:5px 5px 5px 15px;line-height:1;position:absolute;left:55px}.user-panel>.info>p{font-weight:600;margin-bottom:9px}.user-panel>.info>a{text-decoration:none;padding-right:5px;margin-top:3px;font-size:11px}.user-panel>.info>a>.fa,.user-panel>.info>a>.glyphicon,.user-panel>.info>a>.ion{margin-right:3px}.sidebar-menu{list-style:none;margin:0;padding:0}.sidebar-menu>li{position:relative;margin:0;padding:0}.sidebar-menu>li>a{padding:12px 5px 12px 15px;display:block}.sidebar-menu>li>a>.fa,.sidebar-menu>li>a>.glyphicon,.sidebar-menu>li>a>.ion{width:20px}.sidebar-menu>li .badge,.sidebar-menu>li .label{margin-right:5px}.sidebar-menu>li .badge{margin-top:3px}.sidebar-menu li.header{padding:10px 25px 10px 15px;font-size:12px}.sidebar-menu li>a>.fa-angle-left,.sidebar-menu li>a>.pull-right-container>.fa-angle-left{width:auto;height:auto;padding:0;margin-right:10px}.sidebar-menu li.active>a>.fa-angle-left>a>.pull-right-container>.fa-angle-left{transform:rotate(-90deg)}.sidebar-menu li.active>.treeview-menu{display:block}.sidebar-menu .treeview-menu{display:none;list-style:none;padding:0;margin:0;padding-left:5px}.sidebar-menu .treeview-menu .treeview-menu{padding-left:20px}.sidebar-menu .treeview-menu>li{margin:0}.sidebar-menu .treeview-menu>li>a{padding:5px 5px 5px 15px;display:block;font-size:14px}.sidebar-menu .treeview-menu>li>a>.fa,.sidebar-menu .treeview-menu>li>a>.glyphicon,.sidebar-menu .treeview-menu>li>a>.ion{width:20px}.sidebar-menu .treeview-menu>li>a>.fa-angle-down,.sidebar-menu .treeview-menu>li>a>.fa-angle-left,.sidebar-menu .treeview-menu>li>a>.pull-right-container>.fa-angle-down,.sidebar-menu .treeview-menu>li>a>.pull-right-container>.fa-angle-left{width:auto}@media (min-width:768px){.sidebar-mini.sidebar-collapse .content-wrapper,.sidebar-mini.sidebar-collapse .main-footer,.sidebar-mini.sidebar-collapse .right-side{margin-left:50px!important;z-index:840}.sidebar-mini.sidebar-collapse .main-sidebar{transform:translate(0);width:50px!important;z-index:850}.sidebar-mini.sidebar-collapse .sidebar-menu>li{position:relative}.sidebar-mini.sidebar-collapse .sidebar-menu>li>a{margin-right:0}.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>span{border-top-right-radius:4px}.sidebar-mini.sidebar-collapse .sidebar-menu>li:not(.treeview)>a>span{border-bottom-right-radius:4px}.sidebar-mini.sidebar-collapse .sidebar-menu>li>.treeview-menu{padding-top:5px;padding-bottom:5px;border-bottom-right-radius:4px}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>.treeview-menu,.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>a>span:not(.pull-right){display:block!important;position:absolute;width:180px;left:50px}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>a>span{top:0;margin-left:-3px;padding:12px 5px 12px 20px;background-color:inherit}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>a>.pull-right-container{float:right;width:auto!important;left:200px!important;top:10px!important}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>a>.pull-right-container>.label:not(:first-of-type){display:none}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>.treeview-menu{top:44px;margin-left:0}.sidebar-mini.sidebar-collapse .main-sidebar .user-panel>.info,.sidebar-mini.sidebar-collapse .sidebar-form,.sidebar-mini.sidebar-collapse .sidebar-menu>li>.treeview-menu,.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>.pull-right,.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>span,.sidebar-mini.sidebar-collapse .sidebar-menu li.header{display:none!important;-webkit-transform:translateZ(0)}.sidebar-mini.sidebar-collapse .main-header .logo{width:50px}.sidebar-mini.sidebar-collapse .main-header .logo>.logo-mini{display:block;margin-left:-15px;margin-right:-15px;font-size:18px}.sidebar-mini.sidebar-collapse .main-header .logo>.logo-lg{display:none}.sidebar-mini.sidebar-collapse .main-header .navbar{margin-left:50px}}.main-sidebar .user-panel,.sidebar-menu,.sidebar-menu>li.header{white-space:nowrap;overflow:hidden}.sidebar-menu:hover{overflow:visible}.sidebar-form,.sidebar-menu>li.header{overflow:hidden;text-overflow:clip}.sidebar-menu li>a{position:relative}.sidebar-menu li>a>.pull-right-container{position:absolute;right:10px;top:50%;margin-top:-7px}.control-sidebar-bg{position:fixed;z-index:1000;bottom:0}.control-sidebar,.control-sidebar-bg{top:0;right:-230px;width:230px;transition:right .3s ease-in-out}.control-sidebar{position:absolute;padding-top:50px;z-index:1010}@media (max-width:768px){.control-sidebar{padding-top:100px}}.control-sidebar>.tab-content{padding:10px 15px}.control-sidebar-open .control-sidebar,.control-sidebar-open .control-sidebar-bg,.control-sidebar.control-sidebar-open,.control-sidebar.control-sidebar-open+.control-sidebar-bg{right:0}@media (min-width:768px){.control-sidebar-open .content-wrapper,.control-sidebar-open .main-footer,.control-sidebar-open .right-side{margin-right:230px}}.nav-tabs.control-sidebar-tabs>li:first-of-type>a,.nav-tabs.control-sidebar-tabs>li:first-of-type>a:focus,.nav-tabs.control-sidebar-tabs>li:first-of-type>a:hover{border-left-width:0}.nav-tabs.control-sidebar-tabs>li>a{border-radius:0}.nav-tabs.control-sidebar-tabs>li>a,.nav-tabs.control-sidebar-tabs>li>a:hover{border-top:none;border-right:none;border-left:1px solid transparent;border-bottom:1px solid transparent}.nav-tabs.control-sidebar-tabs>li>a .icon{font-size:16px}.nav-tabs.control-sidebar-tabs>li.active>a,.nav-tabs.control-sidebar-tabs>li.active>a:active,.nav-tabs.control-sidebar-tabs>li.active>a:focus,.nav-tabs.control-sidebar-tabs>li.active>a:hover{border-top:none;border-right:none;border-bottom:none}@media (max-width:768px){.nav-tabs.control-sidebar-tabs{display:table}.nav-tabs.control-sidebar-tabs>li{display:table-cell}}.control-sidebar-heading{font-weight:400;font-size:16px;padding:10px 0;margin-bottom:10px}.control-sidebar-subheading{display:block;font-weight:400;font-size:14px}.control-sidebar-menu{list-style:none;padding:0;margin:0 -15px}.control-sidebar-menu>li>a{display:block;padding:10px 15px}.control-sidebar-menu>li>a:after,.control-sidebar-menu>li>a:before{content:\\\" \\\";display:table}.control-sidebar-menu>li>a:after{clear:both}.control-sidebar-menu>li>a>.control-sidebar-subheading{margin-top:0}.control-sidebar-menu .menu-icon{float:left;width:35px;height:35px;border-radius:50%;text-align:center;line-height:35px}.control-sidebar-menu .menu-info{margin-left:45px;margin-top:3px}.control-sidebar-menu .menu-info>.control-sidebar-subheading{margin:0}.control-sidebar-menu .menu-info>p{margin:0;font-size:11px}.control-sidebar-menu .progress{margin:0}.control-sidebar-dark{color:#b8c7ce}.control-sidebar-dark,.control-sidebar-dark+.control-sidebar-bg{background:#222d32}.control-sidebar-dark .nav-tabs.control-sidebar-tabs{border-bottom:#1c2529}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a{background:#181f23;color:#b8c7ce}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:focus,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:hover{border-left-color:#141a1d;border-bottom-color:#141a1d}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:active,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:focus,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:hover{background:#1c2529}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:hover{color:#fff}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a:active,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a:focus,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a:hover{background:#222d32;color:#fff}.control-sidebar-dark .control-sidebar-heading,.control-sidebar-dark .control-sidebar-subheading{color:#fff}.control-sidebar-dark .control-sidebar-menu>li>a:hover{background:#1e282c}.control-sidebar-dark .control-sidebar-menu>li>a .menu-info>p{color:#b8c7ce}.control-sidebar-light{color:#5e5e5e}.control-sidebar-light,.control-sidebar-light+.control-sidebar-bg{background:#f9fafc;border-left:1px solid #d2d6de}.control-sidebar-light .nav-tabs.control-sidebar-tabs{border-bottom:#d2d6de}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a{background:#e8ecf4;color:#444}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:focus,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:hover{border-left-color:#d2d6de;border-bottom-color:#d2d6de}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:active,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:focus,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:hover{background:#eff1f7}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a:active,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a:focus,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a:hover{background:#f9fafc;color:#111}.control-sidebar-light .control-sidebar-heading,.control-sidebar-light .control-sidebar-subheading{color:#111}.control-sidebar-light .control-sidebar-menu{margin-left:-14px}.control-sidebar-light .control-sidebar-menu>li>a:hover{background:#f4f4f5}.control-sidebar-light .control-sidebar-menu>li>a .menu-info>p{color:#5e5e5e}.dropdown-menu{box-shadow:none;border-color:#eee}.dropdown-menu>li>a{color:#777}.dropdown-menu>li>a>.fa,.dropdown-menu>li>a>.glyphicon,.dropdown-menu>li>a>.ion{margin-right:10px}.dropdown-menu>li>a:hover{background-color:#e1e3e9;color:#333}.dropdown-menu>.divider{background-color:#eee}.navbar-nav>.messages-menu>.dropdown-menu,.navbar-nav>.notifications-menu>.dropdown-menu,.navbar-nav>.tasks-menu>.dropdown-menu{width:280px;padding:0;margin:0;top:100%}.navbar-nav>.messages-menu>.dropdown-menu>li,.navbar-nav>.notifications-menu>.dropdown-menu>li,.navbar-nav>.tasks-menu>.dropdown-menu>li{position:relative}.navbar-nav>.messages-menu>.dropdown-menu>li.header,.navbar-nav>.notifications-menu>.dropdown-menu>li.header,.navbar-nav>.tasks-menu>.dropdown-menu>li.header{border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0;background-color:#fff;padding:7px 10px;border-bottom:1px solid #f4f4f4;color:#444;font-size:14px}.navbar-nav>.messages-menu>.dropdown-menu>li.footer>a,.navbar-nav>.notifications-menu>.dropdown-menu>li.footer>a,.navbar-nav>.tasks-menu>.dropdown-menu>li.footer>a{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px;font-size:12px;background-color:#fff;padding:7px 10px;border-bottom:1px solid #eee;color:#444!important;text-align:center}@media (max-width:991px){.navbar-nav>.messages-menu>.dropdown-menu>li.footer>a,.navbar-nav>.notifications-menu>.dropdown-menu>li.footer>a,.navbar-nav>.tasks-menu>.dropdown-menu>li.footer>a{background:#fff!important;color:#444!important}}.navbar-nav>.messages-menu>.dropdown-menu>li.footer>a:hover,.navbar-nav>.notifications-menu>.dropdown-menu>li.footer>a:hover,.navbar-nav>.tasks-menu>.dropdown-menu>li.footer>a:hover{text-decoration:none;font-weight:400}.navbar-nav>.messages-menu>.dropdown-menu>li .menu,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu,.navbar-nav>.tasks-menu>.dropdown-menu>li .menu{max-height:200px;margin:0;padding:0;list-style:none;overflow-x:hidden}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a,.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a{display:block;white-space:nowrap;border-bottom:1px solid #f4f4f4}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:hover,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a:hover,.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background:#f4f4f4;text-decoration:none}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a{color:#444;overflow:hidden;text-overflow:ellipsis;padding:10px}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a>.fa,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a>.glyphicon,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a>.ion{width:20px}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a{margin:0;padding:10px}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>div>img{margin:auto 10px auto auto;width:40px;height:40px}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>h4{padding:0;margin:0 0 0 45px;color:#444;font-size:15px;position:relative}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>h4>small{color:#999;font-size:10px;position:absolute;top:0;right:0}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>p{margin:0 0 0 45px;font-size:12px;color:#888}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:after,.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:before{content:\\\" \\\";display:table}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:after{clear:both}.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a{padding:10px}.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a>h3{font-size:14px;padding:0;margin:0 0 10px;color:#666}.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a>.progress{padding:0;margin:0}.navbar-nav>.user-menu>.dropdown-menu{border-top-right-radius:0;border-top-left-radius:0;padding:1px 0 0;border-top-width:0;width:280px}.navbar-nav>.user-menu>.dropdown-menu,.navbar-nav>.user-menu>.dropdown-menu>.user-body{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.navbar-nav>.user-menu>.dropdown-menu>li.user-header{height:175px;padding:10px;text-align:center}.navbar-nav>.user-menu>.dropdown-menu>li.user-header>img{z-index:5;height:90px;width:90px;border:3px solid;border-color:transparent;border-color:hsla(0,0%,100%,.2)}.navbar-nav>.user-menu>.dropdown-menu>li.user-header>p{z-index:5;color:#fff;color:hsla(0,0%,100%,.8);font-size:17px;margin-top:10px}.navbar-nav>.user-menu>.dropdown-menu>li.user-header>p>small{display:block;font-size:12px}.navbar-nav>.user-menu>.dropdown-menu>.user-body{padding:15px;border-bottom:1px solid #f4f4f4;border-top:1px solid #ddd}.navbar-nav>.user-menu>.dropdown-menu>.user-body:after,.navbar-nav>.user-menu>.dropdown-menu>.user-body:before{content:\\\" \\\";display:table}.navbar-nav>.user-menu>.dropdown-menu>.user-body:after{clear:both}.navbar-nav>.user-menu>.dropdown-menu>.user-body a{color:#444!important}@media (max-width:991px){.navbar-nav>.user-menu>.dropdown-menu>.user-body a{background:#fff!important;color:#444!important}}.navbar-nav>.user-menu>.dropdown-menu>.user-footer{background-color:#f9f9f9;padding:10px}.navbar-nav>.user-menu>.dropdown-menu>.user-footer:after,.navbar-nav>.user-menu>.dropdown-menu>.user-footer:before{content:\\\" \\\";display:table}.navbar-nav>.user-menu>.dropdown-menu>.user-footer:after{clear:both}.navbar-nav>.user-menu>.dropdown-menu>.user-footer .btn-default{color:#666}@media (max-width:991px){.navbar-nav>.user-menu>.dropdown-menu>.user-footer .btn-default:hover{background-color:#f9f9f9}}.navbar-nav>.user-menu .user-image{float:left;width:25px;height:25px;border-radius:50%;margin-right:10px;margin-top:-2px}@media (max-width:767px){.navbar-nav>.user-menu .user-image{float:none;margin-right:0;margin-top:-8px;line-height:10px}}.open:not(.dropup)>.animated-dropdown-menu{backface-visibility:visible!important;animation:flipInX .7s both}@keyframes flipInX{0%{transform:perspective(400px) rotateX(90deg);transition-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);transition-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}.navbar-custom-menu>.navbar-nav>li{position:relative}.navbar-custom-menu>.navbar-nav>li>.dropdown-menu{position:absolute;right:0;left:auto}@media (max-width:991px){.navbar-custom-menu>.navbar-nav{float:right}.navbar-custom-menu>.navbar-nav>li{position:static}.navbar-custom-menu>.navbar-nav>li>.dropdown-menu{position:absolute;right:5%;left:auto;border:1px solid #ddd;background:#fff}}.form-control{border-radius:0;box-shadow:none;border-color:#d2d6de}.form-control:focus{border-color:#3c8dbc;box-shadow:none}.form-control:-ms-input-placeholder,.form-control::-moz-placeholder,.form-control::-webkit-input-placeholder{color:#bbb;opacity:1}.form-control:not(select){-moz-appearance:none;appearance:none}.form-group.has-success label{color:#00a65a}.form-group.has-success .form-control{border-color:#00a65a;box-shadow:none}.form-group.has-success .help-block{color:#00a65a}.form-group.has-warning label{color:#f39c12}.form-group.has-warning .form-control{border-color:#f39c12;box-shadow:none}.form-group.has-warning .help-block{color:#f39c12}.form-group.has-error label{color:#dd4b39}.form-group.has-error .form-control{border-color:#dd4b39;box-shadow:none}.form-group.has-error .help-block{color:#dd4b39}.input-group .input-group-addon{border-radius:0;border-color:#d2d6de;background-color:#fff}.btn-group-vertical .btn.btn-flat:first-of-type,.btn-group-vertical .btn.btn-flat:last-of-type{border-radius:0}.icheck>label{padding-left:0}.form-control-feedback.fa{line-height:34px}.form-group-lg .form-control+.form-control-feedback.fa,.input-group-lg+.form-control-feedback.fa,.input-lg+.form-control-feedback.fa{line-height:46px}.form-group-sm .form-control+.form-control-feedback.fa,.input-group-sm+.form-control-feedback.fa,.input-sm+.form-control-feedback.fa{line-height:30px}.progress,.progress>.progress-bar{box-shadow:none}.progress,.progress .progress-bar,.progress>.progress-bar,.progress>.progress-bar .progress-bar{border-radius:1px}.progress-sm,.progress.sm{height:10px}.progress-sm,.progress-sm .progress-bar,.progress.sm,.progress.sm .progress-bar{border-radius:1px}.progress-xs,.progress.xs{height:7px}.progress-xs,.progress-xs .progress-bar,.progress.xs,.progress.xs .progress-bar{border-radius:1px}.progress-xxs,.progress.xxs{height:3px}.progress-xxs,.progress-xxs .progress-bar,.progress.xxs,.progress.xxs .progress-bar{border-radius:1px}.progress.vertical{position:relative;width:30px;height:200px;display:inline-block;margin-right:10px}.progress.vertical>.progress-bar{width:100%;position:absolute;bottom:0}.progress.vertical.progress-sm,.progress.vertical.sm{width:20px}.progress.vertical.progress-xs,.progress.vertical.xs{width:10px}.progress.vertical.progress-xxs,.progress.vertical.xxs{width:3px}.progress-group .progress-text{font-weight:600}.progress-group .progress-number{float:right}.table tr>td .progress{margin:0}.progress-bar-light-blue,.progress-bar-primary{background-color:#3c8dbc}.progress-striped .progress-bar-light-blue,.progress-striped .progress-bar-primary{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-green,.progress-bar-success{background-color:#00a65a}.progress-striped .progress-bar-green,.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-aqua,.progress-bar-info{background-color:#00c0ef}.progress-striped .progress-bar-aqua,.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning,.progress-bar-yellow{background-color:#f39c12}.progress-striped .progress-bar-warning,.progress-striped .progress-bar-yellow{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger,.progress-bar-red{background-color:#dd4b39}.progress-striped .progress-bar-danger,.progress-striped .progress-bar-red{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.small-box{border-radius:2px;position:relative;display:block;margin-bottom:20px;box-shadow:0 1px 1px rgba(0,0,0,.1)}.small-box>.inner{padding:10px}.small-box>.small-box-footer{position:relative;text-align:center;padding:3px 0;color:#fff;color:hsla(0,0%,100%,.8);display:block;z-index:10;background:rgba(0,0,0,.1);text-decoration:none}.small-box>.small-box-footer:hover{color:#fff;background:rgba(0,0,0,.15)}.small-box h3{font-size:38px;font-weight:700;margin:0 0 10px;white-space:nowrap;padding:0}.small-box p{font-size:15px}.small-box p>small{display:block;color:#f9f9f9;font-size:13px;margin-top:5px}.small-box h3,.small-box p{z-index:5}.small-box .icon{transition:all .3s linear;position:absolute;top:-10px;right:10px;z-index:0;font-size:90px;color:rgba(0,0,0,.15)}.small-box:hover{text-decoration:none;color:#f9f9f9}.small-box:hover .icon{font-size:95px}@media (max-width:767px){.small-box{text-align:center}.small-box .icon{display:none}.small-box p{font-size:12px}}.box{position:relative;border-radius:3px;background:#fff;border-top:3px solid #d2d6de;margin-bottom:20px;width:100%;box-shadow:0 1px 1px rgba(0,0,0,.1)}.box.box-primary{border-top-color:#3c8dbc}.box.box-info{border-top-color:#00c0ef}.box.box-danger{border-top-color:#dd4b39}.box.box-warning{border-top-color:#f39c12}.box.box-success{border-top-color:#00a65a}.box.box-default{border-top-color:#d2d6de}.box.collapsed-box .box-body,.box.collapsed-box .box-footer{display:none}.box .nav-stacked>li{border-bottom:1px solid #f4f4f4;margin:0}.box .nav-stacked>li:last-of-type{border-bottom:none}.box.height-control .box-body{max-height:300px;overflow:auto}.box .border-right{border-right:1px solid #f4f4f4}.box .border-left{border-left:1px solid #f4f4f4}.box.box-solid{border-top:0}.box.box-solid>.box-header .btn.btn-default{background:transparent}.box.box-solid>.box-header .btn:hover,.box.box-solid>.box-header a:hover{background:rgba(0,0,0,.1)}.box.box-solid.box-default{border:1px solid #d2d6de}.box.box-solid.box-default>.box-header{color:#444;background:#d2d6de;background-color:#d2d6de}.box.box-solid.box-default>.box-header .btn,.box.box-solid.box-default>.box-header a{color:#444}.box.box-solid.box-primary{border:1px solid #3c8dbc}.box.box-solid.box-primary>.box-header{color:#fff;background:#3c8dbc;background-color:#3c8dbc}.box.box-solid.box-primary>.box-header .btn,.box.box-solid.box-primary>.box-header a{color:#fff}.box.box-solid.box-info{border:1px solid #00c0ef}.box.box-solid.box-info>.box-header{color:#fff;background:#00c0ef;background-color:#00c0ef}.box.box-solid.box-info>.box-header .btn,.box.box-solid.box-info>.box-header a{color:#fff}.box.box-solid.box-danger{border:1px solid #dd4b39}.box.box-solid.box-danger>.box-header{color:#fff;background:#dd4b39;background-color:#dd4b39}.box.box-solid.box-danger>.box-header .btn,.box.box-solid.box-danger>.box-header a{color:#fff}.box.box-solid.box-warning{border:1px solid #f39c12}.box.box-solid.box-warning>.box-header{color:#fff;background:#f39c12;background-color:#f39c12}.box.box-solid.box-warning>.box-header .btn,.box.box-solid.box-warning>.box-header a{color:#fff}.box.box-solid.box-success{border:1px solid #00a65a}.box.box-solid.box-success>.box-header{color:#fff;background:#00a65a;background-color:#00a65a}.box.box-solid.box-success>.box-header .btn,.box.box-solid.box-success>.box-header a{color:#fff}.box.box-solid>.box-header>.box-tools .btn{border:0;box-shadow:none}.box.box-solid[class*=bg]>.box-header{color:#fff}.box .box-group>.box{margin-bottom:5px}.box .knob-label{text-align:center;color:#333;font-weight:100;font-size:12px;margin-bottom:.3em}.box>.loading-img,.box>.overlay,.overlay-wrapper>.loading-img,.overlay-wrapper>.overlay{position:absolute;top:0;left:0;width:100%;height:100%}.box .overlay,.overlay-wrapper .overlay{z-index:50;background:hsla(0,0%,100%,.7);border-radius:3px}.box .overlay>.fa,.overlay-wrapper .overlay>.fa{position:absolute;top:50%;left:50%;margin-left:-15px;margin-top:-15px;color:#000;font-size:30px}.box .overlay.dark,.overlay-wrapper .overlay.dark{background:rgba(0,0,0,.5)}.box-body:after,.box-body:before,.box-footer:after,.box-footer:before,.box-header:after,.box-header:before{content:\\\" \\\";display:table}.box-body:after,.box-footer:after,.box-header:after{clear:both}.box-header{color:#444;display:block;padding:10px;position:relative}.box-header.with-border{border-bottom:1px solid #f4f4f4}.collapsed-box .box-header.with-border{border-bottom:none}.box-header .box-title,.box-header>.fa,.box-header>.glyphicon,.box-header>.ion{display:inline-block;font-size:18px;margin:0;line-height:1}.box-header>.fa,.box-header>.glyphicon,.box-header>.ion{margin-right:5px}.box-header>.box-tools{position:absolute;right:10px;top:5px}.box-header>.box-tools [data-toggle=tooltip]{position:relative}.box-header>.box-tools.pull-right .dropdown-menu{right:0;left:auto}.btn-box-tool{padding:5px;font-size:12px;background:transparent;color:#97a0b3}.btn-box-tool:hover,.open .btn-box-tool{color:#606c84}.btn-box-tool.btn:active{box-shadow:none}.box-body{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px;padding:10px}.no-header .box-body{border-top-right-radius:3px;border-top-left-radius:3px}.box-body>.table{margin-bottom:0}.box-body .fc{margin-top:5px}.box-body .full-width-chart{margin:-19px}.box-body.no-padding .full-width-chart{margin:-9px}.box-body .box-pane{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:3px}.box-body .box-pane-right{border-bottom-left-radius:0}.box-body .box-pane-right,.box-footer{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:3px}.box-footer{border-bottom-left-radius:3px;border-top:1px solid #f4f4f4;padding:10px;background-color:#fff}.chart-legend{margin:10px 0}@media (max-width:991px){.chart-legend>li{float:left;margin-right:10px}}.box-comments{background:#f7f7f7}.box-comments .box-comment{padding:8px 0;border-bottom:1px solid #eee}.box-comments .box-comment:after,.box-comments .box-comment:before{content:\\\" \\\";display:table}.box-comments .box-comment:after{clear:both}.box-comments .box-comment:last-of-type{border-bottom:0}.box-comments .box-comment:first-of-type{padding-top:0}.box-comments .box-comment img{float:left}.box-comments .comment-text{margin-left:40px;color:#555}.box-comments .username{color:#444;display:block;font-weight:600}.box-comments .text-muted{font-weight:400;font-size:12px}.todo-list{margin:0;padding:0;list-style:none;overflow:auto}.todo-list>li{border-radius:2px;padding:10px;background:#f4f4f4;margin-bottom:2px;border-left:2px solid #e6e7e8;color:#444}.todo-list>li:last-of-type{margin-bottom:0}.todo-list>li>input[type=checkbox]{margin:0 10px 0 5px}.todo-list>li .text{display:inline-block;margin-left:5px;font-weight:600}.todo-list>li .label{margin-left:10px;font-size:9px}.todo-list>li .tools{display:none;float:right;color:#dd4b39}.todo-list>li .tools>.fa,.todo-list>li .tools>.glyphicon,.todo-list>li .tools>.ion{margin-right:5px;cursor:pointer}.todo-list>li:hover .tools{display:inline-block}.todo-list>li.done{color:#999}.todo-list>li.done .text{text-decoration:line-through;font-weight:500}.todo-list>li.done .label{background:#d2d6de!important}.todo-list .danger{border-left-color:#dd4b39}.todo-list .warning{border-left-color:#f39c12}.todo-list .info{border-left-color:#00c0ef}.todo-list .success{border-left-color:#00a65a}.todo-list .primary{border-left-color:#3c8dbc}.todo-list .handle{display:inline-block;cursor:move;margin:0 5px}.chat{padding:5px 20px 5px 10px}.chat .item{margin-bottom:10px}.chat .item:after,.chat .item:before{content:\\\" \\\";display:table}.chat .item:after{clear:both}.chat .item>img{width:40px;height:40px;border:2px solid transparent;border-radius:50%}.chat .item>.online{border:2px solid #00a65a}.chat .item>.offline{border:2px solid #dd4b39}.chat .item>.message{margin-left:55px;margin-top:-40px}.chat .item>.message>.name{display:block;font-weight:600}.chat .item>.attachment{border-radius:3px;background:#f4f4f4;margin-left:65px;margin-right:15px;padding:10px}.chat .item>.attachment>h4{margin:0 0 5px;font-weight:600;font-size:14px}.chat .item>.attachment>.filename,.chat .item>.attachment>p{font-weight:600;font-size:13px;font-style:italic;margin:0}.chat .item>.attachment:after,.chat .item>.attachment:before{content:\\\" \\\";display:table}.chat .item>.attachment:after{clear:both}.box-input{max-width:200px}.modal .panel-body{color:#444}.panel-body{min-height:170px}.panel-body>img{max-width:150px;max-height:140px}.panel-title{font-size:13px}.info-box{display:block;min-height:90px;background:#fff;width:100%;box-shadow:0 1px 1px rgba(0,0,0,.1);border-radius:2px;margin-bottom:15px}.info-box small{font-size:14px}.info-box .progress{background:rgba(0,0,0,.2);margin:5px -10px;height:2px}.info-box .progress,.info-box .progress .progress-bar{border-radius:0}.info-box .progress .progress-bar{background:#fff}.info-box-icon{border-top-left-radius:2px;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:2px;display:block;float:left;height:90px;width:90px;text-align:center;font-size:45px;line-height:90px;background:rgba(0,0,0,.2)}.info-box-icon>img{max-width:100%}.info-box-content{padding:5px 10px;margin-left:90px}.info-box-number{display:block;font-weight:700;font-size:18px}.info-box-text,.progress-description{display:block;font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.info-box-text{text-transform:uppercase}.info-box-more{display:block}.progress-description{margin:0}.timeline{position:relative;margin:0 0 30px;padding:0;list-style:none}.timeline:before{content:\\\"\\\";position:absolute;top:0;bottom:0;width:4px;background:#ddd;left:31px;margin:0;border-radius:2px}.timeline>li{position:relative;margin-right:10px;margin-bottom:15px}.timeline>li:after,.timeline>li:before{content:\\\" \\\";display:table}.timeline>li:after{clear:both}.timeline>li>.timeline-item{box-shadow:0 1px 1px rgba(0,0,0,.1);border-radius:3px;margin-top:0;background:#fff;color:#444;margin-left:60px;margin-right:15px;padding:0;position:relative}.timeline>li>.timeline-item>.time{color:#999;float:right;padding:10px;font-size:12px}.timeline>li>.timeline-item>.timeline-header{margin:0;color:#555;border-bottom:1px solid #f4f4f4;padding:10px;font-size:16px;line-height:1.1}.timeline>li>.timeline-item>.timeline-header>a{font-weight:600}.timeline>li>.timeline-item>.timeline-body,.timeline>li>.timeline-item>.timeline-footer{padding:10px}.timeline>li>.fa,.timeline>li>.glyphicon,.timeline>li>.ion{width:30px;height:30px;font-size:15px;line-height:30px;position:absolute;color:#666;background:#d2d6de;border-radius:50%;text-align:center;left:18px;top:0}.timeline>.time-label>span{font-weight:600;padding:5px;display:inline-block;background-color:#fff;border-radius:4px}.timeline-inverse>li>.timeline-item{background:#f0f0f0;border:1px solid #ddd;box-shadow:none}.timeline-inverse>li>.timeline-item>.timeline-header{border-bottom-color:#ddd}.btn{border-radius:3px;box-shadow:none;border:1px solid transparent}.btn.uppercase{text-transform:uppercase}.btn.btn-flat{border-radius:0;box-shadow:none;border-width:1px}.btn:active{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn:focus{outline:none}.btn.btn-file{position:relative;overflow:hidden}.btn.btn-file>input[type=file]{position:absolute;top:0;right:0;min-width:100%;min-height:100%;font-size:100px;text-align:right;opacity:0;filter:alpha(opacity=0);outline:none;background:#fff;cursor:inherit;display:block}.btn-default{background-color:#f4f4f4;color:#444;border-color:#ddd}.btn-default.hover,.btn-default:active,.btn-default:hover{background-color:#e7e7e7}.btn-primary{background-color:#3c8dbc;border-color:#367fa9}.btn-primary.hover,.btn-primary:active,.btn-primary:hover{background-color:#367fa9}.btn-success{background-color:#00a65a;border-color:#008d4c}.btn-success.hover,.btn-success:active,.btn-success:hover{background-color:#008d4c}.btn-info{background-color:#00c0ef;border-color:#00acd6}.btn-info.hover,.btn-info:active,.btn-info:hover{background-color:#00acd6}.btn-danger{background-color:#dd4b39;border-color:#d73925}.btn-danger.hover,.btn-danger:active,.btn-danger:hover{background-color:#d73925}.btn-warning{background-color:#f39c12;border-color:#e08e0b}.btn-warning.hover,.btn-warning:active,.btn-warning:hover{background-color:#e08e0b}.btn-outline{border:1px solid #fff;background:transparent;color:#fff}.btn-outline:active,.btn-outline:focus,.btn-outline:hover{color:hsla(0,0%,100%,.7);border-color:hsla(0,0%,100%,.7)}.btn-link{box-shadow:none}.btn[class*=bg-]:hover{box-shadow:inset 0 0 100px rgba(0,0,0,.2)}.btn-app{border-radius:3px;position:relative;padding:15px 5px;margin:0 0 10px 10px;min-width:80px;height:60px;text-align:center;color:#666;border:1px solid #ddd;background-color:#f4f4f4;font-size:12px}.btn-app>.fa,.btn-app>.glyphicon,.btn-app>.ion{font-size:20px;display:block}.btn-app:hover{background:#f4f4f4;color:#444;border-color:#aaa}.btn-app:active,.btn-app:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-app>.badge{position:absolute;top:-3px;right:-10px;font-size:10px;font-weight:400}.callout{border-radius:3px;margin:0 0 20px;padding:15px 30px 15px 15px;border-left:5px solid #eee}.callout a{color:#fff;text-decoration:underline}.callout a:hover{color:#eee}.callout h4{margin-top:0;font-weight:600}.callout p:last-child{margin-bottom:0}.callout .highlight,.callout code{background-color:#fff}.callout.callout-danger{border-color:#c23321}.callout.callout-warning{border-color:#c87f0a}.callout.callout-info{border-color:#0097bc}.callout.callout-success{border-color:#00733e}.alert{border-radius:3px}.alert h4{font-weight:600}.alert .icon{margin-right:10px}.alert .close{color:#000;opacity:.2;filter:alpha(opacity=20)}.alert .close:hover{opacity:.5;filter:alpha(opacity=50)}.alert a{color:#fff;text-decoration:underline}.alert-success{border-color:#008d4c}.alert-danger,.alert-error{border-color:#d73925}.alert-warning{border-color:#e08e0b}.alert-info{border-color:#00acd6}.nav>li>a:active,.nav>li>a:focus,.nav>li>a:hover{color:#444;background:#f7f7f7}.nav-pills>li>a{border-radius:0;border-top:3px solid transparent;color:#444}.nav-pills>li>a>.fa,.nav-pills>li>a>.glyphicon,.nav-pills>li>a>.ion{margin-right:5px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{border-top-color:#3c8dbc}.nav-pills>li.active>a{font-weight:600}.nav-stacked>li>a{border-radius:0;border-top:0;border-left:3px solid transparent;color:#444}.nav-stacked>li.active>a,.nav-stacked>li.active>a:hover{background:transparent;color:#444;border-top:0;border-left-color:#3c8dbc}.nav-stacked>li.header{border-bottom:1px solid #ddd;color:#777;margin-bottom:10px;padding:5px 10px;text-transform:uppercase}.nav-tabs-custom{margin-bottom:20px;background:#fff;box-shadow:0 1px 1px rgba(0,0,0,.1);border-radius:3px}.nav-tabs-custom>.nav-tabs{margin:0;border-bottom-color:#f4f4f4;border-top-right-radius:3px;border-top-left-radius:3px}.nav-tabs-custom>.nav-tabs>li{border-top:3px solid transparent;margin-bottom:-2px;margin-right:5px}.nav-tabs-custom>.nav-tabs>li>a{color:#444;border-radius:0}.nav-tabs-custom>.nav-tabs>li>a.text-muted{color:#999}.nav-tabs-custom>.nav-tabs>li>a,.nav-tabs-custom>.nav-tabs>li>a:hover{background:transparent;margin:0}.nav-tabs-custom>.nav-tabs>li>a:hover{color:#999}.nav-tabs-custom>.nav-tabs>li:not(.active)>a:active,.nav-tabs-custom>.nav-tabs>li:not(.active)>a:focus,.nav-tabs-custom>.nav-tabs>li:not(.active)>a:hover{border-color:transparent}.nav-tabs-custom>.nav-tabs>li.active{border-top-color:#3c8dbc}.nav-tabs-custom>.nav-tabs>li.active:hover>a,.nav-tabs-custom>.nav-tabs>li.active>a{background-color:#fff;color:#444}.nav-tabs-custom>.nav-tabs>li.active>a{border-top-color:transparent;border-left-color:#f4f4f4;border-right-color:#f4f4f4}.nav-tabs-custom>.nav-tabs>li:first-of-type{margin-left:0}.nav-tabs-custom>.nav-tabs>li:first-of-type.active>a{border-left-color:transparent}.nav-tabs-custom>.nav-tabs.pull-right{float:none!important}.nav-tabs-custom>.nav-tabs.pull-right>li{float:right}.nav-tabs-custom>.nav-tabs.pull-right>li:first-of-type{margin-right:0}.nav-tabs-custom>.nav-tabs.pull-right>li:first-of-type>a{border-left-width:1px}.nav-tabs-custom>.nav-tabs.pull-right>li:first-of-type.active>a{border-left-color:#f4f4f4;border-right-color:transparent}.nav-tabs-custom>.nav-tabs>li.header{line-height:35px;padding:0 10px;font-size:20px;color:#444}.nav-tabs-custom>.nav-tabs>li.header>.fa,.nav-tabs-custom>.nav-tabs>li.header>.glyphicon,.nav-tabs-custom>.nav-tabs>li.header>.ion{margin-right:5px}.nav-tabs-custom>.tab-content{background:#fff;padding:10px;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.nav-tabs-custom .dropdown.open>a:active,.nav-tabs-custom .dropdown.open>a:focus{background:transparent;color:#999}.nav-tabs-custom.tab-primary>.nav-tabs>li.active{border-top-color:#3c8dbc}.nav-tabs-custom.tab-info>.nav-tabs>li.active{border-top-color:#00c0ef}.nav-tabs-custom.tab-danger>.nav-tabs>li.active{border-top-color:#dd4b39}.nav-tabs-custom.tab-warning>.nav-tabs>li.active{border-top-color:#f39c12}.nav-tabs-custom.tab-success>.nav-tabs>li.active{border-top-color:#00a65a}.nav-tabs-custom.tab-default>.nav-tabs>li.active{border-top-color:#d2d6de}.pagination>li>a{background:#fafafa;color:#666}.pagination.pagination-flat>li>a{border-radius:0!important}.products-list{list-style:none;margin:0;padding:0}.products-list>.item{border-radius:3px;box-shadow:0 1px 1px rgba(0,0,0,.1);padding:10px 0;background:#fff}.products-list>.item:after,.products-list>.item:before{content:\\\" \\\";display:table}.products-list>.item:after{clear:both}.products-list .product-img{float:left}.products-list .product-img img{width:50px;height:50px}.products-list .product-info{margin-left:60px}.products-list .product-title{font-weight:600}.products-list .product-description{display:block;color:#999;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.product-list-in-box>.item{box-shadow:none;border-radius:0;border-bottom:1px solid #f4f4f4}.product-list-in-box>.item:last-of-type{border-bottom-width:0}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{border-top:1px solid #f4f4f4}.table>thead>tr>th{border-bottom:2px solid #f4f4f4}.table tr td .progress{margin-top:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #f4f4f4}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table.no-border,.table.no-border td,.table.no-border th{border:0}table.text-center,table.text-center td,table.text-center th{text-align:center}.table.align th{text-align:left}.table.align td{text-align:right}.label-default{background-color:#d2d6de;color:#444}.direct-chat .box-body{border-bottom-right-radius:0;border-bottom-left-radius:0;position:relative;overflow-x:hidden;padding:0}.direct-chat-messages,.direct-chat.chat-pane-open .direct-chat-contacts{transform:translate(0)}.direct-chat-messages{padding:10px;height:250px;overflow:auto}.direct-chat-msg,.direct-chat-text{display:block}.direct-chat-msg{margin-bottom:10px}.direct-chat-msg:after,.direct-chat-msg:before{content:\\\" \\\";display:table}.direct-chat-msg:after{clear:both}.direct-chat-contacts,.direct-chat-messages{transition:transform .5s ease-in-out}.direct-chat-text{border-radius:5px;position:relative;padding:5px 10px;background:#d2d6de;border:1px solid #d2d6de;margin:5px 0 0 50px;color:#444}.direct-chat-text:after,.direct-chat-text:before{position:absolute;right:100%;top:15px;border:solid transparent;border-right-color:#d2d6de;content:\\\" \\\";height:0;width:0;pointer-events:none}.direct-chat-text:after{border-width:5px;margin-top:-5px}.direct-chat-text:before{border-width:6px;margin-top:-6px}.right .direct-chat-text{margin-right:50px;margin-left:0}.right .direct-chat-text:after,.right .direct-chat-text:before{right:auto;left:100%;border-right-color:transparent;border-left-color:#d2d6de}.direct-chat-img{border-radius:50%;float:left;width:40px;height:40px}.right .direct-chat-img{float:right}.direct-chat-info{display:block;margin-bottom:2px;font-size:12px}.direct-chat-name{font-weight:600}.direct-chat-timestamp{color:#999}.direct-chat-contacts-open .direct-chat-contacts{transform:translate(0)}.direct-chat-contacts{transform:translate(101%);position:absolute;top:0;bottom:0;height:250px;width:100%;background:#222d32;color:#fff;overflow:auto}.contacts-list>li{border-bottom:1px solid rgba(0,0,0,.2);padding:10px;margin:0}.contacts-list>li:after,.contacts-list>li:before{content:\\\" \\\";display:table}.contacts-list>li:after{clear:both}.contacts-list>li:last-of-type{border-bottom:none}.contacts-list-img{border-radius:50%;width:40px;float:left}.contacts-list-info{margin-left:45px;color:#fff}.contacts-list-name,.contacts-list-status{display:block}.contacts-list-name{font-weight:600}.contacts-list-status{font-size:12px}.contacts-list-date{color:#aaa;font-weight:400}.contacts-list-msg{color:#999}.direct-chat-danger .right>.direct-chat-text{background:#dd4b39;border-color:#dd4b39;color:#fff}.direct-chat-danger .right>.direct-chat-text:after,.direct-chat-danger .right>.direct-chat-text:before{border-left-color:#dd4b39}.direct-chat-primary .right>.direct-chat-text{background:#3c8dbc;border-color:#3c8dbc;color:#fff}.direct-chat-primary .right>.direct-chat-text:after,.direct-chat-primary .right>.direct-chat-text:before{border-left-color:#3c8dbc}.direct-chat-warning .right>.direct-chat-text{background:#f39c12;border-color:#f39c12;color:#fff}.direct-chat-warning .right>.direct-chat-text:after,.direct-chat-warning .right>.direct-chat-text:before{border-left-color:#f39c12}.direct-chat-info .right>.direct-chat-text{background:#00c0ef;border-color:#00c0ef;color:#fff}.direct-chat-info .right>.direct-chat-text:after,.direct-chat-info .right>.direct-chat-text:before{border-left-color:#00c0ef}.direct-chat-success .right>.direct-chat-text{background:#00a65a;border-color:#00a65a;color:#fff}.direct-chat-success .right>.direct-chat-text:after,.direct-chat-success .right>.direct-chat-text:before{border-left-color:#00a65a}.users-list>li{width:25%;float:left;padding:10px;text-align:center}.users-list>li img{border-radius:50%;max-width:100%;height:auto}.users-list>li>a:hover,.users-list>li>a:hover .users-list-name{color:#999}.users-list-date,.users-list-name{display:block}.users-list-name{font-weight:600;color:#444;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.users-list-date{color:#999;font-size:12px}.carousel-control.left,.carousel-control.right{background-image:none}.carousel-control>.fa{font-size:40px;position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-20px}.modal{background:rgba(0,0,0,.3)}.modal-content{border-radius:0;box-shadow:0 2px 3px rgba(0,0,0,.125);border:0}@media (min-width:768px){.modal-content{box-shadow:0 2px 3px rgba(0,0,0,.125)}}.modal-header{border-bottom-color:#f4f4f4}.modal-footer{border-top-color:#f4f4f4}.modal-primary .modal-footer,.modal-primary .modal-header{border-color:#307095}.modal-warning .modal-footer,.modal-warning .modal-header{border-color:#c87f0a}.modal-info .modal-footer,.modal-info .modal-header{border-color:#0097bc}.modal-success .modal-footer,.modal-success .modal-header{border-color:#00733e}.modal-danger .modal-footer,.modal-danger .modal-header{border-color:#c23321}.box-widget{border:none;position:relative}.widget-user .widget-user-header{padding:20px;height:120px;border-top-right-radius:3px;border-top-left-radius:3px}.widget-user .widget-user-username{margin-top:0;margin-bottom:5px;font-size:25px;font-weight:300;text-shadow:0 1px 1px rgba(0,0,0,.2)}.widget-user .widget-user-desc{margin-top:0}.widget-user .widget-user-image{position:absolute;top:65px;left:50%;margin-left:-45px}.widget-user .widget-user-image>img{width:90px;height:auto;border:3px solid #fff}.widget-user .box-footer{padding-top:30px}.widget-user-2 .widget-user-header{padding:20px;border-top-right-radius:3px;border-top-left-radius:3px}.widget-user-2 .widget-user-username{margin-top:5px;margin-bottom:5px;font-size:25px;font-weight:300}.widget-user-2 .widget-user-desc{margin-top:0}.widget-user-2 .widget-user-desc,.widget-user-2 .widget-user-username{margin-left:75px}.widget-user-2 .widget-user-image>img{width:65px;height:auto;float:left}.mailbox-messages>.table{margin:0}.mailbox-controls{padding:5px}.mailbox-controls.with-border,.mailbox-read-info{border-bottom:1px solid #f4f4f4}.mailbox-read-info{padding:10px}.mailbox-read-info h3{font-size:20px;margin:0}.mailbox-read-info h5{margin:0;padding:5px 0 0}.mailbox-read-time{color:#999;font-size:13px}.mailbox-read-message{padding:10px}.mailbox-attachments li{float:left;width:200px;border:1px solid #eee;margin-bottom:10px;margin-right:10px}.mailbox-attachment-name{font-weight:700;color:#666}.mailbox-attachment-icon,.mailbox-attachment-info,.mailbox-attachment-size{display:block}.mailbox-attachment-info{padding:10px;background:#f4f4f4}.mailbox-attachment-size{color:#999;font-size:12px}.mailbox-attachment-icon{text-align:center;font-size:65px;color:#666;padding:20px 10px}.mailbox-attachment-icon.has-img{padding:0}.mailbox-attachment-icon.has-img>img{max-width:100%;height:auto}.lockscreen{background:#d2d6de}.lockscreen-logo{font-size:35px;text-align:center;margin-bottom:25px;font-weight:300}.lockscreen-logo a{color:#444}.lockscreen-wrapper{max-width:400px;margin:0 auto;margin-top:10%}.lockscreen .lockscreen-name{text-align:center;font-weight:600}.lockscreen-item{border-radius:4px;padding:0;background:#fff;position:relative;margin:10px auto 30px;width:290px}.lockscreen-image{border-radius:50%;position:absolute;left:-10px;top:-25px;background:#fff;padding:5px;z-index:10}.lockscreen-image>img{border-radius:50%;width:70px;height:70px}.lockscreen-credentials{margin-left:70px}.lockscreen-credentials .form-control{border:0}.lockscreen-credentials .btn{background-color:#fff;border:0;padding:0 10px}.lockscreen-footer{margin-top:10px}.login-logo,.register-logo{font-size:35px;text-align:center;margin-bottom:25px;font-weight:300}.login-logo a,.register-logo a{color:#444}.login-page,.register-page{background:#d2d6de}.login-box,.register-box{width:360px;margin:7% auto}@media (max-width:768px){.login-box,.register-box{width:90%;margin-top:20px}}.login-box-body,.register-box-body{background:#fff;padding:20px;border-top:0;color:#666}.login-box-body .form-control-feedback,.register-box-body .form-control-feedback{color:#777}.login-box-msg,.register-box-msg{margin:0;text-align:center;padding:0 20px 20px}.social-auth-links{margin:10px 0}.error-page{width:600px;margin:20px auto 0}@media (max-width:991px){.error-page{width:100%}}.error-page>.headline{float:left;font-size:100px;font-weight:300}@media (max-width:991px){.error-page>.headline{float:none;text-align:center}}.error-page>.error-content{margin-left:190px;display:block}@media (max-width:991px){.error-page>.error-content{margin-left:0}}.error-page>.error-content>h3{font-weight:300;font-size:25px}@media (max-width:991px){.error-page>.error-content>h3{text-align:center}}.invoice{position:relative;background:#fff;border:1px solid #f4f4f4;padding:20px;margin:10px 25px}.invoice-title{margin-top:0}.profile-user-img{margin:0 auto;width:100px;padding:3px;border:3px solid #d2d6de}.profile-username{font-size:21px;margin-top:5px}.post{border-bottom:1px solid #d2d6de;margin-bottom:15px;padding-bottom:15px;color:#666}.post:last-of-type{border-bottom:0;margin-bottom:0;padding-bottom:0}.post .user-block{margin-bottom:15px}.btn-social{position:relative;padding-left:44px;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.btn-social>:first-child{position:absolute;left:0;top:0;bottom:0;width:32px;line-height:34px;font-size:1.6em;text-align:center;border-right:1px solid rgba(0,0,0,.2)}.btn-social.btn-lg{padding-left:61px}.btn-social.btn-lg>:first-child{line-height:45px;width:45px;font-size:1.8em}.btn-social.btn-sm{padding-left:38px}.btn-social.btn-sm>:first-child{line-height:28px;width:28px;font-size:1.4em}.btn-social.btn-xs{padding-left:30px}.btn-social.btn-xs>:first-child{line-height:20px;width:20px;font-size:1.2em}.btn-social-icon{position:relative;padding-left:44px;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:34px;width:34px;padding:0}.btn-social-icon>:first-child{position:absolute;left:0;top:0;bottom:0;width:32px;line-height:34px;font-size:1.6em;border-right:1px solid rgba(0,0,0,.2)}.btn-social-icon.btn-lg{padding-left:61px}.btn-social-icon.btn-lg>:first-child{line-height:45px;width:45px;font-size:1.8em}.btn-social-icon.btn-sm{padding-left:38px}.btn-social-icon.btn-sm>:first-child{line-height:28px;width:28px;font-size:1.4em}.btn-social-icon.btn-xs{padding-left:30px}.btn-social-icon.btn-xs>:first-child{line-height:20px;width:20px;font-size:1.2em}.btn-social-icon>:first-child{border:none;text-align:center;width:100%}.btn-social-icon.btn-lg{height:45px;width:45px;padding-left:0;padding-right:0}.btn-social-icon.btn-sm{height:30px;width:30px;padding-left:0;padding-right:0}.btn-social-icon.btn-xs{height:22px;width:22px;padding-left:0;padding-right:0}.btn-adn{color:#fff;background-color:#d87a68;border-color:rgba(0,0,0,.2)}.btn-adn.active,.btn-adn.focus,.btn-adn:active,.btn-adn:focus,.btn-adn:hover,.open>.dropdown-toggle.btn-adn{color:#fff;background-color:#ce563f;border-color:rgba(0,0,0,.2)}.btn-adn.active,.btn-adn:active,.open>.dropdown-toggle.btn-adn{background-image:none}.btn-adn .badge{color:#d87a68;background-color:#fff}.btn-bitbucket{color:#fff;background-color:#205081;border-color:rgba(0,0,0,.2)}.btn-bitbucket.active,.btn-bitbucket.focus,.btn-bitbucket:active,.btn-bitbucket:focus,.btn-bitbucket:hover,.open>.dropdown-toggle.btn-bitbucket{color:#fff;background-color:#163758;border-color:rgba(0,0,0,.2)}.btn-bitbucket.active,.btn-bitbucket:active,.open>.dropdown-toggle.btn-bitbucket{background-image:none}.btn-bitbucket .badge{color:#205081;background-color:#fff}.btn-dropbox{color:#fff;background-color:#1087dd;border-color:rgba(0,0,0,.2)}.btn-dropbox.active,.btn-dropbox.focus,.btn-dropbox:active,.btn-dropbox:focus,.btn-dropbox:hover,.open>.dropdown-toggle.btn-dropbox{color:#fff;background-color:#0d6aad;border-color:rgba(0,0,0,.2)}.btn-dropbox.active,.btn-dropbox:active,.open>.dropdown-toggle.btn-dropbox{background-image:none}.btn-dropbox .badge{color:#1087dd;background-color:#fff}.btn-facebook{color:#fff;background-color:#3b5998;border-color:rgba(0,0,0,.2)}.btn-facebook.active,.btn-facebook.focus,.btn-facebook:active,.btn-facebook:focus,.btn-facebook:hover,.open>.dropdown-toggle.btn-facebook{color:#fff;background-color:#2d4373;border-color:rgba(0,0,0,.2)}.btn-facebook.active,.btn-facebook:active,.open>.dropdown-toggle.btn-facebook{background-image:none}.btn-facebook .badge{color:#3b5998;background-color:#fff}.btn-flickr{color:#fff;background-color:#ff0084;border-color:rgba(0,0,0,.2)}.btn-flickr.active,.btn-flickr.focus,.btn-flickr:active,.btn-flickr:focus,.btn-flickr:hover,.open>.dropdown-toggle.btn-flickr{color:#fff;background-color:#cc006a;border-color:rgba(0,0,0,.2)}.btn-flickr.active,.btn-flickr:active,.open>.dropdown-toggle.btn-flickr{background-image:none}.btn-flickr .badge{color:#ff0084;background-color:#fff}.btn-foursquare{color:#fff;background-color:#f94877;border-color:rgba(0,0,0,.2)}.btn-foursquare.active,.btn-foursquare.focus,.btn-foursquare:active,.btn-foursquare:focus,.btn-foursquare:hover,.open>.dropdown-toggle.btn-foursquare{color:#fff;background-color:#f71752;border-color:rgba(0,0,0,.2)}.btn-foursquare.active,.btn-foursquare:active,.open>.dropdown-toggle.btn-foursquare{background-image:none}.btn-foursquare .badge{color:#f94877;background-color:#fff}.btn-github{color:#fff;background-color:#444;border-color:rgba(0,0,0,.2)}.btn-github.active,.btn-github.focus,.btn-github:active,.btn-github:focus,.btn-github:hover,.open>.dropdown-toggle.btn-github{color:#fff;background-color:#2b2b2b;border-color:rgba(0,0,0,.2)}.btn-github.active,.btn-github:active,.open>.dropdown-toggle.btn-github{background-image:none}.btn-github .badge{color:#444;background-color:#fff}.btn-google{color:#fff;background-color:#dd4b39;border-color:rgba(0,0,0,.2)}.btn-google.active,.btn-google.focus,.btn-google:active,.btn-google:focus,.btn-google:hover,.open>.dropdown-toggle.btn-google{color:#fff;background-color:#c23321;border-color:rgba(0,0,0,.2)}.btn-google.active,.btn-google:active,.open>.dropdown-toggle.btn-google{background-image:none}.btn-google .badge{color:#dd4b39;background-color:#fff}.btn-instagram{color:#fff;background-color:#3f729b;border-color:rgba(0,0,0,.2)}.btn-instagram.active,.btn-instagram.focus,.btn-instagram:active,.btn-instagram:focus,.btn-instagram:hover,.open>.dropdown-toggle.btn-instagram{color:#fff;background-color:#305777;border-color:rgba(0,0,0,.2)}.btn-instagram.active,.btn-instagram:active,.open>.dropdown-toggle.btn-instagram{background-image:none}.btn-instagram .badge{color:#3f729b;background-color:#fff}.btn-linkedin{color:#fff;background-color:#007bb6;border-color:rgba(0,0,0,.2)}.btn-linkedin.active,.btn-linkedin.focus,.btn-linkedin:active,.btn-linkedin:focus,.btn-linkedin:hover,.open>.dropdown-toggle.btn-linkedin{color:#fff;background-color:#005983;border-color:rgba(0,0,0,.2)}.btn-linkedin.active,.btn-linkedin:active,.open>.dropdown-toggle.btn-linkedin{background-image:none}.btn-linkedin .badge{color:#007bb6;background-color:#fff}.btn-microsoft{color:#fff;background-color:#2672ec;border-color:rgba(0,0,0,.2)}.btn-microsoft.active,.btn-microsoft.focus,.btn-microsoft:active,.btn-microsoft:focus,.btn-microsoft:hover,.open>.dropdown-toggle.btn-microsoft{color:#fff;background-color:#125acd;border-color:rgba(0,0,0,.2)}.btn-microsoft.active,.btn-microsoft:active,.open>.dropdown-toggle.btn-microsoft{background-image:none}.btn-microsoft .badge{color:#2672ec;background-color:#fff}.btn-openid{color:#fff;background-color:#f7931e;border-color:rgba(0,0,0,.2)}.btn-openid.active,.btn-openid.focus,.btn-openid:active,.btn-openid:focus,.btn-openid:hover,.open>.dropdown-toggle.btn-openid{color:#fff;background-color:#da7908;border-color:rgba(0,0,0,.2)}.btn-openid.active,.btn-openid:active,.open>.dropdown-toggle.btn-openid{background-image:none}.btn-openid .badge{color:#f7931e;background-color:#fff}.btn-pinterest{color:#fff;background-color:#cb2027;border-color:rgba(0,0,0,.2)}.btn-pinterest.active,.btn-pinterest.focus,.btn-pinterest:active,.btn-pinterest:focus,.btn-pinterest:hover,.open>.dropdown-toggle.btn-pinterest{color:#fff;background-color:#9f191f;border-color:rgba(0,0,0,.2)}.btn-pinterest.active,.btn-pinterest:active,.open>.dropdown-toggle.btn-pinterest{background-image:none}.btn-pinterest .badge{color:#cb2027;background-color:#fff}.btn-reddit{color:#000;background-color:#eff7ff;border-color:rgba(0,0,0,.2)}.btn-reddit.active,.btn-reddit.focus,.btn-reddit:active,.btn-reddit:focus,.btn-reddit:hover,.open>.dropdown-toggle.btn-reddit{color:#000;background-color:#bcddff;border-color:rgba(0,0,0,.2)}.btn-reddit.active,.btn-reddit:active,.open>.dropdown-toggle.btn-reddit{background-image:none}.btn-reddit .badge{color:#eff7ff;background-color:#000}.btn-soundcloud{color:#fff;background-color:#f50;border-color:rgba(0,0,0,.2)}.btn-soundcloud.active,.btn-soundcloud.focus,.btn-soundcloud:active,.btn-soundcloud:focus,.btn-soundcloud:hover,.open>.dropdown-toggle.btn-soundcloud{color:#fff;background-color:#c40;border-color:rgba(0,0,0,.2)}.btn-soundcloud.active,.btn-soundcloud:active,.open>.dropdown-toggle.btn-soundcloud{background-image:none}.btn-soundcloud .badge{color:#f50;background-color:#fff}.btn-tumblr{color:#fff;background-color:#2c4762;border-color:rgba(0,0,0,.2)}.btn-tumblr.active,.btn-tumblr.focus,.btn-tumblr:active,.btn-tumblr:focus,.btn-tumblr:hover,.open>.dropdown-toggle.btn-tumblr{color:#fff;background-color:#1c2d3f;border-color:rgba(0,0,0,.2)}.btn-tumblr.active,.btn-tumblr:active,.open>.dropdown-toggle.btn-tumblr{background-image:none}.btn-tumblr .badge{color:#2c4762;background-color:#fff}.btn-twitter{color:#fff;background-color:#55acee;border-color:rgba(0,0,0,.2)}.btn-twitter.active,.btn-twitter.focus,.btn-twitter:active,.btn-twitter:focus,.btn-twitter:hover,.open>.dropdown-toggle.btn-twitter{color:#fff;background-color:#2795e9;border-color:rgba(0,0,0,.2)}.btn-twitter.active,.btn-twitter:active,.open>.dropdown-toggle.btn-twitter{background-image:none}.btn-twitter .badge{color:#55acee;background-color:#fff}.btn-vimeo{color:#fff;background-color:#1ab7ea;border-color:rgba(0,0,0,.2)}.btn-vimeo.active,.btn-vimeo.focus,.btn-vimeo:active,.btn-vimeo:focus,.btn-vimeo:hover,.open>.dropdown-toggle.btn-vimeo{color:#fff;background-color:#1295bf;border-color:rgba(0,0,0,.2)}.btn-vimeo.active,.btn-vimeo:active,.open>.dropdown-toggle.btn-vimeo{background-image:none}.btn-vimeo .badge{color:#1ab7ea;background-color:#fff}.btn-vk{color:#fff;background-color:#587ea3;border-color:rgba(0,0,0,.2)}.btn-vk.active,.btn-vk.focus,.btn-vk:active,.btn-vk:focus,.btn-vk:hover,.open>.dropdown-toggle.btn-vk{color:#fff;background-color:#466482;border-color:rgba(0,0,0,.2)}.btn-vk.active,.btn-vk:active,.open>.dropdown-toggle.btn-vk{background-image:none}.btn-vk .badge{color:#587ea3;background-color:#fff}.btn-yahoo{color:#fff;background-color:#720e9e;border-color:rgba(0,0,0,.2)}.btn-yahoo.active,.btn-yahoo.focus,.btn-yahoo:active,.btn-yahoo:focus,.btn-yahoo:hover,.open>.dropdown-toggle.btn-yahoo{color:#fff;background-color:#500a6f;border-color:rgba(0,0,0,.2)}.btn-yahoo.active,.btn-yahoo:active,.open>.dropdown-toggle.btn-yahoo{background-image:none}.btn-yahoo .badge{color:#720e9e;background-color:#fff}.fc-button{background:#f4f4f4;background-image:none;color:#444;border-color:#ddd;border-bottom-color:#ddd}.fc-button.hover,.fc-button:active,.fc-button:hover{background-color:#e9e9e9}.fc-header-title h2{font-size:15px;line-height:1.6em;color:#666;margin-left:10px}.fc-header-right{padding-right:10px}.fc-header-left{padding-left:10px}.fc-widget-header{background:#fafafa}.fc-grid{width:100%;border:0}.fc-widget-content:first-of-type,.fc-widget-header:first-of-type{border-left:0;border-right:0}.fc-widget-content:last-of-type,.fc-widget-header:last-of-type{border-right:0}.fc-toolbar{padding:10px;margin:0}.fc-day-number{font-size:20px;font-weight:300;padding-right:10px}.fc-color-picker{list-style:none;margin:0;padding:0}.fc-color-picker>li{float:left;font-size:30px;margin-right:5px;line-height:30px}.fc-color-picker>li .fa{transition:transform .3s linear}.fc-color-picker>li .fa:hover{transform:rotate(30deg)}#add-new-event{transition:all .3s linear}.external-event{padding:5px 10px;font-weight:700;margin-bottom:4px;box-shadow:0 1px 1px rgba(0,0,0,.1);text-shadow:0 1px 1px rgba(0,0,0,.1);border-radius:3px;cursor:move}.external-event:hover{box-shadow:inset 0 0 90px rgba(0,0,0,.2)}.select2-container--default.select2-container--focus,.select2-container--default:active,.select2-container--default:focus,.select2-selection.select2-container--focus,.select2-selection:active,.select2-selection:focus{outline:none}.select2-container--default .select2-selection--single,.select2-selection .select2-selection--single{border:1px solid #d2d6de;border-radius:0;padding:6px 12px;height:34px}.select2-container--default.select2-container--open{border-color:#3c8dbc}.select2-dropdown{border:1px solid #d2d6de;border-radius:0}.select2-container--default .select2-results__option--highlighted[aria-selected]{background-color:#3c8dbc;color:#fff}.select2-results__option{padding:6px 12px;user-select:none;-webkit-user-select:none}.select2-container .select2-selection--single .select2-selection__rendered{padding-left:0;padding-right:0;height:auto;margin-top:-4px}.select2-container[dir=rtl] .select2-selection--single .select2-selection__rendered{padding-right:6px;padding-left:20px}.select2-container--default .select2-selection--single .select2-selection__arrow{height:28px;right:3px}.select2-container--default .select2-selection--single .select2-selection__arrow b{margin-top:0}.select2-dropdown .select2-search__field,.select2-search--inline .select2-search__field{border:1px solid #d2d6de}.select2-dropdown .select2-search__field:focus,.select2-search--inline .select2-search__field:focus{outline:none;border:1px solid #3c8dbc}.select2-container--default .select2-results__option[aria-disabled=true]{color:#999}.select2-container--default .select2-results__option[aria-selected=true]{background-color:#ddd}.select2-container--default .select2-results__option[aria-selected=true],.select2-container--default .select2-results__option[aria-selected=true]:hover{color:#444}.select2-container--default .select2-selection--multiple{border:1px solid #d2d6de;border-radius:0}.select2-container--default .select2-selection--multiple:focus{border-color:#3c8dbc}.select2-container--default.select2-container--focus .select2-selection--multiple{border-color:#d2d6de}.select2-container--default .select2-selection--multiple .select2-selection__choice{background-color:#3c8dbc;border-color:#367fa9;padding:1px 10px;color:#fff}.select2-container--default .select2-selection--multiple .select2-selection__choice__remove{margin-right:5px;color:hsla(0,0%,100%,.7)}.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover{color:#fff}.select2-container .select2-selection--single .select2-selection__rendered{padding-right:10px}.pad{padding:10px}.margin{margin:10px}.margin-bottom{margin-bottom:20px}.margin-bottom-none{margin-bottom:0}.margin-r-5{margin-right:5px}.inline{display:inline}.description-block{display:block;margin:10px 0;text-align:center}.description-block.margin-bottom{margin-bottom:25px}.description-block>.description-header{margin:0;padding:0;font-weight:600;font-size:16px}.description-block>.description-text{text-transform:uppercase}.alert-danger,.alert-error,.alert-info,.alert-success,.alert-warning,.bg-aqua,.bg-aqua-active,.bg-black,.bg-black-active,.bg-blue,.bg-blue-active,.bg-fuchsia,.bg-fuchsia-active,.bg-green,.bg-green-active,.bg-light-blue,.bg-light-blue-active,.bg-lime,.bg-lime-active,.bg-maroon,.bg-maroon-active,.bg-navy,.bg-navy-active,.bg-olive,.bg-olive-active,.bg-orange,.bg-orange-active,.bg-purple,.bg-purple-active,.bg-red,.bg-red-active,.bg-teal,.bg-teal-active,.bg-yellow,.bg-yellow-active,.callout.callout-danger,.callout.callout-info,.callout.callout-success,.callout.callout-warning,.label-danger,.label-info,.label-primary,.label-success,.label-warning,.modal-danger .modal-body,.modal-danger .modal-footer,.modal-danger .modal-header,.modal-info .modal-body,.modal-info .modal-footer,.modal-info .modal-header,.modal-primary .modal-body,.modal-primary .modal-footer,.modal-primary .modal-header,.modal-success .modal-body,.modal-success .modal-footer,.modal-success .modal-header,.modal-warning .modal-body,.modal-warning .modal-footer,.modal-warning .modal-header{color:#fff!important}.bg-gray{color:#000;background-color:#d2d6de!important}.bg-gray-light{background-color:#f7f7f7}.bg-black{background-color:#111!important}.alert-danger,.alert-error,.bg-red,.callout.callout-danger,.label-danger,.modal-danger .modal-body{background-color:#dd4b39!important}.alert-warning,.bg-yellow,.callout.callout-warning,.label-warning,.modal-warning .modal-body{background-color:#f39c12!important}.alert-info,.bg-aqua,.callout.callout-info,.label-info,.modal-info .modal-body{background-color:#00c0ef!important}.bg-blue{background-color:#0073b7!important}.bg-light-blue,.label-primary,.modal-primary .modal-body{background-color:#3c8dbc!important}.alert-success,.bg-green,.callout.callout-success,.label-success,.modal-success .modal-body{background-color:#00a65a!important}.bg-navy{background-color:#001f3f!important}.bg-teal{background-color:#39cccc!important}.bg-olive{background-color:#3d9970!important}.bg-lime{background-color:#01ff70!important}.bg-orange{background-color:#ff851b!important}.bg-fuchsia{background-color:#f012be!important}.bg-purple{background-color:#605ca8!important}.bg-maroon{background-color:#d81b60!important}.bg-gray-active{color:#000;background-color:#b5bbc8!important}.bg-black-active{background-color:#000!important}.bg-red-active,.modal-danger .modal-footer,.modal-danger .modal-header{background-color:#d33724!important}.bg-yellow-active,.modal-warning .modal-footer,.modal-warning .modal-header{background-color:#db8b0b!important}.bg-aqua-active,.modal-info .modal-footer,.modal-info .modal-header{background-color:#00a7d0!important}.bg-blue-active{background-color:#005384!important}.bg-light-blue-active,.modal-primary .modal-footer,.modal-primary .modal-header{background-color:#357ca5!important}.bg-green-active,.modal-success .modal-footer,.modal-success .modal-header{background-color:#008d4c!important}.bg-navy-active{background-color:#001a35!important}.bg-teal-active{background-color:#30bbbb!important}.bg-olive-active{background-color:#368763!important}.bg-lime-active{background-color:#00e765!important}.bg-orange-active{background-color:#ff7701!important}.bg-fuchsia-active{background-color:#db0ead!important}.bg-purple-active{background-color:#555299!important}.bg-maroon-active{background-color:#ca195a!important}[class^=bg-].disabled{opacity:.65;filter:alpha(opacity=65)}.text-red{color:#dd4b39!important}.text-yellow{color:#f39c12!important}.text-aqua{color:#00c0ef!important}.text-blue{color:#0073b7!important}.text-black{color:#111!important}.text-light-blue{color:#3c8dbc!important}.text-green{color:#00a65a!important}.text-gray{color:#d2d6de!important}.text-navy{color:#001f3f!important}.text-teal{color:#39cccc!important}.text-olive{color:#3d9970!important}.text-lime{color:#01ff70!important}.text-orange{color:#ff851b!important}.text-fuchsia{color:#f012be!important}.text-purple{color:#605ca8!important}.text-maroon{color:#d81b60!important}.link-muted{color:#7a869d}.link-muted:focus,.link-muted:hover{color:#606c84}.link-black{color:#666}.link-black:focus,.link-black:hover{color:#999}.hide{display:none!important}.no-border{border:0!important}.no-padding{padding:0!important}.no-margin{margin:0!important}.no-shadow{box-shadow:none!important}.chart-legend,.contacts-list,.list-unstyled,.mailbox-attachments,.users-list{list-style:none;margin:0;padding:0}.list-group-unbordered>.list-group-item{border-left:0;border-right:0;border-radius:0;padding-left:0;padding-right:0}.flat{border-radius:0!important}.text-bold,.text-bold.table td,.text-bold.table th{font-weight:700}.text-sm{font-size:12px}.jqstooltip{padding:5px!important;width:auto!important;height:auto!important}.bg-teal-gradient{background:#39cccc!important;background:-o-linear-gradient(#7adddd,#39cccc)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\\\" #7adddd\\\",endColorstr=\\\" #39cccc\\\",GradientType=0)!important;color:#fff}.bg-light-blue-gradient{background:#3c8dbc!important;background:-o-linear-gradient(#67a8ce,#3c8dbc)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\\\" #67a8ce\\\",endColorstr=\\\" #3c8dbc\\\",GradientType=0)!important;color:#fff}.bg-blue-gradient{background:#0073b7!important;background:-o-linear-gradient(#0089db,#0073b7)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\\\" #0089db\\\",endColorstr=\\\" #0073b7\\\",GradientType=0)!important;color:#fff}.bg-aqua-gradient{background:#00c0ef!important;background:-o-linear-gradient(#14d1ff,#00c0ef)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\\\" #14d1ff\\\",endColorstr=\\\" #00c0ef\\\",GradientType=0)!important;color:#fff}.bg-yellow-gradient{background:#f39c12!important;background:-o-linear-gradient(#f7bc60,#f39c12)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\\\" #f7bc60\\\",endColorstr=\\\" #f39c12\\\",GradientType=0)!important;color:#fff}.bg-purple-gradient{background:#605ca8!important;background:-o-linear-gradient(#9491c4,#605ca8)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\\\" #9491c4\\\",endColorstr=\\\" #605ca8\\\",GradientType=0)!important;color:#fff}.bg-green-gradient{background:#00a65a!important;background:-o-linear-gradient(#00ca6d,#00a65a)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\\\" #00ca6d\\\",endColorstr=\\\" #00a65a\\\",GradientType=0)!important;color:#fff}.bg-red-gradient{background:#dd4b39!important;background:-o-linear-gradient(#e47365,#dd4b39)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\\\" #e47365\\\",endColorstr=\\\" #dd4b39\\\",GradientType=0)!important;color:#fff}.bg-black-gradient{background:#111!important;background:-o-linear-gradient(#2b2b2b,#111)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\\\" #2b2b2b\\\",endColorstr=\\\" #111111\\\",GradientType=0)!important;color:#fff}.bg-maroon-gradient{background:#d81b60!important;background:-o-linear-gradient(#e73f7c,#d81b60)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\\\" #e73f7c\\\",endColorstr=\\\" #d81b60\\\",GradientType=0)!important;color:#fff}.description-block .description-icon{font-size:16px}.no-pad-top{padding-top:0}.position-static{position:static!important}.list-header{font-size:15px;padding:10px 4px;font-weight:700;color:#666}.list-seperator{height:1px;background:#f4f4f4;margin:15px 0 9px}.list-link>a{padding:4px;color:#777}.list-link>a:hover{color:#222}.font-light{font-weight:300}.user-block:after,.user-block:before{content:\\\" \\\";display:table}.user-block:after{clear:both}.user-block img{width:40px;height:40px;float:left}.user-block .comment,.user-block .description,.user-block .username{display:block;margin-left:50px}.user-block .username{font-size:16px;font-weight:600}.user-block .description{color:#999;font-size:13px}.user-block.user-block-sm .comment,.user-block.user-block-sm .description,.user-block.user-block-sm .username{margin-left:40px}.user-block.user-block-sm .username{font-size:14px}.box-comments .box-comment img,.img-lg,.img-md,.img-sm,.user-block.user-block-sm img{float:left}.box-comments .box-comment img,.img-sm,.user-block.user-block-sm img{width:30px!important;height:30px!important}.img-sm+.img-push{margin-left:40px}.img-md{width:60px;height:60px}.img-md+.img-push{margin-left:70px}.img-lg{width:100px;height:100px}.img-lg+.img-push{margin-left:110px}.img-bordered{border:3px solid #d2d6de;padding:3px}.img-bordered-sm{border:2px solid #d2d6de;padding:2px}.attachment-block{border:1px solid #f4f4f4;padding:5px;margin-bottom:10px;background:#f7f7f7}.attachment-block .attachment-img{max-width:100px;max-height:100px;height:auto;float:left}.attachment-block .attachment-pushed{margin-left:110px}.attachment-block .attachment-heading{margin:0}.attachment-block .attachment-text{color:#555}.connectedSortable{min-height:100px}.ui-helper-hidden-accessible{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sort-highlight{background:#f4f4f4;border:1px dashed #ddd;margin-bottom:10px}.full-opacity-hover{opacity:.65;filter:alpha(opacity=65)}.full-opacity-hover:hover{opacity:1;filter:alpha(opacity=100)}.chart{position:relative;overflow:hidden;width:100%}.chart canvas,.chart svg{width:100%!important}@media print{.content-header,.left-side,.main-header,.main-sidebar,.no-print{display:none!important}.content-wrapper,.main-footer,.right-side{margin-left:0!important;min-height:0!important;transform:translate(0)!important}.fixed .content-wrapper,.fixed .right-side{padding-top:0!important}.invoice{width:100%;border:0;margin:0;padding:0}.invoice-col{float:left;width:33.3333333%}.table-responsive{overflow:auto}.table-responsive>.table tr td,.table-responsive>.table tr th{white-space:normal!important}}", ""]);
	
	// exports


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(20);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(232)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./skin-blue.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./skin-blue.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(250)();
	// imports
	
	
	// module
	exports.push([module.id, ".skin-blue .main-header .navbar{background-color:#3c8dbc}.skin-blue .main-header .navbar .nav>li>a{color:#fff}.skin-blue .main-header .navbar .nav .open>a,.skin-blue .main-header .navbar .nav .open>a:focus,.skin-blue .main-header .navbar .nav .open>a:hover,.skin-blue .main-header .navbar .nav>.active>a,.skin-blue .main-header .navbar .nav>li>a:active,.skin-blue .main-header .navbar .nav>li>a:focus,.skin-blue .main-header .navbar .nav>li>a:hover,.skin-blue .main-header .navbar .sidebar-toggle:hover{background:rgba(0,0,0,.1);color:#f6f6f6}.skin-blue .main-header .navbar .sidebar-toggle{color:#fff}.skin-blue .main-header .navbar .sidebar-toggle:hover{background-color:#367fa9}@media (max-width:767px){.skin-blue .main-header .navbar .dropdown-menu li.divider{background-color:hsla(0,0%,100%,.1)}.skin-blue .main-header .navbar .dropdown-menu li a{color:#fff}.skin-blue .main-header .navbar .dropdown-menu li a:hover{background:#367fa9}}.skin-blue .main-header .logo{background-color:#367fa9;color:#fff;border-bottom:0 solid transparent}.skin-blue .main-header .logo:hover{background-color:#357ca5}.skin-blue .main-header li.user-header{background-color:#3c8dbc}.skin-blue .content-header{background:transparent}.skin-blue .left-side,.skin-blue .main-sidebar,.skin-blue .wrapper{background-color:#222d32;overflow:auto}.skin-blue .user-panel>.info,.skin-blue .user-panel>.info>a{color:#fff}.skin-blue .sidebar-menu>li.header{color:#4b646f;background:#1a2226}.skin-blue .sidebar-menu>li>a{border-left:3px solid transparent}.skin-blue .sidebar-menu>li.active>a,.skin-blue .sidebar-menu>li:hover>a{color:#fff;background:#1e282c;border-left-color:#3c8dbc}.skin-blue .sidebar-menu>li>.treeview-menu{margin:0 1px;background:#2c3b41}.skin-blue .sidebar a{color:#b8c7ce}.skin-blue .sidebar a:hover{text-decoration:none}.skin-blue .treeview-menu>li>a{color:#8aa4af}.skin-blue .treeview-menu>li.active>a,.skin-blue .treeview-menu>li>a:hover{color:#fff}.skin-blue .sidebar-form{border-radius:3px;border:1px solid #374850;margin:10px}.skin-blue .sidebar-form .btn,.skin-blue .sidebar-form input[type=text]{box-shadow:none;background-color:#374850;border:1px solid transparent;height:35px}.skin-blue .sidebar-form input[type=text]{color:#666;border-top-left-radius:2px;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:2px}.skin-blue .sidebar-form input[type=text]:focus,.skin-blue .sidebar-form input[type=text]:focus+.input-group-btn .btn{background-color:#fff;color:#666}.skin-blue .sidebar-form input[type=text]:focus+.input-group-btn .btn{border-left-color:#fff}.skin-blue .sidebar-form .btn{color:#999;border-top-left-radius:0;border-top-right-radius:2px;border-bottom-right-radius:2px;border-bottom-left-radius:0}.skin-blue.layout-top-nav .main-header>.logo{background-color:#3c8dbc;color:#fff;border-bottom:0 solid transparent}.skin-blue.layout-top-nav .main-header>.logo:hover{background-color:#3b8ab8}", ""]);
	
	// exports


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(22);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(232)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./bootstrap-v-tabs.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./bootstrap-v-tabs.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(250)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\\n * bootstrap-vertical-tabs - v1.2.1\\n * https://dbtek.github.io/bootstrap-vertical-tabs\\n * 2014-11-07\\n * Copyright (c) 2014 İsmail Demirbilek\\n * License: MIT\\n */.tabs-left,.tabs-right{border-bottom:none;padding-top:2px}.tabs-left{border-right:1px solid #ddd}.tabs-right{border-left:1px solid #ddd}.tabs-left>li,.tabs-right>li{float:none;margin-bottom:2px}.tabs-left>li{margin-right:-1px}.tabs-right>li{margin-left:-1px}.tabs-left>li>a{border:1px transparent!important}.tabs-left>li>a:first-child{border-top:1px transparent}.tabs-left>li.active>a,.tabs-left>li.active>a:focus,.tabs-left>li.active>a:hover{border-bottom-color:#ddd;border-right-color:transparent}.tabs-right>li.active>a,.tabs-right>li.active>a:focus,.tabs-right>li.active>a:hover{border-bottom:1px solid #ddd;border-left-color:transparent}.tabs-left>li>a{display:block}.tabs-left>li>a,.tabs-right>li>a{border-radius:0 0 0 0;margin-right:0}.sideways{margin-top:50px;border:none;position:relative}.sideways>li{height:20px;width:120px;margin-bottom:100px}.sideways>li>a{border-bottom:1px solid #ddd;border-right-color:transparent;text-align:center;border-radius:0 0 0 0}.sideways>li.active>a,.sideways>li.active>a:focus,.sideways>li.active>a:hover{border-bottom-color:transparent;border-right-color:#ddd;border-left-color:#ddd}.sideways.tabs-left{left:-50px}.sideways.tabs-right{right:-50px}.sideways.tabs-right>li{transform:rotate(90deg)}.sideways.tabs-left>li{transform:rotate(-90deg)}", ""]);
	
	// exports


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(24);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(232)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(250)();
	// imports
	
	
	// module
	exports.push([module.id, ".color-content-bg{min-height:50px;margin:15px auto;border:1px dashed #000}.color-content-fg{padding:15px;min-height:90%;margin:15px;border:1px dashed #000}.portlet>.portlet-title>.caption{display:inline-block;font-size:18px;line-height:18px;padding:10px 0}.portlet>.portlet-title{border-bottom:1px solid #eee;margin-bottom:10px;min-height:41px;padding:0}.portlet>.portlet-title>.actions{display:inline-block;float:right;padding:6px 0}a,a:hover,a label,i{cursor:pointer!important}form .box.box-warning{min-height:300px}.box-body .fa,table .fa{font-size:18px;margin:0 4px}.sort-icon{display:inline-block;position:relative;top:1px;left:-5px}.sort-icon i{border-left:5px solid transparent;border-right:5px solid transparent;display:block;margin:2px 0 2px 6px;position:relative;top:4px}.si-sort-asc{border-bottom:6px solid silver}.si-sort-asc.active{border-bottom:6px solid #424242}.si-sort-desc{border-top:6px solid silver}.si-sort-desc.active{border-top:6px solid #424242}.panel-default.edit{position:relative}.panel-default.edit .panel-heading{padding:10px 9px}.panel-default.edit .loader{background-color:hsla(0,0%,100%,.85);height:100%;left:0;position:absolute;top:0;width:100%}.panel-default.edit .loader span{color:#000;position:relative;top:50%;left:50%;margin:-12px 0 0 -12px}.panel-default.edit .panel-heading .pull-left{position:relative;padding-right:17px;width:100%}.panel-default.edit .panel-heading .pull-left input[type=checkbox]{position:absolute;top:5px;right:-3px}.portlet.box.yellow-crusta>.portlet-title{background-color:#f3c200}.portlet.box{border:none;border-color:-moz-use-text-color #ffd327 #ffd327;border-image:none;border-style:none solid solid;border-width:0 1px 1px}.portlet.box.blue-hoki{border:none;border-color:-moz-use-text-color #869ab3 #869ab3;border-image:none;border-style:none solid solid;border-width:0 1px 1px}.portlet.box.blue-hoki>.portlet-title{background-color:#67809f}.portlet.box{padding:0!important}.portlet{border-radius:4px;margin-bottom:25px;margin-top:0;padding:0}.portlet.box.green-meadow{border:none;border-color:-moz-use-text-color #2ae0bb #2ae0bb;border-image:none;border-style:none solid solid;border-width:0 1px 1px}.portlet.box.green-meadow>.portlet-title{background-color:#1bbc9b}.portlet.box.red-sunglo{border:none;border-color:-moz-use-text-color #ea9595 #ea9595;border-image:none;border-style:none solid solid;border-width:0 1px 1px}.portlet.box.red-sunglo>.portlet-title{background-color:#e26a6a}.portlet.light .portlet-body{padding-top:8px}.portlet.box>.portlet-body{background-color:#fff;padding:15px}.portlet>.portlet-body{border-radius:0 0 4px 4px;clear:both}.static-info .name{font-size:14px}.portlet.box>.portlet-title{border-bottom:0 none;color:#fff;margin-bottom:0;padding:0 10px}.portlet{border-radius:0}.portlet.box.grey-cascade{border:none;border-color:-moz-use-text-color #b1bdbd #b1bdbd;border-image:none;border-style:none solid solid;border-width:0 1px 1px}.portlet.box.grey-cascade>.portlet-title,.portlet.grey-cascade,.portlet>.portlet-body.grey-cascade{background-color:#95a5a6}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:6px}.table-responsive{table-layout:fixed}.table-responsive input{max-width:100%}.box.box-primary.pricing input[type=number],.box.box-primary.pricing input[type=text]{width:105px}.width-height-box th{font-weight:lighter;padding:0 4px}.width-height-box td{padding:4px}.commentbox-padding{padding:0 20px}.commentbox-remove{position:absolute}.commentbox-text{word-wrap:break-word}.timestamp{color:gray;font-style:italic}.box-profile p{margin:0}.domain-code{position:absolute;left:50%;width:36px;margin-left:-18px}.order-status .label{border:1px solid #67809f;font-weight:600;color:#000}.btn-new,.label-new{background-color:#d9e1f2;border-color:#67809f}.btn-prod,.label-prod{background-color:#2f75b5;border-color:#008d4c;color:#fff!important}.btn-ready-to-ship,.label-ready-to-ship{background-color:#ff0;border-color:#008d4c}.btn-shipped,.label-shipped{background-color:#ffe699;border-color:#008d4c}.btn-invoiced,.label-invoiced{background-color:#c6e0b4;border-color:#008d4c}.btn-paid,.label-paid{background-color:#92d050;border-color:#008d4c}.btn-reminder,.label-reminder{background-color:#f39c12;border-color:#008d4c}.btn-cancelled,.label-cancelled{background-color:red;border-color:#008d4c}.btn-remake{background-color:#7030a0;border-color:#008d4c;color:#fff!important}.btn-create-invoice,.btn-create-receipt,.btn-create-workorder{background-color:#00a65a;border-color:#00a65a}.btn-create-reminder{background-color:#f31212;border-color:#f31212}@media screen and (max-width:767px){.main-sidebar.open-side{transform:translate(0)}}", ""]);
	
	// exports


/***/ },
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _user = __webpack_require__(371);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userModule = _angular2.default.module('user', []).factory('User', _user2.default).name;
	
	exports.default = userModule;
	
	// WEBPACK FOOTER //

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _auth = __webpack_require__(369);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _auth3 = __webpack_require__(370);
	
	__webpack_require__(429);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginmodule = _angular2.default.module('loginform', [
	//uiRouter,
	'ngStorage']).component('loginform', _auth2.default).service('AuthService', _auth3.AuthService).name;
	
	exports.default = loginmodule;
	
	// WEBPACK FOOTER //

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dbFactory;
	
	var _lokijs = __webpack_require__(441);
	
	var _lokijs2 = _interopRequireDefault(_lokijs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var db = new _lokijs2.default("signlabs", { env: "BROWSER" });
	var collections = [{
	  name: "products",
	  props: {
	    indices: ['id']
	  }
	}, {
	  name: "materials",
	  props: {
	    indices: ['id']
	  }
	}, {
	  name: "colors",
	  props: {
	    indices: ['id']
	  }
	}, {
	  name: "shapes",
	  props: {
	    indices: ['id']
	  }
	}, {
	  name: "fonts",
	  props: {
	    indices: ['id']
	  }
	}, {
	  name: "fix_methods",
	  props: {
	    indices: ['id']
	  }
	}];
	collections.forEach(function (collection) {
	  return db.addCollection(collection.name, collection.props);
	});
	window.db = db;
	function dbFactory() {
	  return db;
	}
	
	// WEBPACK FOOTER //

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Api = function () {
	  Api.$inject = ["$http", "$q", "API_URL"];
	  function Api($http, $q, API_URL) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, Api);
	    this.API_URL = API_URL;
	    this.$http = $http;
	    this.$q = $q;
	  }
	
	  (0, _createClass3.default)(Api, [{
	    key: "call",
	    value: function call(params) {
	
	      var isAbsolute = 0 === params.url.indexOf("http://");
	      if (!isAbsolute) {
	        params.url = this.API_URL + params.url;
	      }
	
	      return this.$http(params).then(function (response) {
	        return response.data;
	      }).catch(function (error) {
	        throw error;
	      });
	    }
	  }]);
	  return Api;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = Api;

/***/ },
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _listing = __webpack_require__(375);
	
	var _listing2 = _interopRequireDefault(_listing);
	
	var _view = __webpack_require__(376);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _order = __webpack_require__(372);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _order2 = __webpack_require__(373);
	
	var _order3 = _interopRequireDefault(_order2);
	
	var _orderDataprovider = __webpack_require__(374);
	
	var _orderDataprovider2 = _interopRequireDefault(_orderDataprovider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('orders', [_angularUiRouter2.default]).component('ordersListing', _listing2.default).component('orderView', _view2.default).service('Orders', _order3.default).service('OrdersDataProvider', _orderDataprovider2.default).config(_order.OrderConfig).name;
	
	// WEBPACK FOOTER //

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dashboard = __webpack_require__(390);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboard3 = __webpack_require__(391);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('dashboard', [_angularUiRouter2.default]).component('dashboard', _dashboard2.default).config(_dashboard3.DashboardConfig).name;
	
	// WEBPACK FOOTER //

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _config = __webpack_require__(377);
	
	var _materials = __webpack_require__(381);
	
	var _materials2 = _interopRequireDefault(_materials);
	
	var _materialSpec = __webpack_require__(382);
	
	var _materialSpec2 = _interopRequireDefault(_materialSpec);
	
	var _materialShapeSpec = __webpack_require__(383);
	
	var _materialShapeSpec2 = _interopRequireDefault(_materialShapeSpec);
	
	var _materialColorSpec = __webpack_require__(384);
	
	var _materialColorSpec2 = _interopRequireDefault(_materialColorSpec);
	
	var _materialFixmethodSpec = __webpack_require__(385);
	
	var _materialFixmethodSpec2 = _interopRequireDefault(_materialFixmethodSpec);
	
	var _materialMode = __webpack_require__(386);
	
	var _materialMode2 = _interopRequireDefault(_materialMode);
	
	var _materialPricing = __webpack_require__(387);
	
	var _materialPricing2 = _interopRequireDefault(_materialPricing);
	
	var _products = __webpack_require__(378);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _productsDataprovider = __webpack_require__(379);
	
	var _productsDataprovider2 = _interopRequireDefault(_productsDataprovider);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _run = __webpack_require__(380);
	
	var _run2 = _interopRequireDefault(_run);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('products', [_angularUiRouter2.default]).component('productMaterials', _materials2.default).component('productMaterialSpec', _materialSpec2.default).component('materialShapes', _materialShapeSpec2.default).component('materialColors', _materialColorSpec2.default).component('materialFixmethods', _materialFixmethodSpec2.default).component('materialMode', _materialMode2.default).component('productMaterialPricing', _materialPricing2.default).service('ProductsService', _products2.default).service('ProductsDataProvider', _productsDataprovider2.default).config(_config.ProductsConfig).run(_run2.default).name;
	
	// WEBPACK FOOTER //

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _parts = __webpack_require__(388);
	
	var _parts2 = _interopRequireDefault(_parts);
	
	var _partsDataprovider = __webpack_require__(389);
	
	var _partsDataprovider2 = _interopRequireDefault(_partsDataprovider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('product-parts', []).service('ProductPartsService', _parts2.default).service('ProductPartsDataProvider', _partsDataprovider2.default).name;
	
	// WEBPACK FOOTER //

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _listing = __webpack_require__(400);
	
	var _listing2 = _interopRequireDefault(_listing);
	
	var _add = __webpack_require__(401);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(402);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _category_listing = __webpack_require__(403);
	
	var _category_listing2 = _interopRequireDefault(_category_listing);
	
	var _category_add = __webpack_require__(404);
	
	var _category_add2 = _interopRequireDefault(_category_add);
	
	var _category_edit = __webpack_require__(405);
	
	var _category_edit2 = _interopRequireDefault(_category_edit);
	
	var _subcategory_listing = __webpack_require__(406);
	
	var _subcategory_listing2 = _interopRequireDefault(_subcategory_listing);
	
	var _subcategory_add = __webpack_require__(407);
	
	var _subcategory_add2 = _interopRequireDefault(_subcategory_add);
	
	var _subcategory_edit = __webpack_require__(408);
	
	var _subcategory_edit2 = _interopRequireDefault(_subcategory_edit);
	
	var _productPage = __webpack_require__(397);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _ngFileUpload = __webpack_require__(430);
	
	var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);
	
	var _productsPages = __webpack_require__(398);
	
	var _productsPages2 = _interopRequireDefault(_productsPages);
	
	var _productsPagesDataprovider = __webpack_require__(399);
	
	var _productsPagesDataprovider2 = _interopRequireDefault(_productsPagesDataprovider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('product-page', [_angularUiRouter2.default, _ngFileUpload2.default]).component('productPagesListing', _listing2.default).component('productPageAdd', _add2.default).component('productPageEdit', _edit2.default).component('productPageCategoryList', _category_listing2.default).component('categoryAdd', _category_add2.default).component('categoryEdit', _category_edit2.default).component('subCategoryList', _subcategory_listing2.default).component('subCategoryAdd', _subcategory_add2.default).component('subCategoryEdit', _subcategory_edit2.default).service('ProductPages', _productsPages2.default).service('ProductPagesDataProvider', _productsPagesDataprovider2.default).config(_productPage.ProductPageConfig).name;
	
	// WEBPACK FOOTER //

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _listing = __webpack_require__(412);
	
	var _listing2 = _interopRequireDefault(_listing);
	
	var _add = __webpack_require__(413);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(414);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _coupon = __webpack_require__(409);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _coupon2 = __webpack_require__(410);
	
	var _coupon3 = _interopRequireDefault(_coupon2);
	
	var _couponDataprovider = __webpack_require__(411);
	
	var _couponDataprovider2 = _interopRequireDefault(_couponDataprovider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('coupons', [_angularUiRouter2.default]).component('couponsListing', _listing2.default).component('couponsAdd', _add2.default).component('couponsEdit', _edit2.default).service('Coupons', _coupon3.default).service('CouponsDataProvider', _couponDataprovider2.default).config(_coupon.CouponConfig).name;
	
	// WEBPACK FOOTER //

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _send = __webpack_require__(395);
	
	var _send2 = _interopRequireDefault(_send);
	
	var _subscribers = __webpack_require__(396);
	
	var _subscribers2 = _interopRequireDefault(_subscribers);
	
	var _newsletter = __webpack_require__(392);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _newsletter2 = __webpack_require__(393);
	
	var _newsletter3 = _interopRequireDefault(_newsletter2);
	
	var _newsletterDataprovider = __webpack_require__(394);
	
	var _newsletterDataprovider2 = _interopRequireDefault(_newsletterDataprovider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('newsletters', [_angularUiRouter2.default]).component('newsletter', _send2.default).component('subscriberListing', _subscribers2.default).service('Newsletter', _newsletter3.default).service('NewsletterDataProvider', _newsletterDataprovider2.default).config(_newsletter.NewsletterConfig).name;
	
	// WEBPACK FOOTER //

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _listing = __webpack_require__(418);
	
	var _listing2 = _interopRequireDefault(_listing);
	
	var _view = __webpack_require__(419);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _user = __webpack_require__(415);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _user2 = __webpack_require__(416);
	
	var _user3 = _interopRequireDefault(_user2);
	
	var _userDataprovider = __webpack_require__(417);
	
	var _userDataprovider2 = _interopRequireDefault(_userDataprovider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('users', [_angularUiRouter2.default]).component('usersListing', _listing2.default).component('userView', _view2.default).service('Users', _user3.default).service('UsersDataProvider', _userDataprovider2.default).config(_user.UserConfig).name;
	
	// WEBPACK FOOTER //

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _category_listing = __webpack_require__(424);
	
	var _category_listing2 = _interopRequireDefault(_category_listing);
	
	var _category_add = __webpack_require__(425);
	
	var _category_add2 = _interopRequireDefault(_category_add);
	
	var _category_edit = __webpack_require__(426);
	
	var _category_edit2 = _interopRequireDefault(_category_edit);
	
	var _list = __webpack_require__(427);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _add = __webpack_require__(428);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(423);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _images = __webpack_require__(420);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _ngFileUpload = __webpack_require__(430);
	
	var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);
	
	var _images2 = __webpack_require__(421);
	
	var _images3 = _interopRequireDefault(_images2);
	
	var _imagesDataprovider = __webpack_require__(422);
	
	var _imagesDataprovider2 = _interopRequireDefault(_imagesDataprovider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('images', [_angularUiRouter2.default, _ngFileUpload2.default]).component('imageCategoryList', _category_listing2.default).component('imageCategoryAdd', _category_add2.default).component('imageCategoryEdit', _category_edit2.default).component('imageList', _list2.default).component('imageAdd', _add2.default).component('imageEdit', _edit2.default).service('Images', _images3.default).service('ImagesDataProvider', _imagesDataprovider2.default).config(_images.ImagesConfig).name;
	
	// WEBPACK FOOTER //

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('ui.tabs', []).directive('tabs', function () {
	  return {
	    restrict: 'E',
	    transclude: true,
	    scope: {},
	    controller: ["$scope", "$element", function controller($scope, $element) {
	      "ngInject";
	
	      var panes = $scope.panes = [];
	
	      $scope.select = function (pane) {
	        _angular2.default.forEach(panes, function (pane) {
	          pane.selected = false;
	        });
	        pane.selected = true;
	      };
	
	      this.addPane = function (pane) {
	        if (panes.length == 0) $scope.select(pane);
	        panes.push(pane);
	      };
	    }],
	    template: '<div class="row">' + '<div class="col-xs-3" style="width: 90px;">' + '<ul class="nav nav-tabs tabs-left" style="background-color: #eee; padding-top:0;">' + '<li ng-repeat="pane in panes" ng-class="{active:pane.selected}">' + '<a href="" ng-click="select(pane)">{{pane.title}}</a>' + '</li>' + '</ul>' + '</div>' + '<div class="col-xs-9" style="width: calc(100% - 90px);">' + '<div class="tab-content" ng-transclude></div>' + '</div>' + '</div>',
	
	    replace: true
	  };
	}).directive('pane', function () {
	  return {
	    require: '^tabs',
	    restrict: 'E',
	    transclude: true,
	    scope: { title: '@' },
	    link: function link(scope, element, attrs, tabsController) {
	      tabsController.addPane(scope);
	    },
	    template: '<div class="tab-pane" ng-class="{active: selected}" ng-transclude>' + '</div>',
	    replace: true
	  };
	}).name;
	
	// WEBPACK FOOTER //
	/**
	 * Created by murzik on 10.10.16.
	 */

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('ui.flipper', []).directive("flipper", function () {
	  return {
	    restrict: "E",
	    template: "<div class='flipper' ng-transclude ng-class='{ flipped: flipped }'></div>",
	    transclude: true,
	    scope: {
	      flipped: "="
	    }
	  };
	}).directive("front", function () {
	  return {
	    restrict: "E",
	    template: "<div class='front tile' ng-transclude></div>",
	    transclude: true
	  };
	}).directive("back", function () {
	  return {
	    restrict: "E",
	    template: "<div class='back tile' ng-transclude></div>",
	    transclude: true
	  };
	}).name;
	
	// WEBPACK FOOTER //
	/**
	 * Created by murzik on 10.10.16.
	 */

/***/ },
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _login = __webpack_require__(444);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _auth = __webpack_require__(445);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _login2.default,
	  controller: _auth2.default
	};
	
	exports.default = loginComponent;
	
	// WEBPACK FOOTER //

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var AuthService = exports.AuthService = ["$q", "$timeout", "$localStorage", "$http", function AuthService($q, $timeout, $localStorage, $http) {
	  'ngInject';
	
	  var actions = {};
	
	  actions.login = function (username, password) {
	    if (username == 'admin' && password == 'ChangeMe') {
	      $localStorage.user = {
	        login: 'admin'
	      };
	      return true;
	    } else {
	      return false;
	    }
	    //return $http({
	    //  method: 'post',
	    //  url: `${API_URL}/auth/login`,
	    //  data: {
	    //    login: username,
	    //    password: password
	    //  }
	    //}).then(response => {
	    //  return response.data.token;
	    //});
	  };
	
	  actions.logout = function () {
	    //const defer = $q.defer();
	    //delete $localStorage.token;
	    delete $localStorage.user;
	    //defer.resolve();
	    //return defer.promise;
	  };
	
	  actions.me = function () {
	    //return $http({
	    //  method: 'get',
	    //  url: `${API_URL}/users/me`
	    //}).then(response => {
	    //  return response.data;
	    //});
	  };
	
	  actions.getCurrentUser = function () {
	    return $localStorage.user;
	    //const defer = $q.defer();
	    //defer.resolve($localStorage.user);
	    //return defer.promise;
	  };
	
	  actions.setCurrentUser = function (data) {
	    //const defer = $q.defer();
	    //if (!data) {
	    //  return defer.reject('Current User is empty');
	    //}
	    //$localStorage.user = data;
	    //defer.resolve();
	    //return defer.promise;
	  };
	
	  actions.setToken = function (token) {
	    //const defer = $q.defer();
	    //if (!token) {
	    //  return defer.reject('Token is empty');
	    //}
	    //$localStorage.token = token;
	    //defer.resolve();
	    //return defer.promise;
	  };
	
	  actions.getToken = function () {
	    //return $localStorage.token;
	  };
	
	  return actions;
	}];
	
	// WEBPACK FOOTER //

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UserFactory = function UserFactory() {
	  var user = {};
	
	  var getUser = function getUser() {
	    return user;
	  };
	
	  var isSignedIn = function isSignedIn() {
	    return user.isSignedIn;
	  };
	
	  return { getUser: getUser, isSignedIn: isSignedIn };
	};
	
	exports.default = UserFactory;
	
	// WEBPACK FOOTER //

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var OrderConfig = exports.OrderConfig = ["$stateProvider", function OrderConfig($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('app.orderlisting', {
	    url: '^/orders',
	    template: '<orders-listing></orders-listing>'
	  });
	  $stateProvider.state('app.orderView', {
	    url: '^/order-details-view/:id',
	    template: '<order-view></order-view>'
	  });
	}];
	
	// WEBPACK FOOTER //

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrdersService = function () {
	  OrdersService.$inject = ["Api"];
	  function OrdersService(Api) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, OrdersService);
	    this.api = Api;
	  }
	
	  (0, _createClass3.default)(OrdersService, [{
	    key: 'loadOrders',
	    value: function loadOrders(data) {
	      var url = '/orders/list';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'getOrder',
	    value: function getOrder(id) {
	      return this.api.call({
	        method: 'get',
	        url: '/orders/get/' + id
	      });
	    }
	  }, {
	    key: 'getItems',
	    value: function getItems(id) {
	      return this.api.call({
	        method: 'get',
	        url: '/orders/items/' + id
	      });
	    }
	  }, {
	    key: 'getOrderStatusLogs',
	    value: function getOrderStatusLogs(id) {
	      return this.api.call({
	        method: 'get',
	        url: '/orders/statusLogs/' + id
	      });
	    }
	  }, {
	    key: 'updateOrderStatus',
	    value: function updateOrderStatus(data) {
	      var url = '/orders/updateStatus';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'resetOrderStatus',
	    value: function resetOrderStatus(id) {
	      return this.api.call({
	        method: 'get',
	        url: '/orders/resetOrderStatus/' + id
	      });
	    }
	  }, {
	    key: 'updateInvoiceId',
	    value: function updateInvoiceId(data) {
	      var url = '/orders/updateInvoiceId';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'getComments',
	    value: function getComments(id) {
	      return this.api.call({
	        method: 'get',
	        url: '/orders/comments/' + id
	      });
	    }
	  }, {
	    key: 'saveComments',
	    value: function saveComments(data) {
	      var url = '/orders/saveComment';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'removeComment',
	    value: function removeComment(id) {
	      var url = '/orders/removeComment/' + id;
	      return this.api.call({
	        method: 'delete',
	        url: url
	      });
	    }
	  }, {
	    key: 'sendShippedMail',
	    value: function sendShippedMail(id) {
	      var url = '/orders/sendShippedMail/' + id;
	      return this.api.call({
	        method: 'get',
	        url: url
	      });
	    }
	  }, {
	    key: 'sendInvoiceMail',
	    value: function sendInvoiceMail(id) {
	      var url = '/orders/sendInvoiceMail/' + id;
	      return this.api.call({
	        method: 'get',
	        url: url
	      });
	    }
	  }, {
	    key: 'sendCollectionMail',
	    value: function sendCollectionMail(id) {
	      var url = '/orders/sendCollectionMail/' + id;
	      return this.api.call({
	        method: 'get',
	        url: url
	      });
	    }
	  }, {
	    key: 'sendReceiptMail',
	    value: function sendReceiptMail(id) {
	      var url = '/orders/sendReceiptMail/' + id;
	      return this.api.call({
	        method: 'get',
	        url: url
	      });
	    }
	  }, {
	    key: 'sendReviewMail',
	    value: function sendReviewMail(id) {
	      var url = '/orders/sendReviewMail/' + id;
	      return this.api.call({
	        method: 'get',
	        url: url
	      });
	    }
	  }, {
	    key: 'sendPaperInvoiceMail',
	    value: function sendPaperInvoiceMail(id) {
	      var url = '/orders/sendPaperInvoiceMail/' + id;
	      return this.api.call({
	        method: 'get',
	        url: url
	      });
	    }
	  }, {
	    key: 'sendReminderInvoiceMail',
	    value: function sendReminderInvoiceMail(id) {
	      var url = '/orders/sendReminderInvoiceMail/' + id;
	      return this.api.call({
	        method: 'get',
	        url: url
	      });
	    }
	  }, {
	    key: 'saveShipmentResp',
	    value: function saveShipmentResp(data) {
	      var url = '/orders/saveShipmentResp';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'tosvg',
	    value: function tosvg(data) {
	      var url = '/orders/tosvg';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }]);
	  return OrdersService;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = OrdersService;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrdersDataProvider = function () {
	  OrdersDataProvider.$inject = ["Orders"];
	  function OrdersDataProvider(Orders) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, OrdersDataProvider);
	    this.OrdersService = Orders;
	  }
	
	  (0, _createClass3.default)(OrdersDataProvider, [{
	    key: "updateOrder",
	    value: function updateOrder(data, type) {
	      return this.OrdersService.updateOrder(data, type).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "getOrders",
	    value: function getOrders(data) {
	      return this.OrdersService.loadOrders(data).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: "getOrder",
	    value: function getOrder(id) {
	      return this.OrdersService.getOrder(id).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: "getItems",
	    value: function getItems(id) {
	      return this.OrdersService.getItems(id).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: "getOrderStatusLogs",
	    value: function getOrderStatusLogs(id) {
	      return this.OrdersService.getOrderStatusLogs(id).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: "updateOrderStatus",
	    value: function updateOrderStatus(data) {
	      return this.OrdersService.updateOrderStatus(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "resetOrderStatus",
	    value: function resetOrderStatus(id) {
	      return this.OrdersService.resetOrderStatus(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "updateInvoiceId",
	    value: function updateInvoiceId(data) {
	      return this.OrdersService.updateInvoiceId(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "getComments",
	    value: function getComments(id) {
	      return this.OrdersService.getComments(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "saveComments",
	    value: function saveComments(data) {
	      return this.OrdersService.saveComments(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "removeComment",
	    value: function removeComment(id) {
	      return this.OrdersService.removeComment(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "sendShippedMail",
	    value: function sendShippedMail(id) {
	      return this.OrdersService.sendShippedMail(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "sendInvoiceMail",
	    value: function sendInvoiceMail(id) {
	      return this.OrdersService.sendInvoiceMail(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "sendCollectionMail",
	    value: function sendCollectionMail(id) {
	      return this.OrdersService.sendCollectionMail(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "sendReceiptMail",
	    value: function sendReceiptMail(id) {
	      return this.OrdersService.sendReceiptMail(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "sendReviewMail",
	    value: function sendReviewMail(id) {
	      return this.OrdersService.sendReviewMail(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "sendPaperInvoiceMail",
	    value: function sendPaperInvoiceMail(id) {
	      return this.OrdersService.sendPaperInvoiceMail(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "sendReminderInvoiceMail",
	    value: function sendReminderInvoiceMail(id) {
	      return this.OrdersService.sendReminderInvoiceMail(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "saveShipmentResp",
	    value: function saveShipmentResp(data) {
	      return this.OrdersService.saveShipmentResp(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "tosvg",
	    value: function tosvg(data) {
	      return this.OrdersService.tosvg(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }]);
	  return OrdersDataProvider;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = OrdersDataProvider;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(448);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(449);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(450);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(451);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ProductsConfig = exports.ProductsConfig = ["$stateProvider", function ProductsConfig($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('app.product', {
	    url: '^/products/:product',
	    template: '<product-materials></product-materials>',
	    resolve: {
	      materials: ["data", "ProductsDataProvider", "$stateParams", function materials(data, ProductsDataProvider, $stateParams) {
	        "ngInject";
	
	        return ProductsDataProvider.loadProductMaterials($stateParams.product);
	      }]
	    }
	  });
	
	  $stateProvider.state('app.product.material', {
	    url: '^/products/:product/:material',
	    template: '<material-mode> </material-mode>',
	    resolve: {
	      spec: ["materials", "ProductsDataProvider", "$stateParams", function spec(materials, ProductsDataProvider, $stateParams) {
	        "ngInject";
	
	        var product = $stateParams.product,
	            material = $stateParams.material;
	
	        return ProductsDataProvider.loadProductMaterialsSpec(product, material);
	      }],
	      pricing: ["materials", "ProductsDataProvider", "$stateParams", function pricing(materials, ProductsDataProvider, $stateParams) {
	        var product = $stateParams.product,
	            material = $stateParams.material;
	
	        return ProductsDataProvider.loadProductMaterialPricing(product, material);
	      }]
	    }
	  });
	
	  $stateProvider.state('app.product.material.spec', {
	    url: '^/products/:product/:material/spec',
	    template: '<product-material-spec> </product-material-spec>'
	  });
	
	  $stateProvider.state('app.product.material.pricing', {
	    url: '^/products/:product/:material/pricing',
	    template: '<product-material-pricing> </product-material-pricing>'
	  });
	}];
	
	// WEBPACK FOOTER //

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductsService = function () {
	  ProductsService.$inject = ["Api"];
	  function ProductsService(Api) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ProductsService);
	    this.api = Api;
	  }
	
	  (0, _createClass3.default)(ProductsService, [{
	    key: 'loadAllProducts',
	    value: function loadAllProducts() {
	      return this.api.call({
	        method: 'get',
	        url: '/products'
	      });
	    }
	  }, {
	    key: 'loadProductMaterials',
	    value: function loadProductMaterials(productId) {
	      return this.api.call({
	        method: 'get',
	        url: '/products/' + productId + '/materials'
	      });
	    }
	  }, {
	    key: 'loadProductMaterialSpec',
	    value: function loadProductMaterialSpec(productId, materialId) {
	      var url = '/products/' + productId + '/materials/' + materialId + '/spec';
	      return this.api.call({
	        method: 'get',
	        url: url
	      });
	    }
	  }, {
	    key: 'loadProductMaterialPricing',
	    value: function loadProductMaterialPricing(productSlug, materialSlug) {
	      var url = '/products/' + productSlug + '/materials/' + materialSlug + '/pricing_spec';
	      return this.api.call({
	        method: 'get',
	        url: url
	      });
	    }
	  }, {
	    key: 'deleteProductMaterialShape',
	    value: function deleteProductMaterialShape(productId, materialId, shapeId) {
	      var url = '/products/' + productId + '/materials/' + materialId + '/shapes/' + shapeId;
	      return this.api.call({
	        method: 'delete',
	        url: url
	      });
	    }
	  }, {
	    key: 'addProductMaterialShape',
	    value: function addProductMaterialShape(productId, materialId, shapeId) {
	      var url = '/products/' + productId + '/materials/' + materialId + '/shapes/' + shapeId;
	      return this.api.call({
	        method: 'post',
	        url: url
	      });
	    }
	  }, {
	    key: 'deleteProductMaterialFixmethod',
	    value: function deleteProductMaterialFixmethod(productId, materialId, fixmethodId) {
	      var url = '/products/' + productId + '/materials/' + materialId + '/fixmethods/' + fixmethodId;
	      return this.api.call({
	        method: 'delete',
	        url: url
	      });
	    }
	  }, {
	    key: 'addProductMaterialFixmethod',
	    value: function addProductMaterialFixmethod(productId, materialId, fixmethodId) {
	      var url = '/products/' + productId + '/materials/' + materialId + '/fixmethods/' + fixmethodId;
	      return this.api.call({
	        method: 'post',
	        url: url
	      });
	    }
	  }, {
	    key: 'addProductMaterialColor',
	    value: function addProductMaterialColor(productId, materialId, colorId) {
	      var url = '/products/' + productId + '/materials/' + materialId + '/colors/' + colorId;
	      return this.api.call({
	        method: 'post',
	        url: url
	      });
	    }
	  }, {
	    key: 'deleteProductMaterialColor',
	    value: function deleteProductMaterialColor(productId, materialId, colorId) {
	      var url = '/products/' + productId + '/materials/' + materialId + '/colors/' + colorId;
	      return this.api.call({
	        method: 'delete',
	        url: url
	      });
	    }
	  }, {
	    key: 'saveProductMaterialPricing',
	    value: function saveProductMaterialPricing(productSlug, materialSlug, spec) {
	      var url = '/products/' + productSlug + '/materials/' + materialSlug + '/pricing_spec';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: spec,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'updateName',
	    value: function updateName(data, type) {
	      var url = '/products/update_name/' + type;
	      return this.api.call({
	        method: 'put',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }]);
	  return ProductsService;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = ProductsService;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductsDataProvider = function () {
	  ProductsDataProvider.$inject = ["ProductsService", "db"];
	  function ProductsDataProvider(ProductsService, db) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ProductsDataProvider);
	    this.ProductsService = ProductsService;
	    this.products = db.getCollection("products");
	    this.db = db;
	  }
	
	  (0, _createClass3.default)(ProductsDataProvider, [{
	    key: "getProducts",
	    value: function getProducts() {
	      return this.products.find({});
	    }
	  }, {
	    key: "loadProducts",
	    value: function loadProducts(forceReload) {
	      var _this = this;
	
	      return this.ProductsService.loadAllProducts().then(function (products) {
	        _this.products.insert(products);
	        return products;
	      });
	    }
	  }, {
	    key: "loadProductMaterials",
	    value: function loadProductMaterials(slug) {
	      var _this2 = this;
	
	      var product = this.db.getCollection('products').findOne({ slug: slug }),
	          service = this.ProductsService;
	
	      return service.loadProductMaterials(product.id).then(function (materials) {
	        product.materials = materials;
	        _this2.products.update(product);
	        return materials;
	      });
	    }
	  }, {
	    key: "loadProductMaterialsSpec",
	    value: function loadProductMaterialsSpec(productSlug, materialSlug) {
	      var _this3 = this;
	
	      var product = this.db.getCollection('products').findOne({ slug: productSlug }),
	          service = this.ProductsService,
	          material = product.materials.find(function (material) {
	        return material.slug == materialSlug;
	      });
	      return service.loadProductMaterialSpec(product.id, material.id).then(function (spec) {
	        material.spec = spec;
	        _this3.products.update(product);
	        return spec;
	      });
	    }
	  }, {
	    key: "loadProductMaterialPricing",
	    value: function loadProductMaterialPricing(productSlug, materialSlug) {
	      var _this4 = this;
	
	      var product = this.db.getCollection('products').findOne({ slug: productSlug }),
	          service = this.ProductsService,
	          material = product.materials.find(function (material) {
	        return material.slug == materialSlug;
	      });
	      return service.loadProductMaterialPricing(productSlug, materialSlug).then(function (pricing) {
	        material.pricing = pricing;
	        _this4.products.update(product);
	        return pricing;
	      });
	    }
	  }, {
	    key: "saveProductMaterialPricing",
	    value: function saveProductMaterialPricing(productSlug, materialSlug, spec) {
	      var _this5 = this;
	
	      var product = this.db.getCollection('products').findOne({ slug: productSlug }),
	          service = this.ProductsService,
	          material = product.materials.find(function (material) {
	        return material.slug == materialSlug;
	      });
	      return service.saveProductMaterialPricing(productSlug, materialSlug, spec).then(function (resp) {
	        material.pricing = spec;
	        _this5.products.update(product);
	        return resp;
	      });
	    }
	  }, {
	    key: "addProductMaterialShape",
	    value: function addProductMaterialShape(productId, materialId, shapeId) {
	      var _this6 = this;
	
	      var product = this.db.getCollection('products').findOne({ id: productId }),
	          service = this.ProductsService,
	          material = product.materials.find(function (material) {
	        return material.id == materialId;
	      }),
	          shapes = material.spec.shapes;
	
	      return service.addProductMaterialShape(productId, materialId, shapeId).then(function (shape) {
	        shapes.push(shape, 1);
	        _this6.products.update(product);
	        return shape;
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: "deleteProductMaterialShape",
	    value: function deleteProductMaterialShape(productId, materialId, shapeId) {
	      var _this7 = this;
	
	      var product = this.db.getCollection('products').findOne({ id: productId }),
	          service = this.ProductsService,
	          material = product.materials.find(function (material) {
	        return material.id == materialId;
	      }),
	          shapes = material.spec.shapes,
	          shapeIdx = shapes.findIndex(function (shape) {
	        return shape.id == shapeId;
	      });
	      return service.deleteProductMaterialShape(productId, materialId, shapeId).then(function (shape) {
	        //delete from storage on successful api call
	        shapes.splice(shapeIdx, 1);
	        _this7.products.update(product);
	        return shape;
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: "addProductMaterialColor",
	    value: function addProductMaterialColor(productId, materialId, colorId) {
	      var _this8 = this;
	
	      var product = this.db.getCollection('products').findOne({ id: productId }),
	          service = this.ProductsService,
	          material = product.materials.find(function (material) {
	        return material.id == materialId;
	      }),
	          colors = material.spec.colors;
	
	      return service.addProductMaterialColor(productId, materialId, colorId).then(function (color) {
	        colors.push(color, 1);
	        _this8.products.update(product);
	        return color;
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: "deleteProductMaterialColor",
	    value: function deleteProductMaterialColor(productId, materialId, colorId) {
	      var _this9 = this;
	
	      var product = this.db.getCollection('products').findOne({ id: productId }),
	          service = this.ProductsService,
	          material = product.materials.find(function (material) {
	        return material.id == materialId;
	      }),
	          colors = material.spec.colors,
	          colorIdx = colors.findIndex(function (color) {
	        return color.id == colorId;
	      });
	      return service.deleteProductMaterialColor(productId, materialId, colorId).then(function (color) {
	        //delete from storage on successful api call
	        colors.splice(colorIdx, 1);
	        _this9.products.update(product);
	        return color;
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: "updateName",
	    value: function updateName(data, type) {
	      var dataS = { id: data.id, name: data.name, slug: data.slug };
	      return this.ProductsService.updateName(dataS, type).then(function (result) {
	        return result;
	      });
	    }
	  }]);
	  return ProductsDataProvider;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = ProductsDataProvider;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ["$templateCache", function ($templateCache) {
	  "ngInject";
	
	  console.log('run func', _templates2.default);
	  for (var prod in _templates2.default) {
	    var prodTemplates = _templates2.default[prod];
	    for (var material in prodTemplates) {
	      //console.log(material, `${prod}-${material}.html`);
	      $templateCache.put(prod + '-' + material + '.html', _templates2.default[prod][material]);
	    }
	  }
	}];
	
	var _templates = __webpack_require__(454);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(455);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(456);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(452);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(453);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(457);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(458);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(459);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(460);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(461);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(462);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(464);
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import controller from './controller';
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: function controller() {}
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _controller = __webpack_require__(463);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: '<div ng-include="$ctrl.tpl"></div>',
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	}; // import template from './template.html';

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductPartsService = function () {
	  ProductPartsService.$inject = ["Api"];
	  function ProductPartsService(Api) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ProductPartsService);
	    this.api = Api;
	  }
	
	  (0, _createClass3.default)(ProductPartsService, [{
	    key: 'loadAllShapes',
	    value: function loadAllShapes() {
	      return this.api.call({
	        method: 'get',
	        url: '/shapes'
	      });
	    }
	  }, {
	    key: 'loadAllFixmethods',
	    value: function loadAllFixmethods() {
	      return this.api.call({
	        method: 'get',
	        url: '/fixmethods'
	      });
	    }
	  }, {
	    key: 'loadAllColors',
	    value: function loadAllColors() {
	      return this.api.call({
	        method: 'get',
	        url: '/colors'
	      });
	    }
	  }]);
	  return ProductPartsService;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = ProductPartsService;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductPartsDataProvider = function () {
	  ProductPartsDataProvider.$inject = ["ProductPartsService", "db"];
	  function ProductPartsDataProvider(ProductPartsService, db) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ProductPartsDataProvider);
	    this.ProductPartsService = ProductPartsService;
	    this.colors = db.getCollection("colors");
	    this.shapes = db.getCollection("shapes");
	    this.fixmethods = db.getCollection("fix_methods");
	    this.db = db;
	  }
	
	  (0, _createClass3.default)(ProductPartsDataProvider, [{
	    key: "loadShapes",
	    value: function loadShapes() {
	      var _this = this;
	
	      return this.ProductPartsService.loadAllShapes().then(function (shapes) {
	        _this.shapes.insert(shapes);
	        return shapes;
	      });
	    }
	  }, {
	    key: "loadFixmethods",
	    value: function loadFixmethods() {
	      var _this2 = this;
	
	      return this.ProductPartsService.loadAllFixmethods().then(function (fixmethods) {
	        _this2.fixmethods.insert(fixmethods);
	        return fixmethods;
	      });
	    }
	  }, {
	    key: "loadColors",
	    value: function loadColors() {
	      var _this3 = this;
	
	      return this.ProductPartsService.loadAllColors().then(function (colors) {
	        _this3.colors.insert(colors);
	        return colors;
	      });
	    }
	  }]);
	  return ProductPartsDataProvider;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = ProductPartsDataProvider;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dashboard = __webpack_require__(446);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboard3 = __webpack_require__(447);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _dashboard2.default,
	  controller: _dashboard4.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DashboardConfig = exports.DashboardConfig = ["$stateProvider", function DashboardConfig($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('app.dashboard', {
	    url: '^/dashboard',
	    template: '<dashboard></dashboard>'
	  });
	}];
	
	// WEBPACK FOOTER //

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NewsletterConfig = exports.NewsletterConfig = ["$stateProvider", function NewsletterConfig($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('app.newsletter', {
	    url: '^/newsletter',
	    template: '<newsletter></newsletter>'
	  });
	  $stateProvider.state('app.subscriberListing', {
	    url: '^/subscribers',
	    template: '<subscriber-listing></subscriber-listing>'
	  });
	}];
	
	// WEBPACK FOOTER //

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsletterService = function () {
	  NewsletterService.$inject = ["Api"];
	  function NewsletterService(Api) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, NewsletterService);
	    this.api = Api;
	  }
	
	  (0, _createClass3.default)(NewsletterService, [{
	    key: 'loadSubscribers',
	    value: function loadSubscribers(data) {
	      var url = '/subscribers/list';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'removeSubscriber',
	    value: function removeSubscriber(id) {
	      var url = '/subscribers/remove/' + id;
	      return this.api.call({
	        method: 'delete',
	        url: url
	      });
	    }
	  }, {
	    key: 'getNewsletter',
	    value: function getNewsletter(type) {
	      var url = '/newsletter/get/' + type;
	      return this.api.call({
	        method: 'get',
	        url: url
	      });
	    }
	  }]);
	  return NewsletterService;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = NewsletterService;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsletterDataProvider = function () {
	  NewsletterDataProvider.$inject = ["Newsletter"];
	  function NewsletterDataProvider(Newsletter) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, NewsletterDataProvider);
	    this.NewsletterService = Newsletter;
	  }
	
	  (0, _createClass3.default)(NewsletterDataProvider, [{
	    key: 'editor',
	    value: function editor() {
	      // Initialize
	      tinymce.EditorManager.editors = [];
	      tinymce.init({
	        selector: '.tinymce',
	        plugins: ['paste', 'link', 'autoresize']
	      });
	      tinymce.init({
	        selector: '.full-tinymce',
	        toolbar1: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
	        toolbar2: 'print preview media | forecolor backcolor emoticons ',
	        image_advtab: true,
	        plugins: ['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality', 'paste textcolor colorpicker textpattern imagetools toc']
	      });
	    }
	  }, {
	    key: 'getSubscribers',
	    value: function getSubscribers(data) {
	      return this.NewsletterService.loadSubscribers(data).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: 'removeSubscriber',
	    value: function removeSubscriber(id) {
	      return this.NewsletterService.removeSubscriber(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: 'getNewsletter',
	    value: function getNewsletter(type) {
	      return this.NewsletterService.getNewsletter(type).then(function (resp) {
	        return resp;
	      });
	    }
	  }]);
	  return NewsletterDataProvider;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = NewsletterDataProvider;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(465);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(466);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(467);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(468);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ProductPageConfig = exports.ProductPageConfig = ["$stateProvider", function ProductPageConfig($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('app.productPagelisting', {
	    url: '^/product-pages',
	    template: '<product-pages-listing></product-pages-listing>'
	  });
	  $stateProvider.state('app.productPagelistingC', {
	    url: '^/product-pages/:categoryId/:subCategoryId',
	    template: '<product-pages-listing></product-pages-listing>'
	  });
	  $stateProvider.state('app.productPageAdd', {
	    url: '^/product-page-add',
	    template: '<product-page-add></product-page-add>'
	  });
	  $stateProvider.state('app.productPageEdit', {
	    url: '^/product-page-edit/:id/:tabId',
	    template: '<product-page-edit></product-page-edit>'
	  });
	  $stateProvider.state('app.categoryList', {
	    url: '^/categories',
	    template: '<product-page-category-list></product-page-category-list>'
	  });
	  $stateProvider.state('app.categoryAdd', {
	    url: '^/category-add',
	    template: '<category-add></category-add>'
	  });
	  $stateProvider.state('app.categoryEdit', {
	    url: '^/category-edit/:id/:tabId',
	    template: '<category-edit></category-edit>'
	  });
	  $stateProvider.state('app.subCategoryList', {
	    url: '^/sub-categories/:parentId',
	    template: '<sub-category-list></sub-category-list>'
	  });
	  $stateProvider.state('app.subCategoryAdd', {
	    url: '^/sub-category-add',
	    template: '<sub-category-add></sub-category-add>'
	  });
	  $stateProvider.state('app.subCategoryEdit', {
	    url: '^/sub-category-edit/:id/:tabId',
	    template: '<sub-category-edit></subcategory-edit>'
	  });
	}];
	
	// WEBPACK FOOTER //

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductPagesService = function () {
	  ProductPagesService.$inject = ["Api"];
	  function ProductPagesService(Api) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ProductPagesService);
	    this.api = Api;
	  }
	
	  (0, _createClass3.default)(ProductPagesService, [{
	    key: 'loadCategories',
	    value: function loadCategories(data) {
	      return this.api.call({
	        method: 'get',
	        url: '/productPage/categories/' + data.parentId + '/' + data.currentPage + '/' + data.pageLimit + '/' + data.field + '/' + data.order_type
	      });
	    }
	  }, {
	    key: 'loadCategoriesNoLimit',
	    value: function loadCategoriesNoLimit(parentId) {
	      return this.api.call({
	        method: 'get',
	        url: '/productPage/categoriesNoLimit/' + parentId
	      });
	    }
	  }, {
	    key: 'getProductPage',
	    value: function getProductPage(id, type) {
	      return this.api.call({
	        method: 'get',
	        url: '/productPage/get/' + id + '/' + type
	      });
	    }
	  }, {
	    key: 'getProductPageProducts',
	    value: function getProductPageProducts(id, type) {
	      return this.api.call({
	        method: 'get',
	        url: '/productPage/products/' + id + '/' + type
	      });
	    }
	  }, {
	    key: 'saveProductPage',
	    value: function saveProductPage(data) {
	      var url = '/productPage/saveProductPage';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'updateProductPage',
	    value: function updateProductPage(data, type) {
	      var url = '/productPage/updateProductPage/' + type;
	      return this.api.call({
	        method: 'put',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'loadProductPages',
	    value: function loadProductPages(data, type) {
	      return this.api.call({
	        method: 'get',
	        url: '/productPage/list/' + data.categoryId + '/' + data.subCategoryId + '/' + data.currentPage + '/' + data.pageLimit + '/' + type + '/' + data.field + '/' + data.order_type
	      });
	    }
	  }, {
	    key: 'saveCategory',
	    value: function saveCategory(data) {
	      var url = '/productPage/saveCategory';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'updateCategoryOrder',
	    value: function updateCategoryOrder(data) {
	      var url = '/productPage/updateCategoryOrder';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'updateProductPageOrder',
	    value: function updateProductPageOrder(data) {
	      var url = '/productPage/updateProductPageOrder';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'removeCategory',
	    value: function removeCategory(id, type) {
	      var url = '/productPage/removeCategory/' + id + '/' + type;
	      return this.api.call({
	        method: 'delete',
	        url: url
	      });
	    }
	  }, {
	    key: 'categoryById',
	    value: function categoryById(id) {
	      return this.api.call({
	        method: 'get',
	        url: '/productPage/category/' + id
	      });
	    }
	  }, {
	    key: 'updateCategory',
	    value: function updateCategory(data) {
	      var url = '/productPage/updateCategory';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'getSubCategory',
	    value: function getSubCategory(data) {
	      return this.api.call({
	        method: 'get',
	        url: '/productPage/getSubCategory/' + data.parentId + '/' + data.currentPage + '/' + data.pageLimit + '/' + data.field + '/' + data.order_type
	      });
	    }
	  }, {
	    key: 'updateProductPageStatus',
	    value: function updateProductPageStatus(data) {
	      var url = '/productPage/updateStatus';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'removeProductPage',
	    value: function removeProductPage(id) {
	      var url = '/productPage/removeProductPage/' + id;
	      return this.api.call({
	        method: 'delete',
	        url: url
	      });
	    }
	  }, {
	    key: 'removeProduct',
	    value: function removeProduct(id, apid) {
	      var url = '/productPage/removeProduct/' + id + '/' + apid;
	      return this.api.call({
	        method: 'delete',
	        url: url
	      });
	    }
	  }]);
	  return ProductPagesService;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = ProductPagesService;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductPagesDataProvider = function () {
	  ProductPagesDataProvider.$inject = ["ProductPages"];
	  function ProductPagesDataProvider(ProductPages) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ProductPagesDataProvider);
	    this.ProductPagesService = ProductPages;
	  }
	
	  (0, _createClass3.default)(ProductPagesDataProvider, [{
	    key: 'editor',
	    value: function editor() {
	      // Initialize
	      tinymce.EditorManager.editors = [];
	      tinymce.init({
	        selector: '.tinymce',
	        plugins: ['paste', 'link', 'autoresize']
	      });
	      tinymce.init({
	        selector: '.full-tinymce',
	        toolbar1: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
	        toolbar2: 'print preview media | forecolor backcolor emoticons ',
	        image_advtab: true,
	        plugins: ['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality', 'paste textcolor colorpicker textpattern imagetools toc']
	      });
	    }
	  }, {
	    key: 'getCategory',
	    value: function getCategory(data, type) {
	      return this.ProductPagesService.loadCategories(data).then(function (categories) {
	        return categories;
	      });
	    }
	  }, {
	    key: 'loadCategoriesNoLimit',
	    value: function loadCategoriesNoLimit(parentId) {
	      return this.ProductPagesService.loadCategoriesNoLimit(parentId).then(function (categories) {
	        return categories;
	      });
	    }
	  }, {
	    key: 'saveProductPage',
	    value: function saveProductPage(data) {
	      return this.ProductPagesService.saveProductPage(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: 'updateProductPage',
	    value: function updateProductPage(data, type) {
	      return this.ProductPagesService.updateProductPage(data, type).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: 'getProductPages',
	    value: function getProductPages(data, type) {
	      return this.ProductPagesService.loadProductPages(data, type).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: 'getProductPage',
	    value: function getProductPage(id, type) {
	      return this.ProductPagesService.getProductPage(id, type).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: 'getProductPageProducts',
	    value: function getProductPageProducts(id, type) {
	      return this.ProductPagesService.getProductPageProducts(id, type).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: 'saveCategory',
	    value: function saveCategory(data) {
	      return this.ProductPagesService.saveCategory(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: 'updateCategoryOrder',
	    value: function updateCategoryOrder(data) {
	      return this.ProductPagesService.updateCategoryOrder(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: 'updateProductPageOrder',
	    value: function updateProductPageOrder(data) {
	      return this.ProductPagesService.updateProductPageOrder(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: 'removeCategory',
	    value: function removeCategory(id, type) {
	      return this.ProductPagesService.removeCategory(id, type).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: 'getCategoryById',
	    value: function getCategoryById(id) {
	      return this.ProductPagesService.categoryById(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: 'updateCategory',
	    value: function updateCategory(data) {
	      return this.ProductPagesService.updateCategory(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: 'getSubCategory',
	    value: function getSubCategory(data) {
	      return this.ProductPagesService.getSubCategory(data).then(function (categories) {
	        return categories;
	      });
	    }
	  }, {
	    key: 'updateProductPageStatus',
	    value: function updateProductPageStatus(data) {
	      return this.ProductPagesService.updateProductPageStatus(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: 'removeProductPage',
	    value: function removeProductPage(id) {
	      return this.ProductPagesService.removeProductPage(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: 'removeProduct',
	    value: function removeProduct(id, apid) {
	      return this.ProductPagesService.removeProduct(id, apid).then(function (resp) {
	        return resp;
	      });
	    }
	  }]);
	  return ProductPagesDataProvider;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = ProductPagesDataProvider;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(471);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(472);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinymce = __webpack_require__(512);
	
	var _tinymce2 = _interopRequireDefault(_tinymce);
	
	__webpack_require__(544);
	
	__webpack_require__(514);
	
	__webpack_require__(515);
	
	__webpack_require__(516);
	
	__webpack_require__(517);
	
	__webpack_require__(518);
	
	__webpack_require__(519);
	
	__webpack_require__(520);
	
	__webpack_require__(521);
	
	__webpack_require__(522);
	
	__webpack_require__(523);
	
	__webpack_require__(524);
	
	__webpack_require__(525);
	
	__webpack_require__(526);
	
	__webpack_require__(527);
	
	__webpack_require__(528);
	
	__webpack_require__(513);
	
	__webpack_require__(529);
	
	__webpack_require__(530);
	
	__webpack_require__(531);
	
	__webpack_require__(532);
	
	__webpack_require__(533);
	
	__webpack_require__(534);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	__webpack_require__(537);
	
	__webpack_require__(538);
	
	__webpack_require__(539);
	
	__webpack_require__(540);
	
	__webpack_require__(541);
	
	__webpack_require__(542);
	
	var _template = __webpack_require__(469);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(470);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Plugins
	// Core - these two are required :-)
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinymce = __webpack_require__(512);
	
	var _tinymce2 = _interopRequireDefault(_tinymce);
	
	__webpack_require__(514);
	
	__webpack_require__(515);
	
	__webpack_require__(516);
	
	__webpack_require__(517);
	
	__webpack_require__(518);
	
	__webpack_require__(519);
	
	__webpack_require__(520);
	
	__webpack_require__(521);
	
	__webpack_require__(522);
	
	__webpack_require__(523);
	
	__webpack_require__(524);
	
	__webpack_require__(525);
	
	__webpack_require__(526);
	
	__webpack_require__(527);
	
	__webpack_require__(528);
	
	__webpack_require__(513);
	
	__webpack_require__(529);
	
	__webpack_require__(530);
	
	__webpack_require__(531);
	
	__webpack_require__(532);
	
	__webpack_require__(533);
	
	__webpack_require__(534);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	__webpack_require__(537);
	
	__webpack_require__(538);
	
	__webpack_require__(539);
	
	__webpack_require__(540);
	
	__webpack_require__(541);
	
	__webpack_require__(542);
	
	var _template = __webpack_require__(473);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(474);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Plugins
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	}; // Core - these two are required :-)

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(475);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(476);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinymce = __webpack_require__(512);
	
	var _tinymce2 = _interopRequireDefault(_tinymce);
	
	__webpack_require__(544);
	
	__webpack_require__(514);
	
	__webpack_require__(515);
	
	__webpack_require__(516);
	
	__webpack_require__(517);
	
	__webpack_require__(518);
	
	__webpack_require__(519);
	
	__webpack_require__(520);
	
	__webpack_require__(521);
	
	__webpack_require__(522);
	
	__webpack_require__(523);
	
	__webpack_require__(524);
	
	__webpack_require__(525);
	
	__webpack_require__(543);
	
	__webpack_require__(526);
	
	__webpack_require__(527);
	
	__webpack_require__(528);
	
	__webpack_require__(513);
	
	__webpack_require__(529);
	
	__webpack_require__(530);
	
	__webpack_require__(531);
	
	__webpack_require__(532);
	
	__webpack_require__(533);
	
	__webpack_require__(534);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	__webpack_require__(537);
	
	__webpack_require__(538);
	
	__webpack_require__(539);
	
	__webpack_require__(540);
	
	__webpack_require__(541);
	
	__webpack_require__(542);
	
	var _template = __webpack_require__(477);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(478);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};
	// Plugins
	// Core - these two are required :-)

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinymce = __webpack_require__(512);
	
	var _tinymce2 = _interopRequireDefault(_tinymce);
	
	__webpack_require__(544);
	
	__webpack_require__(514);
	
	__webpack_require__(515);
	
	__webpack_require__(516);
	
	__webpack_require__(517);
	
	__webpack_require__(518);
	
	__webpack_require__(519);
	
	__webpack_require__(520);
	
	__webpack_require__(521);
	
	__webpack_require__(522);
	
	__webpack_require__(523);
	
	__webpack_require__(524);
	
	__webpack_require__(525);
	
	__webpack_require__(543);
	
	__webpack_require__(526);
	
	__webpack_require__(527);
	
	__webpack_require__(528);
	
	__webpack_require__(513);
	
	__webpack_require__(529);
	
	__webpack_require__(530);
	
	__webpack_require__(531);
	
	__webpack_require__(532);
	
	__webpack_require__(533);
	
	__webpack_require__(534);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	__webpack_require__(537);
	
	__webpack_require__(538);
	
	__webpack_require__(539);
	
	__webpack_require__(540);
	
	__webpack_require__(541);
	
	__webpack_require__(542);
	
	var _template = __webpack_require__(483);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(484);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};
	// Plugins
	// Core - these two are required :-)

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(479);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(480);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinymce = __webpack_require__(512);
	
	var _tinymce2 = _interopRequireDefault(_tinymce);
	
	__webpack_require__(544);
	
	__webpack_require__(514);
	
	__webpack_require__(515);
	
	__webpack_require__(516);
	
	__webpack_require__(517);
	
	__webpack_require__(518);
	
	__webpack_require__(519);
	
	__webpack_require__(520);
	
	__webpack_require__(521);
	
	__webpack_require__(522);
	
	__webpack_require__(523);
	
	__webpack_require__(524);
	
	__webpack_require__(525);
	
	__webpack_require__(543);
	
	__webpack_require__(526);
	
	__webpack_require__(527);
	
	__webpack_require__(528);
	
	__webpack_require__(513);
	
	__webpack_require__(529);
	
	__webpack_require__(530);
	
	__webpack_require__(531);
	
	__webpack_require__(532);
	
	__webpack_require__(533);
	
	__webpack_require__(534);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	__webpack_require__(537);
	
	__webpack_require__(538);
	
	__webpack_require__(539);
	
	__webpack_require__(540);
	
	__webpack_require__(541);
	
	__webpack_require__(542);
	
	var _template = __webpack_require__(481);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(482);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};
	// Plugins
	// Core - these two are required :-)

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinymce = __webpack_require__(512);
	
	var _tinymce2 = _interopRequireDefault(_tinymce);
	
	__webpack_require__(544);
	
	__webpack_require__(514);
	
	__webpack_require__(515);
	
	__webpack_require__(516);
	
	__webpack_require__(517);
	
	__webpack_require__(518);
	
	__webpack_require__(519);
	
	__webpack_require__(520);
	
	__webpack_require__(521);
	
	__webpack_require__(522);
	
	__webpack_require__(523);
	
	__webpack_require__(524);
	
	__webpack_require__(525);
	
	__webpack_require__(543);
	
	__webpack_require__(526);
	
	__webpack_require__(527);
	
	__webpack_require__(528);
	
	__webpack_require__(513);
	
	__webpack_require__(529);
	
	__webpack_require__(530);
	
	__webpack_require__(531);
	
	__webpack_require__(532);
	
	__webpack_require__(533);
	
	__webpack_require__(534);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	__webpack_require__(537);
	
	__webpack_require__(538);
	
	__webpack_require__(539);
	
	__webpack_require__(540);
	
	__webpack_require__(541);
	
	__webpack_require__(542);
	
	var _template = __webpack_require__(485);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(486);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};
	// Plugins
	// Core - these two are required :-)

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CouponConfig = exports.CouponConfig = ["$stateProvider", function CouponConfig($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('app.couponlisting', {
	    url: '^/coupons',
	    template: '<coupons-listing></coupons-listing>'
	  });
	  $stateProvider.state('app.couponAdd', {
	    url: '^/coupons/add',
	    template: '<coupons-add></coupons-add>'
	  });
	  $stateProvider.state('app.couponEdit', {
	    url: '^/coupons/edit/:id',
	    template: '<coupons-edit></coupons-edit>'
	  });
	}];
	
	// WEBPACK FOOTER //

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CouponsService = function () {
	  CouponsService.$inject = ["Api"];
	  function CouponsService(Api) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CouponsService);
	    this.api = Api;
	  }
	
	  (0, _createClass3.default)(CouponsService, [{
	    key: 'loadCoupons',
	    value: function loadCoupons(data) {
	      var url = '/coupons/list';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'getCoupon',
	    value: function getCoupon(id, type) {
	      return this.api.call({
	        method: 'get',
	        url: '/coupons/get/' + id
	      });
	    }
	  }, {
	    key: 'updateCoupon',
	    value: function updateCoupon(data, id) {
	      var url = '/coupons/updateCoupon/' + id;
	      return this.api.call({
	        method: 'put',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'removeCoupon',
	    value: function removeCoupon(id) {
	      var url = '/coupons/removeCoupons/' + id;
	      return this.api.call({
	        method: 'delete',
	        url: url
	      });
	    }
	  }, {
	    key: 'updateCouponStatus',
	    value: function updateCouponStatus(data) {
	      var url = '/coupons/updateCouponStatus';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'createCoupon',
	    value: function createCoupon(data) {
	      var url = '/coupons/createCoupon';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }]);
	  return CouponsService;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = CouponsService;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CouponsDataProvider = function () {
	  CouponsDataProvider.$inject = ["Coupons"];
	  function CouponsDataProvider(Coupons) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CouponsDataProvider);
	    this.CouponsService = Coupons;
	  }
	
	  (0, _createClass3.default)(CouponsDataProvider, [{
	    key: "getCoupons",
	    value: function getCoupons(data) {
	      return this.CouponsService.loadCoupons(data).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: "getCoupon",
	    value: function getCoupon(id) {
	      return this.CouponsService.getCoupon(id).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: "updateCoupon",
	    value: function updateCoupon(data, id) {
	      return this.CouponsService.updateCoupon(data, id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "updateCouponStatus",
	    value: function updateCouponStatus(data) {
	      return this.CouponsService.updateCouponStatus(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "removeCoupon",
	    value: function removeCoupon(id) {
	      return this.CouponsService.removeCoupon(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "createCoupon",
	    value: function createCoupon(data) {
	      return this.CouponsService.createCoupon(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }]);
	  return CouponsDataProvider;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = CouponsDataProvider;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(489);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(490);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(487);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(488);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(491);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(492);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UserConfig = exports.UserConfig = ["$stateProvider", function UserConfig($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('app.userListing', {
	    url: '^/users',
	    template: '<users-listing></users-listing>'
	  });
	  $stateProvider.state('app.userView', {
	    url: '^/user-details-view/:id',
	    template: '<user-view></user-view>'
	  });
	}];
	
	// WEBPACK FOOTER //

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersService = function () {
	  UsersService.$inject = ["Api"];
	  function UsersService(Api) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UsersService);
	    this.api = Api;
	  }
	
	  (0, _createClass3.default)(UsersService, [{
	    key: 'loadUsers',
	    value: function loadUsers(data) {
	      var url = '/users/list';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'getUser',
	    value: function getUser(id) {
	      return this.api.call({
	        method: 'get',
	        url: '/users/get/' + id
	      });
	    }
	  }, {
	    key: 'getOrders',
	    value: function getOrders(data) {
	      var url = '/users/getOrders';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'getComments',
	    value: function getComments(id) {
	      return this.api.call({
	        method: 'get',
	        url: '/users/comments/' + id
	      });
	    }
	  }, {
	    key: 'saveComments',
	    value: function saveComments(data) {
	      var url = '/users/saveComment';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'removeComment',
	    value: function removeComment(id) {
	      var url = '/users/removeComment/' + id;
	      return this.api.call({
	        method: 'delete',
	        url: url
	      });
	    }
	  }]);
	  return UsersService;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = UsersService;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersDataProvider = function () {
	  UsersDataProvider.$inject = ["Users"];
	  function UsersDataProvider(Users) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UsersDataProvider);
	    this.UsersService = Users;
	  }
	
	  (0, _createClass3.default)(UsersDataProvider, [{
	    key: "getUsers",
	    value: function getUsers(data) {
	      return this.UsersService.loadUsers(data).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: "getUser",
	    value: function getUser(id) {
	      return this.UsersService.getUser(id).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: "getOrders",
	    value: function getOrders(data) {
	      return this.UsersService.getOrders(data).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: "getComments",
	    value: function getComments(id) {
	      return this.UsersService.getComments(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "saveComments",
	    value: function saveComments(data) {
	      return this.UsersService.saveComments(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "removeComment",
	    value: function removeComment(id) {
	      return this.UsersService.removeComment(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }]);
	  return UsersDataProvider;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = UsersDataProvider;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(495);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(496);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(493);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(494);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ImagesConfig = exports.ImagesConfig = ["$stateProvider", function ImagesConfig($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('app.imageCategories', {
	    url: '^/image-categories',
	    template: '<image-category-list></image-category-list>'
	  });
	  $stateProvider.state('app.imageCategoryAdd', {
	    url: '^/image-category-add',
	    template: '<image-category-add></image-category-add>'
	  });
	  $stateProvider.state('app.imageCategoryEdit', {
	    url: '^/image-category-edit/:id',
	    template: '<image-category-edit></image-category-edit>'
	  });
	  $stateProvider.state('app.images', {
	    url: '^/images/:parentId',
	    template: '<image-list></image-list>'
	  });
	  $stateProvider.state('app.addImage', {
	    url: '^/add-image',
	    template: '<image-add></image-add>'
	  });
	  $stateProvider.state('app.editImage', {
	    url: '^/edit-image/:id',
	    template: '<image-edit></image-edit>'
	  });
	}];
	
	// WEBPACK FOOTER //

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagesService = function () {
	  ImagesService.$inject = ["Api"];
	  function ImagesService(Api) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ImagesService);
	    this.api = Api;
	  }
	
	  (0, _createClass3.default)(ImagesService, [{
	    key: 'loadCategories',
	    value: function loadCategories(data) {
	      return this.api.call({
	        method: 'get',
	        url: '/images/categories/' + data.currentPage + '/' + data.pageLimit + '/' + data.field + '/' + data.order_type
	      });
	    }
	  }, {
	    key: 'saveCategory',
	    value: function saveCategory(data) {
	      var url = '/images/saveCategory';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'removeCategory',
	    value: function removeCategory(id) {
	      var url = '/images/removeCategory/' + id;
	      return this.api.call({
	        method: 'delete',
	        url: url
	      });
	    }
	  }, {
	    key: 'categoryById',
	    value: function categoryById(id) {
	      return this.api.call({
	        method: 'get',
	        url: '/images/category/' + id
	      });
	    }
	  }, {
	    key: 'updateCategory',
	    value: function updateCategory(data) {
	      var url = '/images/updateCategory';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'getImages',
	    value: function getImages(data) {
	      return this.api.call({
	        method: 'get',
	        url: '/images/getAll/' + data.currentPage + '/' + data.pageLimit + '/' + data.field + '/' + data.order_type + '/' + data.image_category_id
	      });
	    }
	  }, {
	    key: 'getImage',
	    value: function getImage(id) {
	      return this.api.call({
	        method: 'get',
	        url: '/images/getById/' + id
	      });
	    }
	  }, {
	    key: 'loadCategoriesNoLimit',
	    value: function loadCategoriesNoLimit() {
	      return this.api.call({
	        method: 'get',
	        url: '/images/categoriesNoLimit'
	      });
	    }
	  }, {
	    key: 'removeImage',
	    value: function removeImage(id) {
	      var url = '/images/removeImage/' + id;
	      return this.api.call({
	        method: 'delete',
	        url: url
	      });
	    }
	  }, {
	    key: 'updateData',
	    value: function updateData(data) {
	      var url = '/images/updateData';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'updateImageOrder',
	    value: function updateImageOrder(data) {
	      var url = '/images/updateImageOrder';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'updateImageData',
	    value: function updateImageData(data) {
	      var url = '/images/updateImageData';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'checkRecordExist',
	    value: function checkRecordExist(data) {
	      var url = '/images/checkRecordExist';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }, {
	    key: 'saveImageData',
	    value: function saveImageData(data) {
	      var url = '/images/saveImageData';
	      return this.api.call({
	        method: 'post',
	        url: url,
	        data: data,
	        headers: {
	          "Content-Type": 'application/json'
	        }
	      });
	    }
	  }]);
	  return ImagesService;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = ImagesService;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagesDataProvider = function () {
	  ImagesDataProvider.$inject = ["Images"];
	  function ImagesDataProvider(Images) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ImagesDataProvider);
	    this.ImagesService = Images;
	  }
	
	  (0, _createClass3.default)(ImagesDataProvider, [{
	    key: "getCategory",
	    value: function getCategory(data) {
	      return this.ImagesService.loadCategories(data).then(function (categories) {
	        return categories;
	      });
	    }
	  }, {
	    key: "saveCategory",
	    value: function saveCategory(data) {
	      return this.ImagesService.saveCategory(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "removeCategory",
	    value: function removeCategory(id) {
	      return this.ImagesService.removeCategory(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "getCategoryById",
	    value: function getCategoryById(id) {
	      return this.ImagesService.categoryById(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "updateCategory",
	    value: function updateCategory(data) {
	      return this.ImagesService.updateCategory(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "getImages",
	    value: function getImages(data) {
	      return this.ImagesService.getImages(data).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: "getImage",
	    value: function getImage(id) {
	      return this.ImagesService.getImage(id).then(function (result) {
	        return result;
	      });
	    }
	  }, {
	    key: "loadCategoriesNoLimit",
	    value: function loadCategoriesNoLimit() {
	      return this.ImagesService.loadCategoriesNoLimit().then(function (categories) {
	        return categories;
	      });
	    }
	  }, {
	    key: "removeImage",
	    value: function removeImage(id) {
	      return this.ImagesService.removeImage(id).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "updateData",
	    value: function updateData(data) {
	      return this.ImagesService.updateData(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "updateImageOrder",
	    value: function updateImageOrder(data) {
	      return this.ImagesService.updateImageOrder(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "updateImageData",
	    value: function updateImageData(data) {
	      return this.ImagesService.updateImageData(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "checkRecordExist",
	    value: function checkRecordExist(data) {
	      return this.ImagesService.checkRecordExist(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }, {
	    key: "saveImageData",
	    value: function saveImageData(data) {
	      return this.ImagesService.saveImageData(data).then(function (resp) {
	        return resp;
	      });
	    }
	  }]);
	  return ImagesDataProvider;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = ImagesDataProvider;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinymce = __webpack_require__(512);
	
	var _tinymce2 = _interopRequireDefault(_tinymce);
	
	__webpack_require__(544);
	
	__webpack_require__(514);
	
	__webpack_require__(515);
	
	__webpack_require__(516);
	
	__webpack_require__(517);
	
	__webpack_require__(518);
	
	__webpack_require__(519);
	
	__webpack_require__(520);
	
	__webpack_require__(521);
	
	__webpack_require__(522);
	
	__webpack_require__(523);
	
	__webpack_require__(524);
	
	__webpack_require__(525);
	
	__webpack_require__(526);
	
	__webpack_require__(527);
	
	__webpack_require__(528);
	
	__webpack_require__(513);
	
	__webpack_require__(529);
	
	__webpack_require__(530);
	
	__webpack_require__(531);
	
	__webpack_require__(532);
	
	__webpack_require__(533);
	
	__webpack_require__(534);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	__webpack_require__(537);
	
	__webpack_require__(538);
	
	__webpack_require__(539);
	
	__webpack_require__(540);
	
	__webpack_require__(541);
	
	__webpack_require__(542);
	
	var _template = __webpack_require__(499);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(500);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Plugins
	// Core - these two are required :-)
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(497);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(498);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinymce = __webpack_require__(512);
	
	var _tinymce2 = _interopRequireDefault(_tinymce);
	
	__webpack_require__(544);
	
	__webpack_require__(514);
	
	__webpack_require__(515);
	
	__webpack_require__(516);
	
	__webpack_require__(517);
	
	__webpack_require__(518);
	
	__webpack_require__(519);
	
	__webpack_require__(520);
	
	__webpack_require__(521);
	
	__webpack_require__(522);
	
	__webpack_require__(523);
	
	__webpack_require__(524);
	
	__webpack_require__(525);
	
	__webpack_require__(543);
	
	__webpack_require__(526);
	
	__webpack_require__(527);
	
	__webpack_require__(528);
	
	__webpack_require__(513);
	
	__webpack_require__(529);
	
	__webpack_require__(530);
	
	__webpack_require__(531);
	
	__webpack_require__(532);
	
	__webpack_require__(533);
	
	__webpack_require__(534);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	__webpack_require__(537);
	
	__webpack_require__(538);
	
	__webpack_require__(539);
	
	__webpack_require__(540);
	
	__webpack_require__(541);
	
	__webpack_require__(542);
	
	var _template = __webpack_require__(503);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(504);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};
	// Plugins
	// Core - these two are required :-)

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinymce = __webpack_require__(512);
	
	var _tinymce2 = _interopRequireDefault(_tinymce);
	
	__webpack_require__(544);
	
	__webpack_require__(514);
	
	__webpack_require__(515);
	
	__webpack_require__(516);
	
	__webpack_require__(517);
	
	__webpack_require__(518);
	
	__webpack_require__(519);
	
	__webpack_require__(520);
	
	__webpack_require__(521);
	
	__webpack_require__(522);
	
	__webpack_require__(523);
	
	__webpack_require__(524);
	
	__webpack_require__(525);
	
	__webpack_require__(543);
	
	__webpack_require__(526);
	
	__webpack_require__(527);
	
	__webpack_require__(528);
	
	__webpack_require__(513);
	
	__webpack_require__(529);
	
	__webpack_require__(530);
	
	__webpack_require__(531);
	
	__webpack_require__(532);
	
	__webpack_require__(533);
	
	__webpack_require__(534);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	__webpack_require__(537);
	
	__webpack_require__(538);
	
	__webpack_require__(539);
	
	__webpack_require__(540);
	
	__webpack_require__(541);
	
	__webpack_require__(542);
	
	var _template = __webpack_require__(505);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(506);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};
	// Plugins
	// Core - these two are required :-)

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _template = __webpack_require__(501);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(502);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinymce = __webpack_require__(512);
	
	var _tinymce2 = _interopRequireDefault(_tinymce);
	
	__webpack_require__(544);
	
	__webpack_require__(514);
	
	__webpack_require__(515);
	
	__webpack_require__(516);
	
	__webpack_require__(517);
	
	__webpack_require__(518);
	
	__webpack_require__(519);
	
	__webpack_require__(520);
	
	__webpack_require__(521);
	
	__webpack_require__(522);
	
	__webpack_require__(523);
	
	__webpack_require__(524);
	
	__webpack_require__(525);
	
	__webpack_require__(526);
	
	__webpack_require__(527);
	
	__webpack_require__(528);
	
	__webpack_require__(513);
	
	__webpack_require__(529);
	
	__webpack_require__(530);
	
	__webpack_require__(531);
	
	__webpack_require__(532);
	
	__webpack_require__(533);
	
	__webpack_require__(534);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	__webpack_require__(537);
	
	__webpack_require__(538);
	
	__webpack_require__(539);
	
	__webpack_require__(540);
	
	__webpack_require__(541);
	
	__webpack_require__(542);
	
	var _template = __webpack_require__(507);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _controller = __webpack_require__(508);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Plugins
	// Core - these two are required :-)
	exports.default = {
	  restrict: 'E',
	  bindings: {},
	  template: _template2.default,
	  controller: _controller2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<form method=\"post\">\r\n  <div ng-if=\"$ctrl.error\" class=\"alert alert-danger\" role=\"alert\">\r\n    <span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>\r\n    <span class=\"sr-only\">Error:</span>\r\n    {{$ctrl.error}}\r\n  </div>\r\n  <div class=\"form-group has-feedback\">\r\n    <input ng-model=\"$ctrl.email\" type=\"text\" class=\"form-control\" placeholder=\"Email\">\r\n    <span class=\"glyphicon glyphicon-envelope form-control-feedback\"></span>\r\n  </div>\r\n  <div class=\"form-group has-feedback\">\r\n    <input ng-model=\"$ctrl.password\" type=\"password\" class=\"form-control\" placeholder=\"Password\">\r\n    <span class=\"glyphicon glyphicon-lock form-control-feedback\"></span>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-8\">\r\n      <div class=\"checkbox icheck\">\r\n        <label>\r\n          <!--<input  type=\"checkbox\"> Remember Me-->\r\n        </label>\r\n      </div>\r\n    </div>\r\n    <!-- /.col -->\r\n    <div class=\"col-xs-4\">\r\n      <button type=\"submit\" ng-click=\"$ctrl.login($event)\" class=\"btn btn-primary btn-block btn-flat\">Sign In</button>\r\n    </div>\r\n    <!-- /.col -->\r\n  </div>\r\n</form>\r\n\r\n"

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthController = function () {
	  AuthController.$inject = ["AuthService", "$injector"];
	  function AuthController(AuthService, $injector) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AuthController);
	    this.email = "";
	    this.password = "";
	    this.userService = AuthService;
	    this.$injector = $injector;
	  }
	
	  (0, _createClass3.default)(AuthController, [{
	    key: "login",
	    value: function login($event) {
	      $event.preventDefault();
	      var result = this.userService.login(this.email, this.password);
	      if (!result) {
	        this.error = "Wrong Credentials";
	      } else {
	        this.$injector.get('$state').go('app');
	      }
	      console.log('login', this);
	    }
	  }]);
	  return AuthController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = AuthController;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<h2>\r\n  Dashboard will be here\r\n</h2>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardController = function DashboardController() {
	  (0, _classCallCheck3.default)(this, DashboardController);
	};
	
	// WEBPACK FOOTER //
	
	
	exports.default = DashboardController;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Order Listing\r\n    <small>List of Order</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li class=\"active\"><a ui-sref=\"app.orderlisting\">Orders</a></li>\r\n  </ol>\r\n</section>\r\n\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n\t<div style=\"float:left;width: 200px;\">\r\n            Select Limit :\r\n            <select ng-model=\"$ctrl.pageLimit\" name='pageLimit' class=\"form-control\"\r\n                    ng-options=\"key as value for (key , value) in $ctrl.pageLimitOptions\"\r\n                    ng-change=\"$ctrl.currentPage = 1;\r\n                                        $ctrl.getOrders()\" required style=\"display: inline; width: 75px;\">\r\n              <option ng-repeat=\"(key, value) in data\" value=\"{{key}}\">{{value}}</option>\r\n            </select>\r\n            <div class=\"input-group\" style=\"display: none;\">\r\n              <input type=\"text\" ng-model=\"text\" placeholder=\"Search\"\r\n                     class=\"form-control input-sm pull-right ng-pristine ng-valid ng-not-empty ng-touched\"\r\n                     name=\"table_search\" style=\"\">\r\n            <div class=\"input-group-btn\">\r\n\t\t\t\t<button ng-click=\"search(text, searchIn)\" type=\"submit\" class=\"btn btn-sm btn-default\"><i\r\n\t\t\t\tclass=\"fa fa-search\"></i></button>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <div class='box'>\r\n        <div class=\"box-header\">\r\n        </div>\r\n        <div class=\"box-body table-responsive no-padding\">\r\n          <table id=\"datatable_orders\"\r\n                 class=\"table table-striped table-bordered table-hover table-checkable dataTable no-footer\"\r\n                 aria-describedby=\"datatable_orders_info\" role=\"grid\">\r\n            <thead>\r\n            <tr class=\"heading\" role=\"row\">\r\n              <th width=\"50px\" class=\"sorting_disabled\" rowspan=\"1\" colspan=\"1\" aria-label=\"\">\r\n                <label class=\"mt-checkbox mt-checkbox-single mt-checkbox-outline\">\r\n                  <input type=\"checkbox\" ng-change=\"$ctrl.checkAll()\" class=\"group-checkable\"\r\n                         ng-model=\"$ctrl.selectall\">\r\n                  <span></span>\r\n                </label>\r\n              </th>\r\n              <th width=\"50px\" ng-class=\"{'active': $ctrl.col == '1'}\"> Order#\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('id', 'asc', 1, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('id', 'desc', 1, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"60px\" ng-class=\"{'active': $ctrl.col == '2'}\"> Gateway\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('orderType', 'asc', 2, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('orderType', 'desc', 2, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"60px\" ng-class=\"{'active': $ctrl.col == '3'}\"> Order&nbsp;Id\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('orderId', 'asc', 3, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('orderId', 'desc', 3, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"80px\" ng-class=\"{'active': $ctrl.col == '4'}\"> Purchased&nbsp;On\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('created_at', 'asc', 4, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('created_at', 'desc', 4, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"80px\"> Due&nbsp;Date</th>\r\n              <th width=\"80px\"> Invoice Due&nbsp;Date</th>\r\n              <th width=\"180px\" ng-class=\"{'active': $ctrl.col == '5'}\"> Customer\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '5' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('fullName', 'asc', 5, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '5' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('fullName', 'desc', 5, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"50px\" ng-class=\"{'active': $ctrl.col == '6'}\"> Qnty\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '6' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('quantity', 'asc',6, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '6' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('quantity', 'desc',6, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"100px\" ng-class=\"{'active': $ctrl.col == '7'}\"> Price\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '7' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('amount', 'asc', 7, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '7' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('amount', 'desc', 7, 2)\"></i>\r\n                                    </span>\r\n              </th> \r\n              <th width=\"120px\" ng-class=\"{'active': $ctrl.col == '10'}\"> Invoice\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '10' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('checkout_id', 'asc', 10, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '10' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('checkout_id', 'desc', 10, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"110px\" ng-class=\"{'active': $ctrl.col == '8'}\"> Shipping\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '8' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('delivery_type', 'asc', 8, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '8' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('delivery_type', 'desc', 8, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"100px\" ng-class=\"{'active': $ctrl.col == '9'}\"> Status\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '9' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('invoice_status', 'asc', 9, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '9' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('invoice_status', 'desc', 9, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"100px\"> Actions</th>\r\n            </tr>\r\n            <tr class=\"filter\" role=\"row\">\r\n              <td rowspan=\"1\" colspan=\"1\"></td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.id\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.orderType\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.orderId\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <p class=\"input-group\">\r\n                  <input type=\"text\" readonly class=\"form-control\" uib-datepicker-popup=\"{{$ctrl.format}}\"\r\n                         ng-model=\"$ctrl.from\" is-open=\"$ctrl.popup1.opened\" datepicker-options=\"$ctrl.dateOptions\"\r\n                         ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"$ctrl.altInputFormats\"/>\r\n                  <span class=\"input-group-btn\">\r\n                                            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.open1()\"><i\r\n                                              class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                                        </span>\r\n                </p>\r\n                <p class=\"input-group\">\r\n                  <input type=\"text\" readonly class=\"form-control\" uib-datepicker-popup=\"{{$ctrl.format}}\"\r\n                         ng-model=\"$ctrl.to\" is-open=\"$ctrl.popup2.opened\" datepicker-options=\"$ctrl.dateOptions\"\r\n                         ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"$ctrl.altInputFormats\"/>\r\n                  <span class=\"input-group-btn\">\r\n                                            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.open2()\"><i\r\n                                              class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                                        </span>\r\n                </p>\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.fullName\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.quantity\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <div class=\"margin-bottom-5\">\r\n                  <input type=\"text\" placeholder=\"From\" ng-model=\"$ctrl.price_from\"\r\n                         class=\"form-control form-filter input-sm margin-bottom-5 clearfix\"></div>\r\n                <input type=\"text\" placeholder=\"To\" ng-model=\"$ctrl.price_to\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.checkout_id\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <select class=\"form-control form-filter input-sm\" ng-model=\"$ctrl.delivery_type\">\r\n                  <option value=\"\">Select...</option>\r\n                  <option value=\"1\">Brev</option>\r\n                  <option value=\"2\">Varubrev</option>\r\n                  <option value=\"3\">Schenker</option>\r\n                  <option value=\"4\">Varubrev</option>\r\n                </select>\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <select class=\"form-control form-filter input-sm\" ng-model=\"$ctrl.invoice_status\">\r\n                  <option value=\"\">Select...</option>\r\n                  <option value=\"0\">New</option>\r\n                  <option value=\"1\">Production</option>\r\n                  <option value=\"2\">Ready for ship</option>\r\n                  <option value=\"3\">Shipped</option>\r\n                  <option value=\"4\">Invoiced</option>\r\n                  <option value=\"5\">Reminder</option>\r\n                  <option value=\"6\">Paid</option>\r\n                  <option value=\"7\">Cancelled</option>\r\n                  <option value=\"8\">Beställa mtrl.</option>\r\n                </select>\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <div class=\"margin-bottom-5\">\r\n                  <button class=\"btn btn-sm btn-success filter-submit margin-bottom\" ng-click=\"$ctrl.getOrders();\">\r\n                    <i class=\"fa fa-search\"></i> Search\r\n                  </button>\r\n                </div>\r\n                <button class=\"btn btn-sm btn-default filter-cancel\" ng-click=\"$ctrl.clearFilter();\">\r\n                  <i class=\"fa fa-times\"></i> Reset\r\n                </button>\r\n              </td>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat=\"data in $ctrl.orders\">\r\n              <td>\r\n                <label class=\"mt-checkbox mt-checkbox-single mt-checkbox-outline\">\r\n                  <input type=\"checkbox\" ng-model='data.checkbox' ng-checked=\"data.checked\" class=\"checkboxes\"\r\n                         name=\"id[]\" ng-change='$ctrl.checkbox(data.order_id,data.invoice_status,data.checkbox)'>\r\n                  <span></span>\r\n                </label>\r\n              </td>\r\n              <td>{{data.id}}</td>\r\n              <td align=\"center\">\r\n                <span ng-if='data.orderType == \"Invoice\"'>Invoice</span>\r\n                <span ng-if='data.orderType == \"Card\"'>Card</span>\r\n\t\t\t\t<span ng-if='data.orderType == \"Blog\"'>Blog</span>\r\n              </td>\r\n              <td>{{data.orderId}}</td>\r\n              <td>{{data.created_at|date : \"yyyy-MM-dd\"}}</td>\r\n              <td>{{data.due_date|date : \"yyyy-MM-dd\"}}</td>\r\n              <!-- Invoice Due Date -->\r\n                <td ng-if=\"data.invoice_due_date_status=='0'\" style=\"background-color: #F44336!important; color:#fff;\">\r\n                  <span ng-if=\"data.dateShowOrNot=='1'\">\r\n                      {{data.invoice_due_date|date : \"yyyy-MM-dd\"}}\r\n                  </span>\r\n                </td>\r\n                <td ng-if=\"data.invoice_due_date_status=='1' || data.invoice_due_date_status=='2'\">\r\n                  <span ng-if=\"data.dateShowOrNot=='1'\">\r\n                      {{data.invoice_due_date|date : \"yyyy-MM-dd\"}}\r\n                  </span>\r\n                </td>\r\n                <!-- <td ng-if=\"data.invoice_due_date_status=='0' && data.invoice_status<'5' && data.orderType == 'Invoice' && data.invoice_number != null\" style=\"background-color: #F44336!important; color:#fff;\">\r\n                  {{data.invoice_due_date|date : \"yyyy-MM-dd\"}}\r\n                </td>\r\n                <td ng-if=\"data.invoice_due_date_status=='1' && data.invoice_status>='5' && data.orderType == 'Invoice' && data.invoice_number != null\">\r\n                  {{data.invoice_due_date|date : \"yyyy-MM-dd\"}}\r\n                </td>\r\n                <td ng-if=\"(data.invoice_due_date_status=='0' || data.invoice_due_date_status=='1') && (data.orderType != 'Invoice' || data.invoice_number == null)\" >\r\n                  \r\n                </td> -->\r\n              <!-- End Invoice Due Date -->\r\n              <td>{{data.fullName}}</td>\r\n              <td align=\"center\">{{data.quantity}}</td>\r\n              <td>{{data.formatPrice}}</td>\r\n              <td>{{data.invoice_number || \"0\"}}</td>\r\n              <td align=\"center\">\r\n                <span class=\"label label-sm label-warning\" ng-if=\"data.delivery_type=='1'\">Brev</span>\r\n                <span style=\"background-color: #F44336!important;\" class=\"label label-sm label-warning\" ng-if=\"data.delivery_type=='2'\">Varubrev</span>\r\n                <span class=\"label label-sm label-success\" ng-if=\"data.delivery_type=='3'\">Schenker</span>\r\n                <span class=\"label label-sm label-success\" ng-if=\"data.delivery_type=='4'\">Varubrev</span>\r\n              </td>\r\n              <td align=\"center\" class=\"order-status\">\r\n                <span class=\"label label-sm label-new\" ng-if=\"data.invoice_status=='0'\">New</span>\r\n                <span class=\"label label-sm label-prod\" ng-if=\"data.invoice_status=='1'\">Production</span>\r\n                <span class=\"label label-sm label-ready-to-ship\" ng-if=\"data.invoice_status=='2'\">Ready for ship</span>\r\n                <span class=\"label label-sm label-shipped\" ng-if=\"data.invoice_status=='3'\">Shipped</span>\r\n                <span class=\"label label-sm label-invoiced\" ng-if=\"data.invoice_status=='4'\">Invoiced</span>\r\n                <span class=\"label label-sm label-reminder\" ng-if=\"data.invoice_status=='5'\">Reminder</span>\r\n                <span class=\"label label-sm label-paid\" ng-if=\"data.invoice_status=='6'\">Paid</span>\r\n                <span class=\"label label-sm label-cancelled\" ng-if=\"data.invoice_status=='7'\">Cancelled</span>\r\n                <span class=\"label label-sm btn-remake\" ng-if=\"data.invoice_status=='8'\">Beställa mtrl.</span>\r\n              </td>\r\n              <td>\r\n                <a class=\"btn btn-sm btn-circle btn-default btn-editable\" ui-sref=\"app.orderView({id:data.id})\">\r\n                  <i class=\"fa fa-search\"></i> View\r\n                </a>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"box-footer clearfix\">\r\n          <div style=\"display: inline;\">\r\n            <select ng-model='$ctrl.invoice_status_change'\r\n                    class=\"table-group-action-input form-control input-inline input-small input-sm\"\r\n                    style=\"float: left; width: 110px; margin-right: 10px;\">\r\n              <option value=\"\">Select...</option>\r\n              <option value=\"0\">New</option>\r\n              <option value=\"1\">Production</option>\r\n              <option value=\"2\">Ready for ship</option>\r\n              <option value=\"3\">Shipped</option>\r\n              <option value=\"4\">Invoiced</option>\r\n              <option value=\"5\">Reminder</option>\r\n              <option value=\"6\">Paid</option>\r\n              <option value=\"7\">Cancelled</option>\r\n              <option value=\"8\">Beställa mtrl.</option>\r\n            </select>\r\n            <button class=\"btn btn-sm btn-default table-group-action-submit\" ng-click='$ctrl.changeStatus();'><i\r\n              class=\"fa fa-check\"></i> Submit\r\n            </button>\r\n          </div>\r\n          <ul ng-if=\"$ctrl.ordersTotal > $ctrl.pageLimit\" uib-pagination boundary-links=\"true\" max-size=\"$ctrl.maxSize\"\r\n              total-items=\"$ctrl.ordersTotal\" items-per-page=\"$ctrl.pageLimit\" ng-model=\"$ctrl.currentPage\"\r\n              ng-change=\"$ctrl.getOrders()\" class=\"pagination-sm pull-right\" previous-text=\"&lsaquo;\"\r\n              next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></ul>\r\n          <ul ng-if=\"$ctrl.ordersTotal <= $ctrl.pageLimit\" class=\"pagination pagination-sm no-margin pull-right\">\r\n            <li><a href=\"#\">&laquo;</a></li>\r\n            <li><a href=\"#\">1</a></li>\r\n            <li><a href=\"#\">&raquo;</a></li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderController = function () {
	  OrderController.$inject = ["OrdersDataProvider"];
	  function OrderController(OrdersDataProvider) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, OrderController);
	    this.OrdersDataProvider = OrdersDataProvider;
	    this.currentPage = 1;
	    this.pageLimit = '100';
	    this.maxSize = 5;
	    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
	    this.field = 'id';
	    this.order_type = 'desc';
	    this.col = 0;
	    this.colTopDown = 0;
	    this.getOrders();
	    this.checkboxes = [];
	    this.checkboxesStatus = [];
	    var vm = this;
	    vm.open1 = function () {
	      vm.popup1.opened = true;
	    };
	    vm.open2 = function () {
	      vm.popup2.opened = true;
	    };
	    vm.format = 'yyyy-MM-dd';
	    vm.altInputFormats = ['M!/d!/yyyy'];
	    vm.popup1 = {
	      opened: false
	    };
	    vm.popup2 = {
	      opened: false
	    };
	  }
	
	  (0, _createClass3.default)(OrderController, [{
	    key: 'getSortRecors',
	    value: function getSortRecors(field, order_type, col, colTopDown) {
	      this.field = field;
	      this.order_type = order_type;
	      this.col = col;
	      this.colTopDown = colTopDown;
	      this.getOrders();
	    }
	  }, {
	    key: 'getOrders',
	    value: function getOrders() {
	      var currency = [];
	      currency['default'] = 'kr';
	      currency['signlabs.se'] = 'SEK';
	      currency['signlabs.dk'] = 'DKK';
	      currency['signlabs.no'] = 'NOK';
	      currency['signlabs.fi'] = 'EUR';
	      currency['signlabs.de'] = 'EUR';
	      currency['signlabs.at'] = 'EUR';
	      currency['signlabs.ch'] = 'EUR';
	      currency['signlabs.es'] = 'EUR';
	      currency['signlabs.fr'] = 'EUR';
	      currency['signlabs.it'] = 'EUR';
	      currency['signlabs.nl'] = 'EUR';
	      currency['signlabs.be'] = 'EUR';
	      currency['signlabs.pl'] = 'PLN';
	      currency['signlabs.eu'] = 'EUR';
	      currency['signlabs.co.uk'] = 'GBP';
	      currency['signlabs.com'] = 'USD';
	      currency['signlabs.loc'] = 'SEK';
	
	      var currencyDivider = [];
	      currencyDivider['default'] = ",";
	      currencyDivider['signlabs.se'] = ",";
	      currencyDivider['signlabs.dk'] = ",";
	      currencyDivider['signlabs.no'] = ",";
	      currencyDivider['signlabs.fi'] = ".";
	      currencyDivider['signlabs.de'] = ".";
	      currencyDivider['signlabs.at'] = ".";
	      currencyDivider['signlabs.ch'] = ".";
	      currencyDivider['signlabs.es'] = ".";
	      currencyDivider['signlabs.fr'] = ".";
	      currencyDivider['signlabs.it'] = ".";
	      currencyDivider['signlabs.nl'] = ".";
	      currencyDivider['signlabs.be'] = ".";
	      currencyDivider['signlabs.pl'] = ".";
	      currencyDivider['signlabs.eu'] = ".";
	      currencyDivider['signlabs.co.uk'] = ".";
	      currencyDivider['signlabs.com'] = ",";
	      currencyDivider['signlabs.loc'] = ",";
	
	      var vm = this;
	      var data = {};
	      var searchData = {};
	      searchData.invoice_status = vm.invoice_status;
	      searchData.price_to = vm.price_to;
	      searchData.price_from = vm.price_from;
	      searchData.quantity = vm.quantity;
	      searchData.fullName = vm.fullName;
	      searchData.to = vm.to;
	      searchData.from = vm.from;
	      searchData.orderId = vm.orderId;
	      searchData.delivery_type = vm.delivery_type;
	      if (vm.orderType == 'Svea') searchData.orderType = 'Invoice';
	      if (vm.orderType == 'Card') searchData.orderType = 'Card';
	      searchData.id = vm.id;
	      data.searchData = searchData;
	      data.currentPage = vm.currentPage;
	      data.pageLimit = vm.pageLimit;
	      data.field = vm.field;
	      data.order_type = vm.order_type;
	      vm.OrdersDataProvider.getOrders(data).then(function (result) {
	        vm.orders = result.data;
	        console.log('gg', vm.orders);
	        for (var i = 0; i < vm.orders.length; i++) {
	          var orderData = vm.orders[i];
	          vm.orders[i].currency = currency['default'];
	          if (vm.orders[i].site_domain) {
	            if (vm.orders[i].site_domain == "localhost:8000") {
	              vm.orders[i].site_domain = "signlabs.se";
	            }
	            vm.orders[i].currency = currency[vm.orders[i].site_domain];
	            vm.orders[i].currencyDivider = currencyDivider[vm.orders[i].site_domain];
	          } else {
	            vm.orders[i].currencyDivider = ",";
	          }
	          if (!vm.orders[i].currency_rate) {
	            vm.orders[i].currency_rate = 1;
	          }
	
	          //    vm.orders[i].formatPrice = ((orderData.amount * vm.orders[i].currency_rate).toFixed(2)).replace(".",vm.orders[i].currencyDivider)+" "+vm.orders[i].currency;
	          vm.orders[i].formatPrice = orderData.amount.toFixed(2).replace(".", vm.orders[i].currencyDivider) + " " + vm.orders[i].currency;
	          vm.mydate = new Date(orderData.created_at);
	          vm.currentDateInvoice = new Date();
	          if (orderData.invoice_created_at != null) {
	            vm.invoiceCreateDate = new Date(orderData.invoice_created_at);
	          } else {
	            vm.invoiceCreateDate = new Date();
	          }
	          orderData.invoice_due_date = angular.copy(vm.invoiceCreateDate);
	          vm.currentDateInvoice = angular.copy(vm.currentDateInvoice);
	          vm.invoiceNewDate = orderData.invoice_due_date.setDate(orderData.invoice_due_date.getDate() + 20);
	          vm.invoiceNewDate = new Date(vm.invoiceNewDate);
	          vm.invoiceNewDate = Date.parse(vm.invoiceNewDate);
	          vm.currentDateInvoice = Date.parse(vm.currentDateInvoice);
	
	          if (vm.invoiceNewDate < vm.currentDateInvoice && orderData.invoice_status < 6 && orderData.invoice_number != null) {
	            orderData.invoice_due_date_status = 0;
	          } else if (vm.invoiceNewDate > vm.currentDateInvoice && orderData.invoice_status >= 6 && orderData.invoice_number != null) {
	            orderData.invoice_due_date_status = 1;
	          } else {
	            orderData.invoice_due_date_status = 2;
	          }
	          if (orderData.orderType == "Invoice" && orderData.invoice_number != null) {
	            orderData.dateShowOrNot = 1;
	          } else {
	            orderData.dateShowOrNot = 0;
	          }
	          // console.log('orderData.invoice_due_date_status',orderData.invoice_due_date_status);
	          // console.log('orderData.dateShowOrNot',orderData.dateShowOrNot);
	
	          orderData.due_date = angular.copy(vm.mydate);
	          if (!orderData.delivery_time) orderData.delivery_time = '3-5';
	          vm.delivery_time = orderData.delivery_time.split("-");
	          var numberOfDaysToAdd = vm.delivery_time[1];
	          orderData.due_date.setDate(orderData.due_date.getDate() + parseInt(numberOfDaysToAdd));
	          //remove sat sunday
	          var currentDate = vm.mydate;
	          var fromDate = angular.copy(vm.mydate);
	          var toDate = angular.copy(orderData.due_date);
	          for (var d = fromDate; d <= toDate; d.setDate(d.getDate() + 1)) {
	            currentDate = new Date(d);
	            if (currentDate.getDay() == 0 || currentDate.getDay() == 6) {
	              orderData.due_date.setDate(orderData.due_date.getDate() + 1);
	            }
	          }
	          if (orderData.due_date.getDay() == 0) orderData.due_date.setDate(orderData.due_date.getDate() + 1);
	          if (orderData.due_date.getDay() == 6) orderData.due_date.setDate(orderData.due_date.getDate() + 2);
	        }
	        vm.ordersTotal = result.total;
	        vm.selectall = false;
	      });
	    }
	  }, {
	    key: 'priceFormat',
	    value: function priceFormat(amount) {
	      var vm = this;
	      console.log('listing', vm);
	      return (amount * vm.currency_rate).toFixed(2).replace(".", vm.currencyDivider) + " " + vm.currency;
	    }
	  }, {
	    key: 'changeStatus',
	    value: function changeStatus() {
	      if (!this.invoice_status_change) {
	        return false;
	      }
	      if (this.checkboxes.length == 0) {
	        alert('please select order first');
	        return false;
	      }
	      var vm = this;
	      var data = { 'invoice_status': vm.invoice_status_change, 'ids': vm.checkboxes, 'status': vm.checkboxesStatus };
	      vm.OrdersDataProvider.updateOrderStatus(data).then(function (resp) {
	        vm.pages = resp;
	        vm.getOrders();
	        vm.checkboxes = [];
	        vm.checkboxesStatus = [];
	      });
	    }
	  }, {
	    key: 'removeOrder',
	    value: function removeOrder(id) {
	      if (confirm("Are you sure to delete!") !== true) {
	        return false;
	      }
	      var vm = this;
	      vm.OrdersDataProvider.removeOrder(id).then(function (res) {
	        vm.getOrders();
	      });
	    }
	  }, {
	    key: 'clearFilter',
	    value: function clearFilter() {
	      this.invoice_status = '';
	      this.price_to = '';
	      this.price_from = '';
	      this.quantity = '';
	      this.fullName = '';
	      this.to = '';
	      this.from = '';
	      this.sveaOrderId = '';
	      this.orderType = '';
	      this.checkout_id = '';
	      this.getOrders();
	    }
	  }, {
	    key: 'checkbox',
	    value: function checkbox(order_id, status, _checkbox) {
	      if (_checkbox == true) {
	        if (this.checkboxes.indexOf(order_id) == '-1') {
	          this.checkboxes.push(order_id);
	          this.checkboxesStatus.push(status);
	        }
	      } else {
	        var index = this.checkboxes.indexOf(order_id);
	        this.checkboxes.splice(index, 1);
	        this.checkboxesStatus.splice(index, 1);
	      }
	    }
	  }, {
	    key: 'checkAll',
	    value: function checkAll() {
	      if (this.selectall) {
	        var _vm = this;
	        angular.forEach(this.orders, function (order) {
	          order.checked = 1;
	          _vm.checkboxes.push(order.order_id);
	          _vm.checkboxesStatus.push(order.invoice_status);
	        });
	      } else {
	        angular.forEach(this.orders, function (order) {
	          order.checked = 0;
	        });
	        this.checkboxes = [];
	        vm.checkboxesStatus = [];
	      }
	    }
	  }]);
	  return OrderController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = OrderController;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Order Details\r\n    <small></small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.orderlisting\">Orders</a></li>\r\n    <li class=\"active\">Details</li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <div class='box'>\r\n        <div class=\"box-body\">\r\n          <div class=\"alert alert-success\" ng-if=\"$ctrl.shippedMail == 1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\"\r\n               ng-click='$ctrl.shippedMail = 0;'>×</a>\r\n            Shipped email sent to customer\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6 col-sm-12\">\r\n              <div class=\"portlet \">\r\n                <div class=\"portlet-title\" style=\"border-bottom:none;\">\r\n                  <div class=\"caption\" style=\"width: 100%;font-size: 14px;\">\r\n                    Order Number: <strong>{{$ctrl.data.orderId}}</strong>\r\n                    <span class=\"domain-code\">\r\n                                            {{$ctrl.data.site_domain}}\r\n                                        </span>\r\n                    <span class=\"pull-right\">Order Date: <strong>{{$ctrl.data.created_at|date : \"yyyy-MM-dd HH:mm:ss\"}}</strong> </span>\r\n                    <br/>\r\n                    Order# : <strong>{{$ctrl.data.id}}</strong>\r\n                    <span class=\"pull-right\">Customer Type: <strong>{{$ctrl.data.customerType}} </strong><span\r\n                      ng-if=\"$ctrl.data.customerType=='Company'\"> - {{$ctrl.data.company_name}}</span> </span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"portlet-body\">\r\n                  <a ng-href='{{$ctrl.APPLICATION_URL}}/api/delivery/note/{{$ctrl.data.id}}' target='_blank'>\r\n                    <button class=\"btn btn-warning btn-create-receipt\">Delivery Note</button>\r\n                  </a>\r\n                  <a ng-href='{{$ctrl.APPLICATION_URL}}/api/order/pdf/{{$ctrl.data.id}}' target='_blank'>\r\n                    <button class=\"btn btn-warning btn-create-workorder\">Work Order</button>\r\n                  </a>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-6 col-sm-12\">\r\n              <div class=\"portlet\">\r\n                <div class=\"portlet-title clearfix\" style=\"border-bottom:none;\">\r\n                  <div style=\"width: 100%;font-size: 14px;\" class=\"caption clearfix\">\r\n                    Due Date: <strong>{{$ctrl.data.due_date|date : \"yyyy-MM-dd\"}}</strong>\r\n                    <div class=\"pull-right\">\r\n                      Order Status:\r\n                      <span\r\n                        style=\"background-color: buttonshadow; color: rgb(255, 255, 255); padding: 5px 10px; display: inline-block; border: 1px solid darkgray; float: right;\">\r\n                                                <span ng-if=\"$ctrl.data.invoice_status == '0'\">New</span>\r\n                                                <span ng-if=\"$ctrl.data.invoice_status == '1'\">Production</span>\r\n                                                <span ng-if=\"$ctrl.data.invoice_status == '2'\">Ready for ship</span>\r\n                                                <span ng-if=\"$ctrl.data.invoice_status == '3'\">Shipped</span>\r\n                                                <span ng-if=\"$ctrl.data.invoice_status == '4'\">Invoiced</span>\r\n                                                <span ng-if=\"$ctrl.data.invoice_status == '5'\">Paid</span>\r\n                                                <span ng-if=\"$ctrl.data.invoice_status == '6'\">Finished</span>\r\n                                                <span ng-if=\"$ctrl.data.invoice_status == '7'\">Cancelled</span>\r\n                                                <span ng-if=\"$ctrl.data.invoice_status == '8'\">Beställa mtrl.</span>\r\n                                            </span>\r\n                      <div class=\"yellow-crusta clearfix\"\r\n                           style=\"background-color: skyblue; padding: 8px 12px; border: 1px solid darkblue; width: 250px; margin-top: 12px;\">\r\n                        <span class=\"pull-left\">Grand Total:</span>\r\n                        <span class=\"pull-right\">{{$ctrl.priceFormatLocal($ctrl.data.amount)}}</span>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6 col-sm-12\">\r\n              <div class=\"portlet yellow-crusta box\">\r\n                <div class=\"portlet-title\">\r\n                  <div class=\"caption\">\r\n                    <i class=\"fa fa-shopping-cart\"></i>Order Status\r\n                  </div>\r\n                  <button class=\"btn btn-warning pull-right\" type=\"reset\" style=\"margin-top: 3px;\"\r\n                          ng-click=\"$ctrl.resetStatus($ctrl.data.order_id);\">Reset Status\r\n                  </button>\r\n                </div>\r\n                <div class=\"portlet-body\">\r\n                  <table class=\"table table-hover table-bordered table-striped\">\r\n                    <thead>\r\n                    <tr>\r\n                      <th align=\"center\"></th>\r\n                      <th align=\"center\">Date</th>\r\n                      <th align=\"center\">Time</th>\r\n                      <th align=\"center\">Time Spent</th>\r\n                    </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                    <tr>\r\n                      <td>\r\n                        <button class=\"btn btn-block\"\r\n                                ng-class=\"($ctrl.data.invoice_status >= 0) ? 'btn-new': 'btn-default'\"\r\n                                ng-click=\"$ctrl.changeStatus('0', $ctrl.data.order_id, $ctrl.data.invoice_status)\">New\r\n                        </button>\r\n                      </td>\r\n                      <td>{{$ctrl.data.created_at|date : \"yyyy-MM-dd\"}}</td>\r\n                      <td>{{$ctrl.data.created_at|date : \"HH:mm:ss\"}}</td>\r\n                      <td>\r\n                        <span ng-if=\"$ctrl.newTimeSpent != undefined\">{{$ctrl.newTimeSpent}}</span>\r\n                        <span ng-if=\"$ctrl.newTimeSpent == undefined\">-</span>\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>\r\n                        <button class=\"btn btn-default btn-block\"\r\n                                ng-class=\"($ctrl.data.invoice_status >= 1) ? 'btn-prod': 'btn-default'\"\r\n                                ng-click=\"$ctrl.changeStatus('1', $ctrl.data.order_id, $ctrl.data.invoice_status)\">\r\n                          Production\r\n                        </button>\r\n                      </td>\r\n                      <td>{{$ctrl.productionStatus.created_at|date : \"yyyy-MM-dd\"}}</td>\r\n                      <td>{{$ctrl.productionStatus.created_at|date : \"HH:mm:ss\"}}</td>\r\n                      <td>\r\n                        <span ng-if=\"$ctrl.productionTimeSpent != undefined\">{{$ctrl.productionTimeSpent}}</span>\r\n                        <span ng-if=\"$ctrl.productionStatus == undefined\">-</span>\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>\r\n                        <button class=\"btn btn-default btn-block\"\r\n                                ng-class=\"($ctrl.data.invoice_status >= 2) ? 'btn-ready-to-ship': 'btn-default'\"\r\n                                ng-click=\"$ctrl.changeStatus('2', $ctrl.data.order_id, $ctrl.data.invoice_status)\">Ready\r\n                          for ship\r\n                        </button>\r\n                      </td>\r\n                      <td>{{$ctrl.readyShipStatus.created_at|date : \"yyyy-MM-dd\"}}</td>\r\n                      <td>{{$ctrl.readyShipStatus.created_at|date : \"HH:mm:ss\"}}</td>\r\n                      <td>\r\n                        <span ng-if=\"$ctrl.readyShipTimeSpent != undefined\">{{$ctrl.readyShipTimeSpent}}</span>\r\n                        <span ng-if=\"$ctrl.readyShipTimeSpent == undefined\">-</span>\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>\r\n                        <button class=\"btn btn-default btn-block\"\r\n                                ng-class=\"($ctrl.data.invoice_status >= 3) ? 'btn-shipped': 'btn-default'\"\r\n                                ng-click=\"$ctrl.changeStatus('3', $ctrl.data.order_id, $ctrl.data.invoice_status)\">\r\n                          Shipped\r\n                        </button>\r\n                      </td>\r\n                      <td>{{$ctrl.shippedStatus.created_at|date : \"yyyy-MM-dd\"}}</td>\r\n                      <td>{{$ctrl.shippedStatus.created_at|date : \"HH:mm:ss\"}}</td>\r\n                      <td>\r\n                        <span ng-if=\"$ctrl.shippedTimeSpent != undefined\">{{$ctrl.shippedTimeSpent}}</span>\r\n                        <span ng-if=\"$ctrl.shippedTimeSpent == undefined\">-</span>\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>\r\n                        <button class=\"btn btn-default btn-block\"\r\n                                ng-class=\"($ctrl.data.invoice_status >= 4) ? 'btn-invoiced': 'btn-default'\"\r\n                                ng-click=\"$ctrl.changeStatus('4', $ctrl.data.order_id, $ctrl.data.invoice_status)\">\r\n                          Invoiced\r\n                        </button>\r\n                      </td>\r\n                      <td>{{$ctrl.invoicedStatus.created_at|date : \"yyyy-MM-dd\"}}</td>\r\n                      <td>{{$ctrl.invoicedStatus.created_at|date : \"HH:mm:ss\"}}</td>\r\n                      <td>\r\n                        <span ng-if=\"$ctrl.invoicedTimeSpent != undefined\">{{$ctrl.invoicedTimeSpent}}</span>\r\n                        <span ng-if=\"$ctrl.invoicedTimeSpent == undefined\">-</span>\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>\r\n                        <button class=\"btn btn-default btn-block\"\r\n                                ng-class=\"($ctrl.data.invoice_status >= 5) ? 'btn-reminder': 'btn-default'\"\r\n                                ng-click=\"$ctrl.changeStatus('5', $ctrl.data.order_id, $ctrl.data.invoice_status)\">\r\n                          Reminder\r\n                        </button>\r\n                      </td>\r\n                      <td>{{$ctrl.finishedStatus.created_at|date : \"yyyy-MM-dd\"}}</td>\r\n                      <td>{{$ctrl.finishedStatus.created_at|date : \"HH:mm:ss\"}}</td>\r\n                      <td>\r\n                        <span ng-if=\"$ctrl.finishedTimeSpent != undefined\">{{$ctrl.finishedTimeSpent}}</span>\r\n                        <span ng-if=\"$ctrl.finishedTimeSpent == undefined\">-</span>\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>\r\n                        <button class=\"btn btn-default btn-block\"\r\n                                ng-class=\"($ctrl.data.invoice_status >= 6) ? 'btn-paid': 'btn-default'\"\r\n                                ng-click=\"$ctrl.changeStatus('6', $ctrl.data.order_id, $ctrl.data.invoice_status)\">Paid\r\n                        </button>\r\n                      </td>\r\n                      <td>{{$ctrl.paidStatus.created_at|date : \"yyyy-MM-dd\"}}</td>\r\n                      <td>{{$ctrl.paidStatus.created_at|date : \"HH:mm:ss\"}}</td>\r\n                      <td>\r\n                        <span ng-if=\"$ctrl.paidTimeSpent != undefined\">{{$ctrl.paidTimeSpent}}</span>\r\n                        <span ng-if=\"$ctrl.paidTimeSpent == undefined\">-</span>\r\n                      </td>\r\n                    </tr>\r\n\r\n                    <tr>\r\n                      <td>\r\n                        <button class=\"btn btn-default btn-block\"\r\n                                ng-class=\"($ctrl.data.invoice_status >= 7) ? 'btn-cancelled': 'btn-default'\"\r\n                                ng-click=\"$ctrl.changeStatus('7', $ctrl.data.order_id, $ctrl.data.invoice_status)\">\r\n                          Cancelled\r\n                        </button>\r\n                      </td>\r\n                      <td>{{$ctrl.cancelledStatus.created_at|date : \"yyyy-MM-dd\"}}</td>\r\n                      <td>{{$ctrl.cancelledStatus.created_at|date : \"HH:mm:ss\"}}</td>\r\n                      <td>\r\n                        <span ng-if=\"$ctrl.cancelledTimeSpent != undefined\">{{$ctrl.cancelledTimeSpent}}</span>\r\n                        <span ng-if=\"$ctrl.cancelledTimeSpent == undefined\">-</span>\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>\r\n                        <button class=\"btn btn-default btn-block\"\r\n                                ng-class=\"($ctrl.data.invoice_status >= 8) ? 'btn-remake': 'btn-default'\"\r\n                                ng-click=\"$ctrl.changeStatus('8', $ctrl.data.order_id, $ctrl.data.invoice_status)\">\r\n                          Remake\r\n                        </button>\r\n                      </td>\r\n                      <td>-</td>\r\n                      <td>-</td>\r\n                      <td>-</td>\r\n                    </tr>\r\n                    </tbody>\r\n                  </table>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-6 col-sm-12\">\r\n              <div class=\"col-md-12 col-sm-12\">\r\n                <div class=\"portlet blue-hoki box\">\r\n                  <div class=\"portlet-title\">\r\n                    <div class=\"caption\">\r\n                      <i class=\"fa fa-credit-card\"></i>Betalinformation\r\n\t\t\t\t\t<a ng-href='{{$ctrl.APPLICATION_URL}}/api/invoice/note/{{$ctrl.data.id}}' target='_blank'>\r\n\t\t\t\t\t\t<button class=\"btn btn-warning btn-create-invoice\"ng-if='$ctrl.data.orderType == \"Invoice\" && !$ctrl.data.svea_invoice_id'>Faktura Kopia</button>\r\n\t\t\t\t\t</a>\r\n\t\t\t\t\t<a ng-href='{{$ctrl.APPLICATION_URL}}/api/custom/pdf/{{$ctrl.data.id}}' target='_blank'>\r\n\t\t\t\t\t\t<button class=\"btn btn-warning btn-create-reminder\" ng-if='$ctrl.data.orderType == \"Invoice\"'>Påminnelse Kopia</button>\r\n\t\t\t\t\t</a>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"portlet-body\">\r\n                    <div class=\"row static-info\">\r\n                      <div class=\"col-md-3 name\">Betalmetod:</div>\r\n                      <div class=\"col-md-9 value\">\r\n                        <!--<span ng-if='$ctrl.data.orderType == \"Invoice\"'>Faktura</span>\r\n                        <span ng-if='$ctrl.data.orderType == \"Card\"'>Kort</span>\r\n\t\t\t\t\t\t<span ng-if='$ctrl.data.orderType == \"Blog\"'>Blog</span>-->\r\n\t\t\t\t\t\t{{$ctrl.data.orderType}}\r\n                      </div>\r\n\t\t\t\t\t  \r\n                    </div>\r\n                    <div class=\"row static-info\">\r\n                      <div class=\"col-md-3 name\">Order Id :</div>\r\n                      <div class=\"col-md-9 value\">{{$ctrl.data.orderId}}</div>\r\n                    </div>\r\n                    <div class=\"row static-info\" ng-if='$ctrl.data.orderType == \"Invoice\"'>\r\n                      <div class=\"col-md-3 name\">Fakturatyp:</div>\r\n                      <div class=\"col-md-9 value\">\r\n                        <span >{{$ctrl.data.invoice_type_value}}</span>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row static-info\">\r\n                      <div class=\"col-md-3 name\">Fakturanummer:</div>\r\n                      <div class=\"col-md-9 value\">{{$ctrl.data.invoice_number || \"N/A\"}}</div>\r\n                    </div>\r\n                    <div class=\"row static-info\">\r\n                      <div class=\"col-md-3 name\">ORG nummer:</div>\r\n                      <div class=\"col-md-9 value\">{{$ctrl.data.orgnummer || \"N/A\"}}</div>\r\n                    </div>\r\n                    <div class=\"row static-info\" ng-if='$ctrl.data.orgnummer == \"\" && $ctrl.data.company_name == \"\"'>\r\n                      <div class=\"col-md-3 name\">Kreditkontroll:</div>\r\n                      <div class=\"col-md-9 value\">{{$ctrl.data.invoice_security_number || \"N/A\"}}</div>\r\n                    </div>\r\n                    <div class=\"row static-info\">\r\n                      <div class=\"col-md-3 name\">Ekopost:</div>\r\n                      <div class=\"col-md-9 value\">{{$ctrl.data.ekopost_status ? \"Completed\" : \"Pending\"}}</div>\r\n                    </div>\r\n                    <div class=\"row static-info\">\r\n                      <div class=\"col-md-3 name\">Förfallodatum:</div>\r\n                      <div class=\"col-md-9 value\">\r\n                        <span>{{$ctrl.data.invoice_due_date|date : \"yyyy-MM-dd\"}}</span>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row static-info\" ng-if='$ctrl.data.orderType == \"Card\"'>\r\n                      <div class=\"col-md-3 name\">ePay TXN-id:</div>\r\n                      <div class=\"col-md-9 value\">{{$ctrl.data.epay_txnid}}</div>\r\n                    </div>\r\n                    <div class=\"row static-info\" ng-if='$ctrl.data.orderType == \"Blog\"'>\r\n                      <div class=\"col-md-3 name\">Blogadress:</div>\r\n                      <div class=\"col-md-9 value\">{{$ctrl.data.blog_url}}</div>\r\n                    </div>\r\n                    <!--<div class=\"row static-info\">\r\n                      <div class=\"col-md-3 name\">Order Id:</div>\r\n                      <div class=\"col-md-9 value\">{{$ctrl.data.orderId}}</div>\r\n                    </div>-->\r\n                    <!--<div class=\"row static-info\">\r\n                      <div class=\"col-md-3 name\">Email :</div>\r\n                      <div class=\"col-md-9 value\"> {{$ctrl.data.email}}</div>\r\n                    </div>-->\r\n                    <!--<div class=\"row static-info\">\r\n                      <div class=\"col-md-3 name\">\r\n                        <span ng-if='$ctrl.data.orderType == \"Invoice\"'>TBD</span>\r\n                        <span ng-if='$ctrl.data.orderType == \"Card\"'>ePay TXN-id</span>\r\n                      </div>\r\n\t\t\t\t\t</div>-->\r\n                      <!--<div class=\"col-md-9 value\">\r\n                        <span ng-if='$ctrl.data.orderType == \"Invoice\"'>{{$ctrl.data.sveaOrderId}}</span>\r\n                        <span ng-if='$ctrl.data.orderType == \"Card\"'>{{$ctrl.data.epay_txnid}}</span>\r\n                      </div>\r\n                    </div>-->\r\n                    <!--<div class=\"row static-info\">\r\n                      <div class=\"col-md-3 name\"> Payment Status:</div>\r\n                      <div class=\"col-md-9 value\">\r\n                        <span ng-if='$ctrl.data.orderType == \"Invoice\"'>Not Paid</span>\r\n                        <span ng-if='$ctrl.data.orderType == \"Card\"'>Paid</span>\r\n                      </div>\r\n                    </div>-->\r\n                    <!--<div class=\"row static-info\" ng-if='$ctrl.data.svea_invoice_id'>\r\n                      <div class=\"col-md-3 name\"> Svea Invoice Id:</div>\r\n                      <div class=\"col-md-9 value\">\r\n                        {{$ctrl.data.svea_invoice_id}}\r\n                      </div>\r\n                    </div>-->\r\n                    <div class=\"row static-info\" ng-if='$ctrl.data.reference_no'>\r\n                      <div class=\"col-md-3 name\">Referens:</div>\r\n                      <div class=\"col-md-9 value\">\r\n                        {{$ctrl.data.reference_no}}\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row static-info\">\r\n                      <div class=\"col-md-12 value\">\r\n                        <!--<button class=\"btn btn-warning\"\r\n                                ng-if='$ctrl.data.orderType == \"Invoice\" && !$ctrl.data.svea_invoice_id'\r\n                                ng-click=\"$ctrl.generateInvoice()\">Approve Invoice\r\n                        </button>-->\r\n                        <!--<button class=\"btn btn-default\"\r\n                                ng-if='$ctrl.data.orderType == \"Card\" || $ctrl.data.svea_invoice_id'>Approve Invoice\r\n                        </button>-->\r\n                        \r\n                        <button class=\"btn btn-default\" ng-if=\"$ctrl.data.invoice_type == 1 && $ctrl.data.invoice_mail != '1' && $ctrl.data.orderType == 'Invoice'\" ng-click=\"$ctrl.sendInvoiceMail($ctrl.data.order_id)\">Epost-Faktura</button>\r\n                        <button class=\"btn btn-success\" ng-if=\"$ctrl.data.invoice_mail == '1'\">Epost-Faktura (Skickad)</button>\r\n                        <button class=\"btn btn-default\" ng-if=\"$ctrl.data.invoice_type == 2 && $ctrl.data.paper_invoice_mail != '1' && $ctrl.data.orderType == 'Invoice'\" ng-click=\"$ctrl.sendPaperInvoiceMail($ctrl.data.order_id)\">Pappersfaktura</button>\r\n                        <button class=\"btn btn-success\" ng-if=\"$ctrl.data.paper_invoice_mail == '1'\">Pappersfaktura (Skickad)</button>\r\n                        <button class=\"btn btn-default\" ng-if=\"$ctrl.data.reminder_mail != '1' && $ctrl.data.orderType == 'Invoice' && ($ctrl.data.invoice_mail == '1' || $ctrl.data.paper_invoice_mail == '1' )\" ng-click=\"$ctrl.sendReminderInvoiceMail($ctrl.data.order_id)\">Påminnelse</button>\r\n                        <button class=\"btn btn-success\" ng-if=\"$ctrl.data.reminder_mail == '1'\">Påminnelse (Skickad)</button>\r\n                        <a ng-href='{{$ctrl.APPLICATION_URL}}/api/invoice/credit/{{$ctrl.data.id}}' target='_blank'>\r\n                          <!-- <button class=\"btn btn-warning btn-create-invoice\" ng-if='$ctrl.data.orderType == \"Invoice\" && !$ctrl.data.svea_invoice_id'>Credit Invoice</button> -->\r\n                          <button class=\"btn btn-warning btn-create-invoice\" ng-if=\"$ctrl.data.invoice_mail == '1' && $ctrl.data.orderType == 'Invoice'\">Kreditfaktura</button>\r\n                        </a>\r\n                        <button class=\"btn btn-success pull-right\" ng-if=\"$ctrl.data.receipt_mail != '1' && $ctrl.data.orderType != 'Invoice'\" ng-click=\"$ctrl.sendReceiptMail($ctrl.data.order_id)\">Kvitto</button>\r\n                        <button class=\"btn btn-success pull-right\" ng-if=\"$ctrl.data.receipt_mail == '1'\">Kvitto (Skickad)</button>\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t<button class=\"btn btn-success pull-right\" ng-if=\"$ctrl.data.review_mail != '1'\" ng-click=\"$ctrl.sendReviewMail($ctrl.data.order_id)\">Recension</button>\r\n\t\t\t\t\t\t<button class=\"btn btn-success pull-right\" ng-if=\"$ctrl.data.review_mail == '1'\">Recension (Skickad)</button>\r\n\r\n                        <button class=\"btn btn-default\" ng-if=\"$ctrl.data.collection_mail != '1' && $ctrl.data.orderType == 'Invoice'\"\r\n                                ng-click=\"$ctrl.sendCollectionMail($ctrl.data.order_id)\">Inkasso\r\n                        </button>\r\n                        <button class=\"btn btn-success\" ng-if=\"$ctrl.data.collection_mail == '1'\">Inkasso (Skickad)</button>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-md-12 col-sm-12\">\r\n                <div class=\"portlet blue-hoki box\">\r\n                  <div class=\"portlet-title\">\r\n                    <div class=\"caption\">\r\n                      <i class=\"fa fa-truck\"></i>Leveransinformation\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"portlet-body\">\r\n                    <div>\r\n                      Shipping Method :\r\n                      <span class=\"label label-sm label-warning\" ng-if=\"$ctrl.data.delivery_type == '1'\">Brev</span>\r\n                      <span class=\"label label-sm label-warning\" ng-if=\"$ctrl.data.delivery_type == '2'\">Varubrev</span>\r\n                      <span class=\"label label-sm label-success\" ng-if=\"$ctrl.data.delivery_type == '3'\">Schenker</span>\r\n                      <span class=\"label label-sm label-success\" ng-if=\"$ctrl.data.delivery_type == '4'\">Varubrev</span>\r\n                    </div>\r\n                    <div class=\"row static-info\">\r\n                      <div class=\"col-md-5 name\"> Items :</div>\r\n                      <div class=\"col-md-7 value\">{{$ctrl.items.length}}</div>\r\n                    </div>\r\n                    <div class=\"row static-info\">\r\n                      <div class=\"col-md-5 name\"> Weight :</div>\r\n                      <div class=\"col-md-7 value\">{{$ctrl.parcelsWeight}} gr.</div>\r\n                    </div>\r\n                    <div class=\"row static-info\">\r\n                      <div class=\"col-md-4 name\"> Size :</div>\r\n                      <div class=\"col-md-8 value\">\r\n                        <table class=\"width-height-box\">\r\n                          <thead>\r\n                          <tr>\r\n                            <th>width</th>\r\n                            <th>height</th>\r\n                          </tr>\r\n                          </thead>\r\n                          <tbody>\r\n                          <tr>\r\n                            <td>{{$ctrl.itemMaxWH[0]}}</td>\r\n                            <td>{{$ctrl.itemMaxWH[1]}}</td>\r\n                          </tr>\r\n                          </tbody>\r\n                        </table>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row static-info\">\r\n                      <div class=\"col-md-12 name alert-success\" ng-if='$ctrl.data.shipped == 1'>\r\n                        Skickat till Unifaun\r\n                      </div>\r\n                      <div class=\"col-md-12 name\">\r\n                        <hr class=\"no-margin\">\r\n                        <h4>Shipping API</h4>\r\n                        <hr class=\"no-margin\">\r\n                        <br>\r\n                        <form name='shippedForm' novalidate>\r\n                          <div class=\"row static-info\">\r\n                            <div class=\"col-md-5 name\">Service</div>\r\n                            <div class=\"col-md-7 name\">\r\n                              <select ng-model=\"$ctrl.service_id\" class='form-control'\r\n                                      ng-init=\"$ctrl.service_id = 'BREVPOST'\"\r\n                                      ng-change=\"$ctrl.checkShippingService($ctrl.service_id);\">\r\n                                <option value=\"BREVPOST\">PostNord - Brev (BREVPOST)</option>\r\n\t\t\t\t\t\t\t\t<option value=\"PUA\">PostNord - Varubrev 1:a klass</option>\r\n                                <option value=\"P19\">PostNord MyPack Collect (P19)</option>\r\n                                <option value=\"P17\">PostNord MyPack Home (P17)</option>\r\n                                <option value=\"P18\">PostNord Parcel (P18)</option>\r\n                                <option value=\"DPD\">PostNord DPD Utrikes (DPD)</option>\r\n                                <option value=\"P91\">PostNord International Parcel (P91)</option>\r\n                                <option value=\"BREKD\">PostNord - Rek (BREKD)</option>\r\n                                <option value=\"BREKI\">PostNord - Rek (BREKI)</option>\r\n                                <option value=\"P34\">PostNord - Spårbart brev utrikes (LA) (P34)</option>\r\n                                <option value=\"BPA\">DB SCHENKER Parcel  (BPA)</option>\r\n                                <option value=\"BCF\">DB SCHENKER System  (BCF)</option>\r\n                                <option value=\"BHP\">DB SCHENKER Ombud (BHP)</option>\r\n                              </select>\r\n                            </div>\r\n                          </div>\r\n                          <div class=\"row static-info\">\r\n                            <div class=\"col-md-5 name\">Antal kolli</div>\r\n                            <div class=\"col-md-7 name\">\r\n                              <input ng-model=\"$ctrl.parcelsCopies\" name='copies' class='form-control' required\r\n                                     placeholder='Enter number of copies'>\r\n                              <span class=\"text-danger\" ng-show=\"(shippedForm.copies.$dirty) || shippedForm.$submitted\">\r\n                                                                <span ng-show=\"shippedForm.copies.$error.required\">Ange antal kolli</span>\r\n                                                            </span>\r\n                            </div>\r\n                          </div>\r\n                          <div class=\"row static-info\">\r\n                            <div class=\"col-md-5 name\">Vikt sändning</div>\r\n                            <div class=\"col-md-7 name\">\r\n                              <input ng-model=\"$ctrl.parcelsWeight\" name='weight' class='form-control' required\r\n                                     placeholder='Enter weight in gm'>\r\n                              <span class=\"text-danger\" ng-show=\"(shippedForm.weight.$dirty) || shippedForm.$submitted\">\r\n                                                                <span ng-show=\"shippedForm.weight.$error.required\">Ange vikt</span>\r\n                                                            </span>\r\n                            </div>\r\n                          </div>\r\n                          <div class=\"row static-info\" ng-if=\"($ctrl.service_id!='DPD' && $ctrl.service_id!='P91' && $ctrl.service_id!='BPA' && $ctrl.service_id!='BCF' && $ctrl.service_id!='BHP')\">\r\n                            <div class=\"col-md-5 name\">Addons</div>\r\n                            <div class=\"col-md-7 name\">\r\n                              <div ng-repeat=\"(key, value) in $ctrl.checkboxs\" class=\"standard\" flex=\"50\">\r\n                                <label>\r\n                                  <input type=\"checkbox\" ng-checked=\"$ctrl.exists(key, $ctrl.selected,$index)\"\r\n                                         ng-disabled=\"$ctrl.disabled==$index\"\r\n                                         ng-click=\"$ctrl.toggle(key, $ctrl.selected,0)\"/>\r\n                                  {{ value }}\r\n                                </label>\r\n                              </div>\r\n                            </div>\r\n                          </div>\r\n                          <div class=\"row static-info\"\r\n                               ng-if=\"($ctrl.service_id=='P18' || $ctrl.service_id=='P19' || $ctrl.service_id=='PUA' || $ctrl.service_id=='P17' || $ctrl.service_id=='P91' || $ctrl.service_id=='DPD' || $ctrl.service_id=='BPA' || $ctrl.service_id=='BCF' || $ctrl.service_id=='BHP')\">\r\n                            <div class=\"col-md-5 name\">Option</div>\r\n                            <div class=\"col-md-7 name\">\r\n                              <div ng-repeat=\"(key, value) in $ctrl.checkboxsOpt\" class=\"standard\" flex=\"50\">\r\n                                <label>\r\n                                  <input type=\"checkbox\" ng-checked=\"$ctrl.exists(key, $ctrl.selectedOpt,$index)\"\r\n                                         ng-click=\"$ctrl.toggle(key, $ctrl.selectedOpt,1)\"/>\r\n                                  {{ value }}\r\n                                </label>\r\n                              </div>\r\n                            </div>\r\n                          </div>\r\n                          <div class=\"row static-info\"\r\n                               ng-if=\"($ctrl.service_id=='BREVPOST' || $ctrl.service_id=='PUA' || $ctrl.service_id=='BREKI' || $ctrl.service_id=='P91' || $ctrl.service_id=='P34' || $ctrl.service_id=='BPA' || $ctrl.service_id=='BCF')\">\r\n                            <div class=\"col-md-5 name\">Customs</div>\r\n                            <div class=\"col-md-7 name\">\r\n                              <div ng-repeat=\"(key, value) in $ctrl.othersOpt\" class=\"standard\" flex=\"50\">\r\n                                <label>\r\n                                  <input type=\"checkbox\" ng-checked=\"$ctrl.exists(key, $ctrl.selectedOthrOpt,-1)\"\r\n                                         ng-disabled=\"$ctrl.disableCN==$index\"\r\n                                         ng-click=\"$ctrl.toggle(key, $ctrl.selectedOthrOpt,2)\"/>\r\n                                  {{ value }}\r\n                                </label>\r\n                              </div>\r\n                            </div>\r\n                          </div>\r\n                          <div class=\"row static-info\">\r\n                            <div class=\"col-md-12 name\">\r\n                              <button class=\"btn btn-success\" ng-click='shippedForm.$valid && $ctrl.sendShipment()'>Skicka\r\n                                till Unifaun\r\n                              </button>\r\n\t\t\t\t\t\t\t\t<button class=\"btn btn-default\" ng-if=\"$ctrl.data.shipped_mail != '1'\"\r\n\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.sendShippedMail($ctrl.data.order_id)\">Shipped Email\r\n\t\t\t\t\t\t\t\t</button>\r\n                  <button class=\"btn btn-success\" ng-if=\"$ctrl.data.shipped_mail == '1'\">Shipped Email (Sent)</button>\r\n                            </div>\r\n                            <div ng-show=\"$ctrl.__loading\" style=\"margin-top: 8px;\">\r\n                              <span class=\"fa fa-spinner fa-spin\"></span>\r\n                            </div>\r\n                          </div>\r\n                        </form>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12 col-sm-12\">\r\n              <div class=\"portlet yellow-crusta box\">\r\n                <div class=\"portlet-title\">\r\n                  <div class=\"caption\">\r\n                    <i class=\"fa fa-comments\"></i>Comments\r\n                  </div>\r\n                </div>\r\n                <div class=\"portlet-body no-padding\">\r\n                  <div class=\"row static-info\">\r\n                    <div class=\"col-md-6\"><textarea class=\"form-control\" placeholder=\"write comment\"\r\n                                                    ng-model=\"$ctrl.comment\" rows=\"5\"></textarea></div>\r\n                  </div>\r\n                  <div class=\"row static-info\">\r\n                    <div class=\"col-md-6\">\r\n                      <button class=\"btn btn-success pull-right\" ng-click='$ctrl.saveComment();'>Add Comment</button>\r\n                    </div>\r\n                  </div>\r\n                  <hr/>\r\n                  <div class=\"row static-info commentbox-padding\">\r\n                    <div class=\"col-md-12\" ng-repeat='com in $ctrl.comments' style=\"word-wrap: break-word;\">\r\n                      {{$index + 1}}. {{com.comment}}\r\n                      <span ng-if=\"!com.created_at\" class=\"timestamp\"> just now</span>\r\n                      <span ng-if=\"com.created_at\" class=\"timestamp\"> at {{com.created_at|date : \"yyyy-MM-dd HH:mm:ss\"}}</span>\r\n                      &nbsp;<i class=\"fa fa-remove commentbox-remove\" ng-click=\"$ctrl.removeComment(com.id);\"></i>\r\n                    </div>\r\n                  </div>\r\n                  <hr/>\r\n                </div>\r\n                <div class=\"portlet-title\" style=\"min-height: 0px;\">\r\n                  <i class=\"fa fa-comments\"></i>Customer Comments\r\n                </div>\r\n                <div class=\"portlet-body\">\r\n                  <div class=\"row static-info commentbox-padding\">\r\n                    Customer Comments goes here\r\n                    <div class=\"col-md-12 commentbox-text\" ng-repeat='com in $ctrl.customerComments'>{{$index + 1}}.\r\n                      {{com.comment}}\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6 col-sm-12\">\r\n              <div class=\"portlet blue-hoki box\">\r\n                <div class=\"portlet-title\">\r\n                  <div class=\"caption\">\r\n                    <i class=\"fa fa-user\"></i>Customer Information\r\n                  </div>\r\n                </div>\r\n                <div class=\"portlet-body\">\r\n                  <div class=\"row static-info\">\r\n                    <div class=\"col-md-5 name\"> Customer No:</div>\r\n                    <div class=\"col-md-7 value\"><a ng-href=\"/user-details-view/{{$ctrl.data.user_id}}\">{{$ctrl.data.user_id}}</a></div>\r\n                  </div>\r\n                  <div class=\"row static-info\">\r\n                    <div class=\"col-md-5 name\"> Customer Id/Email:</div>\r\n                    <div class=\"col-md-7 value\"> {{$ctrl.data.user_email}}</div>\r\n                  </div>\r\n                  <div class=\"row static-info\">\r\n                    <div class=\"col-md-5 name\"> Company :</div>\r\n                    <div class=\"col-md-7 value\"> {{$ctrl.data.user_company}}</div>\r\n                  </div>\r\n                  <div class=\"row static-info\">\r\n                    <div class=\"col-md-5 name\"> Name:</div>\r\n                    <div class=\"col-md-7 value\"> {{$ctrl.data.user_f_name}} {{$ctrl.data.user_l_name}}</div>\r\n                  </div>\r\n                  <div class=\"row static-info\">\r\n                    <div class=\"col-md-5 name\"> Location:</div>\r\n                    <div class=\"col-md-7 value\"> {{$ctrl.data.user_city}}</div>\r\n                  </div>\r\n                  <div class=\"row static-info\">\r\n                    <div class=\"col-md-5 name\"> Phone Number:</div>\r\n                    <div class=\"col-md-7 value\"> {{$ctrl.data.user_mobile}}</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-3 col-sm-12\">\r\n              <div class=\"portlet red-sunglo box\">\r\n                <div class=\"portlet-title\">\r\n                  <div class=\"caption\">\r\n                    <i class=\"fa fa-truck\"></i>Shipping Address\r\n                  </div>\r\n                </div>\r\n                <div class=\"portlet-body\">\r\n                  <div class=\"row static-info\">\r\n                    <div class=\"col-md-12 value\">\r\n                      {{$ctrl.data.s_company_name}}\r\n                      <br> {{$ctrl.data.s_fullName}}\r\n                      <br> {{$ctrl.data.s_street}}\r\n                      <br> {{$ctrl.data.s_zipCode}} {{$ctrl.data.s_locality}}\r\n                      <br> {{$ctrl.countries[$ctrl.data.s_country]}}\r\n                      <br> T: {{$ctrl.data.s_phoneNumber}}\r\n                      <br>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-3 col-sm-12\">\r\n              <div class=\"portlet green-meadow box\">\r\n                <div class=\"portlet-title\">\r\n                  <div class=\"caption\">\r\n                    <i class=\"fa fa-credit-card\"></i>Billing Address\r\n                  </div>\r\n                </div>\r\n                <div class=\"portlet-body\">\r\n                  <div class=\"row static-info\">\r\n                    <div class=\"col-md-12 value\">\r\n                      {{$ctrl.data.company_name}}\r\n                      <br> {{$ctrl.data.fullName}}\r\n                      <br> {{$ctrl.data.street}}\r\n                      <br> {{$ctrl.data.zipCode}} {{$ctrl.data.locality}}\r\n                      <br>{{$ctrl.countries[$ctrl.data.countryCode]}}\r\n                      <br> T: {{$ctrl.data.phoneNumber}}\r\n                      <br>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12 col-sm-12\">\r\n              <div class=\"portlet grey-cascade box\">\r\n                <div class=\"portlet-title\">\r\n                  <div class=\"caption\">\r\n                    <i class=\"fa fa-shopping-cart\"></i>Shopping Cart\r\n                  </div>\r\n                </div>\r\n                <div class=\"portlet-body\">\r\n                  <div class=\"table-responsive\">\r\n                    <table class=\"table table-hover table-bordered table-striped\">\r\n                      <thead>\r\n                      <tr>\r\n\t\t\t\t\t\t<th> Cart Pos</th>\r\n                        <th> Image</th>\r\n                        <th> Material</th>\r\n                        <th> Fix Method</th>\r\n                        <th> Width</th>\r\n                        <th> Height</th>\r\n                        <th> Weight</th>\r\n                        <th> Price</th>\r\n                        <th> Quantity</th>\r\n                        <th> Total</th>\r\n                        <th> Export</th>\r\n                      </tr>\r\n                      </thead>\r\n                      <tbody>\r\n                      <tr ng-repeat=\"item in $ctrl.items\">\r\n\t\t\t\t\t  <td>{{item.cart_position}}</td>\r\n                        <td class=\"btn btn-default\" align=\"center\">\r\n                          <a href=\"{{$ctrl.APPLICATION_URL}}/editor_png_files/{{item.unique_id}}.png\" target=\"_blank\">\r\n                            <img width='100' class='img-responsive'\r\n                                 ng-src=\"{{$ctrl.APPLICATION_URL}}/editor_png_files/{{item.unique_id}}.png\"\r\n                                 alt='product'/>\r\n                          </a>\r\n                        </td>\r\n                        <td>{{item.material_type}}</td>\r\n                        <td>{{item.fix_method_name}}</td>\r\n                        <td>{{item.width}}</td>\r\n                        <td>{{item.height}}</td>\r\n                        <td>{{item.weight| number : 2}}</td>\r\n                        <td>{{$ctrl.priceFormat(item.price)}}</td>\r\n                        <td>{{item.quantity}}</td>\r\n                        <td>{{$ctrl.priceFormat(item.price * item.quantity)}}</td>\r\n                        <td>\r\n                          <i class=\"fa fa-download\" aria-hidden=\"true\" ng-click=\"$ctrl.downloadSvgBNW(item)\"></i>\r\n                          <i ng-click=\"$ctrl.downloadSvgColor(item)\" aria-hidden=\"true\" class=\"fa fa-download\"\r\n                             style=\"color: rgb(107, 121, 162);\"></i>\r\n                          <div class=\"loader\" ng-show=\"item.__loading\">\r\n                            <span style=\"font-size: 20px;\" class=\"fa fa-spinner fa-spin\"></span>\r\n                          </div>\r\n                        </td>\r\n                      </tr>\r\n                      </tbody>\r\n                    </table>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6\"></div>\r\n            <div class=\"col-md-6\">\r\n              <div class=\"well\">\r\n                <div class=\"row static-info align-reverse\">\r\n                  <div class=\"col-md-8 name\"> Sub Total:</div>\r\n                  <div class=\"col-md-3 value\"> {{$ctrl.priceFormat($ctrl.data.grand_total)}}</div>\r\n                </div>\r\n                <div class=\"row static-info align-reverse\" ng-if=\"$ctrl.discountAmt > 0\">\r\n                  <div class=\"col-md-8 name\"> Discount</div>\r\n                  <div class=\"col-md-3 value\"> {{$ctrl.priceFormat($ctrl.discountAmt)}}</div>\r\n                </div>\r\n                <div class=\"row static-info align-reverse\" ng-if=\"$ctrl.data.coupon_price > 0\">\r\n                  <div class=\"col-md-8 name\"> Coupon discount amount</div>\r\n                  <div class=\"col-md-3 value\"> {{$ctrl.priceFormat($ctrl.data.coupon_price)}}</div>\r\n                </div>\r\n                <div class=\"row static-info align-reverse\">\r\n                  <div class=\"col-md-8 name\"> Shipping:</div>\r\n                  <div class=\"col-md-3 value\"> {{$ctrl.priceFormatLocal($ctrl.data.delivery_price)}}</div>\r\n                </div>\r\n                <div class=\"row static-info align-reverse\" ng-if='$ctrl.data.orderType == \"Invoice\"'>\r\n                  <div class=\"col-md-8 name\"> Invoice Fee:</div>\r\n                  <div class=\"col-md-3 value\"> {{$ctrl.priceFormatLocal($ctrl.data.invoice_fee)}}</div>\r\n                </div>\r\n                <div class=\"row static-info align-reverse\">\r\n                  <div class=\"col-md-8 name\"> VAT:</div>\r\n                  <div class=\"col-md-3 value\"> {{$ctrl.priceFormat($ctrl.vatAmt)}}</div>\r\n                </div>\r\n                <div class=\"row static-info align-reverse\">\r\n                  <div class=\"col-md-8 name\"><strong>Grand Total:</strong></div>\r\n                  <div class=\"col-md-3 value\"><strong> {{$ctrl.priceFormatLocal($ctrl.data.amount)}}</strong></div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(546);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderViewController = function () {
	  OrderViewController.$inject = ["OrdersDataProvider", "$state", "$timeout", "APPLICATION_URL", "UNIFAUN_ID", "UNIFAUN_SECRET"];
	  function OrderViewController(OrdersDataProvider, $state, $timeout, APPLICATION_URL, UNIFAUN_ID, UNIFAUN_SECRET) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, OrderViewController);
	    this.OrdersDataProvider = OrdersDataProvider;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.APPLICATION_URL = APPLICATION_URL;
	    this.UNIFAUN_ID = UNIFAUN_ID;
	    this.UNIFAUN_SECRET = UNIFAUN_SECRET;
	    this.errorShow = 0;
	    this.shipShow = 0;
	    this.parcelsCopies = 1;
	    this.Math = Math;
	    this.fromEmail = "info@signlabs.se";
	
	    var currency = [];
	    currency['default'] = 'kr';
	    currency['signlabs.se'] = 'SEK';
	    currency['signlabs.dk'] = 'DKK';
	    currency['signlabs.no'] = 'NOK';
	    currency['signlabs.fi'] = 'EUR';
	    currency['signlabs.de'] = 'EUR';
	    currency['signlabs.at'] = 'EUR';
	    currency['signlabs.ch'] = 'EUR';
	    currency['signlabs.es'] = 'EUR';
	    currency['signlabs.fr'] = 'EUR';
	    currency['signlabs.it'] = 'EUR';
	    currency['signlabs.nl'] = 'EUR';
	    currency['signlabs.be'] = 'EUR';
	    currency['signlabs.pl'] = 'PLN';
	    currency['signlabs.eu'] = 'EUR';
	    currency['signlabs.co.uk'] = 'GBP';
	    currency['signlabs.com'] = 'USD';
	    currency['signlabs.loc'] = 'SEK';
	
	    var currencyDivider = [];
	    currencyDivider['default'] = ",";
	    currencyDivider['signlabs.se'] = ",";
	    currencyDivider['signlabs.dk'] = ",";
	    currencyDivider['signlabs.no'] = ",";
	    currencyDivider['signlabs.fi'] = ".";
	    currencyDivider['signlabs.de'] = ".";
	    currencyDivider['signlabs.at'] = ".";
	    currencyDivider['signlabs.ch'] = ".";
	    currencyDivider['signlabs.es'] = ".";
	    currencyDivider['signlabs.fr'] = ".";
	    currencyDivider['signlabs.it'] = ".";
	    currencyDivider['signlabs.nl'] = ".";
	    currencyDivider['signlabs.be'] = ".";
	    currencyDivider['signlabs.pl'] = ".";
	    currencyDivider['signlabs.eu'] = ".";
	    currencyDivider['signlabs.co.uk'] = ".";
	    currencyDivider['signlabs.com'] = ",";
	    currencyDivider['signlabs.loc'] = ",";
	
	    var vm = this;
	    OrdersDataProvider.getOrder($state.params.id).then(function (result) {
	      result.currency = currency['default'];
	
	      if (result.site_domain) {
	        if (result.site_domain == "localhost:8000") {
	          result.site_domain = "signlabs.se";
	        }
	        result.currency = currency[result.site_domain];
	        result.currencyDivider = currencyDivider[result.site_domain];
	      } else {
	        result.currencyDivider = ",";
	      }
	      if (!result.currency_rate) {
	        result.currency_rate = 1;
	      }
	
	      vm.data = result;
	      //vm.cFormat(result);
	      var domainSplit = result.domain.split(".");
	      vm.domain = domainSplit.pop().toUpperCase();
	      if (!vm.data.s_company_name) vm.data.s_company_name = vm.data.company_name;
	      if (!vm.data.s_fullName) vm.data.s_fullName = vm.data.fullName;
	      if (!vm.data.s_street) vm.data.s_street = vm.data.street;
	      if (!vm.data.s_locality) vm.data.s_locality = vm.data.locality;
	      if (!vm.data.s_zipCode) vm.data.s_zipCode = vm.data.zipCode;
	      if (!vm.data.s_country) vm.data.s_country = vm.data.countryCode;
	      if (!vm.data.s_phoneNumber) vm.data.s_phoneNumber = vm.data.phoneNumber;
	      vm.phoneNumberShipp = vm.data.s_phoneNumber.replace(/-|\s/g, "");
	
	      if (vm.data.invoice_cost) {
	        vm.data.invoice_fee = vm.data.invoice_cost;
	      }
	      if (vm.data.invoice_type == 1) {
	        vm.data.invoice_type_value = "Email";
	      } else {
	        vm.data.invoice_type_value = "Paper";
	      }
	      vm.mydate = new Date(vm.data.created_at);
	      vm.data.due_date = angular.copy(vm.mydate);
	
	      if (vm.data.invoice_created_at == null) {
	        vm.data.invoice_due_date = new Date();
	        vm.data.invoice_due_date.setDate(vm.data.invoice_due_date.getDate() + 20);
	      } else {
	        vm.data.invoice_due_date = new Date(vm.data.invoice_created_at);
	        vm.data.invoice_due_date.setDate(vm.data.invoice_due_date.getDate() + 20);
	      }
	      if (!result.delivery_time) result.delivery_time = '3-5';
	      vm.delivery_time = result.delivery_time.split("-");
	      var numberOfDaysToAdd = vm.delivery_time[1];
	      vm.data.due_date.setDate(vm.data.due_date.getDate() + parseInt(numberOfDaysToAdd));
	      //remove sat sunday
	      var currentDate = vm.mydate;
	      var fromDate = angular.copy(vm.mydate);
	      var toDate = angular.copy(vm.data.due_date);
	      for (var d = fromDate; d <= toDate; d.setDate(d.getDate() + 1)) {
	        currentDate = new Date(d);
	        if (currentDate.getDay() == 0 || currentDate.getDay() == 6) {
	          vm.data.due_date.setDate(vm.data.due_date.getDate() + 1);
	        }
	      }
	      if (vm.data.due_date.getDay() == 0) vm.data.due_date.setDate(vm.data.due_date.getDate() + 1);
	      if (vm.data.due_date.getDay() == 6) vm.data.due_date.setDate(vm.data.due_date.getDate() + 2);
	
	      vm.discountAmt = result.grand_total * result.discount_percent / 100;
	      if (!result.coupon_price) result.coupon_price = 0;
	      vm.total = result.grand_total - (parseFloat(vm.discountAmt) + parseFloat(result.coupon_price)) + result.delivery_price / vm.data.currency_rate;
	
	      // vm.data.amount_part1 = Math.floor(result.amount);
	      // let decimal = (result.amount - Math.floor(result.amount)).toFixed(2);
	      // vm.data.amount_part2 = Number(decimal.substring(2));
	
	      if (result.orderType == "Invoice") vm.total += result.invoice_fee / vm.data.currency_rate;
	      vm.vatAmt = vm.total * result.vat_percent / 100;
	      vm.getStatusLog(result.order_id);
	
	      /*
	         OrdersDataProvider.getItems(result.order_id).then(function (items) {
	           vm.items = items;
	           let
	             itemMax = '';
	           vm.totalWeight = 0;
	           if (items.length > 1) {
	             itemMax = items.reduce(function (prev, current) {
	               return ((prev.width * prev.height) > (current.width * prev.height)) ? (prev.width + 'mm-' + prev.height + 'mm') : (current.width + 'mm-' + current.height + 'mm')
	             });
	           }
	           else if (items.length == 1) {
	             itemMax = items[0].width + 'mm-' + items[0].height + 'mm';
	             //let
	             //weight=items[0].weight;
	             //items[0].weight=Math.ceil(weight);
	           }
	           for (var key in items) {
	             vm.totalWeight += parseFloat(items[key].weight*items[key].quantity);
	           }
	           //vm.parcelsWeight = Math.ceil(vm.totalWeight);
	           //vm.parcelsWeight = vm.totalWeight < 80 ? 50 : (vm.totalWeight >= 80 && vm.totalWeight < 150) ? 100 : Math.ceil(vm.totalWeight);
	      vm.parcelsWeight = (vm.totalWeight + 20) < 80 ? 50 : ((vm.totalWeight + 20) >= 80 && (vm.totalWeight + 20) < 150) ? 100 : Math.ceil(vm.totalWeight + 20);
	      vm.itemMaxWH = itemMax.split('-');
	         });
	      */
	
	      /* Denna fungerar!
	      OrdersDataProvider.getItems(result.order_id).then(function (items) {
	      vm.items = items;
	      let maxWidthItem = null;
	      let maxHeightItem = null;
	      vm.totalWeight = 0;
	       // Loopa igenom objekten för att hitta det objekt med största bredd och det objekt med största höjd
	      for (var i = 0; i < items.length; i++) {
	       if (!maxWidthItem || items[i].width > maxWidthItem.width) {
	         maxWidthItem = items[i];
	       }
	       if (!maxHeightItem || items[i].height > maxHeightItem.height) {
	         maxHeightItem = items[i];
	       }
	         vm.totalWeight += parseFloat(items[i].weight * items[i].quantity);
	      }
	       // Beräkna vikten för paket (parcelsWeight) på samma sätt som tidigare
	      vm.parcelsWeight = (vm.totalWeight + 20) < 80 ? 50 :
	                        ((vm.totalWeight + 20) >= 80 && (vm.totalWeight + 20) < 150) ? 100 :
	                        Math.ceil(vm.totalWeight + 20);
	       // Sätt 'itemMaxWH' till det objekt med största bredd och det objekt med största höjd
	      vm.itemMaxWH = [maxWidthItem.width + 'mm', maxHeightItem.height + 'mm'];
	      });
	      */
	      OrdersDataProvider.getItems(result.order_id).then(function (items) {
	        vm.items = items;
	        var maxWidthItem = null;
	        var maxHeightItem = null;
	        vm.totalWeight = 0;
	
	        // Loopa igenom objekten för att hitta det objekt med största bredd och det objekt med största höjd
	        for (var i = 0; i < items.length; i++) {
	          if (!maxWidthItem || items[i].width > maxWidthItem.width) {
	            maxWidthItem = items[i];
	          }
	          if (!maxHeightItem || items[i].height > maxHeightItem.height) {
	            maxHeightItem = items[i];
	          }
	
	          vm.totalWeight += parseFloat(items[i].weight * items[i].quantity);
	        }
	
	        // Lägg till vikter baserat på bredd och höjd
	        if (maxWidthItem.width < 311 || maxHeightItem.height < 311) {
	          vm.totalWeight += 46;
	        } else if (maxWidthItem.width >= 311 && maxWidthItem.width < 387 || maxHeightItem.height >= 311 && maxHeightItem.height < 387) {
	          vm.totalWeight += 88;
	        } else if (maxWidthItem.width >= 387 || maxHeightItem.height >= 387) {
	          vm.totalWeight += 172;
	        }
	
	        // Uppdatera vm.parcelsWeight enligt de nya beräkningarna
	        vm.parcelsWeight = vm.totalWeight < 80 ? 50 : vm.totalWeight >= 80 && vm.totalWeight < 150 ? 100 : Math.ceil(vm.totalWeight);
	
	        // Sätt 'itemMaxWH' till det objekt med största bredd och det objekt med största höjd
	        vm.itemMaxWH = [maxWidthItem.width + 'mm', maxHeightItem.height + 'mm'];
	      });
	
	      OrdersDataProvider.getComments(result.order_id).then(function (comments) {
	        vm.comments = comments;
	      });
	    });
	    // countries
	    var theUrl = vm.APPLICATION_URL + '/api/get/countries';
	    var xmlHttp = new XMLHttpRequest();
	    xmlHttp.open("GET", theUrl, false); // false for synchronous request
	    xmlHttp.send(null);
	    vm.countries = JSON.parse(xmlHttp.response);
	    // shipping
	    vm.checkShippingService('BREVPOST');
	  }
	
	  (0, _createClass3.default)(OrderViewController, [{
	    key: "priceFormat",
	    value: function priceFormat(amount) {
	      var vm = this.data;
	      return amount ? (amount * vm.currency_rate).toFixed(2).replace(".", vm.currencyDivider) + " " + vm.currency : 0;
	    }
	  }, {
	    key: "priceFormatLocal",
	    value: function priceFormatLocal(amount) {
	      var vm = this.data;
	      return amount ? amount.toFixed(2).replace(".", vm.currencyDivider) + " " + vm.currency : 0;
	    }
	  }, {
	    key: "checkShippingService",
	    value: function checkShippingService(id) {
	      this.checkboxs = {};
	      this.selected = [];
	      this.checkboxsOpt = {};
	      this.selectedOpt = [];
	      this.othersOpt = {};
	      this.selectedOthrOpt = [];
	      this.disabled = -1;
	      this.disableCN = -1;
	      var vm = this;
	
	      if (id == 'P19' || id == 'P17' || id == 'P91' || id == 'PUA' || id == 'DPD' || id == 'P18' || id == 'BPA' || id == 'BCF' || id == 'BHP') {
	        vm.checkboxsOpt = { 'ENOT': 'Föravisering (E-post)' };
	        vm.selectedOpt = [{
	          "message": "OrderNo: " + vm.data.orderId,
	          "to": vm.data.s_email,
	          "id": "ENOT",
	          "languageCode": "SE",
	          "from": vm.fromEmail
	        }];
	      }
	      if (id == 'BREVPOST') {
	        vm.checkboxs = { 'PRIO': '1:a-klass brev', 'EBREV': 'Ekonomibrev', 'SPXL': 'Skrymmande' };
	        vm.selected = [{ "id": "PRIO" }];
	      }
	      if (id == 'P18') {
	        vm.checkboxs = { "PRENOT": "Föravisering" };
	      }
	      if (id == 'P19' || id == 'PUA') {
	        vm.checkboxs = { 'NOTSMS': 'SMS-avisering', 'NOTEMAIL': 'E-postavisering' };
	        vm.selected = [];
	      }
	      if (id == 'BREKD') {
	        vm.checkboxs = { "NOTSMS": "SMS-avisering" };
	        vm.selected = [{ "id": "NOTSMS", "misc": vm.phoneNumberShipp }];
	      }
	      if (id == 'BREKI') {
	        vm.checkboxs = { 'NOINSU': 'REK 2000', 'INSU': 'REK 10000' };
	        vm.selected = [{ "id": "NOINSU" }];
	      }
	      if (id == 'P17') {
	        vm.checkboxs = { 'DLVNOT': 'Leveransavisering' };
	        vm.selected = [{ "id": "DLVNOT", "text3": vm.phoneNumberShipp, "text4": vm.data.s_email }];
	      }
	      if (id == 'P34') {
	        vm.checkboxs = { 'NOTMAXI': 'Ej Maxi' };
	        vm.selected = [];
	      }
	      //others
	      if (id == 'P19' || id == 'P18' || id == 'BREVPOST' || id == 'BREKI' || id == 'PUA') {
	        vm.othersOpt = { "CN22": "CN22", "CN23": "CN23" };
	      }
	      if (id == 'P34') {
	        vm.othersOpt = { "CN22": "CN22", "CN23": "CN23" };
	      }
	      if (id == 'P91' || id == 'BPA' || id == 'BCF' || id == 'BHP') {
	        vm.othersOpt = { "CN22": "CN22", "CN23": "CN23" };
	      }
	    }
	  }, {
	    key: "toggle",
	    value: function toggle(checkbox, list, opt) {
	      var vm = this;
	      var index = list.findIndex(function (el) {
	        return el.id === checkbox;
	      });
	      if (index > -1) {
	        list.splice(index, 1);
	        if (opt != 2) vm.disabled = -1;else vm.disableCN = -1;
	      } else {
	        if (opt == 1) {
	          list.push({
	            "message": "OrderNo: " + vm.data.orderId,
	            "to": vm.data.s_email,
	            "id": checkbox,
	            "languageCode": "SE",
	            "from": this.fromEmail
	          });
	        } else if (opt == 2) {
	          //other options
	          list.push({ 'id': checkbox });
	          if (checkbox == 'CN22') {
	            vm.disableCN = 1;
	          }
	          if (checkbox == 'CN23') {
	            vm.disableCN = 0;
	          }
	        } else {
	          var obj = {};
	          var obj1 = {};
	          var id = this.service_id;
	
	          if (id == 'BREVPOST') {
	            if (checkbox == 'PRIO') {
	              this.disabled = 1;
	              index = list.findIndex(function (el) {
	                return el.id === 'EBREV';
	              });
	              if (index > -1) {
	                return false;
	              }
	            }
	            if (checkbox == 'EBREV') {
	              this.disabled = 0;
	              index = list.findIndex(function (el) {
	                return el.id === 'PRIO';
	              });
	              if (index > -1) {
	                return false;
	              }
	            }
	            obj = { "id": checkbox };
	          }
	          if (id == 'P18') {
	            obj = { "id": checkbox, "text3": vm.phoneNumberShipp, "text4": vm.data.s_email };
	          }
	          if (id == 'P19') {
	            if (checkbox == 'NOTSMS') obj = { "id": checkbox, "misc": vm.phoneNumberShipp };
	            if (checkbox == 'NOTEMAIL') obj = { "id": checkbox, "misc": vm.data.s_email };
	          }
	          if (id == 'PUA') {
	            if (checkbox == 'NOTSMS') obj = { "id": checkbox, "misc": vm.phoneNumberShipp };
	            if (checkbox == 'NOTEMAIL') obj = { "id": checkbox, "misc": vm.data.s_email };
	          }
	          if (id == 'BREKD') {
	            obj = { "id": checkbox, "misc": vm.phoneNumberShipp };
	          }
	          if (id == 'BREKI') {
	            if (checkbox == 'NOINSU') {
	              this.disabled = 1;
	              index = list.findIndex(function (el) {
	                return el.id === 'INSU';
	              });
	              if (index > -1) {
	                return false;
	              }
	            }
	            if (checkbox == 'INSU') {
	              this.disabled = 0;
	              index = list.findIndex(function (el) {
	                return el.id === 'NOINSU';
	              });
	              if (index > -1) {
	                return false;
	              }
	            }
	            obj = { "id": checkbox };
	          }
	          if (id == 'P17') {
	            obj = { "id": checkbox, "text3": vm.phoneNumberShipp, "text4": vm.data.s_email };
	          }
	          if (id == 'P34') {
	            obj = { "id": checkbox };
	          }
	          list.push(obj);
	        }
	      }
	    }
	  }, {
	    key: "exists",
	    value: function exists(checkbox, list, index) {
	      var obj = list.filter(function (obj) {
	        return obj.id === checkbox;
	      })[0];
	      if ((this.service_id == 'BREVPOST' || this.service_id == 'BREKI' || this.service_id == 'PUA') && obj != undefined && index == 0) this.disabled = 1;
	      if ((this.service_id == 'BREVPOST' || this.service_id == 'BREKI' || this.service_id == 'PUA') && obj != undefined && index == 1) this.disabled = 0;
	      return obj;
	    }
	  }, {
	    key: "saveComment",
	    value: function saveComment() {
	      if (this.comment) {
	        var vm = this;
	        var saveData = { 'user_id': '0', 'order_id': vm.data.order_id, 'comment': vm.comment };
	        vm.OrdersDataProvider.saveComments(saveData).then(function (res) {
	          if (res.exist == '0') {
	            vm.comments.push(res);
	          }
	        });
	      }
	    }
	  }, {
	    key: "removeComment",
	    value: function removeComment(cid) {
	      var vm = this;
	      vm.OrdersDataProvider.removeComment(cid).then(function (res) {
	        var index = vm.comments.findIndex(function (el) {
	          return el.id === cid;
	        });
	        if (index !== -1) {
	          vm.comments.splice(index, 1);
	        }
	      });
	    }
	  }, {
	    key: "getStatusLog",
	    value: function getStatusLog(order_id) {
	      var vm = this;
	      vm.OrdersDataProvider.getOrderStatusLogs(order_id).then(function (logs) {
	        //vm.statusLog=logs;
	        vm.productionStatus = logs.filter(function (obj) {
	          return obj.status_to === 1;
	        })[0];
	        if (vm.productionStatus != undefined) {
	          vm.newTimeSpent = vm.getTimeSpent(new Date(vm.productionStatus.created_at), vm.mydate);
	        } else {
	          vm.newTimeSpent = undefined;
	        }
	        vm.readyShipStatus = logs.filter(function (obj) {
	          return obj.status_to === 2;
	        })[0];
	        if (vm.readyShipStatus != undefined) {
	          vm.productionTimeSpent = vm.getTimeSpent(new Date(vm.readyShipStatus.created_at), new Date(vm.productionStatus.created_at));
	        } else {
	          vm.productionTimeSpent = undefined;
	        }
	        vm.shippedStatus = logs.filter(function (obj) {
	          return obj.status_to === 3;
	        })[0];
	        if (vm.shippedStatus != undefined) {
	          vm.readyShipTimeSpent = vm.getTimeSpent(new Date(vm.shippedStatus.created_at), new Date(vm.readyShipStatus.created_at));
	        } else {
	          vm.readyShipTimeSpent = undefined;
	        }
	        vm.invoicedStatus = logs.filter(function (obj) {
	          return obj.status_to === 4;
	        })[0];
	        if (vm.invoicedStatus != undefined) {
	          vm.shippedTimeSpent = vm.getTimeSpent(new Date(vm.invoicedStatus.created_at), new Date(vm.shippedStatus.created_at));
	        } else {
	          vm.shippedTimeSpent = undefined;
	        }
	        vm.finishedStatus = logs.filter(function (obj) {
	          return obj.status_to === 5;
	        })[0];
	        if (vm.finishedStatus != undefined) {
	          // vm.paidTimeSpent = vm.getTimeSpent(new Date(vm.finishedStatus.created_at), new Date(vm.paidStatus.created_at));
	          vm.invoicedTimeSpent = vm.getTimeSpent(new Date(vm.finishedStatus.created_at), new Date(vm.invoicedStatus.created_at));
	        } else {
	          // vm.paidTimeSpent = undefined;
	          vm.invoicedTimeSpent = undefined;
	        }
	        vm.paidStatus = logs.filter(function (obj) {
	          return obj.status_to === 6;
	        })[0];
	        if (vm.paidStatus != undefined) {
	          vm.finishedTimeSpent = vm.getTimeSpent(new Date(vm.paidStatus.created_at), new Date(vm.finishedStatus.created_at));
	        } else {
	          vm.finishedTimeSpent = undefined;
	        }
	        vm.cancelledStatus = logs.filter(function (obj) {
	          return obj.status_to === 7;
	        })[0];
	        if (vm.cancelledStatus != undefined) {
	          vm.cancelledTimeSpent = vm.getTimeSpent(new Date(vm.cancelledStatus.created_at), vm.mydate);
	        } else {
	          vm.cancelledTimeSpent = undefined;
	        }
	        var remakeStatus = logs.filter(function (obj) {
	          return obj.status_to === 8;
	        })[0];
	      });
	    }
	  }, {
	    key: "getTimeSpent",
	    value: function getTimeSpent(date_future, date_now) {
	      var delta = Math.abs(date_future - date_now) / 1000;
	      var days = Math.floor(delta / 86400);
	      delta -= days * 86400;
	      var hours = Math.floor(delta / 3600) % 24;
	      delta -= hours * 3600;
	      var minutes = Math.floor(delta / 60) % 60;
	      delta -= minutes * 60;
	      var seconds = delta % 60;
	
	      var returnData = '';
	      if (days > 0) {
	        returnData += days + ' day ';
	      }
	      returnData += ("0" + hours).slice(-2) + ' : ' + ("0" + minutes).slice(-2) + ' : ' + ("0" + seconds).slice(-2);
	      return returnData;
	    }
	  }, {
	    key: "changeStatus",
	    value: function changeStatus(status, id, old_status) {
	      if (!status) {
	        return false;
	      }
	      var vm = this;
	      var data = { 'invoice_status': status, 'ids': [id], 'status': [old_status] };
	      vm.OrdersDataProvider.updateOrderStatus(data).then(function (resp) {
	        vm.data.invoice_status = resp.invoice_status;
	        vm.getStatusLog(id);
	      });
	    }
	  }, {
	    key: "sendShippedMail",
	    value: function sendShippedMail(order_id) {
	      var vm = this;
	      vm.OrdersDataProvider.sendShippedMail(order_id).then(function (resp) {
	        vm.shippedMail = 1;
	        vm.data.shipped_mail = 1;
	      });
	    }
	  }, {
	    key: "sendInvoiceMail",
	    value: function sendInvoiceMail(order_id) {
	      var vm = this;
	      vm.OrdersDataProvider.sendInvoiceMail(order_id).then(function (resp) {
	        vm.invoiceMail = 1;
	        vm.data.invoice_mail = 1;
	      });
	    }
	  }, {
	    key: "sendCollectionMail",
	    value: function sendCollectionMail(order_id) {
	      var vm = this;
	      vm.OrdersDataProvider.sendCollectionMail(order_id).then(function (resp) {
	        vm.invoiceMail = 1;
	        vm.data.collection_mail = 1;
	      });
	    }
	  }, {
	    key: "sendReceiptMail",
	    value: function sendReceiptMail(order_id) {
	      var vm = this;
	      vm.OrdersDataProvider.sendReceiptMail(order_id).then(function (resp) {
	        vm.invoiceMail = 1;
	        vm.data.receipt_mail = 1;
	      });
	    }
	  }, {
	    key: "sendReviewMail",
	    value: function sendReviewMail(order_id) {
	      var vm = this;
	      vm.OrdersDataProvider.sendReviewMail(order_id).then(function (resp) {
	        vm.data.review_mail = 1;
	      });
	    }
	  }, {
	    key: "sendPaperInvoiceMail",
	    value: function sendPaperInvoiceMail(order_id) {
	      var vm = this;
	      vm.OrdersDataProvider.sendPaperInvoiceMail(order_id).then(function (resp) {
	        vm.paperInvoiceMail = 1;
	        vm.data.paper_invoice_mail = 1;
	      });
	    }
	  }, {
	    key: "sendReminderInvoiceMail",
	    value: function sendReminderInvoiceMail(order_id) {
	      var vm = this;
	      vm.OrdersDataProvider.sendReminderInvoiceMail(order_id).then(function (resp) {
	        vm.paperInvoiceMail = 1;
	        vm.data.reminder_mail = 1;
	      });
	    }
	  }, {
	    key: "resetStatus",
	    value: function resetStatus(id) {
	      var vm = this;
	      vm.OrdersDataProvider.resetOrderStatus(id).then(function (resp) {
	        vm.data.invoice_status = '0';
	        vm.getStatusLog(id);
	      });
	    }
	  }, {
	    key: "generateInvoice",
	    value: function generateInvoice() {
	      var vm = this;
	      var theUrl = vm.APPLICATION_URL + '/api/svea/invoice/deliver/' + vm.data.sveaOrderId;
	      var xmlHttp = new XMLHttpRequest();
	      xmlHttp.open("GET", theUrl, false); // false for synchronous request
	      xmlHttp.send(null);
	      var resp = JSON.parse(xmlHttp.response);
	      if (resp.resultcode == '0') {
	        vm.data.svea_invoice_id = resp.invoiceId;
	        var data = { 'svea_invoice_id': vm.data.svea_invoice_id, 'id': vm.$state.params.id };
	        vm.OrdersDataProvider.updateInvoiceId(data).then(function (resp) {});
	      } else {
	        alert(resp.errormessage);
	        vm.data.errorInvoice = resp.errormessage;
	      }
	    }
	  }, {
	    key: "sendShipment",
	    value: function sendShipment(form) {
	      var vm = this;
	      vm.__loading = true;
	      if (this.service_id == 'BREVPOST') {
	        var body = {
	          "sender": {
	            "quickId": "1"
	          },
	          "receiver": {
	            "phone": vm.phoneNumberShipp,
	            "email": vm.data.s_email,
	            "name": vm.data.s_company_name ? vm.data.s_company_name : vm.data.s_fullName,
	            "address1": vm.data.s_company_name ? vm.data.s_fullName : vm.data.s_street,
	            "zipcode": vm.data.s_zipCode,
	            "city": vm.data.s_locality,
	            "country": vm.data.s_country ? vm.data.s_country : "SE",
	            "contact": vm.data.s_fullName,
	            "mobile": vm.phoneNumberShipp
	          },
	          "service": {
	            "id": vm.service_id,
	            "paymentMethodType": "INVODN",
	            "nonDeliveryType": "RETURN"
	          },
	          "parcels": [{
	            "copies": vm.parcelsCopies,
	            "packageCode": "PC",
	            "weight": vm.parcelsWeight / 1000,
	            "contents": "Advertising Signs",
	            "valuePerParcel": false
	          }],
	          "orderNo": vm.data.orderId,
	          "senderReference": "OrderNo: " + vm.data.orderId
	        };
	      } else {
	        var body = {
	          "sender": {
	            "quickId": "1"
	          },
	          "receiver": {
	            "phone": vm.phoneNumberShipp,
	            "email": vm.data.s_email,
	            "name": vm.data.s_company_name ? vm.data.s_company_name : vm.data.s_fullName,
	            "address1": vm.data.s_company_name ? vm.data.s_fullName : vm.data.s_street,
	            "zipcode": vm.data.s_zipCode,
	            "city": vm.data.s_locality,
	            "country": vm.data.s_country ? vm.data.s_country : "SE",
	            "contact": vm.data.s_fullName,
	            "mobile": vm.phoneNumberShipp
	          },
	          "service": {
	            "id": vm.service_id,
	            "paymentMethodType": "INVO",
	            "nonDeliveryType": "RETURN"
	          },
	          "parcels": [{
	            "copies": vm.parcelsCopies,
	            "packageCode": "PC",
	            "weight": vm.parcelsWeight / 1000,
	            "contents": "Advertising Signs",
	            "valuePerParcel": false
	          }],
	          "orderNo": vm.data.orderId,
	          "senderReference": "OrderNo: " + vm.data.orderId
	        };
	      }
	
	      if (vm.selected.length > 0) body.service.addons = vm.selected;
	      if (vm.selectedOpt.length > 0) body.options = vm.selectedOpt;
	      if (vm.data.s_company_name) {
	        body.receiver.address2 = vm.data.s_street;
	      }
	      if (vm.data.reference_no) {
	        body.senderReference = vm.data.reference_no;
	      } else {
	        body.senderReference = "OrderNo: " + vm.data.orderId;
	      }
	      //other options
	      if (vm.selectedOthrOpt.length > 0) {
	        var indexCN22 = vm.selectedOthrOpt.findIndex(function (el) {
	          return el.id === "CN22";
	        });
	        if (indexCN22 > -1) {
	          body.customsDeclaration = {
	            "printSet": ["cn22"]
	          };
	        }
	        var indexCN23 = vm.selectedOthrOpt.findIndex(function (el) {
	          return el.id === "CN23";
	        });
	        if (indexCN23 > -1) {
	          body.customsDeclaration = {
	            "invoiceNo": vm.data.orderId + "-" + new Date().getFullYear().toString().substr(-2) + ("0" + (new Date().getMonth() + 1)).slice(-2) + ("0" + new Date().getDate()).slice(-2),
	            "currencyCode": vm.data.currency,
	            "explanation": "Commercial",
	            "invoiceType": "standard",
	            "printSet": ["cn23", "proforma"]
	          };
	          if (vm.data.delivery_price > 0) body.customsDeclaration.freightCharges = vm.data.delivery_price.toFixed(2);
	        }
	        if (indexCN22 > -1 || indexCN23 > -1) {
	          body.customsDeclaration.importExportType = "OTHER";
	          body.customsDeclaration.sender = {
	            "quickId": "1",
	            "vatNo": "SE5590289186"
	          };
	          body.customsDeclaration.lines = [{
	            "statNo": "49119900",
	            "subStatNo1": "4099",
	            "value": vm.data.amount.toFixed(2),
	            "contents": "Advertising signs",
	            "copies": vm.parcelsCopies,
	            "packageCode": "PC",
	            "netWeight": vm.parcelsWeight / 1000,
	            "sourceCountryCode": "SE",
	            "valuesPerItem": true
	          }];
	        }
	      }
	      var url = "https://api.unifaun.com/rs-extapi/v1/stored-shipments";
	      var token = vm.UNIFAUN_ID + ":" + vm.UNIFAUN_SECRET;
	      var hash = btoa(token);
	      var auth = "Basic " + hash;
	
	      var xhr = new XMLHttpRequest();
	      xhr.open('POST', url, true);
	      xhr.setRequestHeader("Authorization", auth);
	      xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
	      xhr.onreadystatechange = function () {
	        if (xhr.readyState == 4 && xhr.status == 201) {
	          var resp = xhr.response;
	          //check response invalid
	          var err = "Not sent to Unifaunonline, see below error/s :- \n";
	          if (vm.isJson(resp)) {
	            var response = JSON.parse(resp);
	            if (response.status == 'INVALID') {
	              for (var i = 0; i < response.statuses.length; i++) {
	                err += i + 1 + ". " + response.statuses[i].field + " " + response.statuses[i].messageCode + " - " + response.statuses[i].message + "\n";
	              }
	              vm.$timeout(function () {
	                alert(err);
	              }, 1000);
	            }
	          } else {
	            if (window.DOMParser) {
	              var parser = new DOMParser();
	              var xmlDoc = parser.parseFromString(resp, "text/xml");
	            } else {
	              var xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
	              xmlDoc.async = false;
	              xmlDoc.loadXML(resp);
	            }
	            if (xmlDoc.getElementsByTagName("status")[0].childNodes[0].nodeValue == 'INVALID') {
	              var x = xmlDoc.getElementsByTagName("statuses")[0].childNodes;
	              for (var i = 0; i < x.length; i++) {
	                err += i + 1 + ". " + x[i].getElementsByTagName("field")[0].childNodes[0].nodeValue + " " + x[i].getElementsByTagName("messageCode")[0].childNodes[0].nodeValue + " - " + x[i].getElementsByTagName("message")[0].childNodes[0].nodeValue + "\n";
	              }
	              vm.$timeout(function () {
	                alert(err);
	              }, 1000);
	            }
	          }
	          var saveShipmentResp = { 'order_id': vm.data.order_id, 'resp': resp };
	          vm.OrdersDataProvider.saveShipmentResp(saveShipmentResp).then(function (result) {
	            vm.shipShow = 0;
	            vm.data.shipped = 1;
	            vm.__loading = false;
	          });
	        }
	      };
	      xhr.send((0, _stringify2.default)(body));
	      return;
	    }
	  }, {
	    key: "download",
	    value: function download(file, item) {
	      var vm = this;
	      item.__loading = true;
	      var fileUrl = vm.APPLICATION_URL + '/' + file;
	      var img = new Image();
	      img.onload = function () {
	        var url = vm.APPLICATION_URL + '/api/set-dencity';
	        var data = new FormData();
	        data.append('images[0][s]', 1);
	        data.append('images[0][w]', this.width);
	        data.append('images[0][h]', this.height);
	        data.append('images[0][source]', file);
	        var xhr = new XMLHttpRequest();
	        xhr.open('POST', url, true);
	        xhr.onreadystatechange = function () {
	          if (xhr.readyState == 4 && xhr.status == 200) {
	            var resp = JSON.parse(xhr.response);
	            // png to svg from imagemagick
	            var imageName = resp.images[0].convertedPath.substr(1);
	            vm.OrdersDataProvider.tosvg({ 'image': imageName }).then(function (res) {
	              item.__loading = false;
	              if (res.success == '1') {
	                if (res.convertedFile) {
	                  vm.downloadSvg(vm.APPLICATION_URL + '/' + res.convertedFile);
	                }
	              } else {
	                alert('Something went wrong while converting image data');
	                return;
	              }
	            });
	          }
	        };
	        xhr.send(data);
	        return;
	      };
	      img.src = fileUrl;
	    }
	  }, {
	    key: "isJson",
	    value: function isJson(str) {
	      try {
	        JSON.parse(str);
	      } catch (e) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: "downloadSvg",
	    value: function downloadSvg(file) {
	      var dl = document.createElement("a");
	      document.body.appendChild(dl);
	      dl.setAttribute("target", '_blank');
	      dl.setAttribute("href", file);
	      dl.setAttribute("download", 'export.svg');
	      dl.click();
	    }
	  }, {
	    key: "downloadSvgBNW",
	    value: function downloadSvgBNW(item) {
	      item.__loading = true;
	      var url = this.APPLICATION_URL + '/editor#printbw-' + item.unique_id;
	      window.open(url);
	      item.__loading = false;
	    }
	  }, {
	    key: "downloadSvgColor",
	    value: function downloadSvgColor(item) {
	      item.__loading = true;
	      var url = this.APPLICATION_URL + '/editor#printrc-' + item.unique_id;
	      window.open(url);
	      item.__loading = false;
	    }
	  }]);
	  return OrderViewController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = OrderViewController;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"row\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"box box-primary\" style=\"border-radius: 0px;\">\r\n      <div ui-view class=\"box-body no-padding\">\r\n        <tabs>\r\n          <pane title=\"Shape\">\r\n            <material-shapes>\r\n            </material-shapes>\r\n          </pane>\r\n          <pane title=\"Color\">\r\n            <material-colors>\r\n            </material-colors>\r\n          </pane>\r\n          <pane title=\"Size\">\r\n            {{material}} size\r\n          </pane>\r\n          <pane title=\"Text\">\r\n            {{material}} text\r\n          </pane>\r\n          <pane title=\"Fix Method\">\r\n            <!--              <material-fixmethods>\r\n                          </material-fixmethods>-->\r\n          </pane>\r\n        </tabs>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaterialsController = function MaterialsController() {
	  (0, _classCallCheck3.default)(this, MaterialsController);
	};
	
	// WEBPACK FOOTER //
	
	
	exports.default = MaterialsController;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _signs = __webpack_require__(548);
	
	var _signs2 = _interopRequireDefault(_signs);
	
	var _nameBadges = __webpack_require__(549);
	
	var _nameBadges2 = _interopRequireDefault(_nameBadges);
	
	var _decorDecalsStickers = __webpack_require__(550);
	
	var _decorDecalsStickers2 = _interopRequireDefault(_decorDecalsStickers);
	
	var _postersBannersRollUps = __webpack_require__(551);
	
	var _postersBannersRollUps2 = _interopRequireDefault(_postersBannersRollUps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  signs: _signs2.default,
	  "name-badges": _nameBadges2.default,
	  "decor-decals-stickers": _decorDecalsStickers2.default,
	  "posters-banners-roll-ups": _postersBannersRollUps2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"content\">\r\n  <ul class=\"nav nav-pills\" style=\"border-bottom:3px solid #3c8dbc;\">\r\n    <li ui-sref-active=\"active\" ng-repeat=\"material in $ctrl.product.materials\">\r\n      <a ui-sref=\"app.product.material({material:material.slug})\">\r\n        {{material.name}}\r\n      </a>\r\n    </li>\r\n  </ul>\r\n  <div ui-view>\r\n\r\n  </div>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SpecController = function SpecController($state, ProductsDataProvider) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, SpecController);
	  this.product = ProductsDataProvider.products.findOne({ slug: $state.params.product });
	};
	SpecController.$inject = ["$state", "ProductsDataProvider"];
	
	// WEBPACK FOOTER //
	
	
	exports.default = SpecController;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div>\r\n  <div class=\"well well-sm\" style=\"background-color: transparent; border: none;\">\r\n    <div class=\"btn-group\">\r\n      <a href=\"#\" ng-click=\"$ctrl.setFilterState('assigned', $event)\"\r\n         ng-class=\"$ctrl.filterState == 'assigned' ? 'active' : ''\" class=\"btn btn-default btn-sm\">\r\n        <span class=\"fa fa-check-square-o\"></span>\r\n        Assigned\r\n      </a>\r\n      <a href=\"#\" ng-click=\"$ctrl.setFilterState('unassigned', $event)\"\r\n         ng-class=\"$ctrl.filterState == 'unassigned' ? 'active' : ''\" class=\"btn btn-default btn-sm\">\r\n        <span class=\"fa fa-square-o\"></span>\r\n        Unassigned\r\n      </a>\r\n      <a href=\"#\" ng-click=\"$ctrl.setFilterState('all', $event)\" ng-class=\"$ctrl.filterState == 'all' ? 'active' : ''\"\r\n         class=\"btn btn-default btn-sm\">\r\n        <span class=\"fa fa-th\"></span>\r\n        All\r\n      </a>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-md-3\" ng-repeat=\"shape in $ctrl.filter($ctrl.shapes)\">\r\n    <div class=\"panel panel-default edit\">\r\n      <div class=\"panel-heading\">\r\n        <div class=\"pull-left\">\r\n          <h3 class=\"panel-title\">\r\n            <input type=\"text\" ng-model=\"shape.name\" class=\"form-control\" ng-blur=\"$ctrl.updateName(shape,$event)\"/>\r\n          </h3>\r\n          <input type=\"checkbox\" checked=\"shape.assigned\" ng-click=\"$ctrl.changeShapeAssigment(shape,$event)\">\r\n        </div>\r\n        <div class=\"pull-right loader\" ng-show=\"shape.__loading\">\r\n          <span class=\"fa fa-spinner fa-spin\"></span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n      <div class=\"panel-body\" style=\"text-align: center;\">\r\n        <div class=\"shape-item-img\" data-slug=\"{{shape.slug}}\" data-id=\"{{shape.id }}\" data-path=\"{{shape.path}}\">\r\n          <img id=\"shape{{shape.id}}\" class=\"shape-item\" ng-src=\"{{shape.icon_path}}\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(547);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaterialShapesController = function () {
	  MaterialShapesController.$inject = ["ProductsDataProvider", "ProductPartsDataProvider", "$stateParams"];
	  function MaterialShapesController(ProductsDataProvider, ProductPartsDataProvider, $stateParams) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, MaterialShapesController);
	    this.ProductsDataProvider = ProductsDataProvider;
	    this.ProductPartsDataProvider = ProductPartsDataProvider;
	
	    var product = ProductsDataProvider.products.findOne({ slug: $stateParams.product }),
	        materials = product.materials,
	        material = materials.find(function (material) {
	      return material.slug == $stateParams.material;
	    }),
	        productShapes = material.spec.shapes,
	        allShapes = ProductPartsDataProvider.shapes.find({}).map(function (shape) {
	      return (0, _assign2.default)({}, shape);
	    });
	
	    allShapes.forEach(function (shape) {
	      shape.assigned = productShapes.some(function (productShape) {
	        return shape.id == productShape.id;
	      });
	    });
	
	    this.shapes = allShapes;
	    this.product = product;
	    this.material = material;
	    this.filterState = "assigned";
	  }
	
	  (0, _createClass3.default)(MaterialShapesController, [{
	    key: "filter",
	    value: function filter(shapes) {
	      switch (this.filterState) {
	        case 'assigned':
	          return shapes.filter(function (shape) {
	            return shape.assigned == true;
	          });
	        case 'unassigned':
	          return shapes.filter(function (shape) {
	            return shape.assigned != true;
	          });
	        case 'all':
	          return shapes;
	        default:
	          throw new Error("unsupported filter type for shapes");
	      }
	    }
	  }, {
	    key: "setFilterState",
	    value: function setFilterState(value, $event) {
	      if ($event) {
	        $event.preventDefault();
	      }
	      this.filterState = value;
	    }
	  }, {
	    key: "changeShapeAssigment",
	    value: function changeShapeAssigment(shape, $event) {
	      $event.preventDefault();
	      shape.__loading = true;
	      var actionName = '';
	      if (shape.assigned) {
	        actionName = 'deleteProductMaterialShape';
	      } else {
	        actionName = 'addProductMaterialShape';
	      }
	      this.ProductsDataProvider[actionName](this.product.id, this.material.id, shape.id).then(function (responseShape) {
	        delete shape.__loading;
	        shape.assigned = !shape.assigned;
	      });
	    }
	  }, {
	    key: "updateName",
	    value: function updateName(shape, $event) {
	      $event.preventDefault();
	      shape.__loading = true;
	      this.ProductsDataProvider['updateName'](shape, 1).then(function (responseShape) {
	        delete shape.__loading;
	      });
	    }
	  }]);
	  return MaterialShapesController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = MaterialShapesController;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div>\r\n  <div class=\"well well-sm\" style=\"background-color: transparent; border: none;\">\r\n    <div class=\"btn-group\">\r\n      <a\r\n        href=\"#\"\r\n        ng-disabled=\"$ctrl.customColors\"\r\n        ng-click=\"$ctrl.setFilterState('assigned', $event)\"\r\n        ng-class=\"{active: $ctrl.filterState == 'assigned', disabled: $ctrl.customColors }\"\r\n        class=\"btn btn-default btn-sm\"\r\n      >\r\n        <span class=\"fa fa-check-square-o\"></span>\r\n        Assigned\r\n      </a>\r\n      <a\r\n        href=\"#\"\r\n        ng-disabled=\"$ctrl.customColors\"\r\n        ng-click=\"$ctrl.setFilterState('unassigned', $event)\"\r\n        ng-class=\"{active: $ctrl.filterState == 'unassigned', disabled: $ctrl.customColors}\"\r\n        class=\"btn btn-default btn-sm\"\r\n      >\r\n        <span class=\"fa fa-square-o\"></span>\r\n        Unassigned\r\n      </a>\r\n      <a\r\n        href=\"#\"\r\n        ng-disabled=\"$ctrl.customColors\"\r\n        ng-click=\"$ctrl.setFilterState('all', $event)\"\r\n        ng-class=\"{active: $ctrl.filterState == 'all', disabled: $ctrl.customColors}\"\r\n        class=\"btn btn-default btn-sm\"\r\n      >\r\n        <span class=\"fa fa-th\"></span>\r\n        All\r\n      </a>\r\n    </div>\r\n    <div class=\"btn-group\">\r\n      <a\r\n        href=\"#\"\r\n        ng-click=\"$ctrl.toggleCustomColors($event)\"\r\n        ng-class=\"{'active': $ctrl.customColors}\"\r\n        class=\"btn btn-sm btn-default\"\r\n      >\r\n        <span\r\n          type=\"checkbox\"\r\n          class=\"fa\"\r\n          ng-class=\"{'fa-check-square-o': $ctrl.customColors, 'fa-square-o': !$ctrl.customColors}\"\r\n        >\r\n        </span>\r\n        Custom Colors\r\n      </a>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-md-3\" ng-if=\"!$ctrl.customColors\" ng-repeat=\"color in $ctrl.filter($ctrl.colors)\">\r\n    <div class=\"panel panel-default edit\">\r\n      <div class=\"panel-heading\">\r\n        <div class=\"pull-left\">\r\n          <h3 class=\"panel-title\">\r\n            <input type=\"text\" ng-model=\"color.name\" class=\"form-control\" ng-blur=\"$ctrl.updateName(color,$event)\"/>\r\n          </h3>\r\n          <input type=\"checkbox\" ng-checked=\"color.assigned\" ng-click=\"$ctrl.changeColorAssigment(color,$event)\"/>\r\n        </div>\r\n        <div class=\"pull-right loader\" ng-show=\"color.__loading\">\r\n          <span class=\"fa fa-spinner fa-spin\"></span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n      <div class=\"panel-body\" style=\"text-align: center;\">\r\n        <div class=\"color-content\" ng-style=\"{'background-color': color.hex1}\">\r\n          <div class=\"color-content-bg\">\r\n            <div class=\"color-content-fg\" ng-style=\"{'background-color': color.hex2}\">\r\n              &nbsp;\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n  <div ng-if=\"$ctrl.customColors\" class=\"col-md-12\">\r\n    <h2>\r\n      Can't use color assignment while \"Custom Colors\" is in use.\r\n    </h2>\r\n  </div>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(547);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaterialColorsController = function () {
	  MaterialColorsController.$inject = ["ProductsDataProvider", "ProductPartsDataProvider", "$stateParams"];
	  function MaterialColorsController(ProductsDataProvider, ProductPartsDataProvider, $stateParams) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, MaterialColorsController);
	    this.ProductsDataProvider = ProductsDataProvider;
	    this.ProductPartsDataProvider = ProductPartsDataProvider;
	
	    var product = ProductsDataProvider.products.findOne({ slug: $stateParams.product }),
	        materials = product.materials,
	        material = materials.find(function (material) {
	      return material.slug == $stateParams.material;
	    }),
	        productColors = material.spec.colors,
	        allColors = ProductPartsDataProvider.colors.find({}).map(function (color) {
	      return (0, _assign2.default)({}, color);
	    });
	
	    allColors.forEach(function (color) {
	      color.assigned = productColors.some(function (productColor) {
	        return color.id == productColor.id;
	      });
	    });
	
	    this.colors = allColors;
	    this.product = product;
	    this.material = material;
	    this.filterState = "assigned";
	  }
	
	  (0, _createClass3.default)(MaterialColorsController, [{
	    key: "filter",
	    value: function filter(colors) {
	      switch (this.filterState) {
	        case 'assigned':
	          return colors.filter(function (color) {
	            return color.assigned == true;
	          });
	        case 'unassigned':
	          return colors.filter(function (color) {
	            return color.assigned != true;
	          });
	        case 'all':
	          return colors;
	        default:
	          throw new Error("unsupported filter type for colors");
	      }
	    }
	  }, {
	    key: "setFilterState",
	    value: function setFilterState(value, $event) {
	      if ($event) {
	        $event.preventDefault();
	      }
	      this.filterState = value;
	    }
	  }, {
	    key: "changeColorAssigment",
	    value: function changeColorAssigment(color, $event) {
	      $event.preventDefault();
	      color.__loading = true;
	      var actionName = '';
	      if (color.assigned) {
	        actionName = 'deleteProductMaterialColor';
	      } else {
	        actionName = 'addProductMaterialColor';
	      }
	      this.ProductsDataProvider[actionName](this.product.id, this.material.id, color.id).then(function (responseColor) {
	        delete color.__loading;
	        color.assigned = !color.assigned;
	      });
	    }
	  }, {
	    key: "toggleCustomColors",
	    value: function toggleCustomColors($event) {
	      $event.preventDefault();
	      this.customColors = !this.customColors;
	    }
	  }, {
	    key: "updateName",
	    value: function updateName(color, $event) {
	      $event.preventDefault();
	      color.__loading = true;
	      //color.slug=this.onvertToSlug(color.name);    
	      this.ProductsDataProvider['updateName'](color, 2).then(function (responseShape) {
	        delete color.__loading;
	      });
	    }
	  }, {
	    key: "onvertToSlug",
	    value: function onvertToSlug(text) {
	      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
	      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
	      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
	      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
	      .replace(/\-\-+/g, '-') // Replace multiple - with single -
	      .replace(/^-+/, '') // Trim - from start of text
	      .replace(/-+$/, ''); // Trim - from end of text
	    }
	  }]);
	  return MaterialColorsController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = MaterialColorsController;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div>\r\n  <div class=\"well well-sm\" style=\"background-color: transparent; border: none;\">\r\n    <div class=\"btn-group\">\r\n      <a href=\"#\" ng-click=\"$ctrl.setFilterState('assigned', $event)\"\r\n         ng-class=\"$ctrl.filterState == 'assigned' ? 'active' : ''\" class=\"btn btn-default btn-sm\">\r\n        <span class=\"fa fa-check-square-o\"></span>\r\n        Assigned\r\n      </a>\r\n      <a href=\"#\" ng-click=\"$ctrl.setFilterState('unassigned', $event)\"\r\n         ng-class=\"$ctrl.filterState == 'unassigned' ? 'active' : ''\" class=\"btn btn-default btn-sm\">\r\n        <span class=\"fa fa-square-o\"></span>\r\n        Unassigned\r\n      </a>\r\n      <a href=\"#\" ng-click=\"$ctrl.setFilterState('all', $event)\" ng-class=\"$ctrl.filterState == 'all' ? 'active' : ''\"\r\n         class=\"btn btn-default btn-sm\">\r\n        <span class=\"fa fa-th\"></span>\r\n        All\r\n      </a>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-md-3\" ng-repeat=\"fixmethod in $ctrl.filter($ctrl.fixmethods)\">\r\n    <div class=\"panel panel-default\">\r\n      <div class=\"panel-heading\">\r\n        <div class=\"pull-left\">\r\n          <h3 class=\"panel-title\">{{fixmethod.name}} </h3>\r\n        </div>\r\n        <div class=\"pull-right\">\r\n          <input type=\"checkbox\" ng-checked=\"fixmethod.assigned\"\r\n                 ng-click=\"$ctrl.changeShapeAssigment(fixmethod,$event)\"/>\r\n        </div>\r\n        <div class=\"pull-right\" ng-show=\"fixmethod.__loading\">\r\n          <span class=\"fa fa-spinner fa-spin\"></span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n      <div class=\"panel-body\" style=\"text-align: center;\">\r\n        <div class=\"shape-item-img\" data-slug=\"{{fixmethod.slug}}\" data-id=\"{{fixmethod.id }}\"\r\n             data-path=\"{{fixmethod.path}}\">\r\n          <img id=\"shape{{fixmethod.id}}\" class=\"shape-item\" ng-src=\"{{fixmethod.icon_path}}\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!--ng-class=\"{$ctrl.filterState == 'assigned'? active: \"\" }\"-->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(547);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaterialFixmethodsController = function () {
	  MaterialFixmethodsController.$inject = ["ProductsDataProvider", "ProductPartsDataProvider", "$stateParams"];
	  function MaterialFixmethodsController(ProductsDataProvider, ProductPartsDataProvider, $stateParams) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, MaterialFixmethodsController);
	    this.ProductsDataProvider = ProductsDataProvider;
	    this.ProductPartsDataProvider = ProductPartsDataProvider;
	
	    var product = ProductsDataProvider.products.findOne({ slug: $stateParams.product }),
	        materials = product.materials,
	        material = materials.find(function (material) {
	      return material.slug == $stateParams.material;
	    }),
	        productFixmethods = material.spec.fixmethods,
	        allFixmethods = ProductPartsDataProvider.fixmethods.find({}).map(function (fixmethod) {
	      return (0, _assign2.default)({}, fixmethod);
	    });
	
	    allFixmethods.forEach(function (fixmethod) {
	      fixmethod.assigned = productFixmethods.some(function (productFixmethod) {
	        return fixmethod.id == productFixmethod.id;
	      });
	    });
	    this.fixmethods = allFixmethods;
	    this.product = product;
	    this.material = material;
	    this.filterState = "assigned";
	  }
	
	  (0, _createClass3.default)(MaterialFixmethodsController, [{
	    key: "filter",
	    value: function filter(fixmethods) {
	      switch (this.filterState) {
	        case 'assigned':
	          return fixmethods.filter(function (fixmethod) {
	            return fixmethod.assigned == true;
	          });
	        case 'unassigned':
	          return fixmethods.filter(function (fixmethod) {
	            return fixmethod.assigned != true;
	          });
	        case 'all':
	          return fixmethods;
	        default:
	          throw new Error("unsupported filter type for fixmethods");
	      }
	    }
	  }, {
	    key: "setFilterState",
	    value: function setFilterState(value, $event) {
	      if ($event) {
	        $event.preventDefault();
	      }
	      this.filterState = value;
	    }
	  }, {
	    key: "changeShapeAssigment",
	    value: function changeShapeAssigment(fixmethod, $event) {
	      $event.preventDefault();
	      fixmethod.__loading = true;
	      var actionName = '';
	      if (fixmethod.assigned) {
	        actionName = 'deleteProductMaterialFixmethod';
	      } else {
	        actionName = 'addProductMaterialFixmethod';
	      }
	      this.ProductsDataProvider[actionName](this.product.id, this.material.id, fixmethod.id).then(function (responseShape) {
	        delete fixmethod.__loading;
	        fixmethod.assigned = !fixmethod.assigned;
	      });
	    }
	  }]);
	  return MaterialFixmethodsController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = MaterialFixmethodsController;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaterialPricingController = function () {
	  MaterialPricingController.$inject = ["ProductsDataProvider", "$stateParams"];
	  function MaterialPricingController(ProductsDataProvider, $stateParams) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, MaterialPricingController);
	    var product = $stateParams.product,
	        material = $stateParams.material;
	
	
	    this.tpl = product + '-' + material + '.html';
	    this.ProductsDataProvider = ProductsDataProvider;
	    this.product = ProductsDataProvider.products.findOne({ slug: $stateParams.product });
	    this.material = this.product.materials.find(function (material) {
	      return material.slug == $stateParams.material;
	    });
	    this.pricing = this.material.pricing;
	  }
	
	  (0, _createClass3.default)(MaterialPricingController, [{
	    key: 'uniqueColors',
	    value: function uniqueColors(colors) {
	      var flags = {},
	          flags2 = {};
	      return colors.filter(function (color) {
	        if (flags[color.hex1] && flags[color.hex2]) {
	          return false;
	        }
	        flags[color.hex1] = true;
	        flags2[color.hex2] = true;
	        return true;
	      });
	    }
	  }, {
	    key: 'addColor',
	    value: function addColor() {
	      var _this = this;
	
	      if (this.selected == undefined) return;
	      if (this.material.slug == 'decor-1-color') {
	        var alreadyHasColor = this.pricing.color.some(function (color) {
	          return color.value.hex1 == _this.selected.hex1 && color.value.hex2 == _this.selected.hex2;
	        });
	        if (alreadyHasColor) {
	          return;
	        }
	        this.pricing.color.push({
	          calcMethod: 0,
	          cost: 0,
	          startCost: 0,
	          value: { hex1: this.selected.hex1, hex2: this.selected.hex2 }
	        });
	      } else {
	        var _alreadyHasColor = this.pricing.color.some(function (color) {
	          return color.value == _this.selected.hex1;
	        });
	        if (_alreadyHasColor) {
	          return;
	        }
	        this.pricing.color.push({ calcMethod: 0, cost: 0, startCost: 0, value: this.selected.hex1 });
	      }
	    }
	  }, {
	    key: 'removeColor',
	    value: function removeColor(color, color1) {
	      if (color1 != '') {
	        var index = this.pricing.color.findIndex(function (el) {
	          return el.value.hex1 === color && el.value.hex2 === color1;
	        });
	        if (index !== -1) {
	          this.pricing.color.splice(index, 1);
	        }
	      } else {
	        var _index = this.pricing.color.findIndex(function (el) {
	          return el.value === color;
	        });
	        if (_index !== -1) {
	          this.pricing.color.splice(_index, 1);
	        }
	      }
	    }
	  }, {
	    key: 'newSizeCost',
	    value: function newSizeCost() {
	      var tableStand = {
	        width: {
	          min: 0,
	          max: 0
	        },
	        height: {
	          min: 0,
	          max: 0
	        },
	        startCost: 0,
	        cost: 0,
	        weight: 20,
	        calcMethod: 5
	      };
	      this.pricing.fixMethod['table-stand'].push(tableStand);
	    }
	  }, {
	    key: 'newSizeCostCal',
	    value: function newSizeCostCal() {
	      var sizes = {
	        width: {
	          min: 0,
	          max: 0
	        },
	        height: {
	          min: 0,
	          max: 0
	        },
	        startCost: 0,
	        cost: 0,
	        weight: 20,
	        calcMethod: 5
	      };
	      if (this.pricing.fixMethod['sizes'] == undefined) this.pricing.fixMethod['sizes'] = [];
	      this.pricing.fixMethod['sizes'].push(sizes);
	    }
	  }, {
	    key: 'saveSpec',
	    value: function saveSpec() {
	      var productSlug = this.product.slug,
	          materialSlug = this.material.slug;
	
	      this.ProductsDataProvider.saveProductMaterialPricing(productSlug, materialSlug, this.pricing);
	    }
	  }]);
	  return MaterialPricingController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = MaterialPricingController;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<ul class=\"nav nav-pills\">\r\n  <li ui-sref-active=\"active\">{{$ctrl.product}}\r\n    <a ui-sref=\"app.product.material.spec\">\r\n      Spec\r\n    </a>\r\n  </li>\r\n  <li ui-sref-active=\"active\">\r\n    <a ui-sref=\"app.product.material.pricing\">\r\n      Pricing\r\n    </a>\r\n  </li>\r\n</ul>\r\n<div ui-view></div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    News Letter\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.newsletter\">News Letter</a></li>\r\n    <li class=\"active\">Send</li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form class=\"form-row-seperated\" name=\"newsletterForm\" novalidate>\r\n        <div class=\"portlet\">\r\n          <div class=\"alert alert-success\" ng-if=\"$ctrl.submitMsg == 1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.submitMsg = 0;'>×</a>\r\n            Newsletter submitted for send newsletter to subscribers\r\n          </div>\r\n          <div class=\"box box-warning\">\r\n            <div class=\"box-header\">\r\n              <a style=\"float:right\" ui-sref=\"app.subscriberListing\"> Subscriber List</a>\r\n            </div>\r\n            <!-- /.box-header -->\r\n            <div class=\"box-body\">\r\n              <div class=\"row\">\r\n                <div class='col-md-12'>\r\n                  <div class=\"form-group\">\r\n                    <label>Email Subject</label>\r\n                    <input ng-model=\"$ctrl.newsletter.subject\" class=\"form-control\" name='name' required>\r\n                    <span class=\"text-danger\" ng-show=\"(newsletterForm.subject.$dirty) || newsletterForm.$submitted\">\r\n                                            <span ng-show=\"newsletterForm.subject.$error.required\">Email subject is required.</span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class='col-md-12'>\r\n                  <label>Email Template</label>\r\n                  <textarea id='newsletter_text' ng-model='$ctrl.newsletter.data' class=\"full-tinymce\"\r\n                            placeholder=\"Place some text here\" rows='15'></textarea>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"box-footer\">\r\n              <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"$ctrl.send(newsletterForm.$valid)\">Submit</button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsletterController = function () {
	  NewsletterController.$inject = ["NewsletterDataProvider", "$state"];
	  function NewsletterController(NewsletterDataProvider, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, NewsletterController);
	    this.NewsletterDataProvider = NewsletterDataProvider;
	    this.$state = $state;
	    var vm = this;
	    vm.submitMsg = 0;
	    NewsletterDataProvider.editor();
	    vm.NewsletterDataProvider.getNewsletter('newsletter').then(function (result) {
	      vm.newsletter = result;
	      vm.setEditorsData();
	    });
	  }
	
	  (0, _createClass3.default)(NewsletterController, [{
	    key: 'send',
	    value: function send(form) {
	      if (!form) {
	        return false;
	      }
	      var vm = this;
	      vm.NewsletterDataProvider.sendNewsletter().then(function (res) {
	        vm.submitMsg = 1;
	      });
	    }
	  }, {
	    key: 'getEditorsData',
	    value: function getEditorsData() {
	      this.newsletter.data = tinyMCE.get('newsletter_text').getContent();
	    }
	  }, {
	    key: 'setEditorsData',
	    value: function setEditorsData() {
	      tinyMCE.get('newsletter_text').setContent(this.newsletter.data);
	    }
	  }]);
	  return NewsletterController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = NewsletterController;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Subscriber Listing\r\n    <small>List of News letter Subscriber</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <!--        <li><a ui-sref=\"app.newsletter\">News Letter</a></li>-->\r\n    <li class=\"active\">Subscribers</li>\r\n  </ol>\r\n</section>\r\n\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <div class='box'>\r\n        <div class=\"box-header\">\r\n          <div style=\"float:left;width: 200px;\">\r\n            Select Limit :\r\n            <select ng-model=\"$ctrl.pageLimit\" name='pageLimit' class=\"form-control\"\r\n                    ng-options=\"key as value for (key , value) in $ctrl.pageLimitOptions\"\r\n                    ng-change=\"$ctrl.currentPage = 1;\r\n                                        $ctrl.getSubscribers()\" required style=\"display: inline; width: 75px;\">\r\n              <option ng-repeat=\"(key, value) in data\" value=\"{{key}}\">{{value}}</option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n        <div class=\"box-body table-responsive no-padding\">\r\n          <table id=\"datatable_subscribers\"\r\n                 class=\"table table-striped table-bordered table-hover table-checkable dataTable no-footer\"\r\n                 aria-describedby=\"datatable_orders_info\" role=\"grid\">\r\n            <thead>\r\n            <tr class=\"heading\" role=\"row\">\r\n              <th align=\"center\" width=\"5%\">Id</th>\r\n              <th align=\"center\" width=\"30%\" ng-class=\"{'active': $ctrl.col == '1'}\"> Name\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('name', 'asc', 1, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('name', 'desc', 1, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th align=\"center\" width=\"45%\" ng-class=\"{'active': $ctrl.col == '2'}\"> Email\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('code', 'asc', 2, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('code', 'desc', 2, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"20%\"> Actions</th>\r\n            </tr>\r\n            <tr class=\"filter\" role=\"row\">\r\n              <td rowspan=\"1\" colspan=\"1\"></td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.name\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.email\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <div class=\"margin-bottom-5\">\r\n                  <button class=\"btn btn-sm btn-success filter-submit\" ng-click=\"$ctrl.getSubscribers();\">\r\n                    <i class=\"fa fa-search\"></i> Search\r\n                  </button>\r\n\r\n                  <button class=\"btn btn-sm btn-default filter-cancel\" ng-click=\"$ctrl.clearFilter();\">\r\n                    <i class=\"fa fa-times\"></i> Reset\r\n                  </button>\r\n                </div>\r\n              </td>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat=\"data in $ctrl.subscribers\">\r\n              <td>{{$ctrl.pageLimit * ($ctrl.currentPage - 1) + ($index + 1)}}</td>\r\n              <td>{{data.f_name}} {{data.l_name}}</td>\r\n              <td>{{data.email}}</td>\r\n              <td>\r\n                <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeSubscriber(data.id);\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"box-footer clearfix\">\r\n          <ul ng-if=\"$ctrl.subscribersTotal > $ctrl.pageLimit\" uib-pagination boundary-links=\"true\"\r\n              max-size=\"$ctrl.maxSize\" total-items=\"$ctrl.subscribersTotal\" items-per-page=\"$ctrl.pageLimit\"\r\n              ng-model=\"$ctrl.currentPage\" ng-change=\"$ctrl.getSubscribers()\" class=\"pagination-sm pull-right\"\r\n              previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></ul>\r\n          <ul ng-if=\"$ctrl.subscribersTotal <= $ctrl.pageLimit\" class=\"pagination pagination-sm no-margin pull-right\">\r\n            <li><a href=\"#\">&laquo;</a></li>\r\n            <li><a href=\"#\">1</a></li>\r\n            <li><a href=\"#\">&raquo;</a></li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubscribersController = function () {
	  SubscribersController.$inject = ["NewsletterDataProvider"];
	  function SubscribersController(NewsletterDataProvider) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SubscribersController);
	    this.NewsletterDataProvider = NewsletterDataProvider;
	    this.currentPage = 1;
	    this.pageLimit = '100';
	    this.maxSize = 5;
	    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
	    this.field = 'id';
	    this.order_type = 'desc';
	    this.col = 0;
	    this.colTopDown = 0;
	    this.getSubscribers();
	  }
	
	  (0, _createClass3.default)(SubscribersController, [{
	    key: 'getSortRecors',
	    value: function getSortRecors(field, order_type, col, colTopDown) {
	      this.field = field;
	      this.order_type = order_type;
	      this.col = col;
	      this.colTopDown = colTopDown;
	      this.getSubscribers();
	    }
	  }, {
	    key: 'getSubscribers',
	    value: function getSubscribers() {
	      var vm = this;
	      var data = {};
	      var searchData = {};
	      searchData.name = vm.name;
	      searchData.email = vm.email;
	      data.searchData = searchData;
	      data.currentPage = vm.currentPage;
	      data.pageLimit = vm.pageLimit;
	      data.field = vm.field;
	      data.order_type = vm.order_type;
	      vm.NewsletterDataProvider.getSubscribers(data, searchData).then(function (result) {
	        vm.subscribers = result.data;
	        vm.subscribersTotal = result.total;
	        vm.selectall = false;
	      });
	    }
	  }, {
	    key: 'removeSubscriber',
	    value: function removeSubscriber(id) {
	      if (confirm("Are you sure to delete!") !== true) {
	        return false;
	      }
	      var vm = this;
	      vm.NewsletterDataProvider.removeSubscriber(id).then(function (res) {
	        vm.getSubscribers();
	      });
	    }
	  }, {
	    key: 'clearFilter',
	    value: function clearFilter() {
	      this.name = '';
	      this.code = '';
	      this.type = '';
	      this.price_from = '';
	      this.price_to = '';
	      this.used_count = '';
	      this.status = '';
	      this.getSubscribers();
	    }
	  }]);
	  return SubscribersController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = SubscribersController;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Product Pages\r\n    <small>Add new product page</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.productPagelisting\">Product Pages listing</a></li>\r\n    <li class=\"active\"><a ui-sref=\"app.productPageAdd\">Add</a></li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form class=\"form-row-seperated\" name=\"productForm\" novalidate>\r\n        <div class=\"portlet\">\r\n          <div class=\"portlet-title\">\r\n            <div class=\"caption\">\r\n              New Product Page\r\n            </div>\r\n            <div class=\"actions btn-set\">\r\n              <a ui-sref=\"app.productPagelisting\">\r\n                <button class=\"btn btn-secondary-outline\" name=\"back\" type=\"button\">\r\n                  <i class=\"fa fa-angle-left\"></i> Back\r\n                </button>\r\n              </a>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.saveData(productForm,1);\">\r\n                <i class=\"fa fa-check\"></i> Save\r\n              </button>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.saveData(productForm,0);\">\r\n                <i class=\"fa fa-check-circle\"></i> Save &amp; Close\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if='$ctrl.errorShow && !productForm.$valid'>\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.errorShow=0;'>×</a>\r\n            <span ng-show=\"(productForm.category.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.category.$error.required\">Category is required.<br/></span>\r\n                        </span>\r\n            <span ng-show=\"(productForm.subcategory.$dirty) || productForm.$submitted\">\r\n                            <span\r\n                              ng-show=\"productForm.subcategory.$error.required\">Sub-category is required.<br/></span>\r\n                        </span>\r\n            <span ng-show=\"(productForm.name.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.name.$error.required\">Name is required.<br/></span>\r\n                        </span>\r\n          </div>\r\n          <div class=\"alert alert-success\" ng-if=\"$ctrl.successShow==1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.successShow=0;'>×</a>\r\n            <strong>Success!</strong> Product page data saved successfully.\r\n          </div>\r\n          <ul class=\"nav nav-tabs\">\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 1}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(1)\"><label>General</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 2}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(2)\"><label>Meta</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 3}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(3)\"><label>Images</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 4}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(4)\"><label>Product</label></a>\r\n            </li>\r\n          </ul>\r\n          <div class=\"tab-content\">\r\n            <div ng-class=\"{'tab-pane active': $ctrl.activeTab === 1, 'tab-pane' : $ctrl.activeTab !== 1}\">\r\n              <!-- general form elements disabled -->\r\n              <div class=\"box box-warning\">\r\n                <!-- /.box-header -->\r\n                <div class=\"box-body\">\r\n                  <!-- text input -->\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Category</label>\r\n                        <select ng-model=\"$ctrl.page.category\" name='category' class=\"form-control\"\r\n                                ng-change=\"$ctrl.changeCategory()\" required>\r\n                          <option value=''>Select Category</option>\r\n                          <option ng-repeat=\"category in $ctrl.mainCategories\" value=\"{{category.id}}\">\r\n                            {{category.name}}\r\n                          </option>\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Sub Category</label>\r\n                        <select ng-model=\"$ctrl.page.sub_category\" class=\"form-control\" name='subcategory' required>\r\n                          <option value=''>Select Category</option>\r\n                          <option ng-repeat=\"category in $ctrl.categories\" value=\"{{category.id}}\">{{category.name}}\r\n                          </option>\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Name (Sub-sub Category)</label>\r\n                        <input ng-model=\"$ctrl.page.name\" class=\"form-control\" name='name' required>\r\n                      </div>\r\n                    </div>\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Material Id</label>\r\n                        <input ng-model=\"$ctrl.page.material_id\" class=\"form-control\" name='material_id'>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Short Text</label>\r\n                      <textarea id='shortText' ng-model='$ctrl.page.shortText' name='shortText' class=\"tinymce\"\r\n                                placeholder=\"Place some text here\" rows='12'></textarea>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Template Text</label>\r\n                      <textarea id='templateText' ng-model='$ctrl.page.templateText' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Long Text</label>\r\n                      <textarea id='longText' ng-model='$ctrl.page.longText' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active':  $ctrl.page.activeTab === 2, 'tab-pane' :  $ctrl.activeTab !== 2}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Title</label>\r\n                        <input ng-model=\"$ctrl.page.title\" class=\"form-control\" name='title'\r\n                               placeholder=\"Set title for product page\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Meta Data</label>\r\n                      <textarea id='metaData' ng-model='$ctrl.page.metaData' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active':  $ctrl.activeTab === 3, 'tab-pane' : $ctrl.activeTab !== 3}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Alt text for image</label>\r\n                        <input ng-model=\"$ctrl.page.alt\" class=\"form-control\" name='alt'>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Select File</label>\r\n                      <input type=\"file\" ngf-select ng-model=\"$ctrl.page.img\" name=\"file\"\r\n                             accept=\"image/*\" ngf-max-size=\"2MB\"\r\n                             ngf-model-invalid=\"errorFile\">\r\n                      <img ng-show=\"productForm.file.$valid\" ngf-src=\"$ctrl.page.img\" class=\"thumb img-responsive\">\r\n                      <button type='button' class='btn btn-danger' ng-click=\"$ctrl.page.img = null\"\r\n                              ng-show=\"$ctrl.page.img\">Remove\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active': $ctrl.activeTab === 4, 'tab-pane' : $ctrl.activeTab !== 4}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div>\r\n                    <p>Products will be added from front-end.</p>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"portlet-title\">\r\n            <div class=\"actions btn-set\">\r\n              <a ui-sref=\"app.productPagelisting\">\r\n                <button class=\"btn btn-secondary-outline\" name=\"back\" type=\"button\">\r\n                  <i class=\"fa fa-angle-left\"></i> Back\r\n                </button>\r\n              </a>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.saveData(productForm,1)\">\r\n                <i class=\"fa fa-check\"></i> Save\r\n              </button>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.saveData(productForm,0);\">\r\n                <i class=\"fa fa-check-circle\"></i> Save &amp; Close\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if='$ctrl.errorShow && !productForm.$valid'>\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.errorShow=0;'>×</a>\r\n            <span ng-show=\"(productForm.category.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.category.$error.required\">Category is required.<br/></span>\r\n                        </span>\r\n            <span ng-show=\"(productForm.subcategory.$dirty) || productForm.$submitted\">\r\n                            <span\r\n                              ng-show=\"productForm.subcategory.$error.required\">Sub-category is required.<br/></span>\r\n                        </span>\r\n            <span ng-show=\"(productForm.name.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.name.$error.required\">Name is required.<br/></span>\r\n                        </span>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageAddController = function () {
	  PageAddController.$inject = ["ProductPagesDataProvider", "$state", "Upload", "$timeout", "API_URL", "APPLICATION_URL"];
	  function PageAddController(ProductPagesDataProvider, $state, Upload, $timeout, API_URL, APPLICATION_URL) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PageAddController);
	    this.activeTab = 1;
	    this.page = {};
	    this.type = 3;
	    this.page.products = [];
	    this.page.main_category = '';
	    this.page.category = '';
	    this.page.sub_category = '';
	    this.Upload = Upload;
	    this.ProductPagesDataProvider = ProductPagesDataProvider;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.API_URL = API_URL;
	    this.APPLICATION_URL = APPLICATION_URL;
	    this.errorShow = 0;
	    this.field = 'id';
	    this.order_type = 'asc';
	    ProductPagesDataProvider.editor();
	    var vm = this;
	    ProductPagesDataProvider.loadCategoriesNoLimit('0').then(function (result) {
	      vm.mainCategories = result;
	    });
	  }
	
	  (0, _createClass3.default)(PageAddController, [{
	    key: 'setActiveTab',
	    value: function setActiveTab(tabToSet) {
	      this.activeTab = tabToSet;
	      this.setEditorsData();
	    }
	  }, {
	    key: 'changeCategory',
	    value: function changeCategory() {
	      if (this.page.category) {
	        var vm = this;
	        vm.ProductPagesDataProvider.loadCategoriesNoLimit(this.page.category).then(function (result) {
	          vm.categories = result;
	        });
	      } else {
	        this.categories = {};
	      }
	    }
	  }, {
	    key: 'onvertToSlug',
	    value: function onvertToSlug(text) {
	      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
	      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
	      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
	      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
	      .replace(/\-\-+/g, '-') // Replace multiple - with single -
	      .replace(/^-+/, '') // Trim - from start of text
	      .replace(/-+$/, ''); // Trim - from end of text
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(productForm, redirect) {
	      var vm = this;
	      vm.setEditorsData();
	      vm.$timeout(function () {
	        if (!productForm.$valid) {
	          vm.errorShow = 1;
	          vm.$timeout(function () {
	            vm.errorShow = 0;
	          }, 5000);
	          return false;
	        }
	        if (vm.page.name) vm.page.slug = vm.onvertToSlug(vm.page.name);
	        if (!vm.page.sub_category) vm.page.sub_category = 0;
	        if (!vm.page.alt) vm.page.alt = vm.page.name;
	        vm.page.type = vm.type;
	        if (vm.page.img) {
	          vm.saveWithImage(vm.page.img, redirect);
	        } else {
	          var saveData = vm.ProductPagesDataProvider.saveProductPage(vm.page);
	          saveData.then(function (res) {
	            if (redirect == '1') {
	              if (res[0] != undefined && res[0].insertId != undefined) vm.$state.go("app.productPageEdit", { id: res[0].insertId, tabId: vm.activeTab });else alert('Please try again.');
	            } else {
	              vm.$state.go('app.productPagelisting');
	            }
	          });
	        }
	      }, 5);
	    }
	  }, {
	    key: 'saveWithImage',
	    value: function saveWithImage(file, redirect) {
	      var vm = this;
	      file.upload = vm.Upload.upload({
	        url: vm.API_URL + '/productPage/saveProductPageImage',
	        method: 'POST',
	        data: {
	          filename: new Date().valueOf() + file.name,
	          file: file
	        }
	      });
	      file.upload.then(function (response) {
	        var data = vm.page;
	        data.img = vm.APPLICATION_URL + response.data;
	        var result = vm.ProductPagesDataProvider.saveProductPage(data);
	        result.then(function (res) {
	          if (redirect == '1') {
	            if (res[0] != undefined && res[0].insertId != undefined) vm.$state.go("app.productPageEdit", { id: res[0].insertId, tabId: vm.activeTab });else alert('Please try again.');
	          } else {
	            vm.$state.go('app.productPagelisting');
	          }
	        });
	      }, function (response) {
	        if (response.status > 0) alert(response.status + ': ' + response.data);
	      });
	      //    file.upload.progress(function (evt) {
	      //      vm.file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      //    });
	    }
	  }, {
	    key: 'setEditorsData',
	    value: function setEditorsData() {
	      this.page.shortText = tinyMCE.get('shortText').getContent();
	      this.page.templateText = tinyMCE.get('templateText').getContent();
	      this.page.longText = tinyMCE.get('longText').getContent();
	      this.page.metaData = tinyMCE.get('metaData').getContent();
	    }
	  }]);
	  return PageAddController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = PageAddController;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Product Pages\r\n    <small>List of product pages</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li class=\"active\"><a ui-sref=\"app.productPagelisting\">Product Pages listing</a></li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <div class=\"box\">\r\n        <div class=\"box-header\">\r\n          <div style=\"float:left;width: 200px;\">\r\n            Select Limit :\r\n            <select ng-model=\"$ctrl.pageLimit\" name='pageLimit' class=\"form-control\"\r\n                    ng-options=\"key as value for (key , value) in $ctrl.pageLimitOptions\"\r\n                    ng-change=\"$ctrl.currentPage = 1;\r\n                                        $ctrl.getProductPage()\" required style=\"display: inline; width: 75px;\">\r\n              <option ng-repeat=\"(key, value) in data\" value=\"{{key}}\">{{value}}</option>\r\n            </select>\r\n            <div class=\"input-group\" style=\"display: none;\">\r\n              <input type=\"text\" ng-model=\"text\" placeholder=\"Search\"\r\n                     class=\"form-control input-sm pull-right ng-pristine ng-valid ng-not-empty ng-touched\"\r\n                     name=\"table_search\" style=\"\">\r\n              <div class=\"input-group-btn\">\r\n                <button ng-click=\"search(text, searchIn)\" type=\"submit\" class=\"btn btn-sm btn-default\"><i\r\n                  class=\"fa fa-search\"></i></button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <a style=\"float:right\" ui-sref=\"app.productPageAdd\">+ Add Product Page</a>\r\n        </div>\r\n        <!-- /.box-header -->\r\n        <div class=\"box-body table-responsive no-padding\">\r\n          <table class=\"table table-hover table-bordered\">\r\n            <thead>\r\n            <tr>\r\n              <th>Id</th>\r\n              <th ng-class=\"{'active': $ctrl.col == '1'}\">Category\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('category_name', 'asc', 1, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('category_name', 'desc', 1, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th ng-class=\"{'active': $ctrl.col == '2'}\">Sub Category\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('sub_category_name', 'asc', 2, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('sub_category_name', 'desc', 2, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th ng-class=\"{'active': $ctrl.col == '3'}\">Product Page\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('name', 'asc', 3, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('name', 'desc', 3, 2)\"></i></span>\r\n              </th>\r\n              <th>Order\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown=='1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('order_by','asc',4,1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown=='2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('order_by','desc',4,2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th ng-class=\"{'active': $ctrl.col == '4'}\">Status\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '5' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('status', 'asc', 5, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '5' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('status', 'desc', 5, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width='15%'>Action</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody id=\"items\">\r\n            <tr ng-repeat=\"pages in $ctrl.productPages\" style=\"cursor:move\">\r\n              <td>{{$ctrl.pageLimit * ($ctrl.currentPage - 1) + ($index + 1)}}</td>\r\n              <td>{{pages.category_name}}</td>\r\n              <td>{{pages.sub_category_name}}</td>\r\n              <td>{{pages.name}}</td>\r\n              <td>{{pages.order_by}}</td>\r\n              <td>\r\n                <span ng-if='pages.status == 1' class=\"label label-success\">Active</span>\r\n                <span ng-if='pages.status != 1' class=\"label label-warning\">Inactive</span>\r\n              </td>\r\n              <td>\r\n                <i ng-if='pages.status != 1' ng-click=\"$ctrl.changeStatus('1', pages.id)\" class='fa fa-toggle-on'\r\n                   title=\"Make Active\"></i>\r\n                <i ng-if='pages.status == 1' ng-click=\"$ctrl.changeStatus('0', pages.id)\" class='fa fa-toggle-off'\r\n                   title=\"Make Inactive\"></i>\r\n                <i class=\"fa fa-edit\" ui-sref=\"app.productPageEdit({id:pages.id})\"></i>\r\n                <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeProductPage(pages.id);\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"box-footer clearfix\">\r\n          <ul ng-if=\"$ctrl.productPagesTotal > $ctrl.pageLimit\" uib-pagination boundary-links=\"true\"\r\n              max-size=\"$ctrl.maxSize\" total-items=\"$ctrl.productPagesTotal\" items-per-page=\"$ctrl.pageLimit\"\r\n              ng-model=\"$ctrl.currentPage\" ng-change=\"$ctrl.getProductPage()\" class=\"pagination-sm pull-right\"\r\n              previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></ul>\r\n          <ul ng-if=\"$ctrl.productPagesTotal <= $ctrl.pageLimit\" class=\"pagination pagination-sm no-margin pull-right\">\r\n            <li><a href=\"#\">&laquo;</a></li>\r\n            <li><a href=\"#\">1</a></li>\r\n            <li><a href=\"#\">&raquo;</a></li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Sortable = __webpack_require__(583);
	
	var _Sortable2 = _interopRequireDefault(_Sortable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageController = function () {
	  PageController.$inject = ["ProductPagesDataProvider", "$state", "$document", "$scope"];
	  function PageController(ProductPagesDataProvider, $state, $document, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PageController);
	    this.ProductPagesDataProvider = ProductPagesDataProvider;
	    this.$state = $state;
	    this.currentPage = 1;
	    this.pageLimit = '100';
	    this.maxSize = 5;
	    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
	    this.type = 3;
	    this.field = 'category_id,sub_category,order_by';
	    this.order_type = 'asc';
	    this.col = 0;
	    this.colTopDown = 0;
	    this.$document = $document;
	    this.categoryId = $state.params.categoryId;
	    this.subCategoryId = $state.params.subCategoryId;
	    if (this.categoryId != undefined && this.subCategoryId != undefined) {
	      this.pageLimit = '9999';
	      var el = document.getElementById('items');
	      var vm = this;
	      vm.sortingLog = [];
	      var sortable = _Sortable2.default.create(el, {
	        onStart: function onStart(evt) {
	          evt.oldIndex;
	          console.log('start');
	        },
	        onEnd: function onEnd(evt) {
	          var oldData = angular.copy(vm.productPages);
	          var i = 0;
	          if (evt.oldIndex < evt.newIndex) {
	            for (i = evt.oldIndex; i <= evt.newIndex; i++) {
	              if (i == evt.newIndex) {
	                vm.productPages[i] = oldData[evt.oldIndex];
	              } else {
	                vm.productPages[i] = oldData[i + 1];
	              }
	            }
	          }
	          if (evt.oldIndex > evt.newIndex) {
	            for (i = evt.oldIndex; i >= evt.newIndex; i--) {
	              if (i == evt.newIndex) {
	                vm.productPages[i] = oldData[evt.oldIndex];
	              } else {
	                vm.productPages[i] = oldData[i - 1];
	              }
	            }
	          }
	          vm.productPages.map(function (i) {
	            vm.sortingLog.push(i.id);
	          });
	          ProductPagesDataProvider.updateProductPageOrder(vm.sortingLog).then(function (result) {
	            vm.getProductPage();
	          });
	          vm.sortingLog = [];
	        }
	      });
	    }
	    this.getProductPage();
	  }
	
	  (0, _createClass3.default)(PageController, [{
	    key: 'getSortRecors',
	    value: function getSortRecors(field, order_type, col, colTopDown) {
	      this.field = field;
	      this.order_type = order_type;
	      this.col = col;
	      this.colTopDown = colTopDown;
	      this.getProductPage();
	    }
	  }, {
	    key: 'getProductPage',
	    value: function getProductPage() {
	      var vm = this;
	      var data = [];
	      data.currentPage = vm.currentPage;
	      data.pageLimit = vm.pageLimit;
	      data.field = vm.field;
	      data.order_type = vm.order_type;
	      data.categoryId = 0;
	      if (vm.categoryId != undefined) {
	        data.categoryId = vm.categoryId;
	      }
	      data.subCategoryId = 0;
	      if (vm.subCategoryId != undefined) {
	        data.subCategoryId = vm.subCategoryId;
	      }
	      vm.ProductPagesDataProvider.getProductPages(data, vm.type).then(function (result) {
	        vm.productPages = result.data;
	        vm.productPagesTotal = result.total;
	      });
	    }
	  }, {
	    key: 'changeStatus',
	    value: function changeStatus(status, id) {
	      var vm = this;
	      var data = { 'status': status, 'id': id };
	      vm.ProductPagesDataProvider.updateProductPageStatus(data).then(function (resp) {
	        vm.pages = resp;
	        vm.getProductPage();
	      });
	    }
	  }, {
	    key: 'removeProductPage',
	    value: function removeProductPage(id) {
	      if (confirm("Are you sure to delete!") !== true) {
	        return false;
	      }
	      var vm = this;
	      vm.ProductPagesDataProvider.removeProductPage(id).then(function (res) {
	        vm.getProductPage();
	      });
	    }
	  }]);
	  return PageController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = PageController;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Product Pages\r\n    <small>Edit product page</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.productPagelisting\">Product Pages listing</a></li>\r\n    <li class=\"active\">Edit</li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form class=\"form-row-seperated\" name=\"productForm\" novalidate>\r\n        <div class=\"portlet\">\r\n          <div class=\"portlet-title\">\r\n            <div class=\"caption\">\r\n              Edit Product Page\r\n            </div>\r\n            <div class=\"actions btn-set\">\r\n              <a ui-sref=\"app.productPagelisting\">\r\n                <button class=\"btn btn-secondary-outline\" name=\"back\" type=\"button\"><i class=\"fa fa-angle-left\"></i>\r\n                  Back\r\n                </button>\r\n              </a>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.updateData(productForm,0);\">\r\n                <i class=\"fa fa-check\"></i> Update\r\n              </button>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.updateData(productForm,1);\">\r\n                <i class=\"fa fa-check-circle\"></i> Update &amp; Close\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if='$ctrl.errorShow && !productForm.$valid'>\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.errorShow=0;'>×</a>\r\n            <span ng-show=\"(productForm.category.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.category.$error.required\">Category is required.<br/></span>\r\n                        </span>\r\n            <span ng-show=\"(productForm.subcategory.$dirty) || productForm.$submitted\">\r\n                            <span\r\n                              ng-show=\"productForm.subcategory.$error.required\">Sub-category is required.<br/></span>\r\n                        </span>\r\n            <span ng-show=\"(productForm.name.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.name.$error.required\">Name is required.<br/></span>\r\n                        </span>\r\n          </div>\r\n          <div class=\"alert alert-success\" ng-if=\"$ctrl.successShow==1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.successShow=0;'>×</a>\r\n            <strong>Success!</strong> Product page data updated successfully.\r\n          </div>\r\n          <ul class=\"nav nav-tabs\">\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 1}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(1)\"><label>General</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 2}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(2)\"><label>Meta</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 3}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(3)\"><label>Images</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 4}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(4)\"><label>Product</label></a>\r\n            </li>\r\n          </ul>\r\n          <div class=\"tab-content\">\r\n            <div ng-class=\"{'tab-pane active': $ctrl.activeTab == 1, 'tab-pane' : $ctrl.activeTab != 1}\">\r\n              <!-- general form elements disabled -->\r\n              <div class=\"box box-warning\">\r\n                <!-- /.box-header -->\r\n                <div class=\"box-body\">\r\n                  <!-- text input -->\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Category</label>\r\n                        <select ng-model=\"$ctrl.page.category_id\" name='category' class=\"form-control\"\r\n                                ng-change=\"$ctrl.changeCategory()\" required\r\n                                ng-options=\"option.id as option.name for option in $ctrl.mainCategories\">\r\n                          <option value=''>Select Category</option>\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Sub Category</label>\r\n                        <select ng-model=\"$ctrl.page.sub_category\" class=\"form-control\" name='subcategory'\r\n                                ng-options=\"option.id as option.name for option in $ctrl.categories\" required>\r\n                          <option value=\"\">Select Sub-Category</option>\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Name (Sub-sub Category)</label>\r\n                        <input ng-model=\"$ctrl.page.name\" class=\"form-control\" name='name' required>\r\n                      </div>\r\n                    </div>\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Material Id</label>\r\n                        <input ng-model=\"$ctrl.page.material_id\" class=\"form-control\" name='material_id'>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Short Text</label>\r\n                      <textarea id='short_text' ng-model='$ctrl.page.short_text' name='short_text' class=\"tinymce\"\r\n                                placeholder=\"Place some text here\" rows='12'></textarea>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Template Text</label>\r\n                      <textarea id='template_text' ng-model='$ctrl.page.template_text' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Long Text</label>\r\n                      <textarea id='long_text' ng-model='$ctrl.page.long_text' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active':  $ctrl.page.activeTab == 2, 'tab-pane' :  $ctrl.activeTab != 2}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Title</label>\r\n                        <input ng-model=\"$ctrl.page.title\" class=\"form-control\" name='title'\r\n                               placeholder=\"Set title for product page\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Meta Data</label>\r\n                      <textarea id='meta_data' ng-model='$ctrl.page.meta_data' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active':  $ctrl.activeTab == 3, 'tab-pane' : $ctrl.activeTab != 3}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Alt text for image</label>\r\n                        <input ng-model=\"$ctrl.page.alt\" class=\"form-control\" name='alt'>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Select File</label>\r\n                      <input type=\"file\" ngf-select ng-model=\"$ctrl.page.img\" name=\"file\"\r\n                             accept=\"image/*\" ngf-max-size=\"2MB\"\r\n                             ngf-model-invalid=\"errorFile\">\r\n                      <img ng-show=\"productForm.file.$valid\" ngf-src=\"$ctrl.page.img\" class=\"thumb img-responsive\">\r\n                      <button type='button' class='btn btn-danger' ng-click=\"$ctrl.page.img = null\"\r\n                              ng-show=\"$ctrl.page.img\">Remove\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active': $ctrl.activeTab == 4, 'tab-pane' : $ctrl.activeTab != 4}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"col-md-3\" ng-repeat=\"product in $ctrl.products\">\r\n                    <div class=\"panel panel-default\">\r\n                      <div class=\"panel-heading\">\r\n                        <div class=\"pull-left\">\r\n                          <h3 class=\"panel-title\">\r\n                            <input type=\"text\" ng-model=\"product.order_by\" class=\"form-control\"\r\n                                   style=\"width: 50px;text-align: center;\"\r\n                                   ng-blur=\"$ctrl.changeProductAssigment(product)\"/>\r\n                          </h3>\r\n                        </div>\r\n                        <div class=\"pull-right\">\r\n                          <input type=\"checkbox\" ng-model=\"product.assigned\"\r\n                                 ng-change=\"$ctrl.changeProductAssigment(product)\"\r\n                                 ng-init=\"product.assigned=(product.assigned==1)\"/>\r\n                          <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeProduct(product);\"></i>\r\n                        </div>\r\n                        <div class=\"pull-right\" ng-show=\"product.__loading\">\r\n                          <span class=\"fa fa-spinner fa-spin\"></span>\r\n                        </div>\r\n                        <div class=\"clearfix\"></div>\r\n                      </div>\r\n                      <div class=\"panel-body\" style=\"text-align: center;\">\r\n                        <img ng-src=\"{{$ctrl.APPLICATION_URL}}/editor_png_files/{{product.image}}\" alt='product'/>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div ng-if=\"$ctrl.products.length==0\">\r\n                    <p>Products not available in this category</p>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"portlet-title\">\r\n            <div class=\"actions btn-set\">\r\n              <a ui-sref=\"app.productPagelisting\">\r\n                <button class=\"btn btn-secondary-outline\" name=\"back\" type=\"button\">\r\n                  <i class=\"fa fa-angle-left\"></i> Back\r\n                </button>\r\n              </a>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.updateData(productForm,0);\">\r\n                <i class=\"fa fa-check\"></i> Update\r\n              </button>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.updateData(productForm,1);\">\r\n                <i class=\"fa fa-check-circle\"></i> Update &amp; Close\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if='$ctrl.errorShow && !productForm.$valid'>\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.errorShow=0;'>×</a>\r\n            <span ng-show=\"(productForm.category.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.category.$error.required\">Category is required.<br/></span>\r\n                        </span>\r\n            <span ng-show=\"(productForm.subcategory.$dirty) || productForm.$submitted\">\r\n                            <span\r\n                              ng-show=\"productForm.subcategory.$error.required\">Sub-category is required.<br/></span>\r\n                        </span>\r\n            <span ng-show=\"(productForm.name.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.name.$error.required\">Name is required.<br/></span>\r\n                        </span>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n"

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageEditController = function () {
	  PageEditController.$inject = ["ProductPagesDataProvider", "$state", "$timeout", "Upload", "API_URL", "APPLICATION_URL"];
	  function PageEditController(ProductPagesDataProvider, $state, $timeout, Upload, API_URL, APPLICATION_URL) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PageEditController);
	    if ($state.params.tabId) this.activeTab = $state.params.tabId;else this.activeTab = 1;
	    this.type = 3;
	    this.page = {};
	    this.page.products = [];
	    this.page.main_category = '';
	    this.page.category = '';
	    this.page.sub_category = '0';
	    this.Upload = Upload;
	    this.ProductPagesDataProvider = ProductPagesDataProvider;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.API_URL = API_URL;
	    this.APPLICATION_URL = APPLICATION_URL;
	    this.errorShow = 0;
	    this.field = 'id';
	    this.order_type = 'asc';
	    ProductPagesDataProvider.editor();
	    var vm = this;
	    ProductPagesDataProvider.loadCategoriesNoLimit(0).then(function (result) {
	      vm.mainCategories = result;
	    });
	    vm.setProduct();
	  }
	
	  (0, _createClass3.default)(PageEditController, [{
	    key: 'setProduct',
	    value: function setProduct() {
	      var vm = this;
	      vm.ProductPagesDataProvider.getProductPage(vm.$state.params.id, vm.type).then(function (result) {
	        vm.page = result;
	        vm.page.products = [];
	        vm.changeCategory();
	        vm.setEditorsData();
	        vm.ProductPagesDataProvider.getProductPageProducts(vm.$state.params.id, vm.type).then(function (result) {
	          vm.products = result;
	        });
	      });
	    }
	  }, {
	    key: 'changeProductAssigment',
	    value: function changeProductAssigment(product) {
	      product.__loading = true;
	      var vm = this;
	      var productData = { id: product.id, assigned: product.assigned, order: product.order_by };
	      var index = vm.page.products.findIndex(function (el) {
	        return el.id === product.id;
	      });
	      if (index !== -1) {
	        vm.page.products.splice(index, 1);
	      }
	      vm.page.products.push(productData);
	      product.__loading = false;
	    }
	  }, {
	    key: 'setActiveTab',
	    value: function setActiveTab(tabToSet) {
	      this.activeTab = tabToSet;
	      this.getEditorsData();
	    }
	  }, {
	    key: 'changeCategory',
	    value: function changeCategory() {
	      var vm = this;
	      if (vm.page.category_id) {
	        vm.ProductPagesDataProvider.loadCategoriesNoLimit(vm.page.category_id).then(function (result) {
	          vm.categories = result;
	        });
	      } else {
	        vm.categories = {};
	      }
	    }
	  }, {
	    key: 'changeProductAssigment',
	    value: function changeProductAssigment(product) {
	      product.__loading = true;
	      var vm = this;
	      var productData = { id: product.id, assigned: product.assigned, order: product.order_by };
	      var index = vm.page.products.findIndex(function (el) {
	        return el.id === product.id;
	      });
	      if (index !== -1) {
	        vm.page.products.splice(index, 1);
	      }
	      vm.page.products.push(productData);
	      product.__loading = false;
	    }
	  }, {
	    key: 'onvertToSlug',
	    value: function onvertToSlug(text) {
	      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
	      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
	      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
	      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
	      .replace(/\-\-+/g, '-') // Replace multiple - with single -
	      .replace(/^-+/, '') // Trim - from start of text
	      .replace(/-+$/, ''); // Trim - from end of text
	    }
	  }, {
	    key: 'updateData',
	    value: function updateData(productForm, redirect) {
	      var vm = this;
	      vm.getEditorsData();
	      vm.$timeout(function () {
	        if (!productForm.$valid) {
	          vm.errorShow = 1;
	          vm.$timeout(function () {
	            vm.errorShow = 0;
	          }, 3000);
	          return false;
	        }
	        if (vm.page.name) vm.page.slug = vm.onvertToSlug(vm.page.name);
	        if (!vm.page.sub_category) vm.page.sub_category = 0;
	        if (!vm.page.alt) vm.page.alt = vm.page.name;
	        if (vm.page.img && vm.page.img.type) {
	          vm.updateWithImage(vm.page.img, redirect);
	        } else {
	          vm.ProductPagesDataProvider.updateProductPage(vm.page, vm.type).then(function (result) {
	            vm.page = result;
	            vm.page.products = [];
	            if (redirect == '1') vm.$state.go('app.productPagelisting');else {
	              vm.successShow = 1;
	              vm.$timeout(function () {
	                vm.successShow = 0;
	              }, 3000);
	            }
	          });
	        }
	      }, 5);
	    }
	  }, {
	    key: 'updateWithImage',
	    value: function updateWithImage(file, redirect) {
	      var vm = this;
	      file.upload = vm.Upload.upload({
	        url: vm.API_URL + '/productPage/saveProductPageImage',
	        method: 'POST',
	        data: {
	          filename: new Date().valueOf() + file.name,
	          file: file
	        }
	      });
	      file.upload.then(function (response) {
	        var img = vm.page.img;
	        var data = vm.page;
	        data.img = vm.APPLICATION_URL + response.data;
	        vm.ProductPagesDataProvider.updateProductPage(data, vm.type).then(function (result) {
	          vm.page = result;
	          vm.page.products = [];
	          vm.page.img = img;
	          if (redirect == '1') vm.$state.go('app.productPagelisting');else {
	            vm.successShow = 1;
	            vm.$timeout(function () {
	              vm.successShow = 0;
	            }, 3000);
	          }
	        });
	      }, function (response) {
	        if (response.status > 0) alert(response.status + ': ' + response.data);
	      });
	    }
	  }, {
	    key: 'removeProduct',
	    value: function removeProduct(product) {
	      if (confirm("Are you sure to delete!") !== true) {
	        return false;
	      }
	      product.__loading = true;
	      var vm = this;
	      var id = product.id;
	      var apid = product.admin_product_id;
	      vm.ProductPagesDataProvider.removeProduct(id, apid).then(function (res) {
	        vm.ProductPagesDataProvider.getProductPageProducts(vm.$state.params.id, vm.type).then(function (result) {
	          vm.products = result;
	          product.__loading = false;
	        });
	      });
	    }
	  }, {
	    key: 'getEditorsData',
	    value: function getEditorsData() {
	      this.page.short_text = tinyMCE.get('short_text').getContent();
	      this.page.template_text = tinyMCE.get('template_text').getContent();
	      this.page.long_text = tinyMCE.get('long_text').getContent();
	      this.page.meta_data = tinyMCE.get('meta_data').getContent();
	    }
	  }, {
	    key: 'setEditorsData',
	    value: function setEditorsData() {
	
	      tinyMCE.get('short_text').setContent(this.page.short_text);
	      tinyMCE.get('template_text').setContent(this.page.template_text);
	      tinyMCE.get('long_text').setContent(this.page.long_text);
	      tinyMCE.get('meta_data').setContent(this.page.meta_data);
	    }
	  }]);
	  return PageEditController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = PageEditController;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Categories\r\n    <small>List all categories</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li class=\"active\"><a ui-sref=\"app.categoryList\">Categories</a></li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <div class=\"box\">\r\n        <div class=\"box-header\">\r\n          <div style=\"float:left;width: 200px;\">\r\n            Select Limit :\r\n            <select ng-model=\"$ctrl.pageLimit\" name='pageLimit' class=\"form-control\"\r\n                    ng-options=\"key as value for (key , value) in $ctrl.pageLimitOptions\"\r\n                    ng-change=\"$ctrl.currentPage = 1;$ctrl.getCategories()\" required\r\n                    style=\"display: inline; width: 75px;\">\r\n              <option ng-repeat=\"(key, value) in data\" value=\"{{key}}\">{{value}}</option>\r\n            </select>\r\n            <div class=\"input-group\" style=\"display: none;\">\r\n              <input type=\"text\" ng-model=\"text\" placeholder=\"Search\"\r\n                     class=\"form-control input-sm pull-right ng-pristine ng-valid ng-not-empty ng-touched\"\r\n                     name=\"table_search\" style=\"\">\r\n              <div class=\"input-group-btn\">\r\n                <button ng-click=\"search(text, searchIn)\" type=\"submit\" class=\"btn btn-sm btn-default\"><i\r\n                  class=\"fa fa-search\"></i></button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <a style=\"float:right\" ui-sref=\"app.categoryAdd\">+ Add Category</a>\r\n        </div>\r\n        <!-- /.box-header -->\r\n        <div class=\"box-body table-responsive no-padding\">\r\n          <table class=\"table table-hover table-bordered\">\r\n            <thead>\r\n            <tr>\r\n              <!--                <th>SN</th>-->\r\n              <th>Category\r\n                <span class='sort-icon'>\r\n                        <i class=\"si-sort-asc\" ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown=='1')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('name','asc',1,1)\"></i>\r\n                        <i class=\"si-sort-desc\" ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown=='2')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('name','desc',1,2)\"></i>\r\n                    </span>\r\n              </th>\r\n              <th>Order\r\n                <span class='sort-icon'>\r\n                        <i class=\"si-sort-asc\" ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown=='1')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('order_by','asc',2,1)\"></i>\r\n                        <i class=\"si-sort-desc\" ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown=='2')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('order_by','desc',2,2)\"></i>\r\n                    </span>\r\n              </th>\r\n              <th>Status\r\n                <span class='sort-icon'>\r\n                        <i class=\"si-sort-asc\" ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown=='1')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('status','asc',3,1)\"></i>\r\n                        <i class=\"si-sort-desc\" ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown=='2')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('status','desc',3,2)\"></i>\r\n                    </span>\r\n              </th>\r\n              <th>Created\r\n                <span class='sort-icon'>\r\n                       <i class=\"si-sort-asc\" ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown=='1')}\"\r\n                          ng-click=\"$ctrl.getSortRecors('created_at','asc',4,1)\"></i>\r\n                       <i class=\"si-sort-desc\" ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown=='2')}\"\r\n                          ng-click=\"$ctrl.getSortRecors('created_at','desc',4,2)\"></i>\r\n                    </span>\r\n              </th>\r\n              <th width='15%'>Action</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody id=\"items\">\r\n            <tr ng-repeat=\"row in $ctrl.categories\" style=\"cursor:move\">\r\n              <!--                  <td>{{$ctrl.pageLimit * ($ctrl.currentPage - 1) + ($index + 1)}}</td>-->\r\n              <td>{{row.name}}</td>\r\n              <td>{{row.order_by}}</td>\r\n              <td>\r\n                <span ng-if='row.status==\"1\"' class=\"label label-success\">Active</span>\r\n                <span ng-if='row.status!=\"1\"' class=\"label label-warning\">Inactive</span>\r\n              </td>\r\n              <td>{{row.created_at| date : format : timezone}}</td>\r\n              <td>\r\n                <i class=\"fa fa-reorder\" ui-sref=\"app.subCategoryList({parentId:row.id})\"\r\n                   title=\"Make reorder of sub-category\"></i>\r\n                <i ng-if='row.status!=1' ng-click=\"$ctrl.changeStatus('1',row.id)\" class='fa fa-toggle-on'\r\n                   title=\"Make Active\"></i>\r\n                <i ng-if='row.status==1' ng-click=\"$ctrl.changeStatus('0',row.id)\" class='fa fa-toggle-off'\r\n                   title=\"Make Inactive\"></i>\r\n                <i class=\"fa fa-edit\" ui-sref=\"app.categoryEdit({id:row.id})\"></i>\r\n                <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeCategory(row.id);\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <!-- /.box-body -->\r\n        <div class=\"box-footer clearfix\">\r\n          <ul ng-if=\"$ctrl.categoriesTotal > $ctrl.pageLimit\" uib-pagination boundary-links=\"true\"\r\n              max-size=\"$ctrl.maxSize\" total-items=\"$ctrl.categoriesTotal\" items-per-page=\"$ctrl.pageLimit\"\r\n              ng-model=\"$ctrl.currentPage\" ng-change=\"$ctrl.getCategories()\" class=\"pagination-sm pull-right\"\r\n              previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></ul>\r\n          <ul ng-if=\"$ctrl.categoriesTotal <= $ctrl.pageLimit\" class=\"pagination pagination-sm no-margin pull-right\">\r\n            <li><a href=\"#\">&laquo;</a></li>\r\n            <li><a href=\"#\">1</a></li>\r\n            <li><a href=\"#\">&raquo;</a></li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- /.box -->\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Sortable = __webpack_require__(583);
	
	var _Sortable2 = _interopRequireDefault(_Sortable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageController = function () {
	  PageController.$inject = ["ProductPagesDataProvider", "$state"];
	  function PageController(ProductPagesDataProvider, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PageController);
	    this.ProductPagesDataProvider = ProductPagesDataProvider;
	    this.$state = $state;
	    this.currentPage = 1;
	    this.pageLimit = '100';
	    this.maxSize = 5;
	    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
	    this.type = 1;
	    this.field = 'order_by';
	    this.order_type = 'asc';
	    this.col = 0;
	    this.colTopDown = 0;
	    this.getCategories();
	    var el = document.getElementById('items');
	    var vm = this;
	    vm.sortingLog = [];
	    var sortable = _Sortable2.default.create(el, {
	      onStart: function onStart(evt) {
	        evt.oldIndex;
	        console.log('start');
	      },
	      onEnd: function onEnd(evt) {
	        var oldData = angular.copy(vm.categories);
	        var i = 0;
	        if (evt.oldIndex < evt.newIndex) {
	          for (i = evt.oldIndex; i <= evt.newIndex; i++) {
	            if (i == evt.newIndex) {
	              vm.categories[i] = oldData[evt.oldIndex];
	            } else {
	              vm.categories[i] = oldData[i + 1];
	            }
	          }
	        }
	        if (evt.oldIndex > evt.newIndex) {
	          for (i = evt.oldIndex; i >= evt.newIndex; i--) {
	            if (i == evt.newIndex) {
	              vm.categories[i] = oldData[evt.oldIndex];
	            } else {
	              vm.categories[i] = oldData[i - 1];
	            }
	          }
	        }
	        vm.categories.map(function (i) {
	          vm.sortingLog.push(i.id);
	        });
	        ProductPagesDataProvider.updateCategoryOrder(vm.sortingLog).then(function (result) {
	          vm.getCategories();
	        });
	        vm.sortingLog = [];
	      }
	    });
	  }
	
	  (0, _createClass3.default)(PageController, [{
	    key: 'getSortRecors',
	    value: function getSortRecors(field, order_type, col, colTopDown) {
	      this.field = field;
	      this.order_type = order_type;
	      this.col = col;
	      this.colTopDown = colTopDown;
	      this.getCategories();
	    }
	  }, {
	    key: 'getCategories',
	    value: function getCategories() {
	      var vm = this;
	      var data = [];
	      data.currentPage = vm.currentPage;
	      data.pageLimit = vm.pageLimit;
	      data.parentId = 0;
	      data.field = vm.field;
	      data.order_type = vm.order_type;
	      vm.ProductPagesDataProvider.getCategory(data).then(function (result) {
	        vm.categories = result.data;
	        vm.categoriesTotal = result.total;
	      });
	    }
	  }, {
	    key: 'removeCategory',
	    value: function removeCategory(id) {
	      if (confirm("Are you sure to delete!") !== true) {
	        return false;
	      }
	      var vm = this;
	      vm.ProductPagesDataProvider.removeCategory(id, vm.type).then(function (res) {
	        vm.getCategories();
	      });
	    }
	  }, {
	    key: 'changeStatus',
	    value: function changeStatus(status, id) {
	      var vm = this;
	      var data = { 'status': status, 'id': id };
	      vm.ProductPagesDataProvider.updateCategory(data).then(function (resp) {
	        vm.getCategories();
	      });
	    }
	  }]);
	  return PageController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = PageController;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Categories\r\n    <small>Add new category</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.categoryList\">Categories</a></li>\r\n    <li class=\"active\"><a ui-sref=\"app.categoryAdd\">Add</a></li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form class=\"form-row-seperated\" name=\"productForm\" novalidate>\r\n        <div class=\"portlet\">\r\n          <div class=\"portlet-title\">\r\n            <div class=\"caption\">\r\n              New Category\r\n            </div>\r\n            <div class=\"actions btn-set\">\r\n              <a ui-sref=\"app.categoryList\">\r\n                <button class=\"btn btn-secondary-outline\" name=\"back\" type=\"button\">\r\n                  <i class=\"fa fa-angle-left\"></i> Back\r\n                </button>\r\n              </a>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.saveData(productForm,1)\">\r\n                <i class=\"fa fa-check\"></i> Save\r\n              </button>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.saveData(productForm,0);\">\r\n                <i class=\"fa fa-check-circle\"></i> Save &amp; Close\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if='$ctrl.errorShow && !productForm.$valid'>\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.errorShow=0;'>×</a>\r\n            <span ng-show=\"(productForm.name.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.name.$error.required\">Name is required.<br/></span>\r\n                        </span>\r\n          </div>\r\n          <div class=\"alert alert-success\" ng-if=\"$ctrl.successShow==1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.successShow=0;'>×</a>\r\n            <strong>Success!</strong> Product page data saved successfully.\r\n          </div>\r\n          <ul class=\"nav nav-tabs\">\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 1}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(1)\"><label>General</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 2}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(2)\"><label>Meta</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 3}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(3)\"><label>Images</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 4}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(4)\"><label>Product</label></a>\r\n            </li>\r\n          </ul>\r\n          <div class=\"tab-content\">\r\n            <div ng-class=\"{'tab-pane active': $ctrl.activeTab === 1, 'tab-pane' : $ctrl.activeTab !== 1}\">\r\n              <!-- general form elements disabled -->\r\n              <div class=\"box box-warning\">\r\n                <!-- /.box-header -->\r\n                <div class=\"box-body\">\r\n                  <!-- text input -->\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Category Name</label>\r\n                        <input ng-model=\"$ctrl.page.name\" class=\"form-control\" name='name' required>\r\n                      </div>\r\n                    </div>\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Material Id</label>\r\n                        <input ng-model=\"$ctrl.page.material_id\" class=\"form-control\" name='material_id'>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Short Text</label>\r\n                      <textarea id='shortText' ng-model='$ctrl.page.shortText' name='shortText' class=\"tinymce\"\r\n                                placeholder=\"Place some text here\" rows='12'></textarea>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Template Text</label>\r\n                      <textarea id='templateText' ng-model='$ctrl.page.templateText' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Long Text</label>\r\n                      <textarea id='longText' ng-model='$ctrl.page.longText' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active':  $ctrl.page.activeTab === 2, 'tab-pane' :  $ctrl.activeTab !== 2}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Title</label>\r\n                        <input ng-model=\"$ctrl.page.title\" class=\"form-control\" name='title'\r\n                               placeholder=\"Set title for product page\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Meta Data</label>\r\n                      <textarea id='metaData' ng-model='$ctrl.page.metaData' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active':  $ctrl.activeTab === 3, 'tab-pane' : $ctrl.activeTab !== 3}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Alt text for image</label>\r\n                        <input ng-model=\"$ctrl.page.alt\" class=\"form-control\" name='alt'>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Select File</label>\r\n                      <input type=\"file\" ngf-select ng-model=\"$ctrl.page.img\" name=\"file\"\r\n                             accept=\"image/*\" ngf-max-size=\"2MB\"\r\n                             ngf-model-invalid=\"errorFile\">\r\n                      <img ng-show=\"productForm.file.$valid\" ngf-src=\"$ctrl.page.img\" class=\"thumb img-responsive\">\r\n                      <button type='button' class='btn btn-danger' ng-click=\"$ctrl.page.img = null\"\r\n                              ng-show=\"$ctrl.page.img\">Remove\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active': $ctrl.activeTab === 4, 'tab-pane' : $ctrl.activeTab !== 4}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div>\r\n                    <p>Products will be added from front-end.</p>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"portlet-title\">\r\n            <div class=\"actions btn-set\">\r\n              <a ui-sref=\"app.categoryList\">\r\n                <button class=\"btn btn-secondary-outline\" name=\"back\" type=\"button\">\r\n                  <i class=\"fa fa-angle-left\"></i> Back\r\n                </button>\r\n              </a>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.saveData(productForm,1)\">\r\n                <i class=\"fa fa-check\"></i> Save\r\n              </button>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.saveData(productForm,0);\">\r\n                <i class=\"fa fa-check-circle\"></i> Save &amp; Close\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if='$ctrl.errorShow && !productForm.$valid'>\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.errorShow=0;'>×</a>\r\n            <span ng-show=\"(productForm.name.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.name.$error.required\">Name is required.<br/></span>\r\n                        </span>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryAddController = function () {
	  CategoryAddController.$inject = ["ProductPagesDataProvider", "$state", "Upload", "$timeout", "API_URL", "APPLICATION_URL"];
	  function CategoryAddController(ProductPagesDataProvider, $state, Upload, $timeout, API_URL, APPLICATION_URL) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CategoryAddController);
	    this.activeTab = 1;
	    this.page = {};
	    this.type = 1;
	    this.page.products = [];
	    this.Upload = Upload;
	    this.ProductPagesDataProvider = ProductPagesDataProvider;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.API_URL = API_URL;
	    this.APPLICATION_URL = APPLICATION_URL;
	    this.errorShow = 0;
	    ProductPagesDataProvider.editor();
	  }
	
	  (0, _createClass3.default)(CategoryAddController, [{
	    key: 'setActiveTab',
	    value: function setActiveTab(tabToSet) {
	      this.activeTab = tabToSet;
	      this.setEditorsData();
	    }
	  }, {
	    key: 'onvertToSlug',
	    value: function onvertToSlug(text) {
	      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
	      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
	      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
	      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
	      .replace(/\-\-+/g, '-') // Replace multiple - with single -
	      .replace(/^-+/, '') // Trim - from start of text
	      .replace(/-+$/, ''); // Trim - from end of text
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(productForm, redirect) {
	      var vm = this;
	      vm.setEditorsData();
	      vm.$timeout(function () {
	        if (!productForm.$valid) {
	          vm.errorShow = 1;
	          vm.$timeout(function () {
	            vm.errorShow = 0;
	          }, 5000);
	          return false;
	        }
	        if (vm.page.name) vm.page.slug = vm.onvertToSlug(vm.page.name);
	        if (!vm.page.sub_category) vm.page.sub_category = 0;
	        if (!vm.page.alt) vm.page.alt = vm.page.name;
	        vm.page.type = vm.type;
	        vm.page.parent_id = 0;
	        if (vm.page.img) {
	          vm.saveWithImage(vm.page.img, redirect);
	        } else {
	          var saveData = vm.ProductPagesDataProvider.saveCategory(vm.page);
	          saveData.then(function (res) {
	            if (redirect == '1') {
	              if (res.id != undefined) vm.$state.go("app.categoryEdit", { id: res.id, tabId: vm.activeTab });else alert('Please try again.');
	            } else {
	              vm.$state.go("app.categoryList", { parentId: 'all' });
	            }
	          });
	        }
	      }, 5);
	    }
	  }, {
	    key: 'saveWithImage',
	    value: function saveWithImage(file, redirect) {
	      var vm = this;
	      file.upload = vm.Upload.upload({
	        url: vm.API_URL + '/productPage/saveProductPageImage',
	        method: 'POST',
	        data: {
	          filename: new Date().valueOf() + file.name,
	          file: file
	        }
	      });
	      file.upload.then(function (response) {
	        var data = vm.page;
	        data.img = vm.APPLICATION_URL + response.data;
	        var result = vm.ProductPagesDataProvider.saveCategory(data);
	        result.then(function (res) {
	          if (redirect == '1') {
	            if (res.id != undefined) vm.$state.go("app.categoryEdit", { id: res.id, tabId: vm.activeTab });else alert('Please try again.');
	          } else {
	            vm.$state.go("app.categoryList", { parentId: 'all' });
	          }
	        });
	      }, function (response) {
	        if (response.status > 0) alert(response.status + ': ' + response.data);
	      });
	      //    file.upload.progress(function (evt) {
	      //      vm.file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      //    });
	    }
	  }, {
	    key: 'setEditorsData',
	    value: function setEditorsData() {
	      this.page.shortText = tinyMCE.get('shortText').getContent();
	      this.page.templateText = tinyMCE.get('templateText').getContent();
	      this.page.longText = tinyMCE.get('longText').getContent();
	      this.page.metaData = tinyMCE.get('metaData').getContent();
	    }
	  }]);
	  return CategoryAddController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = CategoryAddController;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Sub-Categories\r\n    <small>List all sub-categories</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li class=\"active\"><a ui-sref=\"app.subCategoryList({parentId:'all'})\">Sub-Categories</a></li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <div class=\"box\">\r\n        <div class=\"box-header\">\r\n          <div style=\"float:left;width: 200px;\">\r\n            Select Limit :\r\n            <select ng-model=\"$ctrl.pageLimit\" name='pageLimit' class=\"form-control\"\r\n                    ng-options=\"key as value for (key , value) in $ctrl.pageLimitOptions\"\r\n                    ng-change=\"$ctrl.currentPage = 1;$ctrl.getRecords()\" required style=\"display: inline; width: 75px;\">\r\n              <option ng-repeat=\"(key, value) in data\" value=\"{{key}}\">{{value}}</option>\r\n            </select>\r\n            <div class=\"input-group\" style=\"display: none;\">\r\n              <input type=\"text\" ng-model=\"text\" placeholder=\"Search\"\r\n                     class=\"form-control input-sm pull-right ng-pristine ng-valid ng-not-empty ng-touched\"\r\n                     name=\"table_search\" style=\"\">\r\n              <div class=\"input-group-btn\">\r\n                <button ng-click=\"search(text, searchIn)\" type=\"submit\" class=\"btn btn-sm btn-default\"><i\r\n                  class=\"fa fa-search\"></i></button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <a style=\"float:right\" ui-sref=\"app.subCategoryAdd\">+ Add Sub-Category</a>\r\n        </div>\r\n        <!-- /.box-header -->\r\n        <div class=\"box-body table-responsive no-padding\">\r\n          <table class=\"table table-hover table-bordered\">\r\n            <thead>\r\n            <tr>\r\n              <th>Id</th>\r\n              <th>Sub Category\r\n                <span class='sort-icon'>\r\n                    <i class=\"si-sort-asc\" ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown=='1')}\"\r\n                       ng-click=\"$ctrl.getSortRecors('name','asc',1,1)\"></i>\r\n                    <i class=\"si-sort-desc\" ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown=='2')}\"\r\n                       ng-click=\"$ctrl.getSortRecors('name','desc',1,2)\"></i></span>\r\n              </th>\r\n              <th>Category\r\n                <span class='sort-icon'>\r\n                        <i class=\"si-sort-asc\" ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown=='1')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('category_name','asc',2,1)\"></i>\r\n                        <i class=\"si-sort-desc\" ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown=='2')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('category_name','desc',2,2)\"></i>\r\n                     </span>\r\n              </th>\r\n              <th>Order\r\n                <span class='sort-icon'>\r\n                        <i class=\"si-sort-asc\" ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown=='1')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('order_by','asc',3,1)\"></i>\r\n                        <i class=\"si-sort-desc\" ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown=='2')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('order_by','desc',3,2)\"></i>\r\n                    </span>\r\n              </th>\r\n              <th>Status\r\n                <span class='sort-icon'>\r\n                        <i class=\"si-sort-asc\" ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown=='1')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('status','asc',4,1)\"></i>\r\n                        <i class=\"si-sort-desc\" ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown=='2')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('status','desc',3,2)\"></i>\r\n                    </span>\r\n              </th>\r\n              <th>Created\r\n                <span class='sort-icon'>\r\n                        <i class=\"si-sort-asc\" ng-class=\"{'active': ($ctrl.col == '5' && $ctrl.colTopDown=='1')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('created_at','asc',5,1)\"></i>\r\n                        <i class=\"si-sort-desc\" ng-class=\"{'active': ($ctrl.col == '5' && $ctrl.colTopDown=='2')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('created_at','desc',5,2)\"></i>\r\n                     </span>\r\n              </th>\r\n              <th width='15%'>Action</th>\r\n            </thead>\r\n            <tbody id=\"items\">\r\n            <tr ng-repeat=\"row in $ctrl.categories\" style=\"cursor:move\">\r\n              <td>{{$ctrl.pageLimit * ($ctrl.currentPage - 1) + ($index+1)}}</td>\r\n              <td>{{row.name}}</td>\r\n              <td>{{row.category_name}}</td>\r\n              <td>{{row.order_by}}</td>\r\n              <td>\r\n                <span ng-if='row.status==\"1\"' class=\"label label-success\">Active</span>\r\n                <span ng-if='row.status!=\"1\"' class=\"label label-warning\">Inactive</span>\r\n              </td>\r\n              <td>{{row.created_at| date : format : timezone}}</td>\r\n              <td>\r\n                <i class=\"fa fa-reorder\"\r\n                   ui-sref=\"app.productPagelistingC({categoryId:row.parent_id,subCategoryId:row.id})\"\r\n                   title=\"Make reorder of product pages\"></i>\r\n                <i ng-if='row.status!=1' ng-click=\"$ctrl.changeStatus('1',row.id)\" class='fa fa-toggle-on'\r\n                   title=\"Make Active\"></i>\r\n                <i ng-if='row.status==1' ng-click=\"$ctrl.changeStatus('0',row.id)\" class='fa fa-toggle-off'\r\n                   title=\"Make Inactive\"></i>\r\n                <i class=\"fa fa-edit\" ui-sref=\"app.subCategoryEdit({id:row.id})\"></i>\r\n                <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeCategory(row.id);\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"box-footer clearfix\">\r\n          <ul ng-if=\"$ctrl.categoriesTotal > $ctrl.pageLimit\" uib-pagination boundary-links=\"true\"\r\n              max-size=\"$ctrl.maxSize\" total-items=\"$ctrl.categoriesTotal\" items-per-page=\"$ctrl.pageLimit\"\r\n              ng-model=\"$ctrl.currentPage\" ng-change=\"$ctrl.getRecords()\" class=\"pagination-sm pull-right\"\r\n              previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></ul>\r\n          <ul ng-if=\"$ctrl.categoriesTotal <= $ctrl.pageLimit\" class=\"pagination pagination-sm no-margin pull-right\">\r\n            <li><a href=\"#\">&laquo;</a></li>\r\n            <li><a href=\"#\">1</a></li>\r\n            <li><a href=\"#\">&raquo;</a></li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Sortable = __webpack_require__(583);
	
	var _Sortable2 = _interopRequireDefault(_Sortable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageController = function () {
	  PageController.$inject = ["ProductPagesDataProvider", "$state"];
	  function PageController(ProductPagesDataProvider, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PageController);
	    this.ProductPagesDataProvider = ProductPagesDataProvider;
	    this.$state = $state;
	    this.currentPage = 1;
	    this.pageLimit = '100';
	    this.maxSize = 5;
	    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
	    var parentId = $state.params.parentId;
	    if (parentId == 'all') {
	      parentId = 0;
	    }
	    this.parentId = parentId;
	    this.field = 'parent_id,order_by';
	    this.order_type = 'asc';
	    this.col = 0;
	    this.colTopDown = 0;
	    if (parentId != 0) {
	      this.pageLimit = '9999';
	      var el = document.getElementById('items');
	      var vm = this;
	      vm.sortingLog = [];
	      var sortable = _Sortable2.default.create(el, {
	        onStart: function onStart(evt) {
	          evt.oldIndex;
	          console.log('start');
	        },
	        onEnd: function onEnd(evt) {
	          var oldData = angular.copy(vm.categories);
	          var i = 0;
	          if (evt.oldIndex < evt.newIndex) {
	            for (i = evt.oldIndex; i <= evt.newIndex; i++) {
	              if (i == evt.newIndex) {
	                vm.categories[i] = oldData[evt.oldIndex];
	              } else {
	                vm.categories[i] = oldData[i + 1];
	              }
	            }
	          }
	          if (evt.oldIndex > evt.newIndex) {
	            for (i = evt.oldIndex; i >= evt.newIndex; i--) {
	              if (i == evt.newIndex) {
	                vm.categories[i] = oldData[evt.oldIndex];
	              } else {
	                vm.categories[i] = oldData[i - 1];
	              }
	            }
	          }
	          vm.categories.map(function (i) {
	            vm.sortingLog.push(i.id);
	          });
	          ProductPagesDataProvider.updateCategoryOrder(vm.sortingLog).then(function (result) {
	            vm.getRecords();
	          });
	          vm.sortingLog = [];
	        }
	      });
	    }
	    this.getRecords();
	  }
	
	  (0, _createClass3.default)(PageController, [{
	    key: 'getSortRecors',
	    value: function getSortRecors(field, order_type, col, colTopDown) {
	      this.field = field;
	      this.order_type = order_type;
	      this.col = col;
	      this.colTopDown = colTopDown;
	      this.getRecords();
	    }
	  }, {
	    key: 'getRecords',
	    value: function getRecords() {
	      var vm = this;
	      var data = [];
	      data.currentPage = vm.currentPage;
	      data.pageLimit = vm.pageLimit;
	      data.parentId = vm.parentId;
	      data.field = vm.field;
	      data.order_type = vm.order_type;
	      vm.ProductPagesDataProvider.getSubCategory(data).then(function (result) {
	        vm.categories = result.data;
	        vm.categoriesTotal = result.total;
	      });
	    }
	  }, {
	    key: 'removeCategory',
	    value: function removeCategory(id) {
	      if (confirm("Are you sure to delete!") !== true) {
	        return false;
	      }
	      var vm = this;
	      vm.ProductPagesDataProvider.removeCategory(id).then(function (res) {
	        vm.getRecords();
	      });
	    }
	  }, {
	    key: 'changeStatus',
	    value: function changeStatus(status, id) {
	      var vm = this;
	      var data = { 'status': status, 'id': id };
	      vm.ProductPagesDataProvider.updateCategory(data).then(function (resp) {
	        vm.getRecords();
	      });
	    }
	  }]);
	  return PageController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = PageController;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Sub-Categories\r\n    <small>Add new sub-category</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.subCategoryList({parentId:'all'})\">Sub-Categories</a></li>\r\n    <li class=\"active\"><a ui-sref=\"app.subCategoryAdd\">Add</a></li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form class=\"form-row-seperated\" name=\"productForm\" novalidate>\r\n        <div class=\"portlet\">\r\n          <div class=\"portlet-title\">\r\n            <div class=\"caption\">\r\n              New Sub-Category\r\n            </div>\r\n            <div class=\"actions btn-set\">\r\n              <a ui-sref=\"app.subCategoryList({parentId:'all'})\">\r\n                <button class=\"btn btn-secondary-outline\" name=\"back\" type=\"button\">\r\n                  <i class=\"fa fa-angle-left\"></i> Back\r\n                </button>\r\n              </a>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.saveData(productForm,1)\">\r\n                <i class=\"fa fa-check\"></i> Save\r\n              </button>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.saveData(productForm,0);\">\r\n                <i class=\"fa fa-check-circle\"></i> Save &amp; Close\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if='$ctrl.errorShowExist==\"1\"'>\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.errorShow=0;'>×</a>\r\n            <span>Sub-Category already exist.<br/></span>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if='$ctrl.errorShow && !productForm.$valid'>\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.errorShow=0;'>×</a>\r\n            <span ng-show=\"(productForm.category.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.category.$error.required\">Category is required.<br/></span>\r\n                        </span>\r\n            <span ng-show=\"(productForm.name.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.name.$error.required\">Name is required.<br/></span>\r\n                        </span>\r\n          </div>\r\n          <div class=\"alert alert-success\" ng-if=\"$ctrl.successShow==1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.successShow=0;'>×</a>\r\n            <strong>Success!</strong> Product page data saved successfully.\r\n          </div>\r\n          <ul class=\"nav nav-tabs\">\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 1}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(1)\"><label>General</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 2}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(2)\"><label>Meta</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 3}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(3)\"><label>Images</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 4}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(4)\"><label>Product</label></a>\r\n            </li>\r\n          </ul>\r\n          <div class=\"tab-content\">\r\n            <div ng-class=\"{'tab-pane active': $ctrl.activeTab == 1, 'tab-pane' : $ctrl.activeTab != 1}\">\r\n              <!-- general form elements disabled -->\r\n              <div class=\"box box-warning\">\r\n                <!-- /.box-header -->\r\n                <div class=\"box-body\">\r\n                  <!-- text input -->\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Category</label>\r\n                        <select ng-model=\"$ctrl.page.category_id\" name='category' class=\"form-control\"\r\n                                ng-change=\"$ctrl.changeCategory()\" required>\r\n                          <option value=''>Select Category</option>\r\n                          <option ng-repeat=\"category in $ctrl.mainCategories\" value=\"{{category.id}}\">\r\n                            {{category.name}}\r\n                          </option>\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Sub-Category Name</label>\r\n                        <input ng-model=\"$ctrl.page.name\" class=\"form-control\" name='name' required>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-4'>\r\n                      <div class=\"form-group\">\r\n                        <label>Material Id</label>\r\n                        <input ng-model=\"$ctrl.page.material_id\" class=\"form-control\" name='material_id'>\r\n                      </div>\r\n                    </div>\r\n                    <div class='col-md-4'>\r\n                      <div class=\"form-group\">\r\n                        <label>Sub Category Type</label>\r\n                        <input ng-model=\"$ctrl.page.subcategory_type_id\" class=\"form-control\" name='subcategory_type_id'>\r\n                      </div>\r\n                    </div>\r\n                    <div class='col-md-4'>\r\n                      <div class=\"form-group\">\r\n                        <label>Domain</label>\r\n                          <select ng-model=\"$ctrl.page.domain\" name='domain' class=\"form-control\"\r\n                                ng-change=\"$ctrl.changeDomain()\" required>\r\n                            <option value=''>Select Domain</option>\r\n                            <option ng-repeat=\"domain in $ctrl.mainDomains\" value=\"{{domain}}\">\r\n                              {{domain}}\r\n                            </option>\r\n                          </select>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Short Text</label>\r\n                      <textarea id='shortText' ng-model='$ctrl.page.shortText' name='shortText' class=\"tinymce\"\r\n                                placeholder=\"Place some text here\" rows='12'></textarea>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Template Text</label>\r\n                      <textarea id='templateText' ng-model='$ctrl.page.templateText' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Long Text</label>\r\n                      <textarea id='longText' ng-model='$ctrl.page.longText' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active':  $ctrl.page.activeTab == 2, 'tab-pane' :  $ctrl.activeTab != 2}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Title</label>\r\n                        <input ng-model=\"$ctrl.page.title\" class=\"form-control\" name='title'\r\n                               placeholder=\"Set title for product page\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Meta Data</label>\r\n                      <textarea id='metaData' ng-model='$ctrl.page.metaData' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active':  $ctrl.activeTab == 3, 'tab-pane' : $ctrl.activeTab != 3}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Alt text for image</label>\r\n                        <input ng-model=\"$ctrl.page.alt\" class=\"form-control\" name='alt'>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Select File</label>\r\n                      <input type=\"file\" ngf-select ng-model=\"$ctrl.page.img\" name=\"file\"\r\n                             accept=\"image/*\" ngf-max-size=\"2MB\"\r\n                             ngf-model-invalid=\"errorFile\">\r\n                      <img ng-show=\"productForm.file.$valid\" ngf-src=\"$ctrl.page.img\" class=\"thumb img-responsive\">\r\n                      <button type='button' class='btn btn-danger' ng-click=\"$ctrl.page.img = null\"\r\n                              ng-show=\"$ctrl.page.img\">Remove\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active': $ctrl.activeTab == 4, 'tab-pane' : $ctrl.activeTab != 4}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div>\r\n                    <p>Products will be added from front-end.</p>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"portlet-title\">\r\n            <div class=\"actions btn-set\">\r\n              <a ui-sref=\"app.subCategoryList({parentId:'all'})\">\r\n                <button class=\"btn btn-secondary-outline\" name=\"back\" type=\"button\">\r\n                  <i class=\"fa fa-angle-left\"></i> Back\r\n                </button>\r\n              </a>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.saveData(productForm,1)\">\r\n                <i class=\"fa fa-check\"></i> Save\r\n              </button>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.saveData(productForm,0);\">\r\n                <i class=\"fa fa-check-circle\"></i> Save &amp; Close\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if='$ctrl.errorShow && !productForm.$valid'>\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.errorShow=0;'>×</a>\r\n            <span ng-show=\"(productForm.category.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.category.$error.required\">Category is required.<br/></span>\r\n                        </span>\r\n            <span ng-show=\"(productForm.name.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.name.$error.required\">Name is required.<br/></span>\r\n                        </span>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryAddController = function () {
	  CategoryAddController.$inject = ["ProductPagesDataProvider", "$state", "Upload", "$timeout", "API_URL", "APPLICATION_URL"];
	  function CategoryAddController(ProductPagesDataProvider, $state, Upload, $timeout, API_URL, APPLICATION_URL) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CategoryAddController);
	    this.activeTab = 1;
	    this.page = {};
	    this.type = 2;
	    this.page.products = [];
	    this.Upload = Upload;
	    this.ProductPagesDataProvider = ProductPagesDataProvider;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.API_URL = API_URL;
	    this.APPLICATION_URL = APPLICATION_URL;
	    this.errorShow = 0;
	    this.field = 'id';
	    this.order_type = 'asc';
	    ProductPagesDataProvider.editor();
	    var vm = this;
	    ProductPagesDataProvider.loadCategoriesNoLimit(0).then(function (result) {
	      vm.mainCategories = result;
	    });
	    vm.mainDomains = ["signlabs.se", "signlabs.dk", "signlabs.no", "signlabs.fi", "signlabs.de", "signlabs.at", "signlabs.ch", "signlabs.es", "signlabs.fr", "signlabs.it", "signlabs.nl", "signlabs.be", "signlabs.pl", "signlabs.eu", "signlabs.co.uk", "signlabs.com", "signlabs.loc"];
	  }
	
	  (0, _createClass3.default)(CategoryAddController, [{
	    key: 'setActiveTab',
	    value: function setActiveTab(tabToSet) {
	      this.activeTab = tabToSet;
	      this.setEditorsData();
	    }
	  }, {
	    key: 'onvertToSlug',
	    value: function onvertToSlug(text) {
	      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
	      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
	      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
	      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
	      .replace(/\-\-+/g, '-') // Replace multiple - with single -
	      .replace(/^-+/, '') // Trim - from start of text
	      .replace(/-+$/, ''); // Trim - from end of text
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(productForm, redirect) {
	      var vm = this;
	      vm.setEditorsData();
	      vm.$timeout(function () {
	        if (!productForm.$valid) {
	          vm.errorShow = 1;
	          vm.$timeout(function () {
	            vm.errorShow = 0;
	          }, 5000);
	          return false;
	        }
	        if (vm.page.name) vm.page.slug = vm.onvertToSlug(vm.page.name);
	        if (!vm.page.alt) vm.page.alt = vm.page.name;
	        vm.page.type = vm.type;
	        vm.page.parent_id = vm.page.category_id;
	        if (vm.page.img) {
	          vm.saveWithImage(vm.page.img, redirect);
	        } else {
	          var saveData = vm.ProductPagesDataProvider.saveCategory(vm.page);
	          saveData.then(function (res) {
	            if (redirect == '1') {
	              if (res.id != undefined) vm.$state.go("app.subCategoryEdit", { id: res.id, tabId: vm.activeTab });else if (res.exist == '1') {
	                vm.errorShowExist = 1;
	                vm.$timeout(function () {
	                  vm.errorShowExist = 0;
	                }, 5000);
	              } else alert('Please try again.');
	            } else {
	              vm.$state.go("app.subCategoryList", { parentId: 'all' });
	            }
	          });
	        }
	      }, 5);
	    }
	  }, {
	    key: 'saveWithImage',
	    value: function saveWithImage(file, redirect) {
	      var vm = this;
	      file.upload = vm.Upload.upload({
	        url: vm.API_URL + '/productPage/saveProductPageImage',
	        method: 'POST',
	        data: {
	          filename: new Date().valueOf() + file.name,
	          file: file
	        }
	      });
	      file.upload.then(function (response) {
	        var img = vm.page.img;
	        var data = vm.page;
	        data.img = vm.APPLICATION_URL + response.data;
	        vm.ProductPagesDataProvider.saveCategory(data).then(function (res) {
	          if (redirect == '1') {
	            if (res.id != undefined) vm.$state.go("app.subCategoryEdit", { id: res.id, tabId: vm.activeTab });else alert('Please try again.');
	          } else {
	            vm.$state.go("app.subCategoryList", { parentId: 'all' });
	          }
	        });
	      }, function (response) {
	        if (response.status > 0) alert(response.status + ': ' + response.data);
	      });
	    }
	  }, {
	    key: 'setEditorsData',
	    value: function setEditorsData() {
	      this.page.shortText = tinyMCE.get('shortText').getContent();
	      this.page.templateText = tinyMCE.get('templateText').getContent();
	      this.page.longText = tinyMCE.get('longText').getContent();
	      this.page.metaData = tinyMCE.get('metaData').getContent();
	    }
	  }]);
	  return CategoryAddController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = CategoryAddController;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Categories\r\n    <small>Edit category</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.categoryList\">Categories</a></li>\r\n    <li class=\"active\">Edit</li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form class=\"form-row-seperated\" name=\"productForm\" novalidate>\r\n        <div class=\"portlet\">\r\n          <div class=\"portlet-title\">\r\n            <div class=\"caption\">\r\n              Edit Category\r\n            </div>\r\n            <div class=\"actions btn-set\">\r\n              <a ui-sref=\"app.categoryList\">\r\n                <button class=\"btn btn-secondary-outline\" name=\"back\" type=\"button\"><i class=\"fa fa-angle-left\"></i>\r\n                  Back\r\n                </button>\r\n              </a>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.updateData(productForm,0);\">\r\n                <i class=\"fa fa-check\"></i> Update\r\n              </button>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.updateData(productForm,1);\">\r\n                <i class=\"fa fa-check-circle\"></i> Update &amp; Close\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if='$ctrl.errorShow && !productForm.$valid'>\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.errorShow=0;'>×</a>\r\n            <span ng-show=\"(productForm.name.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.name.$error.required\">Name is required.<br/></span>\r\n                        </span>\r\n          </div>\r\n          <div class=\"alert alert-success\" ng-if=\"$ctrl.successShow==1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.successShow=0;'>×</a>\r\n            <strong>Success!</strong> Product page data updated successfully.\r\n          </div>\r\n          <ul class=\"nav nav-tabs\">\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 1}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(1)\"><label>General</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 2}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(2)\"><label>Meta</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 3}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(3)\"><label>Images</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 4}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(4)\"><label>Product</label></a>\r\n            </li>\r\n          </ul>\r\n          <div class=\"tab-content\">\r\n            <div ng-class=\"{'tab-pane active': $ctrl.activeTab == 1, 'tab-pane' : $ctrl.activeTab != 1}\">\r\n              <!-- general form elements disabled -->\r\n              <div class=\"box box-warning\">\r\n                <!-- /.box-header -->\r\n                <div class=\"box-body\">\r\n                  <!-- text input -->\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Name</label>\r\n                        <input ng-model=\"$ctrl.page.name\" class=\"form-control\" name='name' required>\r\n                      </div>\r\n                    </div>\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Material Id</label>\r\n                        <input ng-model=\"$ctrl.page.material_id\" class=\"form-control\" name='material_id'>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Short Text</label>\r\n                      <textarea id='short_text' ng-model='$ctrl.page.short_text' name='short_text' class=\"tinymce\"\r\n                                placeholder=\"Place some text here\" rows='12'></textarea>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Template Text</label>\r\n                      <textarea id='template_text' ng-model='$ctrl.page.template_text' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Long Text</label>\r\n                      <textarea id='long_text' ng-model='$ctrl.page.long_text' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active':  $ctrl.page.activeTab == 2, 'tab-pane' :  $ctrl.activeTab != 2}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Title</label>\r\n                        <input ng-model=\"$ctrl.page.title\" class=\"form-control\" name='title'\r\n                               placeholder=\"Set title for product page\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Meta Data</label>\r\n                      <textarea id='meta_data' ng-model='$ctrl.page.meta_data' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active':  $ctrl.activeTab == 3, 'tab-pane' : $ctrl.activeTab != 3}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Alt text for image</label>\r\n                        <input ng-model=\"$ctrl.page.alt\" class=\"form-control\" name='alt'>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Select File</label>\r\n                      <input type=\"file\" ngf-select ng-model=\"$ctrl.page.img\" name=\"file\"\r\n                             accept=\"image/*\" ngf-max-size=\"2MB\"\r\n                             ngf-model-invalid=\"errorFile\">\r\n                      <img ng-show=\"productForm.file.$valid\" ngf-src=\"$ctrl.page.img\" class=\"thumb img-responsive\">\r\n                      <button type='button' class='btn btn-danger' ng-click=\"$ctrl.page.img = null\"\r\n                              ng-show=\"$ctrl.page.img\">Remove\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active': $ctrl.activeTab == 4, 'tab-pane' : $ctrl.activeTab != 4}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"col-md-3\" ng-repeat=\"product in $ctrl.products\">\r\n                    <div class=\"panel panel-default\">\r\n                      <div class=\"panel-heading\">\r\n                        <div class=\"pull-left\">\r\n                          <h3 class=\"panel-title\">\r\n                            <input type=\"text\" ng-model=\"product.order_by\" class=\"form-control\"\r\n                                   style=\"width: 50px;text-align: center;\"\r\n                                   ng-blur=\"$ctrl.changeProductAssigment(product)\"/>\r\n                          </h3>\r\n                        </div>\r\n                        <div class=\"pull-right\">\r\n                          <input type=\"checkbox\" ng-model=\"product.assigned\"\r\n                                 ng-change=\"$ctrl.changeProductAssigment(product)\"\r\n                                 ng-init=\"product.assigned=(product.assigned==1)\"/>\r\n                          <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeProduct(product);\"></i>\r\n                        </div>\r\n                        <div class=\"pull-right\" ng-show=\"product.__loading\">\r\n                          <span class=\"fa fa-spinner fa-spin\"></span>\r\n                        </div>\r\n                        <div class=\"clearfix\"></div>\r\n                      </div>\r\n                      <div class=\"panel-body\" style=\"text-align: center;\">\r\n                        <img ng-src=\"{{$ctrl.APPLICATION_URL}}/editor_png_files/{{product.image}}\" alt='product'/>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div ng-if=\"$ctrl.products.length==0\">\r\n                    <p>Products not available in this category</p>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"portlet-title\">\r\n            <div class=\"actions btn-set\">\r\n              <a ui-sref=\"app.categoryList\">\r\n                <button class=\"btn btn-secondary-outline\" name=\"back\" type=\"button\">\r\n                  <i class=\"fa fa-angle-left\"></i> Back\r\n                </button>\r\n              </a>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.updateData(productForm,0);\">\r\n                <i class=\"fa fa-check\"></i> Update\r\n              </button>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.updateData(productForm,1);\">\r\n                <i class=\"fa fa-check-circle\"></i> Update &amp; Close\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if='$ctrl.errorShow && !productForm.$valid'>\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.errorShow=0;'>×</a>\r\n            <span ng-show=\"(productForm.name.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.name.$error.required\">Name is required.<br/></span>\r\n                        </span>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryEditController = function () {
	  CategoryEditController.$inject = ["ProductPagesDataProvider", "$state", "$timeout", "Upload", "API_URL", "APPLICATION_URL"];
	  function CategoryEditController(ProductPagesDataProvider, $state, $timeout, Upload, API_URL, APPLICATION_URL) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CategoryEditController);
	    if ($state.params.tabId) this.activeTab = $state.params.tabId;else this.activeTab = 1;
	    this.type = 1;
	    this.page = {};
	    this.page.products = [];
	    this.Upload = Upload;
	    this.ProductPagesDataProvider = ProductPagesDataProvider;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.API_URL = API_URL;
	    this.APPLICATION_URL = APPLICATION_URL;
	    this.errorShow = 0;
	    ProductPagesDataProvider.editor();
	    this.setProduct();
	  }
	
	  (0, _createClass3.default)(CategoryEditController, [{
	    key: 'setProduct',
	    value: function setProduct() {
	      var vm = this;
	      vm.ProductPagesDataProvider.getProductPage(vm.$state.params.id, vm.type).then(function (result) {
	        vm.page = result;
	        vm.products = [];
	        vm.page.products = [];
	        console.log(result.id);
	        if (result.id != undefined) {
	          vm.getProducts(vm);
	        } else {
	          vm.page = {};
	          vm.ProductPagesDataProvider.getCategoryById(vm.$state.params.id).then(function (response) {
	            vm.page.name = response.name;
	            vm.page.slug = response.slug;
	            vm.page.category_id = response.id;
	            vm.page.sub_category = 0;
	            vm.page.type = vm.type;
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getProducts',
	    value: function getProducts(vm) {
	      vm.setEditorsData();
	      vm.ProductPagesDataProvider.getProductPageProducts(vm.$state.params.id, vm.type).then(function (result) {
	        vm.products = result;
	      });
	    }
	  }, {
	    key: 'changeProductAssigment',
	    value: function changeProductAssigment(product) {
	      product.__loading = true;
	      var vm = this;
	      var productData = { id: product.id, assigned: product.assigned, order: product.order_by };
	      var index = vm.page.products.findIndex(function (el) {
	        return el.id === product.id;
	      });
	      if (index !== -1) {
	        vm.page.products.splice(index, 1);
	      }
	      vm.page.products.push(productData);
	      product.__loading = false;
	    }
	  }, {
	    key: 'setActiveTab',
	    value: function setActiveTab(tabToSet) {
	      this.activeTab = tabToSet;
	      this.getEditorsData();
	    }
	  }, {
	    key: 'changeProductAssigment',
	    value: function changeProductAssigment(product) {
	      product.__loading = true;
	      var vm = this;
	      var productData = { id: product.id, assigned: product.assigned, order: product.order_by };
	      var index = vm.page.products.findIndex(function (el) {
	        return el.id === product.id;
	      });
	      if (index !== -1) {
	        vm.page.products.splice(index, 1);
	      }
	      vm.page.products.push(productData);
	      product.__loading = false;
	    }
	  }, {
	    key: 'onvertToSlug',
	    value: function onvertToSlug(text) {
	      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
	      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
	      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
	      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
	      .replace(/\-\-+/g, '-') // Replace multiple - with single -
	      .replace(/^-+/, '') // Trim - from start of text
	      .replace(/-+$/, ''); // Trim - from end of text
	    }
	  }, {
	    key: 'updateData',
	    value: function updateData(productForm, redirect) {
	      var vm = this;
	      vm.getEditorsData();
	      vm.$timeout(function () {
	        if (!productForm.$valid) {
	          vm.errorShow = 1;
	          vm.$timeout(function () {
	            vm.errorShow = 0;
	          }, 3000);
	          return false;
	        }
	        if (vm.page.name) vm.page.slug = vm.onvertToSlug(vm.page.name);
	        if (!vm.page.sub_category) vm.page.sub_category = 0;
	        if (!vm.page.alt) vm.page.alt = vm.page.name;
	        if (vm.page.img && vm.page.img.type) {
	          vm.updateWithImage(vm.page.img, redirect);
	        } else {
	          vm.ProductPagesDataProvider.updateProductPage(vm.page, vm.type).then(function (result) {
	            vm.page = result;
	            vm.page.products = [];
	            if (redirect == '1') vm.$state.go('app.categoryList');else {
	              vm.successShow = 1;
	              vm.$timeout(function () {
	                vm.successShow = 0;
	              }, 3000);
	            }
	          });
	        }
	      }, 5);
	    }
	  }, {
	    key: 'updateWithImage',
	    value: function updateWithImage(file, redirect) {
	      var vm = this;
	      file.upload = vm.Upload.upload({
	        url: vm.API_URL + '/productPage/saveProductPageImage',
	        method: 'POST',
	        data: {
	          filename: new Date().valueOf() + file.name,
	          file: file
	        }
	      });
	      file.upload.then(function (response) {
	        var img = vm.page.img;
	        var data = vm.page;
	        data.img = vm.APPLICATION_URL + response.data;
	        vm.ProductPagesDataProvider.updateProductPage(data, vm.type).then(function (result) {
	          vm.page = result;
	          vm.page.products = [];
	          vm.page.img = img;
	          if (redirect == '1') vm.$state.go('app.categoryList');else {
	            vm.successShow = 1;
	            vm.$timeout(function () {
	              vm.successShow = 0;
	            }, 3000);
	          }
	        });
	      }, function (response) {
	        if (response.status > 0) alert(response.status + ': ' + response.data);
	      });
	    }
	  }, {
	    key: 'removeProduct',
	    value: function removeProduct(product) {
	      if (confirm("Are you sure to delete!") !== true) {
	        return false;
	      }
	      product.__loading = true;
	      var vm = this;
	      var id = product.id;
	      var apid = product.admin_product_id;
	      vm.ProductPagesDataProvider.removeProduct(id, apid).then(function (res) {
	        vm.ProductPagesDataProvider.getProductPageProducts(vm.$state.params.id, vm.type).then(function (result) {
	          vm.products = result;
	          product.__loading = false;
	        });
	      });
	    }
	  }, {
	    key: 'getEditorsData',
	    value: function getEditorsData() {
	      this.page.short_text = tinyMCE.get('short_text').getContent();
	      this.page.template_text = tinyMCE.get('template_text').getContent();
	      this.page.long_text = tinyMCE.get('long_text').getContent();
	      this.page.meta_data = tinyMCE.get('meta_data').getContent();
	    }
	  }, {
	    key: 'setEditorsData',
	    value: function setEditorsData() {
	      if (this.page.short_text != undefined) tinyMCE.get('short_text').setContent(this.page.short_text);
	      if (this.page.template_text != undefined) tinyMCE.get('template_text').setContent(this.page.template_text);
	      if (this.page.long_text != undefined) tinyMCE.get('long_text').setContent(this.page.long_text);
	      if (this.page.meta_data != undefined) tinyMCE.get('meta_data').setContent(this.page.meta_data);
	    }
	  }]);
	  return CategoryEditController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = CategoryEditController;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Sub-Categories\r\n    <small>Edit category</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.subCategoryList({parentId:'all'})\">Sub-Categories</a></li>\r\n    <li class=\"active\">Edit</li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form class=\"form-row-seperated\" name=\"productForm\" novalidate>\r\n        <div class=\"portlet\">\r\n          <div class=\"portlet-title\">\r\n            <div class=\"caption\">\r\n              Edit Category\r\n            </div>\r\n            <div class=\"actions btn-set\">\r\n              <a ui-sref=\"app.subCategoryList({parentId:'all'})\">\r\n                <button class=\"btn btn-secondary-outline\" name=\"back\" type=\"button\"><i class=\"fa fa-angle-left\"></i>\r\n                  Back\r\n                </button>\r\n              </a>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.updateData(productForm, 0);\">\r\n                <i class=\"fa fa-check\"></i> Update\r\n              </button>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.updateData(productForm, 1);\">\r\n                <i class=\"fa fa-check-circle\"></i> Update &amp; Close\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if='$ctrl.errorShow && !productForm.$valid'>\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.errorShow = 0;'>×</a>\r\n            <span ng-show=\"(productForm.category.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.category.$error.required\">Category is required.<br/></span>\r\n                        </span>\r\n            <span ng-show=\"(productForm.name.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.name.$error.required\">Name is required.<br/></span>\r\n                        </span>\r\n          </div>\r\n          <div class=\"alert alert-success\" ng-if=\"$ctrl.successShow == 1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\"\r\n               ng-click='$ctrl.successShow = 0;'>×</a>\r\n            <strong>Success!</strong> Product page data updated successfully.\r\n          </div>\r\n          <ul class=\"nav nav-tabs\">\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 1}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(1)\"><label>General</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 2}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(2)\"><label>Meta</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 3}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(3)\"><label>Images</label></a>\r\n            </li>\r\n            <li ng-class=\"{'active' : $ctrl.activeTab == 4}\"><a href=\"\"\r\n                                                                ng-click=\"$ctrl.setActiveTab(4)\"><label>Product</label></a>\r\n            </li>\r\n          </ul>\r\n          <div class=\"tab-content\">\r\n            <div ng-class=\"{'tab-pane active': $ctrl.activeTab == 1, 'tab-pane' : $ctrl.activeTab != 1}\">\r\n              <!-- general form elements disabled -->\r\n              <div class=\"box box-warning\">\r\n                <!-- /.box-header -->\r\n                <div class=\"box-body\">\r\n                  <!-- text input -->\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Category</label>\r\n                        <select ng-model=\"$ctrl.page.category_id\" name='category' class=\"form-control\" required\r\n                                ng-options=\"option.id as option.name for option in $ctrl.mainCategories\">\r\n                          <option value=''>Select Category</option>\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Name</label>\r\n                        <input ng-model=\"$ctrl.page.name\" class=\"form-control\" name='name' required>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-4'>\r\n                      <div class=\"form-group\">\r\n                        <label>Material Id</label>\r\n                        <input ng-model=\"$ctrl.page.material_id\" class=\"form-control\" name='material_id'>\r\n                      </div>\r\n                    </div>\r\n                    <div class='col-md-4'>\r\n                      <div class=\"form-group\">\r\n                        <label>Sub Category Type</label>\r\n                        <input ng-model=\"$ctrl.page.subcategory_type_id\" class=\"form-control\" name='subcategory_type_id'>\r\n                      </div>\r\n                    </div>\r\n                    <div class='col-md-4'>\r\n                      <div class=\"form-group\">\r\n                        <label>Domain</label>\r\n                          <select ng-model=\"$ctrl.page.domain\" name='domain' class=\"form-control\"\r\n                                ng-change=\"$ctrl.changeDomain()\" required>\r\n                            <option value=''>Select Domain</option>\r\n                            <option ng-repeat=\"domain in $ctrl.mainDomains\" value=\"{{domain}}\">\r\n                              {{domain}}\r\n                            </option>\r\n                          </select>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Short Text</label>\r\n                      <textarea id='short_text' ng-model='$ctrl.page.short_text' name='short_text' class=\"tinymce\"\r\n                                placeholder=\"Place some text here\" rows='12'></textarea>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Template Text</label>\r\n                      <textarea id='template_text' ng-model='$ctrl.page.template_text' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Long Text</label>\r\n                      <textarea id='long_text' ng-model='$ctrl.page.long_text' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active':  $ctrl.page.activeTab == 2, 'tab-pane' :  $ctrl.activeTab != 2}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Title</label>\r\n                        <input ng-model=\"$ctrl.page.title\" class=\"form-control\" name='title'\r\n                               placeholder=\"Set title for product page\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Meta Data</label>\r\n                      <textarea id='meta_data' ng-model='$ctrl.page.meta_data' class=\"full-tinymce\"\r\n                                placeholder=\"Place some text here\" rows='15'></textarea>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active':  $ctrl.activeTab == 3, 'tab-pane' : $ctrl.activeTab != 3}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"row\">\r\n                    <div class='col-md-6'>\r\n                      <div class=\"form-group\">\r\n                        <label>Alt text for image</label>\r\n                        <input ng-model=\"$ctrl.page.alt\" class=\"form-control\" name='alt'>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class='col-md-12'>\r\n                      <label>Select File</label>\r\n                      <input type=\"file\" ngf-select ng-model=\"$ctrl.page.img\" name=\"file\"\r\n                             accept=\"image/*\" ngf-max-size=\"2MB\"\r\n                             ngf-model-invalid=\"errorFile\">\r\n                      <img ng-show=\"productForm.file.$valid\" ngf-src=\"$ctrl.page.img\" class=\"thumb img-responsive\">\r\n                      <button type='button' class='btn btn-danger' ng-click=\"$ctrl.page.img = null\"\r\n                              ng-show=\"$ctrl.page.img\">Remove\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-class=\"{'tab-pane active': $ctrl.activeTab == 4, 'tab-pane' : $ctrl.activeTab != 4}\">\r\n              <div class=\"box box-warning\">\r\n                <div class=\"box-body\">\r\n                  <div class=\"col-md-3\" ng-repeat=\"product in $ctrl.products\">\r\n                    <div class=\"panel panel-default\">\r\n                      <div class=\"panel-heading\">\r\n                        <div class=\"pull-left\">\r\n                          <h3 class=\"panel-title\">\r\n                            <input type=\"text\" ng-model=\"product.order_by\" class=\"form-control\"\r\n                                   style=\"width: 50px;text-align: center;\"\r\n                                   ng-blur=\"$ctrl.changeProductAssigment(product)\"/>\r\n                          </h3>\r\n                        </div>\r\n                        <div class=\"pull-right\">\r\n                          <input type=\"checkbox\" ng-model=\"product.assigned\"\r\n                                 ng-change=\"$ctrl.changeProductAssigment(product)\"\r\n                                 ng-init=\"product.assigned = (product.assigned == 1)\"/>\r\n                          <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeProduct(product);\"></i>\r\n                        </div>\r\n                        <div class=\"pull-right\" ng-show=\"product.__loading\">\r\n                          <span class=\"fa fa-spinner fa-spin\"></span>\r\n                        </div>\r\n                        <div class=\"clearfix\"></div>\r\n                      </div>\r\n                      <div class=\"panel-body\" style=\"text-align: center;\">\r\n                        <img ng-src=\"{{$ctrl.APPLICATION_URL}}/editor_png_files/{{product.image}}\" alt='product'/>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div ng-if=\"$ctrl.products.length == 0\">\r\n                    <p>Products not available in this category</p>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"portlet-title\">\r\n            <div class=\"actions btn-set\">\r\n              <a ui-sref=\"app.subCategoryList({parentId:'all'})\">\r\n                <button class=\"btn btn-secondary-outline\" name=\"back\" type=\"button\">\r\n                  <i class=\"fa fa-angle-left\"></i> Back\r\n                </button>\r\n              </a>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.updateData(productForm, 0);\">\r\n                <i class=\"fa fa-check\"></i> Update\r\n              </button>\r\n              <button class=\"btn btn-primary\" ng-click=\"$ctrl.updateData(productForm, 1);\">\r\n                <i class=\"fa fa-check-circle\"></i> Update &amp; Close\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if='$ctrl.errorShow && !productForm.$valid'>\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.errorShow = 0;'>×</a>\r\n            <span ng-show=\"(productForm.category.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.category.$error.required\">Category is required.<br/></span>\r\n                        </span>\r\n            <span ng-show=\"(productForm.name.$dirty) || productForm.$submitted\">\r\n                            <span ng-show=\"productForm.name.$error.required\">Name is required.<br/></span>\r\n                        </span>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubCategoryEditController = function () {
	  SubCategoryEditController.$inject = ["ProductPagesDataProvider", "$state", "$timeout", "Upload", "API_URL", "APPLICATION_URL"];
	  function SubCategoryEditController(ProductPagesDataProvider, $state, $timeout, Upload, API_URL, APPLICATION_URL) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SubCategoryEditController);
	    if ($state.params.tabId) this.activeTab = $state.params.tabId;else this.activeTab = 1;
	    this.type = 2;
	    this.page = {};
	    this.page.products = [];
	    this.Upload = Upload;
	    this.ProductPagesDataProvider = ProductPagesDataProvider;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.API_URL = API_URL;
	    this.APPLICATION_URL = APPLICATION_URL;
	    this.errorShow = 0;
	    this.field = 'id';
	    this.order_type = 'asc';
	    ProductPagesDataProvider.editor();
	    this.setProduct();
	  }
	
	  (0, _createClass3.default)(SubCategoryEditController, [{
	    key: 'setProduct',
	    value: function setProduct() {
	
	      var vm = this;
	      vm.ProductPagesDataProvider.loadCategoriesNoLimit(0).then(function (resultCat) {
	        vm.mainDomains = ["signlabs.se", "signlabs.dk", "signlabs.no", "signlabs.fi", "signlabs.de", "signlabs.at", "signlabs.ch", "signlabs.es", "signlabs.fr", "signlabs.it", "signlabs.nl", "signlabs.be", "signlabs.pl", "signlabs.eu", "signlabs.co.uk", "signlabs.com", "signlabs.loc"];
	        vm.mainCategories = resultCat;
	        vm.ProductPagesDataProvider.getProductPage(vm.$state.params.id, vm.type).then(function (result) {
	          vm.page = result;
	
	          vm.products = [];
	          vm.page.products = [];
	          if (result) {
	            vm.getProducts(vm);
	          } else {
	            vm.page = {};
	            vm.ProductPagesDataProvider.getCategoryById(vm.$state.params.id).then(function (response) {
	              vm.page.name = response.name;
	              vm.page.slug = response.slug;
	              vm.page.category_id = response.parent_id;
	              vm.page.sub_category = response.id;
	              vm.page.type = vm.type;
	            });
	          }
	        });
	      });
	    }
	  }, {
	    key: 'getProducts',
	    value: function getProducts(vm) {
	      vm.setEditorsData();
	      vm.ProductPagesDataProvider.getProductPageProducts(vm.$state.params.id, vm.type).then(function (result) {
	        vm.products = result;
	      });
	    }
	  }, {
	    key: 'changeProductAssigment',
	    value: function changeProductAssigment(product) {
	      product.__loading = true;
	      var vm = this;
	      var productData = { id: product.id, assigned: product.assigned, order: product.order_by };
	      var index = vm.page.products.findIndex(function (el) {
	        return el.id === product.id;
	      });
	      if (index !== -1) {
	        vm.page.products.splice(index, 1);
	      }
	      vm.page.products.push(productData);
	      product.__loading = false;
	    }
	  }, {
	    key: 'setActiveTab',
	    value: function setActiveTab(tabToSet) {
	      this.activeTab = tabToSet;
	      this.getEditorsData();
	    }
	  }, {
	    key: 'changeProductAssigment',
	    value: function changeProductAssigment(product) {
	      product.__loading = true;
	      var vm = this;
	      var productData = { id: product.id, assigned: product.assigned, order: product.order_by };
	      var index = vm.page.products.findIndex(function (el) {
	        return el.id === product.id;
	      });
	      if (index !== -1) {
	        vm.page.products.splice(index, 1);
	      }
	      vm.page.products.push(productData);
	      product.__loading = false;
	    }
	  }, {
	    key: 'onvertToSlug',
	    value: function onvertToSlug(text) {
	      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
	      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
	      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
	      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
	      .replace(/\-\-+/g, '-') // Replace multiple - with single -
	      .replace(/^-+/, '') // Trim - from start of text
	      .replace(/-+$/, ''); // Trim - from end of text
	    }
	  }, {
	    key: 'updateData',
	    value: function updateData(productForm, redirect) {
	      var vm = this;
	      vm.getEditorsData();
	      vm.$timeout(function () {
	        if (!productForm.$valid) {
	          vm.errorShow = 1;
	          vm.$timeout(function () {
	            vm.errorShow = 0;
	          }, 3000);
	          return false;
	        }
	        if (vm.page.name) vm.page.slug = vm.onvertToSlug(vm.page.name);
	        if (!vm.page.sub_category) vm.page.sub_category = 0;
	        if (!vm.page.alt) vm.page.alt = vm.page.name;
	        if (vm.page.img && vm.page.img.type) {
	          vm.updateWithImage(vm.page.img, redirect);
	        } else {
	          vm.ProductPagesDataProvider.updateProductPage(vm.page, vm.type).then(function (result) {
	            vm.page = result;
	            vm.page.products = [];
	            if (redirect == '1') vm.$state.go("app.subCategoryList", { parentId: 'all' });else {
	              vm.successShow = 1;
	              vm.$timeout(function () {
	                vm.successShow = 0;
	              }, 3000);
	            }
	          });
	        }
	      }, 5);
	    }
	  }, {
	    key: 'updateWithImage',
	    value: function updateWithImage(file, redirect) {
	      var vm = this;
	      file.upload = vm.Upload.upload({
	        url: vm.API_URL + '/productPage/saveProductPageImage',
	        method: 'POST',
	        data: {
	          filename: new Date().valueOf() + file.name,
	          file: file
	        }
	      });
	      file.upload.then(function (response) {
	        var img = vm.page.img;
	        var data = vm.page;
	        data.img = vm.APPLICATION_URL + response.data;
	        vm.ProductPagesDataProvider.updateProductPage(data, vm.type).then(function (result) {
	          vm.page = result;
	          vm.page.products = [];
	          vm.page.img = img;
	          if (redirect == '1') vm.$state.go("app.subCategoryList", { parentId: 'all' });else {
	            vm.successShow = 1;
	            vm.$timeout(function () {
	              vm.successShow = 0;
	            }, 3000);
	          }
	        });
	      }, function (response) {
	        if (response.status > 0) alert(response.status + ': ' + response.data);
	      });
	    }
	  }, {
	    key: 'removeProduct',
	    value: function removeProduct(product) {
	      if (confirm("Are you sure to delete!") !== true) {
	        return false;
	      }
	      product.__loading = true;
	      var vm = this;
	      var id = product.id;
	      var apid = product.admin_product_id;
	      vm.ProductPagesDataProvider.removeProduct(id, apid).then(function (res) {
	        vm.ProductPagesDataProvider.getProductPageProducts(vm.$state.params.id, vm.type).then(function (result) {
	          vm.products = result;
	          product.__loading = false;
	        });
	      });
	    }
	  }, {
	    key: 'getEditorsData',
	    value: function getEditorsData() {
	      this.page.short_text = tinyMCE.get('short_text').getContent();
	      this.page.template_text = tinyMCE.get('template_text').getContent();
	      this.page.long_text = tinyMCE.get('long_text').getContent();
	      this.page.meta_data = tinyMCE.get('meta_data').getContent();
	    }
	  }, {
	    key: 'setEditorsData',
	    value: function setEditorsData() {
	      if (this.page.short_text != undefined) tinyMCE.get('short_text').setContent(this.page.short_text);
	      if (this.page.template_text != undefined) tinyMCE.get('template_text').setContent(this.page.template_text);
	      if (this.page.long_text != undefined) tinyMCE.get('long_text').setContent(this.page.long_text);
	      if (this.page.meta_data != undefined) tinyMCE.get('meta_data').setContent(this.page.meta_data);
	    }
	  }]);
	  return SubCategoryEditController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = SubCategoryEditController;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Add Coupon\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.couponlisting\">Coupons listing</a></li>\r\n    <li class=\"active\"><a ui-sref=\"app.couponAdd\">Add</a></li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form class=\"form-row-seperated\" name=\"couponForm\" novalidate>\r\n        <div class=\"portlet\">\r\n          <div class=\"portlet-title\">\r\n            <div class=\"caption\">\r\n              New coupon\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if=\"$ctrl.existRecord==1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.existRecord=0;'>×</a>\r\n            Coupon code already exist.\r\n          </div>\r\n          <div class=\"box box-warning\">\r\n            <!-- /.box-header -->\r\n            <div class=\"box-body\">\r\n              <div class=\"row\">\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Coupon Name</label>\r\n                    <input ng-model=\"$ctrl.coupon.name\" class=\"form-control\" name='name' required>\r\n                    <span class=\"text-danger\" ng-show=\"(couponForm.name.$dirty) || couponForm.$submitted\">\r\n                                            <span\r\n                                              ng-show=\"couponForm.name.$error.required\">Coupon name is required.</span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Coupon Code</label>\r\n                    <input ng-model=\"$ctrl.coupon.code\" class=\"form-control\" name='code' required>\r\n                    <span class=\"text-danger\" ng-show=\"(couponForm.code.$dirty) || couponForm.$submitted\">\r\n                                            <span\r\n                                              ng-show=\"couponForm.code.$error.required\">Coupon code is required.</span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Coupon Type</label>\r\n                    <select class=\"form-control\" name='type' ng-model=\"$ctrl.coupon.type\" required>\r\n                      <option value=\"\">Select...</option>\r\n                      <option value=\"1\">Percentage</option>\r\n                      <option value=\"2\">Flat</option>\r\n                    </select>\r\n                    <span class=\"text-danger\" ng-show=\"(couponForm.type.$dirty) || couponForm.$submitted\">\r\n                                            <span\r\n                                              ng-show=\"couponForm.type.$error.required\">Coupon type is required.</span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n                <div class='col-md-3'>\r\n                  <div class=\"form-group\">\r\n                    <label>Percentage/Amount</label>\r\n                    <input ng-model=\"$ctrl.coupon.amount\" class=\"form-control\" name='amount' required>\r\n                    <span class=\"text-danger\" ng-show=\"(couponForm.amount.$dirty) || couponForm.$submitted\">\r\n                                            <span ng-show=\"couponForm.amount.$error.required\">Coupon percentage/amount is required.</span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n                <div class='col-md-3'>\r\n                  <div class=\"form-group\">\r\n                    <label>Currency (e.g. SEK, USD)</label>\r\n                    <input ng-model=\"$ctrl.coupon.currency\" class=\"form-control\" name='currency' required>\r\n                    <span class=\"text-danger\" ng-show=\"(couponForm.currency.$dirty) || couponForm.$submitted\">\r\n                                            <span ng-show=\"couponForm.currency.$error.required\">Coupon currency is required.</span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"box-footer\">\r\n              <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"$ctrl.create(couponForm.$valid)\">Save</button>\r\n              <a ui-sref=\"app.couponlisting\">\r\n                <button class=\"btn btn-default\" type=\"button\">Cancel</button>\r\n              </a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	  AddController.$inject = ["CouponsDataProvider", "$state"];
	  function AddController(CouponsDataProvider, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AddController);
	    this.CouponsDataProvider = CouponsDataProvider;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: 'create',
	    value: function create(form) {
	      if (!form) {
	        return false;
	      }
	      var vm = this;
	      vm.CouponsDataProvider.createCoupon(vm.coupon).then(function (res) {
	        if (res.exist == '1') {
	          vm.existRecord = 1;
	        } else {
	          vm.$state.go('app.couponlisting');
	        }
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = AddController;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Coupon Listing\r\n    <small>List of Coupon</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li class=\"active\"><a ui-sref=\"app.couponlisting\">Coupons</a></li>\r\n  </ol>\r\n</section>\r\n\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <div class='box'>\r\n        <div class=\"box-header\">\r\n          <div style=\"float:left;width: 200px;\">\r\n            Select Limit :\r\n            <select ng-model=\"$ctrl.pageLimit\" name='pageLimit' class=\"form-control\"\r\n                    ng-options=\"key as value for (key , value) in $ctrl.pageLimitOptions\"\r\n                    ng-change=\"$ctrl.currentPage = 1;\r\n                                        $ctrl.getCoupons()\" required style=\"display: inline; width: 75px;\">\r\n              <option ng-repeat=\"(key, value) in data\" value=\"{{key}}\">{{value}}</option>\r\n            </select>\r\n            <div class=\"input-group\" style=\"display: none;\">\r\n              <input type=\"text\" ng-model=\"text\" placeholder=\"Search\"\r\n                     class=\"form-control input-sm pull-right ng-pristine ng-valid ng-not-empty ng-touched\"\r\n                     name=\"table_search\" style=\"\">\r\n              <div class=\"input-group-btn\">\r\n                <button ng-click=\"search(text, searchIn)\" type=\"submit\" class=\"btn btn-sm btn-default\"><i\r\n                  class=\"fa fa-search\"></i></button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <a style=\"float:right\" ui-sref=\"app.couponAdd\">+ Add Coupon</a>\r\n        </div>\r\n        <div class=\"box-body table-responsive no-padding\">\r\n          <table id=\"datatable_coupons\"\r\n                 class=\"table table-striped table-bordered table-hover table-checkable dataTable no-footer\"\r\n                 aria-describedby=\"datatable_orders_info\" role=\"grid\">\r\n            <thead>\r\n            <tr class=\"heading\" role=\"row\">\r\n              <th width=\"2%\" class=\"sorting_disabled\" rowspan=\"1\" colspan=\"1\" aria-label=\"\">\r\n                <label class=\"mt-checkbox mt-checkbox-single mt-checkbox-outline\">\r\n                  <input type=\"checkbox\" ng-change=\"$ctrl.checkAll()\" class=\"group-checkable\"\r\n                         ng-model=\"$ctrl.selectall\">\r\n                  <span></span>\r\n                </label>\r\n              </th>\r\n              <th width=\"15%\" ng-class=\"{'active': $ctrl.col == '1'}\"> Coupon Name\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('name', 'asc', 1, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('name', 'desc', 1, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"15%\" ng-class=\"{'active': $ctrl.col == '2'}\"> Coupon Code\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('code', 'asc', 2, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('code', 'desc', 2, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"12%\" ng-class=\"{'active': $ctrl.col == '3'}\"> Type\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('type', 'asc', 3, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('type', 'desc', 3, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"12%\" ng-class=\"{'active': $ctrl.col == '4'}\"> Amount\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('amount', 'asc', 4, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('amount', 'desc', 4, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"12%\" ng-class=\"{'active': $ctrl.col == '5'}\"> Used&nbsp;Count\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '5' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('used_count', 'asc', 5, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '5' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('used_count', 'desc', 5, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"12%\" ng-class=\"{'active': $ctrl.col == '6'}\"> Status\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '6' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('status', 'asc', 6, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '6' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('status', 'desc', 6, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"2%\"> Actions</th>\r\n            </tr>\r\n            <tr class=\"filter\" role=\"row\">\r\n              <td rowspan=\"1\" colspan=\"1\"></td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.name\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.code\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <select class=\"form-control form-filter input-sm\" ng-model=\"$ctrl.type\">\r\n                  <option value=\"\">Select...</option>\r\n                  <option value=\"1\">Percentage</option>\r\n                  <option value=\"2\">Flat</option>\r\n                </select>\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <div class=\"margin-bottom-5\">\r\n                  <input type=\"text\" placeholder=\"From\" ng-model=\"$ctrl.price_from\"\r\n                         class=\"form-control form-filter input-sm margin-bottom-5 clearfix\"></div>\r\n                <input type=\"text\" placeholder=\"To\" ng-model=\"$ctrl.price_to\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.used_count\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <select class=\"form-control form-filter input-sm\" ng-model=\"$ctrl.status\">\r\n                  <option value=\"\">Select...</option>\r\n                  <option value=\"1\">Active</option>\r\n                  <option value=\"0\">Inactive</option>\r\n                </select>\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <div class=\"margin-bottom-5\">\r\n                  <button class=\"btn btn-sm btn-success filter-submit margin-bottom\" ng-click=\"$ctrl.getCoupons();\">\r\n                    <i class=\"fa fa-search\"></i> Search\r\n                  </button>\r\n                </div>\r\n                <button class=\"btn btn-sm btn-default filter-cancel\" ng-click=\"$ctrl.clearFilter();\">\r\n                  <i class=\"fa fa-times\"></i> Reset\r\n                </button>\r\n              </td>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat=\"data in $ctrl.coupons\">\r\n              <td>\r\n                <label class=\"mt-checkbox mt-checkbox-single mt-checkbox-outline\">\r\n                  <input type=\"checkbox\" ng-model='data.checkbox' ng-checked=\"data.checked\" class=\"checkboxes\"\r\n                         name=\"id[]\" ng-change='$ctrl.checkbox(data.id,data.checkbox)'>\r\n                  <span></span>\r\n                </label>\r\n              </td>\r\n              <td>{{data.name}}</td>\r\n              <td>{{data.code}}</td>\r\n              <td>\r\n                <span ng-if=\"data.type=='1'\">Percentage</span>\r\n                <span ng-if=\"data.type=='2'\">Flat</span>\r\n              </td>\r\n              <td>\r\n                <span ng-if=\"data.type=='1'\">{{data.amount}}%</span>\r\n                <span ng-if=\"data.type=='2'\">{{data.amount}} {{data.currency}}</span>\r\n              </td>\r\n              <td>{{data.used_count}}</td>\r\n              <td align=\"center\">\r\n                <span ng-if='data.status == 1' class=\"label label-success\">Active</span>\r\n                <span ng-if='data.status != 1' class=\"label label-warning\">Inactive</span>\r\n              </td>\r\n              <td>\r\n                <i ng-if='data.status != 1' ng-click=\"$ctrl.changeStatusSingle('1', data.id)\" class='fa fa-toggle-on'\r\n                   title=\"Make Active\"></i>\r\n                <i ng-if='data.status == 1' ng-click=\"$ctrl.changeStatusSingle('0', data.id)\" class='fa fa-toggle-off'\r\n                   title=\"Make Inactive\"></i>\r\n                <i class=\"fa fa-edit\" ui-sref=\"app.couponEdit({id:data.id})\"></i>\r\n                <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeCoupon(data.id);\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"box-footer clearfix\">\r\n          <div style=\"display: inline;\">\r\n            <select ng-model='$ctrl.status_change'\r\n                    class=\"table-group-action-input form-control input-inline input-small input-sm\"\r\n                    style=\"float: left; width: 110px; margin-right: 10px;\">\r\n              <option value=\"\">Select...</option>\r\n              <option value=\"1\">Active</option>\r\n              <option value=\"0\">In-active</option>\r\n            </select>\r\n            <button class=\"btn btn-sm btn-default table-group-action-submit\" ng-click='$ctrl.changeStatus();'><i\r\n              class=\"fa fa-check\"></i> Submit\r\n            </button>\r\n          </div>\r\n          <ul ng-if=\"$ctrl.couponsTotal > $ctrl.pageLimit\" uib-pagination boundary-links=\"true\" max-size=\"$ctrl.maxSize\"\r\n              total-items=\"$ctrl.couponsTotal\" items-per-page=\"$ctrl.pageLimit\" ng-model=\"$ctrl.currentPage\"\r\n              ng-change=\"$ctrl.getCoupons()\" class=\"pagination-sm pull-right\" previous-text=\"&lsaquo;\"\r\n              next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></ul>\r\n          <ul ng-if=\"$ctrl.couponsTotal <= $ctrl.pageLimit\" class=\"pagination pagination-sm no-margin pull-right\">\r\n            <li><a href=\"#\">&laquo;</a></li>\r\n            <li><a href=\"#\">1</a></li>\r\n            <li><a href=\"#\">&raquo;</a></li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CouponController = function () {
	  CouponController.$inject = ["CouponsDataProvider"];
	  function CouponController(CouponsDataProvider) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CouponController);
	    this.CouponsDataProvider = CouponsDataProvider;
	    this.currentPage = 1;
	    this.pageLimit = '100';
	    this.maxSize = 5;
	    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
	    this.field = 'id';
	    this.order_type = 'desc';
	    this.col = 0;
	    this.colTopDown = 0;
	    this.getCoupons();
	    this.checkboxes = [];
	  }
	
	  (0, _createClass3.default)(CouponController, [{
	    key: 'getSortRecors',
	    value: function getSortRecors(field, order_type, col, colTopDown) {
	      this.field = field;
	      this.order_type = order_type;
	      this.col = col;
	      this.colTopDown = colTopDown;
	      this.getCoupons();
	    }
	  }, {
	    key: 'getCoupons',
	    value: function getCoupons() {
	      var vm = this;
	      var data = {};
	      var searchData = {};
	      searchData.name = vm.name;
	      searchData.code = vm.code;
	      searchData.type = vm.type;
	      searchData.price_to = vm.price_to;
	      searchData.price_from = vm.price_from;
	      searchData.used_count = vm.used_count;
	      searchData.status = vm.status;
	      data.searchData = searchData;
	      data.currentPage = vm.currentPage;
	      data.pageLimit = vm.pageLimit;
	      data.field = vm.field;
	      data.order_type = vm.order_type;
	      vm.CouponsDataProvider.getCoupons(data, searchData).then(function (result) {
	        vm.coupons = result.data;
	        vm.couponsTotal = result.total;
	        vm.selectall = false;
	      });
	    }
	  }, {
	    key: 'changeStatus',
	    value: function changeStatus() {
	      if (!this.status_change) {
	        return false;
	      }
	      if (this.checkboxes.length == 0) {
	        alert('please select coupon first');
	        return false;
	      }
	      var vm = this;
	      var data = { 'status': vm.status_change, 'ids': vm.checkboxes };
	      vm.CouponsDataProvider.updateCouponStatus(data).then(function (resp) {
	        vm.pages = resp;
	        vm.getCoupons();
	        vm.checkboxes = [];
	      });
	    }
	  }, {
	    key: 'changeStatusSingle',
	    value: function changeStatusSingle(status, id) {
	      var data = { 'status': status };
	      this.updateCoupon(data, id);
	    }
	  }, {
	    key: 'updateCoupon',
	    value: function updateCoupon(data, id) {
	      var vm = this;
	      vm.CouponsDataProvider.updateCoupon(data, id).then(function (resp) {
	        vm.getCoupons();
	      });
	    }
	  }, {
	    key: 'removeCoupon',
	    value: function removeCoupon(id) {
	      if (confirm("Are you sure to delete!") !== true) {
	        return false;
	      }
	      var vm = this;
	      vm.CouponsDataProvider.removeCoupon(id).then(function (res) {
	        vm.getCoupons();
	      });
	    }
	  }, {
	    key: 'clearFilter',
	    value: function clearFilter() {
	      this.name = '';
	      this.code = '';
	      this.type = '';
	      this.price_from = '';
	      this.price_to = '';
	      this.used_count = '';
	      this.status = '';
	      this.getCoupons();
	    }
	  }, {
	    key: 'checkbox',
	    value: function checkbox(id, check) {
	      var index = this.checkboxes.indexOf(id);
	      if (check == true) {
	        if (index == '-1') {
	          this.checkboxes.push(id);
	        }
	      } else {
	        this.checkboxes.splice(index, 1);
	      }
	    }
	  }, {
	    key: 'checkAll',
	    value: function checkAll() {
	      if (this.selectall) {
	        var vm = this;
	        angular.forEach(this.coupons, function (coupon) {
	          coupon.checked = 1;
	          vm.checkboxes.push(coupon.id);
	        });
	      } else {
	        angular.forEach(this.coupons, function (coupon) {
	          coupon.checked = 0;
	        });
	        this.checkboxes = [];
	      }
	    }
	  }]);
	  return CouponController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = CouponController;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Edit Coupon\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.couponlisting\">Coupons listing</a></li>\r\n    <li class=\"active\">Edit</li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form class=\"form-row-seperated\" name=\"couponForm\" novalidate>\r\n        <div class=\"portlet\">\r\n          <div class=\"portlet-title\">\r\n            <div class=\"caption\">\r\n              Edit coupon\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if=\"$ctrl.existRecord==1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.existRecord=0;'>×</a>\r\n            Coupon code already exist.\r\n          </div>\r\n          <div class=\"box box-warning\">\r\n            <!-- /.box-header -->\r\n            <div class=\"box-body\">\r\n              <div class=\"row\">\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Coupon Name</label>\r\n                    <input ng-model=\"$ctrl.coupon.name\" class=\"form-control\" name='name' required>\r\n                    <span class=\"text-danger\" ng-show=\"(couponForm.name.$dirty) || couponForm.$submitted\">\r\n                                            <span\r\n                                              ng-show=\"couponForm.name.$error.required\">Coupon name is required.</span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Coupon Code</label>\r\n                    <input ng-model=\"$ctrl.coupon.code\" class=\"form-control\" name='code' required>\r\n                    <span class=\"text-danger\" ng-show=\"(couponForm.code.$dirty) || couponForm.$submitted\">\r\n                                            <span\r\n                                              ng-show=\"couponForm.code.$error.required\">Coupon code is required.</span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Coupon Type</label>\r\n                    <select ng-model=\"$ctrl.coupon.type\" name='type' class=\"form-control\" required\r\n                            ng-options=\"option.id as option.name for option in $ctrl.couponTypes\">\r\n                    </select>\r\n                    <span class=\"text-danger\" ng-show=\"(couponForm.type.$dirty) || couponForm.$submitted\">\r\n                                            <span\r\n                                              ng-show=\"couponForm.type.$error.required\">Coupon type is required.</span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n                <div class='col-md-3'>\r\n                  <div class=\"form-group\">\r\n                    <label>Percentage/Amount</label>\r\n                    <input ng-model=\"$ctrl.coupon.amount\" class=\"form-control\" name='amount' required>\r\n                    <span class=\"text-danger\" ng-show=\"(couponForm.amount.$dirty) || couponForm.$submitted\">\r\n                                            <span ng-show=\"couponForm.amount.$error.required\">Coupon percentage/amount is required.</span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n                <div class='col-md-3'>\r\n                  <div class=\"form-group\">\r\n                    <label>Currency (e.g. SEK, USD)</label>\r\n                    <input ng-model=\"$ctrl.coupon.currency\" class=\"form-control\" name='currency' required>\r\n                    <span class=\"text-danger\" ng-show=\"(couponForm.currency.$dirty) || couponForm.$submitted\">\r\n                                            <span ng-show=\"couponForm.currency.$error.required\">Coupon currency is required.</span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"box-footer\">\r\n              <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"$ctrl.update(couponForm.$valid)\">Update</button>\r\n              <a ui-sref=\"app.couponlisting\">\r\n                <button class=\"btn btn-default\" type=\"button\">Cancel</button>\r\n              </a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	  AddController.$inject = ["CouponsDataProvider", "$state"];
	  function AddController(CouponsDataProvider, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AddController);
	    this.CouponsDataProvider = CouponsDataProvider;
	    this.$state = $state;
	    var vm = this;
	    vm.couponTypes = [{ 'id': 1, 'name': 'Percentage' }, { 'id': 2, 'name': 'Flat' }];
	    vm.CouponsDataProvider.getCoupon(vm.$state.params.id).then(function (result) {
	      vm.coupon = result;
	    });
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: 'update',
	    value: function update(form) {
	      if (!form) {
	        return false;
	      }
	      var vm = this;
	      vm.CouponsDataProvider.updateCoupon(vm.coupon, vm.coupon.id).then(function (res) {
	        if (res.exist == '1') {
	          vm.existRecord = 1;
	        } else {
	          vm.$state.go('app.couponlisting');
	        }
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = AddController;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    User Details\r\n    <small></small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.userListing\">Users</a></li>\r\n    <li class=\"active\">Details</li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n\r\n      <!-- Profile Image -->\r\n      <div class=\"box box-primary\">\r\n        <div class=\"box-body box-profile\">\r\n          <img alt=\"User profile picture\" src=\"dist/img/user.png\" class=\"profile-user-img img-responsive img-circle\">\r\n          <h3 class=\"profile-username text-center text-capitalize\">{{$ctrl.data.f_name}} {{$ctrl.data.l_name}}</h3>\r\n          <p class=\"text-muted text-center text-capitalize\">{{$ctrl.data.company}}</p>\r\n          <p class=\"text-muted text-center text-capitalize\" ng-if='$ctrl.countryName'>{{$ctrl.countryName}}</p>\r\n          <p class=\"text-muted text-center text-capitalize\">{{$ctrl.data.email}}</p><br/>\r\n\r\n          <ul class=\"list-group list-group-unbordered\">\r\n            <li class=\"list-group-item\">\r\n              <b>Total Order</b> <a class=\"pull-right\">{{$ctrl.data.total_order}}</a>\r\n            </li>\r\n            <li class=\"list-group-item\">\r\n              <b>Total Saved design</b> <a class=\"pull-right\">{{$ctrl.data.total_saved_design}}</a>\r\n            </li>\r\n            <li class=\"list-group-item\">\r\n              <b>Total Spending</b> <a class=\"pull-right\">{{($ctrl.data.total_spending)? ($ctrl.data.total_spending|\r\n              number : 2)+' kr':0}} </a>\r\n            </li>\r\n            <li class=\"list-group-item\">\r\n              Registration Date <a class=\"pull-right\">{{$ctrl.data.created_at|date : \"yyyy-MM-dd\"}}</a>\r\n            </li>\r\n          </ul>\r\n        </div><!-- /.box-body -->\r\n      </div><!-- /.box -->\r\n    </div><!-- /.col -->\r\n    <div class=\"col-md-9\">\r\n      <div class=\"nav-tabs-custom\">\r\n        <ul class=\"nav nav-tabs\">\r\n          <li ng-class=\"{'active' : $ctrl.activeTab == 1}\"><a href=\"\" ng-click=\"$ctrl.setActiveTab(1)\"><label>Order\r\n            History</label></a></li>\r\n          <li ng-class=\"{'active' : $ctrl.activeTab == 2}\"><a href=\"\"\r\n                                                              ng-click=\"$ctrl.setActiveTab(2)\"><label>Comments</label></a>\r\n          </li>\r\n          <li class=\"pull-right\"><a href=\"{{$ctrl.APPLICATION_URL}}/api/user/login/{{$ctrl.data.token}}\"\r\n                                    target='_blank'>\r\n            <button class='btn btn-info'>User Account</button>\r\n          </a></li>\r\n        </ul>\r\n        <div class=\"tab-content\">\r\n          <div ng-class=\"{'tab-pane active': $ctrl.activeTab === 1, 'tab-pane' : $ctrl.activeTab !== 1}\">\r\n            <div class=\"box-body table-responsive no-padding\">\r\n              <table id=\"datatable_orders\"\r\n                     class=\"table table-striped table-bordered table-hover table-checkable dataTable no-footer\"\r\n                     aria-describedby=\"datatable_orders_info\" role=\"grid\">\r\n                <thead>\r\n                <tr class=\"heading\" role=\"row\">\r\n                  <th width=\"20%\" ng-class=\"{'active': $ctrl.col == '1'}\"> Order&nbsp;Number\r\n                    <span class='sort-icon'>\r\n                                                <i class=\"si-sort-asc\"\r\n                                                   ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '1')}\"\r\n                                                   ng-click=\"$ctrl.getSortRecors('orderId', 'asc', 1, 1)\"></i>\r\n                                                <i class=\"si-sort-desc\"\r\n                                                   ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '2')}\"\r\n                                                   ng-click=\"$ctrl.getSortRecors('orderId', 'desc', 1, 2)\"></i>\r\n                                            </span>\r\n                  </th>\r\n                  <th width=\"20%\" ng-class=\"{'active': $ctrl.col == '2'}\"> Purchased&nbsp;On\r\n                    <span class='sort-icon'>\r\n                                                <i class=\"si-sort-asc\"\r\n                                                   ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '1')}\"\r\n                                                   ng-click=\"$ctrl.getSortRecors('created_at', 'asc', 2, 1)\"></i>\r\n                                                <i class=\"si-sort-desc\"\r\n                                                   ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '2')}\"\r\n                                                   ng-click=\"$ctrl.getSortRecors('created_at', 'desc', 2, 2)\"></i>\r\n                                            </span>\r\n                  </th>\r\n                  <th width=\"20%\" ng-class=\"{'active': $ctrl.col == '3'}\"> Price\r\n                    <span class='sort-icon'>\r\n                                                <i class=\"si-sort-asc\"\r\n                                                   ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown == '1')}\"\r\n                                                   ng-click=\"$ctrl.getSortRecors('amount', 'asc', 3, 1)\"></i>\r\n                                                <i class=\"si-sort-desc\"\r\n                                                   ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown == '2')}\"\r\n                                                   ng-click=\"$ctrl.getSortRecors('amount', 'desc', 3, 2)\"></i>\r\n                                            </span>\r\n                  </th>\r\n                  <th width=\"20%\" ng-class=\"{'active': $ctrl.col == '4'}\"> Type\r\n                    <span class='sort-icon'>\r\n                                                <i class=\"si-sort-asc\"\r\n                                                   ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown == '1')}\"\r\n                                                   ng-click=\"$ctrl.getSortRecors('orderType', 'asc', 4, 1)\"></i>\r\n                                                <i class=\"si-sort-desc\"\r\n                                                   ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown == '2')}\"\r\n                                                   ng-click=\"$ctrl.getSortRecors('orderType', 'desc', 4, 2)\"></i>\r\n                                            </span>\r\n                  </th>\r\n                  <th width=\"20%\"> Actions</th>\r\n                </tr>\r\n                <tr class=\"filter\" role=\"row\">\r\n                  <td rowspan=\"1\" colspan=\"1\">\r\n                    <input type=\"text\" ng-model=\"$ctrl.orderId\" class=\"form-control form-filter input-sm\">\r\n                  </td>\r\n                  <td rowspan=\"1\" colspan=\"1\">\r\n                    <p class=\"input-group\">\r\n                      <input type=\"text\" readonly class=\"form-control\" uib-datepicker-popup=\"{{$ctrl.format}}\"\r\n                             ng-model=\"$ctrl.from\" is-open=\"$ctrl.popup1.opened\" datepicker-options=\"$ctrl.dateOptions\"\r\n                             ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"$ctrl.altInputFormats\"/>\r\n                      <span class=\"input-group-btn\">\r\n                                                    <button type=\"button\" class=\"btn btn-default\"\r\n                                                            ng-click=\"$ctrl.open1()\"><i\r\n                                                      class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                                                </span>\r\n                    </p>\r\n                    <p class=\"input-group\">\r\n                      <input type=\"text\" readonly class=\"form-control\" uib-datepicker-popup=\"{{$ctrl.format}}\"\r\n                             ng-model=\"$ctrl.to\" is-open=\"$ctrl.popup2.opened\" datepicker-options=\"$ctrl.dateOptions\"\r\n                             ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"$ctrl.altInputFormats\"/>\r\n                      <span class=\"input-group-btn\">\r\n                                                    <button type=\"button\" class=\"btn btn-default\"\r\n                                                            ng-click=\"$ctrl.open2()\"><i\r\n                                                      class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                                                </span>\r\n                    </p>\r\n                  </td>\r\n                  <td rowspan=\"1\" colspan=\"1\">\r\n                    <div class=\"margin-bottom-5\">\r\n                      <input type=\"text\" placeholder=\"From\" ng-model=\"$ctrl.price_from\"\r\n                             class=\"form-control form-filter input-sm margin-bottom-5 clearfix\"></div>\r\n                    <input type=\"text\" placeholder=\"To\" ng-model=\"$ctrl.price_to\"\r\n                           class=\"form-control form-filter input-sm\">\r\n                  </td>\r\n                  <td rowspan=\"1\" colspan=\"1\">\r\n                    <input type=\"text\" ng-model=\"$ctrl.orderType\" class=\"form-control form-filter input-sm\">\r\n                  </td>\r\n                  <td rowspan=\"1\" colspan=\"1\">\r\n                    <div class=\"margin-bottom-5\">\r\n                      <button class=\"btn btn-sm btn-success filter-submit margin-bottom\" ng-click=\"$ctrl.getOrders();\">\r\n                        <i class=\"fa fa-search\"></i> Search\r\n                      </button>\r\n                    </div>\r\n                    <button class=\"btn btn-sm btn-default filter-cancel\" ng-click=\"$ctrl.clearFilter();\">\r\n                      <i class=\"fa fa-times\"></i> Reset\r\n                    </button>\r\n                  </td>\r\n                </tr>\r\n                </thead>\r\n                <tbody>\r\n                <tr ng-repeat=\"data in $ctrl.orders\">\r\n                  <td>{{data.orderId}}</td>\r\n                  <td>{{data.created_at|date : \"yyyy-MM-dd HH:mm:ss a\"}}</td>\r\n                  <td>{{data.amount}} kr</td>\r\n                  <td align=\"center\">{{data.orderType}}</td>\r\n                  <td>\r\n                    <a class=\"btn btn-sm btn-circle btn-default btn-editable\" ui-sref=\"app.orderView({id:data.id})\"\r\n                       target='_blank'>\r\n                      <i class=\"fa fa-search\"></i> View\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n                <tr ng-if='$ctrl.orders.length==0'>\r\n                  <td colspan=\"5\">No record to display</td>\r\n                </tr>\r\n                </tbody>\r\n              </table>\r\n            </div>\r\n            <div class=\"box-footer clearfix\">\r\n              <ul ng-if=\"$ctrl.ordersTotal > $ctrl.pageLimit\" uib-pagination boundary-links=\"true\"\r\n                  max-size=\"$ctrl.maxSize\" total-items=\"$ctrl.ordersTotal\" items-per-page=\"$ctrl.pageLimit\"\r\n                  ng-model=\"$ctrl.currentPage\" ng-change=\"$ctrl.getOrders()\" class=\"pagination-sm pull-right\"\r\n                  previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></ul>\r\n              <ul ng-if=\"$ctrl.ordersTotal <= $ctrl.pageLimit\" class=\"pagination pagination-sm no-margin pull-right\">\r\n                <li><a href=\"#\">&laquo;</a></li>\r\n                <li><a href=\"#\">1</a></li>\r\n                <li><a href=\"#\">&raquo;</a></li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n          <div ng-class=\"{'tab-pane active':  $ctrl.page.activeTab === 2, 'tab-pane' :  $ctrl.activeTab !== 2}\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12 col-sm-12\">\r\n                <div class=\"portlet yellow-crusta box\">\r\n                  <div class=\"portlet-title\">\r\n                    <div class=\"caption\">\r\n                      <i class=\"fa fa-comments\"></i>Comments\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"portlet-body no-padding\">\r\n                    <div class=\"row static-info\">\r\n                      <div class=\"col-md-6\"><textarea class=\"form-control\" placeholder=\"write comment\"\r\n                                                      ng-model=\"$ctrl.comment\" rows=\"5\"></textarea></div>\r\n                    </div>\r\n                    <div class=\"row static-info\">\r\n                      <div class=\"col-md-6\">\r\n                        <button class=\"btn btn-success pull-right\" ng-click='$ctrl.saveComment();'>Add Comment</button>\r\n                      </div>\r\n                    </div>\r\n                    <hr/>\r\n                    <div class=\"row static-info commentbox-padding\">\r\n                      <div class=\"col-md-12\" ng-repeat='com in $ctrl.comments' style=\"word-wrap: break-word;\">\r\n                        {{$index + 1}}. {{com.comment}}\r\n                        <span ng-if=\"!com.created_at\" class=\"timestamp\"> just now</span>\r\n                        <span ng-if=\"com.created_at\" class=\"timestamp\"> at {{com.created_at|date : \"yyyy-MM-dd HH:mm:ss a\"}}</span>\r\n                        &nbsp;<i class=\"fa fa-remove commentbox-remove\" ng-click=\"$ctrl.removeComment(com.id);\"></i>\r\n                      </div>\r\n                    </div>\r\n                    <hr/>\r\n                  </div>\r\n                  <div class=\"portlet-title\" style=\"min-height: 0px;\">\r\n                    <i class=\"fa fa-comments\"></i>Customer Comments\r\n                  </div>\r\n                  <div class=\"portlet-body\">\r\n                    <div class=\"row static-info commentbox-padding\">\r\n                      Customer Comments goes here\r\n                      <div class=\"col-md-12 commentbox-text\" ng-repeat='com in $ctrl.customerComments'>{{$index + 1}}.\r\n                        {{com.comment}}\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div><!-- /.nav-tabs-custom -->\r\n    </div><!-- /.col -->\r\n  </div><!-- /.row -->\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserViewController = function () {
	  UserViewController.$inject = ["UsersDataProvider", "$state", "$timeout", "APPLICATION_URL"];
	  function UserViewController(UsersDataProvider, $state, $timeout, APPLICATION_URL) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UserViewController);
	    this.UsersDataProvider = UsersDataProvider;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.APPLICATION_URL = APPLICATION_URL;
	    this.errorShow = 0;
	    this.activeTab = 1;
	    this.currentPage = 1;
	    this.pageLimit = '100';
	    this.maxSize = 5;
	    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
	    this.field = 'id';
	    this.order_type = 'desc';
	    this.col = 0;
	    this.colTopDown = 0;
	    var vm = this;
	    vm.open1 = function () {
	      vm.popup1.opened = true;
	    };
	    vm.open2 = function () {
	      vm.popup2.opened = true;
	    };
	    vm.format = 'yyyy-MM-dd';
	    vm.altInputFormats = ['M!/d!/yyyy'];
	    vm.popup1 = {
	      opened: false
	    };
	    vm.popup2 = {
	      opened: false
	    };
	    UsersDataProvider.getUser($state.params.id).then(function (result) {
	      vm.data = result;
	      var theUrl = vm.APPLICATION_URL + '/api/get/countries';
	      var xmlHttp = new XMLHttpRequest();
	      xmlHttp.open("GET", theUrl, false); // false for synchronous request
	      xmlHttp.send(null);
	      var resp = JSON.parse(xmlHttp.response);
	      if (vm.data.country) vm.countryName = resp[vm.data.country];
	      vm.getOrders();
	      UsersDataProvider.getComments($state.params.id).then(function (comments) {
	        vm.comments = comments;
	      });
	    });
	  }
	
	  (0, _createClass3.default)(UserViewController, [{
	    key: 'getSortRecors',
	    value: function getSortRecors(field, order_type, col, colTopDown) {
	      this.field = field;
	      this.order_type = order_type;
	      this.col = col;
	      this.colTopDown = colTopDown;
	      this.getOrders();
	    }
	  }, {
	    key: 'getOrders',
	    value: function getOrders() {
	      var vm = this;
	      var data = {};
	      var searchData = {};
	      searchData.user_id = vm.$state.params.id;
	      searchData.orderId = vm.orderId;
	      searchData.from = vm.from;
	      searchData.to = vm.to;
	      searchData.price_from = vm.price_from;
	      searchData.price_to = vm.price_to;
	      searchData.orderType = vm.orderType;
	      data.searchData = searchData;
	      data.currentPage = vm.currentPage;
	      data.pageLimit = vm.pageLimit;
	      data.field = vm.field;
	      data.order_type = vm.order_type;
	      vm.UsersDataProvider.getOrders(data).then(function (result) {
	        vm.orders = result.data;
	        vm.ordersTotal = result.total;
	      });
	    }
	  }, {
	    key: 'clearFilter',
	    value: function clearFilter() {
	      this.orderId = '';
	      this.price_to = '';
	      this.price_from = '';
	      this.orderType = '';
	      this.to = '';
	      this.from = '';
	      this.getOrders();
	    }
	  }, {
	    key: 'setActiveTab',
	    value: function setActiveTab(tabToSet) {
	      this.activeTab = tabToSet;
	    }
	  }, {
	    key: 'saveComment',
	    value: function saveComment() {
	      if (this.comment) {
	        var vm = this;
	        var saveData = { 'from_id': '0', 'user_id': vm.data.id, 'comment': vm.comment };
	        vm.UsersDataProvider.saveComments(saveData).then(function (res) {
	          if (res.exist == '0') {
	            vm.comments.push(res);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'removeComment',
	    value: function removeComment(cid) {
	      var vm = this;
	      vm.UsersDataProvider.removeComment(cid).then(function (res) {
	        var index = vm.comments.findIndex(function (el) {
	          return el.id === cid;
	        });
	        if (index !== -1) {
	          vm.comments.splice(index, 1);
	        }
	      });
	    }
	  }]);
	  return UserViewController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = UserViewController;

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    User Listing\r\n    <small>List of User</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li class=\"active\"><a ui-sref=\"app.userlisting\">Users</a></li>\r\n  </ol>\r\n</section>\r\n\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <div class='box'>\r\n        <div class=\"box-header\">\r\n          <div style=\"float:left;width: 200px;\">\r\n            Select Limit :\r\n            <select ng-model=\"$ctrl.pageLimit\" name='pageLimit' class=\"form-control\"\r\n                    ng-options=\"key as value for (key , value) in $ctrl.pageLimitOptions\"\r\n                    ng-change=\"$ctrl.currentPage = 1;\r\n                                        $ctrl.getUsers()\" required style=\"display: inline; width: 75px;\">\r\n              <option ng-repeat=\"(key, value) in data\" value=\"{{key}}\">{{value}}</option>\r\n            </select>\r\n            <div class=\"input-group\" style=\"display: none;\">\r\n              <input type=\"text\" ng-model=\"text\" placeholder=\"Search\"\r\n                     class=\"form-control input-sm pull-right ng-pristine ng-valid ng-not-empty ng-touched\"\r\n                     name=\"table_search\" style=\"\">\r\n              <div class=\"input-group-btn\">\r\n                <button ng-click=\"search(text, searchIn)\" type=\"submit\" class=\"btn btn-sm btn-default\"><i\r\n                  class=\"fa fa-search\"></i></button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"box-body table-responsive no-padding\">\r\n          <table id=\"datatable_orders\"\r\n                 class=\"table table-striped table-bordered table-hover table-checkable dataTable no-footer\"\r\n                 aria-describedby=\"datatable_orders_info\" role=\"grid\">\r\n            <thead>\r\n            <tr class=\"heading\" role=\"row\">\r\n              <th width=\"8%\" ng-class=\"{'active': $ctrl.col == '1'}\"> Id#\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('id', 'asc', 1, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('id', 'desc', 1, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"12%\" ng-class=\"{'active': $ctrl.col == '2'}\"> Name\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('name', 'asc', 2, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('name', 'desc', 2, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"16%\" ng-class=\"{'active': $ctrl.col == '3'}\"> Email\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('email', 'asc', 3, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('email', 'desc', 3, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"12%\" ng-class=\"{'active': $ctrl.col == '4'}\"> Org number\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('orgnumber', 'asc', 4, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '4' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('orgnumber', 'desc', 4, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"10%\" ng-class=\"{'active': $ctrl.col == '5'}\"> Company\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '5' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('company', 'asc', 5, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '5' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('company', 'desc', 5, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"10%\" ng-class=\"{'active': $ctrl.col == '6'}\"> Location\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '6' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('location', 'asc',6, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '6' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('location', 'desc',6, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"10%\" ng-class=\"{'active': $ctrl.col == '7'}\"> Mobile\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '7' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('mobile', 'asc', 7, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '7' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('mobile', 'desc', 7, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"10%\" ng-class=\"{'active': $ctrl.col == '8'}\"> Registration Date\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '8' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('created_at', 'asc', 8, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '8' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('created_at', 'desc',8, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width=\"10%\"> Actions</th>\r\n            </tr>\r\n            <tr class=\"filter\" role=\"row\">\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.id\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.name\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.email\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.orgnumber\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.company\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.location\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.mobile\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <input type=\"text\" ng-model=\"$ctrl.created_at\" class=\"form-control form-filter input-sm\">\r\n              </td>\r\n              <td rowspan=\"1\" colspan=\"1\">\r\n                <div class=\"margin-bottom-5\">\r\n                  <button class=\"btn btn-sm btn-success filter-submit\" ng-click=\"$ctrl.getUsers();\">\r\n                    <i class=\"fa fa-search\"></i> Search\r\n                  </button>\r\n                  <button class=\"btn btn-sm btn-default filter-cancel\" ng-click=\"$ctrl.clearFilter();\">\r\n                    <i class=\"fa fa-times\"></i> Reset\r\n                  </button>\r\n                </div>\r\n              </td>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat=\"data in $ctrl.users\">\r\n              <td>{{data.id}}</td>\r\n              <td>{{data.f_name}} {{data.l_name}}</td>\r\n              <td>{{data.email}}</td>\r\n              <td>{{data.orgnumber}}</td>\r\n              <td>{{data.company}}</td>\r\n              <td>{{data.city}} {{data.state}}</td>\r\n              <td>{{data.mobile}}</td>\r\n              <td>{{$ctrl.data.created_at|date : \"yyyy-MM-dd\"}}</td>\r\n              <td>\r\n                <a class=\"btn btn-sm btn-circle btn-default btn-editable\" ui-sref=\"app.userView({id:data.id})\">\r\n                  <i class=\"fa fa-search\"></i> View\r\n                </a>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"box-footer clearfix\">\r\n          <ul ng-if=\"$ctrl.usersTotal > $ctrl.pageLimit\" uib-pagination boundary-links=\"true\" max-size=\"$ctrl.maxSize\"\r\n              total-items=\"$ctrl.usersTotal\" items-per-page=\"$ctrl.pageLimit\" ng-model=\"$ctrl.currentPage\"\r\n              ng-change=\"$ctrl.getUsers()\" class=\"pagination-sm pull-right\" previous-text=\"&lsaquo;\"\r\n              next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></ul>\r\n          <ul ng-if=\"$ctrl.usersTotal <= $ctrl.pageLimit\" class=\"pagination pagination-sm no-margin pull-right\">\r\n            <li><a href=\"#\">&laquo;</a></li>\r\n            <li><a href=\"#\">1</a></li>\r\n            <li><a href=\"#\">&raquo;</a></li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserController = function () {
	  UserController.$inject = ["UsersDataProvider"];
	  function UserController(UsersDataProvider) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UserController);
	    this.UsersDataProvider = UsersDataProvider;
	    this.currentPage = 1;
	    this.pageLimit = '100';
	    this.maxSize = 5;
	    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
	    this.field = 'id';
	    this.order_type = 'desc';
	    this.col = 0;
	    this.colTopDown = 0;
	    this.getUsers();
	  }
	
	  (0, _createClass3.default)(UserController, [{
	    key: 'getSortRecors',
	    value: function getSortRecors(field, order_type, col, colTopDown) {
	      this.field = field;
	      this.order_type = order_type;
	      this.col = col;
	      this.colTopDown = colTopDown;
	      this.getUsers();
	    }
	  }, {
	    key: 'getUsers',
	    value: function getUsers() {
	      var vm = this;
	      var data = {};
	      var searchData = {};
	      searchData.id = vm.id;
	      searchData.name = vm.name;
	      searchData.email = vm.email;
	      searchData.orgnumber = vm.orgnumber;
	      searchData.company = vm.company;
	      searchData.location = vm.location;
	      searchData.mobile = vm.mobile;
	      data.searchData = searchData;
	      data.currentPage = vm.currentPage;
	      data.pageLimit = vm.pageLimit;
	      data.field = vm.field;
	      data.order_type = vm.order_type;
	      vm.UsersDataProvider.getUsers(data, searchData).then(function (result) {
	        vm.users = result.data;
	        vm.usersTotal = result.total;
	        vm.selectall = false;
	      });
	    }
	  }, {
	    key: 'clearFilter',
	    value: function clearFilter() {
	      this.id = '';
	      this.name = '';
	      this.email = '';
	      this.orgnumber = '';
	      this.company = '';
	      this.location = '';
	      this.mobile = '';
	      this.getUsers();
	    }
	  }]);
	  return UserController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = UserController;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Image Categories\r\n    <small>List all image categories</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li class=\"active\"><a ui-sref=\"app.imageCategories\">Image Categories</a></li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <div class=\"box\">\r\n        <div class=\"box-header\">\r\n          <div style=\"float:left;width: 200px;\">\r\n            Select Limit :\r\n            <select ng-model=\"$ctrl.pageLimit\" name='pageLimit' class=\"form-control\"\r\n                    ng-options=\"key as value for (key , value) in $ctrl.pageLimitOptions\"\r\n                    ng-change=\"$ctrl.currentPage = 1;$ctrl.getCategories()\" required\r\n                    style=\"display: inline; width: 75px;\">\r\n              <option ng-repeat=\"(key, value) in data\" value=\"{{key}}\">{{value}}</option>\r\n            </select>\r\n            <div class=\"input-group\" style=\"display: none;\">\r\n              <input type=\"text\" ng-model=\"text\" placeholder=\"Search\"\r\n                     class=\"form-control input-sm pull-right ng-pristine ng-valid ng-not-empty ng-touched\"\r\n                     name=\"table_search\" style=\"\">\r\n              <div class=\"input-group-btn\">\r\n                <button ng-click=\"search(text, searchIn)\" type=\"submit\" class=\"btn btn-sm btn-default\"><i\r\n                  class=\"fa fa-search\"></i></button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <a style=\"float:right\" ui-sref=\"app.imageCategoryAdd\">+ Add Category</a>\r\n        </div>\r\n        <!-- /.box-header -->\r\n        <div class=\"box-body table-responsive no-padding\">\r\n          <table class=\"table table-hover table-bordered\">\r\n            <thead>\r\n            <tr>\r\n              <!--                <th>SN</th>-->\r\n              <th>Category\r\n                <span class='sort-icon'>\r\n                        <i class=\"si-sort-asc\" ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown=='1')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('name','asc',1,1)\"></i>\r\n                        <i class=\"si-sort-desc\" ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown=='2')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('name','desc',1,2)\"></i>\r\n                    </span>\r\n              </th>\r\n              <th>Description\r\n                <span class='sort-icon'>\r\n                        <i class=\"si-sort-asc\" ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown=='1')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('description','asc',2,1)\"></i>\r\n                        <i class=\"si-sort-desc\" ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown=='2')}\"\r\n                           ng-click=\"$ctrl.getSortRecors('description','desc',2,2)\"></i>\r\n                    </span>\r\n              </th>\r\n              <th>Created\r\n                <span class='sort-icon'>\r\n                       <i class=\"si-sort-asc\" ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown=='1')}\"\r\n                          ng-click=\"$ctrl.getSortRecors('created_at','asc',3,1)\"></i>\r\n                       <i class=\"si-sort-desc\" ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown=='2')}\"\r\n                          ng-click=\"$ctrl.getSortRecors('created_at','desc',3,2)\"></i>\r\n                    </span>\r\n              </th>\r\n              <th width='15%'>Action</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody id=\"items\">\r\n            <tr ng-repeat=\"row in $ctrl.categories\" style=\"cursor:move\">\r\n              <!--                  <td>{{$ctrl.pageLimit * ($ctrl.currentPage - 1) + ($index + 1)}}</td>-->\r\n              <td>{{row.name}}</td>\r\n              <td>{{row.description}}</td>\r\n              <td>{{row.created_at| date : format : timezone}}</td>\r\n              <td>\r\n                <i class=\"fa fa-reorder\" ui-sref=\"app.images({parentId:row.id})\" title=\"Make reorder of images\"></i>\r\n                <i class=\"fa fa-edit\" ui-sref=\"app.imageCategoryEdit({id:row.id})\"></i>\r\n                <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeCategory(row.id);\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <!-- /.box-body -->\r\n        <div class=\"box-footer clearfix\">\r\n          <ul ng-if=\"$ctrl.categoriesTotal > $ctrl.pageLimit\" uib-pagination boundary-links=\"true\"\r\n              max-size=\"$ctrl.maxSize\" total-items=\"$ctrl.categoriesTotal\" items-per-page=\"$ctrl.pageLimit\"\r\n              ng-model=\"$ctrl.currentPage\" ng-change=\"$ctrl.getCategories()\" class=\"pagination-sm pull-right\"\r\n              previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></ul>\r\n          <ul ng-if=\"$ctrl.categoriesTotal <= $ctrl.pageLimit\" class=\"pagination pagination-sm no-margin pull-right\">\r\n            <li><a href=\"#\">&laquo;</a></li>\r\n            <li><a href=\"#\">1</a></li>\r\n            <li><a href=\"#\">&raquo;</a></li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- /.box -->\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryController = function () {
	  CategoryController.$inject = ["ImagesDataProvider", "$state"];
	  function CategoryController(ImagesDataProvider, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CategoryController);
	    this.ImagesDataProvider = ImagesDataProvider;
	    this.$state = $state;
	    this.currentPage = 1;
	    this.pageLimit = '100';
	    this.maxSize = 5;
	    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
	    this.type = 1;
	    this.field = 'id';
	    this.order_type = 'desc';
	    this.col = 0;
	    this.colTopDown = 0;
	    this.getCategories();
	  }
	
	  (0, _createClass3.default)(CategoryController, [{
	    key: 'getSortRecors',
	    value: function getSortRecors(field, order_type, col, colTopDown) {
	      this.field = field;
	      this.order_type = order_type;
	      this.col = col;
	      this.colTopDown = colTopDown;
	      this.getCategories();
	    }
	  }, {
	    key: 'getCategories',
	    value: function getCategories() {
	      var vm = this;
	      var data = [];
	      data.currentPage = vm.currentPage;
	      data.pageLimit = vm.pageLimit;
	      data.field = vm.field;
	      data.order_type = vm.order_type;
	      vm.ImagesDataProvider.getCategory(data).then(function (result) {
	        vm.categories = result.data;
	        vm.categoriesTotal = result.total;
	      });
	    }
	  }, {
	    key: 'removeCategory',
	    value: function removeCategory(id) {
	      if (confirm("Are you sure to delete!") !== true) {
	        return false;
	      }
	      var vm = this;
	      vm.ImagesDataProvider.removeCategory(id).then(function (res) {
	        vm.getCategories();
	      });
	    }
	  }]);
	  return CategoryController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = CategoryController;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Image Library\r\n    <small>Edit image</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.images\">Images</a></li>\r\n    <li class=\"active\">Edit</li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form class=\"form-row-seperated\" name=\"imageForm\" novalidate>\r\n        <div class=\"portlet\">\r\n          <div class=\"portlet-title\">\r\n            <div class=\"caption\">\r\n              Edit Image\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if=\"$ctrl.existRecord==1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.existRecord=0;'>×</a>\r\n            Image name or slug already exist.\r\n          </div>\r\n          <div class=\"box box-warning\">\r\n            <div class=\"box-body\">\r\n              <div class=\"row\">\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Category</label>\r\n                    <select ng-model=\"$ctrl.image.image_category_id\" name='category' class=\"form-control\"\r\n                            ng-options=\"option.id as option.name for option in $ctrl.mainCategories\">\r\n                      <option value=''>Select Category</option>\r\n                    </select>\r\n                    <span class=\"text-danger\" ng-show=\"(imageForm.category.$dirty) || imageForm.$submitted\">\r\n                                            <span\r\n                                              ng-show=\"imageForm.category.$error.required\">Category is required.<br/></span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Name</label>\r\n                    <input ng-model=\"$ctrl.image.name\" name='name' class=\"form-control\">\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class='col-md-12'>\r\n                  <label>Select File</label>\r\n                  <input type=\"file\" ngf-select ngf-change=\"$ctrl.change($file)\" ng-model=\"$ctrl.image.img\" name=\"file\"\r\n                         accept=\"image/*\" ngf-max-size=\"2MB\"\r\n                         ngf-model-invalid=\"errorFile\" required>\r\n                  <img height='600' ng-show=\"imageForm.file.$valid\" ngf-src=\"$ctrl.image.img\"\r\n                       class=\"thumb img-responsive\">\r\n                  <button type='button' class='btn btn-danger' ng-click=\"$ctrl.image.img = null\"\r\n                          ng-show=\"$ctrl.image.img\">Remove\r\n                  </button>\r\n                  <span class=\"text-danger\" ng-show=\"(imageForm.file.$dirty) || imageForm.$submitted\">\r\n                                        <span ng-show=\"imageForm.file.$error.required\">Image is required.<br/></span>\r\n                                    </span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"box-footer\">\r\n              <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"$ctrl.saveData(imageForm.$valid)\">Update</button>\r\n              <a ui-sref=\"app.images\">\r\n                <button class=\"btn btn-default\" type=\"button\">Cancel</button>\r\n              </a>\r\n              <div style=\"width: 50px; display: inline; position: relative; top: 5px;\" class=\"loader \"\r\n                   ng-show=\"$ctrl.__loading\">\r\n                <span style=\"font-size: 25px;\" class=\"fa fa-spinner fa-spin\"></span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageEditController = function () {
	  ImageEditController.$inject = ["ImagesDataProvider", "$state", "Upload", "$timeout", "API_URL", "APPLICATION_URL"];
	  function ImageEditController(ImagesDataProvider, $state, Upload, $timeout, API_URL, APPLICATION_URL) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ImageEditController);
	    this.image = {};
	    this.Upload = Upload;
	    this.ImagesDataProvider = ImagesDataProvider;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.API_URL = API_URL;
	    this.APPLICATION_URL = APPLICATION_URL;
	    this.existRecord = 0;
	    var vm = this;
	    ImagesDataProvider.loadCategoriesNoLimit().then(function (result) {
	      vm.mainCategories = result;
	    });
	    ImagesDataProvider.getImage(vm.$state.params.id).then(function (result) {
	      vm.image = result;
	      vm.image.img = APPLICATION_URL + '/' + result.path;
	      vm.image.oldPath = result.path;
	    });
	  }
	
	  (0, _createClass3.default)(ImageEditController, [{
	    key: 'onvertToSlug',
	    value: function onvertToSlug(text) {
	      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
	      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
	      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
	      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
	      .replace(/\-\-+/g, '-') // Replace multiple - with single -
	      .replace(/^-+/, '') // Trim - from start of text
	      .replace(/-+$/, ''); // Trim - from end of text
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(form) {
	      var vm = this;
	      if (!form) {
	        return false;
	      }
	      vm.__loading = true;
	      if (vm.image.name) vm.image.slug = vm.onvertToSlug(vm.image.name);
	      var file = vm.image.img;
	      var data = {};
	      data.name = vm.image.name;
	      data.id = vm.image.image_id;
	      data.slug = vm.onvertToSlug(vm.image.name);
	      data.image_category_id = vm.image.image_category_id;
	      if (file.name != undefined) {
	        //check image exist or not
	        var chkData = { name: data.name, slug: data.slug, id: data.id };
	        vm.ImagesDataProvider.checkRecordExist(chkData).then(function (res) {
	          if (res.exist == 0) {
	            file.upload = vm.Upload.upload({
	              url: vm.APPLICATION_URL + '/api/upload',
	              method: 'POST',
	              data: { 'image': file, 'max-w': '1200', 'max-h': '600' }
	            });
	            file.upload.then(function (response) {
	              data.filename = new Date().valueOf() + file.name;
	              data.response = response.data;
	              data.oldPath = vm.image.oldPath;
	              data.mime_type = file.type;
	              vm.ImagesDataProvider.updateImageData(data).then(function (response) {
	                vm.$timeout(function () {
	                  vm.$state.go('app.images');
	                }, 5000);
	              });
	            }, function (response) {
	              if (response.status > 0) alert(response.status + ': ' + response.data);
	              vm.__loading = false;
	            });
	          } else {
	            vm.existRecord = 1;
	            vm.__loading = false;
	          }
	        });
	      } else {
	        vm.ImagesDataProvider.updateData(data).then(function (response) {
	          if (response.exist == 0) {
	            vm.$state.go('app.images');
	          } else {
	            vm.__loading = false;
	            vm.existRecord = 1;
	          }
	        });
	      }
	    }
	  }, {
	    key: 'change',
	    value: function change(file) {
	      this.image.name = file.name.replace(/\.[^/.]+$/, "");
	    }
	  }]);
	  return ImageEditController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = ImageEditController;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<section class=\"content-header\">\r\n  <h1>\r\n    Image Library\r\n    <small>List all images</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li class=\"active\"><a ui-sref=\"app.images\">Images</a></li>\r\n  </ol>\r\n</section>\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <div class=\"box\">\r\n        <div class=\"box-header\">\r\n          <div style=\"float:left;width: 200px;\">\r\n            Select Limit :\r\n            <select ng-model=\"$ctrl.pageLimit\" name='pageLimit' class=\"form-control\"\r\n                    ng-options=\"key as value for (key , value) in $ctrl.pageLimitOptions\"\r\n                    ng-change=\"$ctrl.currentPage = 1;\r\n                                $ctrl.getImages()\" required style=\"display: inline; width: 75px;\">\r\n              <option ng-repeat=\"(key, value) in data\" value=\"{{key}}\">{{value}}</option>\r\n            </select>\r\n            <div class=\"input-group\" style=\"display: none;\">\r\n              <input type=\"text\" ng-model=\"text\" placeholder=\"Search\"\r\n                     class=\"form-control input-sm pull-right ng-pristine ng-valid ng-not-empty ng-touched\"\r\n                     name=\"table_search\" style=\"\">\r\n              <div class=\"input-group-btn\">\r\n                <button ng-click=\"search(text, searchIn)\" type=\"submit\" class=\"btn btn-sm btn-default\"><i\r\n                  class=\"fa fa-search\"></i></button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <a style=\"float:right\" ui-sref=\"app.addImage\">+ Add Image</a>\r\n        </div>\r\n        <div class=\"box-body table-responsive no-padding\">\r\n          <table class=\"table table-hover table-bordered\">\r\n            <thead>\r\n            <tr>\r\n              <th>Name\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('name', 'asc', 1, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '1' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('name', 'desc', 1, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th>Category\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('category', 'asc', 2, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '2' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('category', 'desc', 2, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th>Image</th>\r\n              <th>Created\r\n                <span class='sort-icon'>\r\n                                        <i class=\"si-sort-asc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown == '1')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('created_at', 'asc', 3, 1)\"></i>\r\n                                        <i class=\"si-sort-desc\"\r\n                                           ng-class=\"{'active': ($ctrl.col == '3' && $ctrl.colTopDown == '2')}\"\r\n                                           ng-click=\"$ctrl.getSortRecors('created_at', 'desc', 3, 2)\"></i>\r\n                                    </span>\r\n              </th>\r\n              <th width='15%'>Action</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody id=\"items\">\r\n            <tr ng-repeat=\"row in $ctrl.categories\" style=\"cursor:move\">\r\n              <td>{{row.name}}</td>\r\n              <td>{{row.category}}</td>\r\n              <td>\r\n                <img width='100' ng-src=\"{{$ctrl.APPLICATION_URL}}/{{row.path}}\" class=\"thumb img-responsive\">\r\n              </td>\r\n              <td>{{row.created_at| date : format : timezone}}</td>\r\n              <td>\r\n                <i class=\"fa fa-edit\" ui-sref=\"app.editImage({id:row.image_id})\"></i>\r\n                <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeRecord(row.image_id);\"></i>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"box-footer clearfix\">\r\n          <ul ng-if=\"$ctrl.categoriesTotal > $ctrl.pageLimit\" uib-pagination boundary-links=\"true\"\r\n              max-size=\"$ctrl.maxSize\" total-items=\"$ctrl.categoriesTotal\" items-per-page=\"$ctrl.pageLimit\"\r\n              ng-model=\"$ctrl.currentPage\" ng-change=\"$ctrl.getImages()\" class=\"pagination-sm pull-right\"\r\n              previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></ul>\r\n          <ul ng-if=\"$ctrl.categoriesTotal <= $ctrl.pageLimit\" class=\"pagination pagination-sm no-margin pull-right\">\r\n            <li><a href=\"#\">&laquo;</a></li>\r\n            <li><a href=\"#\">1</a></li>\r\n            <li><a href=\"#\">&raquo;</a></li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Sortable = __webpack_require__(583);
	
	var _Sortable2 = _interopRequireDefault(_Sortable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryController = function () {
	  CategoryController.$inject = ["ImagesDataProvider", "$state", "APPLICATION_URL"];
	  function CategoryController(ImagesDataProvider, $state, APPLICATION_URL) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CategoryController);
	    this.ImagesDataProvider = ImagesDataProvider;
	    this.$state = $state;
	    this.currentPage = 1;
	    this.pageLimit = '100';
	    this.maxSize = 5;
	    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
	    this.type = 1;
	    this.field = 'image_id';
	    this.order_type = 'desc';
	    this.col = 0;
	    this.colTopDown = 0;
	    this.APPLICATION_URL = APPLICATION_URL;
	    this.parentId = $state.params.parentId;
	    if (this.parentId) {
	      this.pageLimit = '9999';
	      this.field = 'order_by';
	      this.order_type = 'asc';
	      var el = document.getElementById('items');
	      var vm = this;
	      vm.sortingLog = [];
	      var sortable = _Sortable2.default.create(el, {
	        onStart: function onStart(evt) {
	          evt.oldIndex;
	          console.log('start');
	        },
	        onEnd: function onEnd(evt) {
	          var oldData = angular.copy(vm.categories);
	          var i = 0;
	          if (evt.oldIndex < evt.newIndex) {
	            for (i = evt.oldIndex; i <= evt.newIndex; i++) {
	              if (i == evt.newIndex) {
	                vm.categories[i] = oldData[evt.oldIndex];
	              } else {
	                vm.categories[i] = oldData[i + 1];
	              }
	            }
	          }
	          if (evt.oldIndex > evt.newIndex) {
	            for (i = evt.oldIndex; i >= evt.newIndex; i--) {
	              if (i == evt.newIndex) {
	                vm.categories[i] = oldData[evt.oldIndex];
	              } else {
	                vm.categories[i] = oldData[i - 1];
	              }
	            }
	          }
	          vm.categories.map(function (i) {
	            vm.sortingLog.push(i.image_id);
	          });
	          ImagesDataProvider.updateImageOrder(vm.sortingLog).then(function (result) {
	            vm.getImages();
	          });
	          vm.sortingLog = [];
	        }
	      });
	    } else {
	      this.parentId = 0;
	    }
	    this.getImages();
	  }
	
	  (0, _createClass3.default)(CategoryController, [{
	    key: 'getSortRecors',
	    value: function getSortRecors(field, order_type, col, colTopDown) {
	      this.field = field;
	      this.order_type = order_type;
	      this.col = col;
	      this.colTopDown = colTopDown;
	      this.getImages();
	    }
	  }, {
	    key: 'getImages',
	    value: function getImages() {
	      var vm = this;
	      var data = [];
	      data.currentPage = vm.currentPage;
	      data.pageLimit = vm.pageLimit;
	      data.field = vm.field;
	      data.order_type = vm.order_type;
	      data.image_category_id = vm.parentId;
	      vm.ImagesDataProvider.getImages(data).then(function (result) {
	        vm.categories = result.data;
	        vm.categoriesTotal = result.total;
	      });
	    }
	  }, {
	    key: 'removeRecord',
	    value: function removeRecord(id) {
	      if (confirm("Are you sure to delete!") !== true) {
	        return false;
	      }
	      var vm = this;
	      vm.ImagesDataProvider.removeImage(id).then(function (res) {
	        vm.getImages();
	      });
	    }
	  }]);
	  return CategoryController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = CategoryController;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Image Categories\r\n    <small>Add new category</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.imageCategories\">Categories</a></li>\r\n    <li class=\"active\"><a ui-sref=\"app.imageCategoryAdd\">Add</a></li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form class=\"form-row-seperated\" name=\"categoryForm\" novalidate>\r\n        <div class=\"portlet\">\r\n          <div class=\"portlet-title\">\r\n            <div class=\"caption\">\r\n              New Category\r\n            </div>\r\n          </div><!-- general form elements disabled -->\r\n          <div class=\"alert alert-danger\" ng-if=\"$ctrl.existRecord==1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.existRecord=0;'>×</a>\r\n            Image category already exist.\r\n          </div>\r\n          <div class=\"box box-warning\">\r\n            <!-- /.box-header -->\r\n            <div class=\"box-body\">\r\n              <!-- text input -->\r\n              <div class=\"row\">\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Category Name</label>\r\n                    <input ng-model=\"$ctrl.category.name\" class=\"form-control\" name='name' required>\r\n                    <span class=\"text-danger\" ng-show=\"(categoryForm.name.$dirty) || categoryForm.$submitted\">\r\n                                            <span\r\n                                              ng-show=\"categoryForm.name.$error.required\">Name is required.<br/></span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Category Description</label>\r\n                    <textarea ng-model=\"$ctrl.category.description\" class=\"form-control\" name='description'\r\n                              required></textarea>\r\n                    <span class=\"text-danger\" ng-show=\"(categoryForm.description.$dirty) || categoryForm.$submitted\">\r\n                                            <span ng-show=\"categoryForm.description.$error.required\">Description is required.<br/></span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"box-footer\">\r\n              <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"$ctrl.create(categoryForm.$valid)\">Save</button>\r\n              <a ui-sref=\"app.imageCategories\">\r\n                <button class=\"btn btn-default\" type=\"button\">Cancel</button>\r\n              </a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryAddController = function () {
	  CategoryAddController.$inject = ["ImagesDataProvider", "$state", "$timeout", "API_URL"];
	  function CategoryAddController(ImagesDataProvider, $state, $timeout, API_URL) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CategoryAddController);
	    this.category = {};
	    this.ImagesDataProvider = ImagesDataProvider;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.API_URL = API_URL;
	    this.errorShow = 0;
	  }
	
	  (0, _createClass3.default)(CategoryAddController, [{
	    key: 'onvertToSlug',
	    value: function onvertToSlug(text) {
	      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
	      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
	      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
	      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
	      .replace(/\-\-+/g, '-') // Replace multiple - with single -
	      .replace(/^-+/, '') // Trim - from start of text
	      .replace(/-+$/, ''); // Trim - from end of text
	    }
	  }, {
	    key: 'create',
	    value: function create(form) {
	      if (!form) {
	        return false;
	      }
	      var vm = this;
	      vm.category.slug = vm.onvertToSlug(vm.category.name);
	      vm.ImagesDataProvider.saveCategory(vm.category).then(function (res) {
	        if (res.exist == '1') {
	          vm.existRecord = 1;
	        } else {
	          vm.$state.go('app.imageCategories');
	        }
	      });
	    }
	  }]);
	  return CategoryAddController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = CategoryAddController;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Edit Image Category\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.imageCategories\">Image Categories listing</a></li>\r\n    <li class=\"active\">Edit</li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form class=\"form-row-seperated\" name=\"categoryForm\" novalidate>\r\n        <div class=\"portlet\">\r\n          <div class=\"portlet-title\">\r\n            <div class=\"caption\">\r\n              New category\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if=\"$ctrl.existRecord==1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.existRecord=0;'>×</a>\r\n            Category already exist.\r\n          </div>\r\n          <div class=\"box box-warning\">\r\n            <!-- /.box-header -->\r\n            <div class=\"box-body\">\r\n              <div class=\"row\">\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Category Name</label>\r\n                    <input ng-model=\"$ctrl.category.name\" class=\"form-control\" name='name' required>\r\n                    <span class=\"text-danger\" ng-show=\"(categoryForm.name.$dirty) || categoryForm.$submitted\">\r\n                                            <span\r\n                                              ng-show=\"categoryForm.name.$error.required\">Category name is required.</span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Category Description</label>\r\n                    <textarea ng-model=\"$ctrl.category.description\" class=\"form-control\" name='description'\r\n                              required></textarea>\r\n                    <span class=\"text-danger\" ng-show=\"(categoryForm.description.$dirty) || categoryForm.$submitted\">\r\n                                            <span ng-show=\"categoryForm.description.$error.required\">Description is required.<br/></span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"box-footer\">\r\n              <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"$ctrl.update(categoryForm.$valid)\">Update</button>\r\n              <a ui-sref=\"app.imageCategories\">\r\n                <button class=\"btn btn-default\" type=\"button\">Cancel</button>\r\n              </a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	  EditController.$inject = ["ImagesDataProvider", "$state"];
	  function EditController(ImagesDataProvider, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EditController);
	    this.ImagesDataProvider = ImagesDataProvider;
	    this.$state = $state;
	    var vm = this;
	    vm.ImagesDataProvider.getCategoryById(vm.$state.params.id).then(function (result) {
	      vm.category = result;
	    });
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: 'update',
	    value: function update(form) {
	      if (!form) {
	        return false;
	      }
	      var vm = this;
	      vm.ImagesDataProvider.updateCategory(vm.category).then(function (res) {
	        if (res.exist == '1') {
	          vm.existRecord = 1;
	        } else {
	          vm.$state.go('app.imageCategories');
	        }
	      });
	    }
	  }]);
	  return EditController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = EditController;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!-- Content Header (Page header) -->\r\n<section class=\"content-header\">\r\n  <h1>\r\n    Image Library\r\n    <small>Add new image</small>\r\n  </h1>\r\n  <ol class=\"breadcrumb\">\r\n    <li><a href=\"/\"><i class=\"fa fa-dashboard\"></i> Home</a></li>\r\n    <li><a ui-sref=\"app.images\">Images</a></li>\r\n    <li class=\"active\">Add</li>\r\n  </ol>\r\n</section>\r\n<!-- Main content -->\r\n<section class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form class=\"form-row-seperated\" name=\"imageForm\" novalidate>\r\n        <div class=\"portlet\">\r\n          <div class=\"portlet-title\">\r\n            <div class=\"caption\">\r\n              New Image\r\n            </div>\r\n          </div>\r\n          <div class=\"alert alert-danger\" ng-if=\"$ctrl.existRecord==1\">\r\n            <a title=\"close\" aria-label=\"close\" data-dismiss=\"alert\" class=\"close\" ng-click='$ctrl.existRecord=0;'>×</a>\r\n            Image name or slug already exist.\r\n          </div>\r\n          <div class=\"box box-warning\">\r\n            <div class=\"box-body\">\r\n              <div class=\"row\">\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Category</label>\r\n                    <select ng-model=\"$ctrl.image.image_category_id\" name='category' class=\"form-control\" required>\r\n                      <option value=''>Select Category</option>\r\n                      <option ng-repeat=\"category in $ctrl.mainCategories\" value=\"{{category.id}}\">{{category.name}}\r\n                      </option>\r\n                    </select>\r\n                    <span class=\"text-danger\" ng-show=\"(imageForm.category.$dirty) || imageForm.$submitted\">\r\n                                            <span\r\n                                              ng-show=\"imageForm.category.$error.required\">Category is required.<br/></span>\r\n                                        </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class='col-md-6'>\r\n                  <div class=\"form-group\">\r\n                    <label>Name</label>\r\n                    <input ng-model=\"$ctrl.image.name\" name='name' class=\"form-control\">\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class='col-md-12'>\r\n                  <label>Select File</label>\r\n                  <input type=\"file\" ngf-select ngf-change=\"$ctrl.change($file)\" ng-model=\"$ctrl.image.img\" name=\"file\"\r\n                         accept=\"image/*\" ngf-max-size=\"2MB\"\r\n                         ngf-model-invalid=\"errorFile\" required>\r\n                  <img height='600' ng-show=\"imageForm.file.$valid\" ngf-src=\"$ctrl.image.img\"\r\n                       class=\"thumb img-responsive\">\r\n                  <button type='button' class='btn btn-danger' ng-click=\"$ctrl.image.img = null\"\r\n                          ng-show=\"$ctrl.image.img\">Remove\r\n                  </button>\r\n                  <span class=\"text-danger\" ng-show=\"(imageForm.file.$dirty) || imageForm.$submitted\">\r\n                                        <span ng-show=\"imageForm.file.$error.required\">Image is required.<br/></span>\r\n                                    </span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"box-footer\">\r\n              <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"$ctrl.saveData(imageForm.$valid)\">Save</button>\r\n              <a ui-sref=\"app.images\">\r\n                <button class=\"btn btn-default\" type=\"button\">Cancel</button>\r\n              </a>\r\n              <div style=\"width: 50px; display: inline; position: relative; top: 5px;\" class=\"loader \"\r\n                   ng-show=\"$ctrl.__loading\">\r\n                <span style=\"font-size: 25px;\" class=\"fa fa-spinner fa-spin\"></span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n<!-- /.content -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(442);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(443);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAddController = function () {
	  ImageAddController.$inject = ["ImagesDataProvider", "$state", "Upload", "$timeout", "API_URL", "APPLICATION_URL"];
	  function ImageAddController(ImagesDataProvider, $state, Upload, $timeout, API_URL, APPLICATION_URL) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ImageAddController);
	    this.image = {};
	    this.Upload = Upload;
	    this.ImagesDataProvider = ImagesDataProvider;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.API_URL = API_URL;
	    this.APPLICATION_URL = APPLICATION_URL;
	    this.existRecord = 0;
	    var vm = this;
	    ImagesDataProvider.loadCategoriesNoLimit().then(function (result) {
	      vm.mainCategories = result;
	    });
	  }
	
	  (0, _createClass3.default)(ImageAddController, [{
	    key: 'onvertToSlug',
	    value: function onvertToSlug(text) {
	      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
	      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
	      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
	      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
	      .replace(/\-\-+/g, '-') // Replace multiple - with single -
	      .replace(/^-+/, '') // Trim - from start of text
	      .replace(/-+$/, ''); // Trim - from end of text
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(form) {
	      var vm = this;
	      if (!form) {
	        return false;
	      }
	      vm.__loading = true;
	      if (vm.image.name) vm.image.slug = vm.onvertToSlug(vm.image.name);
	      var file = vm.image.img;
	
	      var data = {};
	      data.name = vm.image.name;
	      data.slug = vm.onvertToSlug(vm.image.name);
	      data.image_category_id = vm.image.image_category_id;
	      data.filename = new Date().valueOf() + file.name;
	      data.file = file;
	
	      var chkData = { name: data.name, slug: data.slug };
	
	      vm.ImagesDataProvider.checkRecordExist(chkData).then(function (res) {
	        if (res.exist == 0) {
	          file.upload = vm.Upload.upload({
	            url: vm.APPLICATION_URL + '/api/upload',
	            method: 'POST',
	            data: { 'image': file, 'max-w': '1200', 'max-h': '600' }
	          });
	          file.upload.then(function (response) {
	            data.filename = new Date().valueOf() + file.name;
	            data.response = response.data;
	            data.mime_type = file.type;
	            vm.ImagesDataProvider.saveImageData(data).then(function (response) {
	              vm.$timeout(function () {
	                vm.$state.go('app.images');
	              }, 5000);
	            });
	          }, function (response) {
	            if (response.status > 0) alert(response.status + ': ' + response.data);
	            vm.__loading = false;
	          });
	        } else {
	          vm.existRecord = 1;
	          vm.__loading = false;
	        }
	      });
	    }
	  }, {
	    key: 'change',
	    value: function change(file) {
	      this.image.name = file.name.replace(/\.[^/.]+$/, "");
	    }
	  }]);
	  return ImageAddController;
	}();
	
	// WEBPACK FOOTER //
	
	
	exports.default = ImageAddController;

/***/ },
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _aluminum = __webpack_require__(592);
	
	var _aluminum2 = _interopRequireDefault(_aluminum);
	
	var _metal = __webpack_require__(593);
	
	var _metal2 = _interopRequireDefault(_metal);
	
	var _plastic = __webpack_require__(594);
	
	var _plastic2 = _interopRequireDefault(_plastic);
	
	var _wood = __webpack_require__(591);
	
	var _wood2 = _interopRequireDefault(_wood);
	
	var _acrylic = __webpack_require__(595);
	
	var _acrylic2 = _interopRequireDefault(_acrylic);
	
	var _led = __webpack_require__(596);
	
	var _led2 = _interopRequireDefault(_led);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  aluminium: _aluminum2.default,
	  metal: _metal2.default,
	  plastic: _plastic2.default,
	  wood: _wood2.default,
	  acrylic: _acrylic2.default,
	  led: _led2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _nameBadge = __webpack_require__(597);
	
	var _nameBadge2 = _interopRequireDefault(_nameBadge);
	
	var _wood = __webpack_require__(598);
	
	var _wood2 = _interopRequireDefault(_wood);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  "name-badge": _nameBadge2.default,
	  wood: _wood2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _decor1Color = __webpack_require__(588);
	
	var _decor1Color2 = _interopRequireDefault(_decor1Color);
	
	var _decorAllColors = __webpack_require__(589);
	
	var _decorAllColors2 = _interopRequireDefault(_decorAllColors);
	
	var _stickersAllColors = __webpack_require__(590);
	
	var _stickersAllColors2 = _interopRequireDefault(_stickersAllColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  "decor-1-color": _decor1Color2.default,
	  "decor-all-colors": _decorAllColors2.default,
	  "stickers-all-colors": _stickersAllColors2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _posters = __webpack_require__(599);
	
	var _posters2 = _interopRequireDefault(_posters);
	
	var _banners = __webpack_require__(600);
	
	var _banners2 = _interopRequireDefault(_banners);
	
	var _rollUps = __webpack_require__(601);
	
	var _rollUps2 = _interopRequireDefault(_rollUps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  posters: _posters2.default,
	  banners: _banners2.default,
	  "roll-ups": _rollUps2.default
	
	  // WEBPACK FOOTER //
	
	};

/***/ },
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>Text</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.cost\"/>\r\n    </label>\r\n    <span>\r\n      per letter\r\n    </span>\r\n\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Image</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.image.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.image.cost\"/>\r\n    </label>\r\n    <span>\r\n      per meter/height\r\n    </span>\r\n\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Colors</legend>\r\n    <div class=\"input-group\" style=\"width: 200px;\">\r\n      <ui-select ng-model=\"$ctrl.selected\" theme=\"bootstrap\" style=\"width:150px;\">\r\n        <ui-select-match placeholder=\"Select color...\">\r\n          <div>\r\n            <span style=\"background-color: {{$select.selected.hex1}};\">&nbsp;</span>\r\n          </div>\r\n        </ui-select-match>\r\n        <ui-select-choices repeat=\"color in $ctrl.uniqueColors($ctrl.material.spec.colors)\">\r\n          <span style=\"background-color: {{color.hex1}};\">&nbsp;</span>\r\n          <span>{{color.name}}</span>\r\n        </ui-select-choices>\r\n        <ui-select-no-choice>\r\n          No colors to select\r\n        </ui-select-no-choice>\r\n      </ui-select>\r\n      <span class=\"input-group-btn\">\r\n        <button ng-click=\"$ctrl.addColor()\" class=\"btn btn-success\">\r\n          <span class=\"fa fa-plus\"></span>\r\n          Add\r\n        </button>\r\n      </span>\r\n    </div>\r\n\r\n    <table class=\"table table-bordered\">\r\n      <thead>\r\n      <tr>\r\n        <th>\r\n          Color\r\n        </th>\r\n        <th>\r\n          Start Cost\r\n        </th>\r\n        <th>\r\n          Cost\r\n        </th>\r\n        <th>\r\n          calcMethod\r\n        </th>\r\n        <th>\r\n          Action\r\n        </th>\r\n      </tr>\r\n      </thead>\r\n      <tbody>\r\n      <tr ng-if=\"!$ctrl.pricing.color.length\">\r\n        <td colspan=\"5\">\r\n          <h3 style=\"text-align: center;\">No Colors with custom pricing rules</h3>\r\n        </td>\r\n      </tr>\r\n      <tr ng-repeat=\"color in $ctrl.pricing.color\">\r\n        <td>\r\n            <span ng-if='color.value.hex1 ==undefined'\r\n                  style=\"display: inline-block; width:100%; background-color: {{color.value}}; border: 1px dashed grey;\">\r\n              &nbsp;\r\n            </span>\r\n          <span ng-if='color.value.hex1!=undefined'\r\n                style=\"display: inline-block; width:100%; background-color: {{color.value.hex1}}; border: 1px dashed grey;\">\r\n              &nbsp;\r\n            </span>\r\n        </td>\r\n        <td>\r\n          <input type=\"text\" ng-model=\"color.startCost\"/>\r\n        </td>\r\n        <td>\r\n          <input type=\"text\" ng-model=\"color.cost\"/>\r\n        </td>\r\n        <td>\r\n          <input type=\"text\" ng-model=\"color.calcMethod\"/>\r\n        </td>\r\n        <td>\r\n          <i ng-if='color.value.hex1==undefined' class=\"fa fa-remove\" ng-click=\"$ctrl.removeColor(color.value,'');\"></i>\r\n          <i ng-if='color.value.hex1!=undefined' class=\"fa fa-remove\"\r\n             ng-click=\"$ctrl.removeColor(color.value.hex1,color.value.hex2);\"></i>\r\n        </td>\r\n      </tr>\r\n      </tbody>\r\n    </table>\r\n  </fieldset>\r\n  <!--  <fieldset>\r\n      <legend>\r\n        Color\r\n      </legend>\r\n      <fieldset>\r\n        <legend>\r\n          Frosty Contour\r\n        </legend>\r\n        <label>\r\n          Start Cost\r\n          <input type=\"text\" ng-model=\"$ctrl.pricing.color['frosty-contour'].startCost\">\r\n        </label>\r\n        <label>\r\n          Cost\r\n          <input type=\"text\" ng-model=\"$ctrl.pricing.color['frosty-contour'].cost\">\r\n        </label>\r\n        <label>\r\n          calcMethod\r\n          <input type=\"text\" ng-model=\"$ctrl.pricing.color['frosty-contour'].calcMethod\">\r\n        </label>\r\n      </fieldset>\r\n      <fieldset>\r\n        <legend>\r\n          Frosty Cutout\r\n        </legend>\r\n        <label>\r\n          Start Cost\r\n          <input type=\"text\" ng-model=\"$ctrl.pricing.color['frosty-cutout'].startCost\" />\r\n        </label>\r\n        <label>\r\n          Cost\r\n          <input type=\"text\" ng-model=\"$ctrl.pricing.color['frosty-cutout'].cost\" />\r\n        </label>\r\n          <label>\r\n          calcMethod\r\n          <input type=\"text\" ng-model=\"$ctrl.pricing.color['frosty-cutout'].calcMethod\">\r\n        </label>\r\n      </fieldset>\r\n    </fieldset>-->\r\n  <fieldset>\r\n    <legend>\r\n      Fix Method\r\n    </legend>\r\n    <fieldset>\r\n      <legend>\r\n        Outdoor Permanent\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['outdoor-permanent'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['outdoor-permanent'].cost\"/>\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['outdoor-permanent'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['outdoor-permanent'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>\r\n      Color\r\n    </legend>\r\n    <fieldset>\r\n      <legend>\r\n        Transparent\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.color.transparent.startCost\">\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.color.transparent.cost\">\r\n      </label>54\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.color.transparent.calcMethod\">\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Frosty\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.color.frosty.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.color.frosty.cost\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.color.frosty.calcMethod\">\r\n      </label>\r\n    </fieldset>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>\r\n      Fix Method\r\n    </legend>\r\n\t    <fieldset>\r\n      <legend>\r\n        Screw\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.cost\"/>\r\n      </label>\r\n      <span>\r\n      per screw\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per screw\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Adhesive Back\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Hanging\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\t    <fieldset>\r\n      <legend>\r\n        Wood Stick\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.polyester.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.polyester.cost\"/>\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.polyester.weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.polyester.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Long Term Decal\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['long-term-decal'].startCost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['long-term-decal'].cost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['long-term-decal'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['long-term-decal'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Wall Sticker (Indoor)\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['wall-sticker-indoor'].startCost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['wall-sticker-indoor'].cost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-sticker-indoor'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-sticker-indoor'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Adhesive Front\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['adhesive-front'].startCost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['adhesive-front'].cost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-front'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-front'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Magnetic Back Outdoor\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-outdoor'].startCost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-outdoor'].cost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-outdoor'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-outdoor'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Magnetic Back Indoor\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-indoor'].startCost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-indoor'].cost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-indoor'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-indoor'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\t\r\n\t<fieldset>\r\n      <legend>\r\n        Bordsställ\r\n      </legend>\r\n      <button class=\"btn btn-success\" ng-click=\"$ctrl.newSizeCost()\">\r\n        <i class=\"fa fa-plus\"></i>\r\n        <span>New Size Cost </span>\r\n      </button>\r\n      <table class=\"table table-bordered table-responsive\">\r\n        <thead>\r\n        <tr>\r\n          <th>\r\n            Min width, mm\r\n          </th>\r\n          <th>\r\n            Max width, mm\r\n          </th>\r\n          <th>\r\n            Min height, mm\r\n          </th>\r\n          <th>\r\n            Max height, mm\r\n          </th>\r\n          <th>\r\n            Start cost\r\n          </th>\r\n          <th>\r\n            Cost\r\n          </th>\r\n          <th>\r\n            Weight\r\n          </th>\r\n          <th>\r\n            calcMethod\r\n          </th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-if=\"!$ctrl.pricing.fixMethod['table-stand'].length\">\r\n          <td colspan=\"3\">\r\n            <h3 style=\"text-align: center;\">No pricing sizes available</h3>\r\n\r\n          </td>\r\n        </tr>\r\n        <tr ng-repeat=\"size in $ctrl.pricing.fixMethod['table-stand']\">\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.width.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.width.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.height.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.height.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.startCost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.cost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.weight\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.calcMethod\"/>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n    </fieldset>\r\n\t\r\n\t<fieldset>\r\n      <legend>\r\n        Studentskylt 500x700\r\n      </legend>\r\n      <label>\r\n        Width\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].width\"/>\r\n      </label>\r\n      <span>\r\n        mm\r\n      </span>\r\n      <label>\r\n        Height\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].height\"/>\r\n      </label>\r\n      <span>\r\n        mm\r\n      </span>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].cost\"/>\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per mm\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Wall Distance\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].cost\"/>\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\t\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>\r\n      Color\r\n    </legend>\r\n    <fieldset>\r\n      <legend>\r\n        Transparent\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.color.transparent.startCost\">\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.color.transparent.cost\">\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.color.transparent.calcMethod\">\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Frosty\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.color.frosty.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.color.frosty.cost\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.color.frosty.calcMethod\">\r\n      </label>\r\n    </fieldset>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>\r\n      Fix Method\r\n    </legend>\r\n    <fieldset>\r\n      <legend>\r\n        Long Term Decal\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['long-term-decal'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['long-term-decal'].cost\"/>\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['long-term-decal'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['long-term-decal'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Wall Sticker (Indoor)\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-sticker-indoor'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['wall-sticker-indoor'].cost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-sticker-indoor'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-sticker-indoor'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Adhesive Front\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['adhesive-front'].startCost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['adhesive-front'].cost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-front'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-front'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Magnetic Back Outdoor\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-outdoor'].startCost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-outdoor'].cost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-outdoor'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-outdoor'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Magnetic Back Indoor\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-indoor'].startCost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-indoor'].cost\"\r\n        />\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-indoor'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back-indoor'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>\r\n      Shape Border\r\n    </legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.cost\"/>\r\n    </label>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>Text</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.text.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.text.cost\"/>\r\n    </label>\r\n    <span>\r\n      per letter\r\n    </span>\r\n\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Image</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.image.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.image.cost\"/>\r\n    </label>\r\n    <span>\r\n      per meter/height\r\n    </span>\r\n\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Colors(base shape)</legend>\r\n    <div class=\"input-group\" style=\"width: 200px;\">\r\n      <ui-select ng-model=\"$ctrl.selected\" theme=\"bootstrap\" style=\"width:150px;\">\r\n        <ui-select-match placeholder=\"Select color...\">\r\n          <div>\r\n            <span style=\"background-color: {{$select.selected.hex1}};\">&nbsp;</span>\r\n          </div>\r\n        </ui-select-match>\r\n        <ui-select-choices repeat=\"color in $ctrl.uniqueColors($ctrl.material.spec.colors)\">\r\n          <span style=\"background-color: {{color.hex1}};\">&nbsp;</span>\r\n          <span>{{color.name.split('/')[0]}}</span>\r\n        </ui-select-choices>\r\n        <ui-select-no-choice>\r\n          No colors to select\r\n        </ui-select-no-choice>\r\n      </ui-select>\r\n      <span class=\"input-group-btn\">\r\n        <button ng-click=\"$ctrl.addColor()\" class=\"btn btn-success\">\r\n          <span class=\"fa fa-plus\"></span>\r\n          Add\r\n        </button>\r\n      </span>\r\n    </div>\r\n\r\n    <table class=\"table table-bordered\">\r\n      <thead>\r\n      <tr>\r\n        <th>\r\n          Color\r\n        </th>\r\n        <th>\r\n          Start Cost\r\n        </th>\r\n        <th>\r\n          Cost\r\n        </th>\r\n        <th>\r\n          calcMethod\r\n        </th>\r\n        <th>\r\n          Action\r\n        </th>\r\n      </tr>\r\n      </thead>\r\n      <tbody>\r\n      <tr ng-if=\"!$ctrl.pricing.color.length\">\r\n        <td colspan=\"5\">\r\n          <h3 style=\"text-align: center;\">No Colors with custom pricing rules</h3>\r\n\r\n        </td>\r\n      </tr>\r\n      <tr ng-repeat=\"color in $ctrl.pricing.color\">\r\n        <td>\r\n            <span\r\n              style=\"display: inline-block; width:100%; background-color: {{color.value}}; border: 1px dashed grey;\">\r\n              &nbsp;\r\n            </span>\r\n        </td>\r\n        <td>\r\n          <input type=\"number\" ng-model=\"color.startCost\"/>\r\n        </td>\r\n        <td>\r\n          <input type=\"number\" ng-model=\"color.cost\"/>\r\n        </td>\r\n        <td>\r\n          <input type=\"text\" ng-model=\"color.calcMethod\"/>\r\n        </td>\r\n        <td>\r\n          <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeColor(color.value);\"></i>\r\n        </td>\r\n      </tr>\r\n      </tbody>\r\n    </table>\r\n\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>\r\n      Fix Methods\r\n    </legend>\r\n    <fieldset>\r\n      <legend>\r\n        Screw\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod.screw.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod.screw.cost\"/>\r\n      </label>\r\n      <span>\r\n      per screw\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per screw\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Adhesive Back\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Hanging\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Magnetic Back\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back'].cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Suction Cups\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['suction-cups'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['suction-cups'].cost\"/>\r\n      </label>\r\n      <span>\r\n      per cup\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['suction-cups'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per cup\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['suction-cups'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Table Stand\r\n      </legend>\r\n      <button class=\"btn btn-success\" ng-click=\"$ctrl.newSizeCost()\">\r\n        <i class=\"fa fa-plus\"></i>\r\n        <span>New Size Cost </span>\r\n      </button>\r\n      <table class=\"table table-bordered table-responsive\">\r\n        <thead>\r\n        <tr>\r\n          <th>\r\n            Min width, mm\r\n          </th>\r\n          <th>\r\n            Max width, mm\r\n          </th>\r\n          <th>\r\n            Min height, mm\r\n          </th>\r\n          <th>\r\n            Max height, mm\r\n          </th>\r\n          <th>\r\n            Start cost\r\n          </th>\r\n          <th>\r\n            Cost\r\n          </th>\r\n          <th>\r\n            Weight\r\n          </th>\r\n          <th>\r\n            calcMethod\r\n          </th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-if=\"!$ctrl.pricing.fixMethod['table-stand'].length\">\r\n          <td colspan=\"3\">\r\n            <h3 style=\"text-align: center;\">No pricing sizes available</h3>\r\n\r\n          </td>\r\n        </tr>\r\n        <tr ng-repeat=\"size in $ctrl.pricing.fixMethod['table-stand']\">\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.width.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.width.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.height.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.height.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.startCost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.cost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.weight\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.calcMethod\"/>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Wall Mount\r\n      </legend>\r\n      <label>\r\n        Width\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].width\"/>\r\n      </label>\r\n      <span>\r\n        mm\r\n      </span>\r\n      <label>\r\n        Height\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].height\"/>\r\n      </label>\r\n      <span>\r\n        mm\r\n      </span>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].cost\"/>\r\n      </label>\r\n\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per mm\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Wall Distance\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].cost\"/>\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>\r\n      Shape Border\r\n    </legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Text</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.cost\"/>\r\n    </label>\r\n    <span>\r\n      per letter\r\n    </span>\r\n\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>Image</legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.image.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.image.cost\"/>\r\n    </label>\r\n    <span>\r\n      per meter/height\r\n    </span>\r\n\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Color</legend>\r\n    <label>\r\n      Background Color Start Cost (not white)\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.color.background.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Background Color Cost (not white)\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.color.background.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.color.background.calcMethod\"/>\r\n    </label>\r\n\r\n    <label>\r\n      Background Color Reflective Start Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.color.reflective.startCost\"/>\r\n    </label>\r\n\r\n    <label>\r\n      Background Color Reflective Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.color.reflective.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.color.reflective.calcMethod\"/>\r\n    </label>\r\n\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>\r\n      Fix Methods\r\n    </legend>\r\n    <fieldset>\r\n      <legend>\r\n        Screw\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod.screw.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod.screw.cost\"/>\r\n      </label>\r\n      <span>\r\n      per screw\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per screw\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Adhesive Back\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Wall Distance\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].cost\"/>\r\n      </label>\r\n      <span>\r\n        per distance\r\n      </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].weight\"/>\r\n      </label>\r\n      <span>\r\n        per distance\r\n      </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Wall Attachment\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-attachment'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-attachment'].cost\"/>\r\n      </label>\r\n      <span>\r\n        per m <sup>2</sup>\r\n      </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-attachment'].weight\"/>\r\n      </label>\r\n      <span>\r\n        per m <sup>2</sup>\r\n      </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-attachment'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Pole Attachment\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['pole-attachment'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['pole-attachment'].cost\"/>\r\n      </label>\r\n      <span>\r\n        per m <sup>2</sup>\r\n      </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['pole-attachment'].weight\"/>\r\n      </label>\r\n      <span>\r\n        per m <sup>2</sup>\r\n      </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['pole-attachment'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Sizes\r\n      </legend>\r\n      <button class=\"btn btn-success\" ng-click=\"$ctrl.newSizeCostCal()\">\r\n        <i class=\"fa fa-plus\"></i>\r\n        <span>New Size Cost </span>\r\n      </button>\r\n      <table class=\"table table-bordered table-responsive\">\r\n        <thead>\r\n        <tr>\r\n          <th>\r\n            Min width, mm\r\n          </th>\r\n          <th>\r\n            Max width, mm\r\n          </th>\r\n          <th>\r\n            Min height, mm\r\n          </th>\r\n          <th>\r\n            Max height, mm\r\n          </th>\r\n          <th>\r\n            Start cost\r\n          </th>\r\n          <th>\r\n            Cost\r\n          </th>\r\n          <th>\r\n            Weight\r\n          </th>\r\n          <th>\r\n            calcMethod\r\n          </th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-if=\"!$ctrl.pricing.fixMethod['sizes'].length\">\r\n          <td colspan=\"8\">\r\n            <h3 style=\"text-align: center;\">No pricing sizes available</h3>\r\n\r\n          </td>\r\n        </tr>\r\n        <tr ng-repeat=\"size in $ctrl.pricing.fixMethod['sizes']\">\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.width.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.width.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.height.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.height.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.startCost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.cost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.weight\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.calcMethod\"/>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </fieldset>\r\n\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>\r\n      Shape Border\r\n    </legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.cost\"/>\r\n    </label>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>Text</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.text.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.cost\"/>\r\n    </label>\r\n    <span>\r\n      per letter\r\n    </span>\r\n\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Image</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.image.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.image.cost\"/>\r\n    </label>\r\n    <span>\r\n      per meter/height\r\n    </span>\r\n\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Colors(base shape)</legend>\r\n    <div class=\"input-group\" style=\"width: 200px;\">\r\n      <ui-select ng-model=\"$ctrl.selected\" theme=\"bootstrap\" style=\"width:150px;\">\r\n        <ui-select-match placeholder=\"Select color...\">\r\n          <div>\r\n            <span style=\"background-color: {{$select.selected.hex1}};\">&nbsp;</span>\r\n          </div>\r\n        </ui-select-match>\r\n        <ui-select-choices repeat=\"color in $ctrl.uniqueColors($ctrl.material.spec.colors)\">\r\n          <span style=\"background-color: {{color.hex1}};\">&nbsp;</span>\r\n          <span>{{color.name.split('/')[0]}}</span>\r\n        </ui-select-choices>\r\n        <ui-select-no-choice>\r\n          No colors to select\r\n        </ui-select-no-choice>\r\n      </ui-select>\r\n      <span class=\"input-group-btn\">\r\n        <button ng-click=\"$ctrl.addColor()\" class=\"btn btn-success\">\r\n          <span class=\"fa fa-plus\"></span>\r\n          Add\r\n        </button>\r\n      </span>\r\n    </div>\r\n\r\n    <table class=\"table table-bordered\">\r\n      <thead>\r\n      <tr>\r\n        <th>\r\n          Color\r\n        </th>\r\n        <th>\r\n          Start Cost\r\n        </th>\r\n        <th>\r\n          Cost\r\n        </th>\r\n        <th>\r\n          calcMethod\r\n        </th>\r\n        <th>\r\n          Action\r\n        </th>\r\n      </tr>\r\n      </thead>\r\n      <tbody>\r\n      <tr ng-if=\"!$ctrl.pricing.color.length\">\r\n        <td colspan=\"5\">\r\n          <h3 style=\"text-align: center;\">No Colors with custom pricing rules</h3>\r\n\r\n        </td>\r\n      </tr>\r\n      <tr ng-repeat=\"color in $ctrl.pricing.color\">\r\n        <td>\r\n            <span\r\n              style=\"display: inline-block; width:100%; background-color: {{color.value}}; border: 1px dashed grey;\">\r\n              &nbsp;\r\n            </span>\r\n        </td>\r\n        <td>\r\n          <input type=\"text\" ng-model=\"color.startCost\"/>\r\n        </td>\r\n        <td>\r\n          <input type=\"text\" ng-model=\"color.cost\"/>\r\n        </td>\r\n        <td>\r\n          <input type=\"text\" ng-model=\"color.calcMethod\"/>\r\n        </td>\r\n        <td>\r\n          <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeColor(color.value);\"></i>\r\n        </td>\r\n      </tr>\r\n      </tbody>\r\n    </table>\r\n\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>\r\n      Fix Methods\r\n    </legend>\r\n    <fieldset>\r\n      <legend>\r\n        Screw\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.cost\"/>\r\n      </label>\r\n      <span>\r\n      per screw\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per screw\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Adhesive Back\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Hanging\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Cable ties\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['cable-ties'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['cable-ties'].cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['cable-ties'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['cable-ties'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>\r\n      Shape Border\r\n    </legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.cost\"/>\r\n    </label>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>Text</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.cost\"/>\r\n    </label>\r\n    <span>\r\n      per letter\r\n    </span>\r\n\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Image</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.image.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.image.cost\"/>\r\n    </label>\r\n    <span>\r\n      per meter/height\r\n    </span>\r\n\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Colors(base shape)</legend>\r\n    <div class=\"input-group\" style=\"width: 200px;\">\r\n      <ui-select ng-model=\"$ctrl.selected\" theme=\"bootstrap\" style=\"width:150px;\">\r\n        <ui-select-match placeholder=\"Select color...\">\r\n          <div>\r\n            <span style=\"background-color: {{$select.selected.hex1}};\">&nbsp;</span>\r\n          </div>\r\n        </ui-select-match>\r\n        <ui-select-choices repeat=\"color in $ctrl.uniqueColors($ctrl.material.spec.colors)\">\r\n          <span style=\"background-color: {{color.hex1}};\">&nbsp;</span>\r\n          <span>{{color.name.split('/')[0]}}</span>\r\n        </ui-select-choices>\r\n        <ui-select-no-choice>\r\n          No colors to select\r\n        </ui-select-no-choice>\r\n      </ui-select>\r\n      <span class=\"input-group-btn\">\r\n        <button ng-click=\"$ctrl.addColor()\" class=\"btn btn-success\">\r\n          <span class=\"fa fa-plus\"></span>\r\n          Add\r\n        </button>\r\n      </span>\r\n    </div>\r\n\r\n    <table class=\"table table-bordered\">\r\n      <thead>\r\n      <tr>\r\n        <th>\r\n          Color\r\n        </th>\r\n        <th>\r\n          Start Cost\r\n        </th>\r\n        <th>\r\n          Cost\r\n        </th>\r\n        <th>\r\n          calcMethod\r\n        </th>\r\n        <th>\r\n          Action\r\n        </th>\r\n      </tr>\r\n      </thead>\r\n      <tbody>\r\n      <tr ng-if=\"!$ctrl.pricing.color.length\">\r\n        <td colspan=\"5\">\r\n          <h3 style=\"text-align: center;\">No Colors with custom pricing rules</h3>\r\n\r\n        </td>\r\n      </tr>\r\n      <tr ng-repeat=\"color in $ctrl.pricing.color\">\r\n        <td>\r\n            <span\r\n              style=\"display: inline-block; width:100%; background-color: {{color.value}}; border: 1px dashed grey;\">\r\n              &nbsp;\r\n            </span>\r\n        </td>\r\n        <td>\r\n          <input type=\"text\" ng-model=\"color.startCost\"/>\r\n        </td>\r\n        <td>\r\n          <input type=\"text\" ng-model=\"color.cost\"/>\r\n        </td>\r\n        <td>\r\n          <input type=\"text\" ng-model=\"color.calcMethod\"/>\r\n        </td>\r\n        <td>\r\n          <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeColor(color.value);\"></i>\r\n        </td>\r\n      </tr>\r\n      </tbody>\r\n    </table>\r\n\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>\r\n      Fix Methods\r\n    </legend>\r\n    <fieldset>\r\n      <legend>\r\n        Screw\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.cost\"/>\r\n      </label>\r\n      <span>\r\n      per screw\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per screw\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Adhesive Back\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['adhesive-back'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Hanging\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Magnetic Back\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back'].cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['magnetic-back'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Suction Cups\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod['suction-cups'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod['suction-cups'].cost\"/>\r\n      </label>\r\n      <span>\r\n      per cup\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['suction-cups'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per cup\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['suction-cups'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Table Stand\r\n      </legend>\r\n      <button class=\"btn btn-success\" ng-click=\"$ctrl.newSizeCost()\">\r\n        <i class=\"fa fa-plus\"></i>\r\n        <span>New Size Cost </span>\r\n      </button>\r\n      <table class=\"table table-bordered table-responsive\">\r\n        <thead>\r\n        <tr>\r\n          <th>\r\n            Min width, mm\r\n          </th>\r\n          <th>\r\n            Max width, mm\r\n          </th>\r\n          <th>\r\n            Min height, mm\r\n          </th>\r\n          <th>\r\n            Max height, mm\r\n          </th>\r\n          <th>\r\n            Start cost\r\n          </th>\r\n          <th>\r\n            Cost\r\n          </th>\r\n          <th>\r\n            Weight\r\n          </th>\r\n          <th>\r\n            calcMethod\r\n          </th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-if=\"!$ctrl.pricing.fixMethod['table-stand'].length\">\r\n          <td colspan=\"3\">\r\n            <h3 style=\"text-align: center;\">No pricing sizes available</h3>\r\n\r\n          </td>\r\n        </tr>\r\n        <tr ng-repeat=\"size in $ctrl.pricing.fixMethod['table-stand']\">\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.width.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.width.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.height.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.height.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.startCost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.cost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.weight\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.calcMethod\"/>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Wall Mount\r\n      </legend>\r\n      <label>\r\n        Width\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].width\"/>\r\n      </label>\r\n      <span>\r\n        mm\r\n      </span>\r\n      <label>\r\n        Height\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].height\"/>\r\n      </label>\r\n      <span>\r\n        mm\r\n      </span>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].cost\"/>\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per mm\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-mount'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Wall Distance\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].cost\"/>\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>\r\n      Shape Border\r\n    </legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.cost\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Text</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.cost\"/>\r\n    </label>\r\n    <span>\r\n      per letter\r\n    </span>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Image</legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.image.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.image.cost\"/>\r\n    </label>\r\n    <span>\r\n      per meter/height\r\n    </span>\r\n\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>\r\n      Fix Methods\r\n    </legend>\r\n    <fieldset>\r\n      <legend>\r\n        Screw\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod.screw.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod.screw.cost\"/>\r\n      </label>\r\n      <span>\r\n      per screw\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per screw\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.screw.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Hanging\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2</sup>\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.hanging.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Suction Cups\r\n      </legend>\r\n      <label>\r\n        Start cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod['suction-cups'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"number\" ng-model=\"$ctrl.pricing.fixMethod['suction-cups'].cost\"/>\r\n      </label>\r\n      <span>\r\n      per cup\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['suction-cups'].weight\"/>\r\n      </label>\r\n      <span>\r\n      grams per cup\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['suction-cups'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Wall Distance\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].cost\"/>\r\n      </label>\r\n      <span>\r\n        per distance\r\n      </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Table Stand\r\n      </legend>\r\n      <button class=\"btn btn-success\" ng-click=\"$ctrl.newSizeCost()\">\r\n        <i class=\"fa fa-plus\"></i>\r\n        <span>New Size Cost </span>\r\n      </button>\r\n      <table class=\"table table-bordered\">\r\n        <thead>\r\n        <tr>\r\n          <th>\r\n            Min width, mm\r\n          </th>\r\n          <th>\r\n            Max width, mm\r\n          </th>\r\n          <th>\r\n            Min height, mm\r\n          </th>\r\n          <th>\r\n            Max height, mm\r\n          </th>\r\n          <th>\r\n            Start cost\r\n          </th>\r\n          <th>\r\n            Cost\r\n          </th>\r\n          <th>\r\n            Weight\r\n          </th>\r\n          <th>\r\n            calcMethod\r\n          </th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-if=\"!$ctrl.pricing.fixMethod['table-stand'].length\">\r\n          <td colspan=\"3\">\r\n            <h3 style=\"text-align: center;\">No pricing sizes available</h3>\r\n\r\n          </td>\r\n        </tr>\r\n        <tr ng-repeat=\"size in $ctrl.pricing.fixMethod['table-stand']\">\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.width.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.width.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.height.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.height.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.startCost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.cost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.weight\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.calcMethod\"/>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Table Stand With LED Light\r\n      </legend>\r\n      <label>\r\n        Min Height\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['table-stand-with-led-light'].height.min\"\r\n        />\r\n\r\n      </label>\r\n      <span>\r\n        mm\r\n      </span>\r\n      <label>\r\n        Max Height\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['table-stand-with-led-light'].height.max\"\r\n        />\r\n      </label>\r\n      <span>\r\n        mm\r\n      </span>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['table-stand-with-led-light'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['table-stand-with-led-light'].cost\"/>\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['table-stand-with-led-light'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['table-stand-with-led-light'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Sizes\r\n      </legend>\r\n      <button class=\"btn btn-success\" ng-click=\"$ctrl.newSizeCostCal()\">\r\n        <i class=\"fa fa-plus\"></i>\r\n        <span>New Size Cost </span>\r\n      </button>\r\n      <table class=\"table table-bordered table-responsive\">\r\n        <thead>\r\n        <tr>\r\n          <th>\r\n            Min width, mm\r\n          </th>\r\n          <th>\r\n            Max width, mm\r\n          </th>\r\n          <th>\r\n            Min height, mm\r\n          </th>\r\n          <th>\r\n            Max height, mm\r\n          </th>\r\n          <th>\r\n            Start cost\r\n          </th>\r\n          <th>\r\n            Cost\r\n          </th>\r\n          <th>\r\n            Weight\r\n          </th>\r\n          <th>\r\n            calcMethod\r\n          </th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-if=\"!$ctrl.pricing.fixMethod['sizes'].length\">\r\n          <td colspan=\"8\">\r\n            <h3 style=\"text-align: center;\">No pricing sizes available</h3>\r\n\r\n          </td>\r\n        </tr>\r\n        <tr ng-repeat=\"size in $ctrl.pricing.fixMethod['sizes']\">\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.width.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.width.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.height.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.height.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.startCost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.cost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.weight\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.calcMethod\"/>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </fieldset>\r\n\r\n\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>\r\n      Shape Border\r\n    </legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.cost\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Text</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.cost\"/>\r\n    </label>\r\n    <span>\r\n      per letter\r\n    </span>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>Image</legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.image.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"number\" ng-model=\"$ctrl.pricing.image.cost\"/>\r\n    </label>\r\n    <span>\r\n      per meter/height\r\n    </span>\r\n\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>\r\n      Fix Methods\r\n    </legend>\r\n    <fieldset>\r\n      <legend>\r\n        Table Stand\r\n      </legend>\r\n      <button class=\"btn btn-success\" ng-click=\"$ctrl.newSizeCost()\">\r\n        <i class=\"fa fa-plus\"></i>\r\n        <span>New Size Cost </span>\r\n      </button>\r\n      <table class=\"table table-bordered\">\r\n        <thead>\r\n        <tr>\r\n          <th>\r\n            Min width, mm\r\n          </th>\r\n          <th>\r\n            Max width, mm\r\n          </th>\r\n          <th>\r\n            Min height, mm\r\n          </th>\r\n          <th>\r\n            Max height, mm\r\n          </th>\r\n          <th>\r\n            Start cost\r\n          </th>\r\n          <th>\r\n            Cost\r\n          </th>\r\n          <th>\r\n            Weight\r\n          </th>\r\n          <th>\r\n            calcMethod\r\n          </th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-if=\"!$ctrl.pricing.fixMethod['table-stand'].length\">\r\n          <td colspan=\"3\">\r\n            <h3 style=\"text-align: center;\">No pricing sizes available</h3>\r\n\r\n          </td>\r\n        </tr>\r\n        <tr ng-repeat=\"size in $ctrl.pricing.fixMethod['table-stand']\">\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.width.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.width.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.height.min\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.height.max\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.startCost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.cost\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"text\" ng-model=\"size.weight\"/>\r\n          </td>\r\n          <td>\r\n            <input type=\"number\" ng-model=\"size.calcMethod\"/>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Table Stand With LED Light\r\n      </legend>\r\n      <label>\r\n        Min Height\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['table-stand-with-led-light'].height.min\"\r\n        />\r\n\r\n      </label>\r\n      <span>\r\n        mm\r\n      </span>\r\n      <label>\r\n        Max Height\r\n        <input\r\n          type=\"text\"\r\n          ng-model=\"$ctrl.pricing.fixMethod['table-stand-with-led-light'].height.max\"\r\n        />\r\n      </label>\r\n      <span>\r\n        mm\r\n      </span>\r\n      <label>\r\n        Start cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['table-stand-with-led-light'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['table-stand-with-led-light'].cost\"/>\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['table-stand-with-led-light'].weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['table-stand-with-led-light'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>\r\n      Shape Border\r\n    </legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.cost\"/>\r\n    </label>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>Text</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.cost\"/>\r\n    </label>\r\n    <span>\r\n      per letter\r\n    </span>\r\n\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Image</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.image.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.image.cost\"/>\r\n    </label>\r\n    <span>\r\n      per meter/height\r\n    </span>\r\n\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Colors(base shape)</legend>\r\n    <div class=\"input-group\" style=\"width: 200px;\">\r\n      <ui-select ng-model=\"$ctrl.selected\" theme=\"bootstrap\" style=\"width:150px;\">\r\n        <ui-select-match placeholder=\"Select color...\">\r\n          <div>\r\n            <span style=\"background-color: {{$select.selected.hex1}};\">&nbsp;</span>\r\n          </div>\r\n        </ui-select-match>\r\n        <ui-select-choices repeat=\"color in $ctrl.uniqueColors($ctrl.material.spec.colors)\">\r\n          <span style=\"background-color: {{color.hex1}};\">&nbsp;</span>\r\n          <span>{{color.name.split('/')[0]}}</span>\r\n        </ui-select-choices>\r\n        <ui-select-no-choice>\r\n          No colors to select\r\n        </ui-select-no-choice>\r\n      </ui-select>\r\n      <span class=\"input-group-btn\">\r\n        <button ng-click=\"$ctrl.addColor()\" class=\"btn btn-success\">\r\n          <span class=\"fa fa-plus\"></span>\r\n          Add\r\n        </button>\r\n      </span>\r\n    </div>\r\n\r\n    <table class=\"table table-bordered\">\r\n      <thead>\r\n      <tr>\r\n        <th>\r\n          Color\r\n        </th>\r\n        <th>\r\n          Start Cost\r\n        </th>\r\n        <th>\r\n          Cost\r\n        </th>\r\n        <th>\r\n          calcMethod\r\n        </th>\r\n        <th>\r\n          Action\r\n        </th>\r\n      </tr>\r\n      </thead>\r\n      <tbody>\r\n      <tr ng-if=\"!$ctrl.pricing.color.length\">\r\n        <td colspan=\"5\">\r\n          <h3 style=\"text-align: center;\">No Colors with custom pricing rules</h3>\r\n\r\n        </td>\r\n      </tr>\r\n      <tr ng-repeat=\"color in $ctrl.pricing.color\">\r\n        <td>\r\n            <span\r\n              style=\"display: inline-block; width:100%; background-color: {{color.value}}; border: 1px dashed grey;\">\r\n              &nbsp;\r\n            </span>\r\n        </td>\r\n        <td>\r\n          <input type=\"text\" ng-model=\"color.startCost\"/>\r\n        </td>\r\n        <td>\r\n          <input type=\"text\" ng-model=\"color.cost\"/>\r\n        </td>\r\n        <td>\r\n          <input type=\"text\" ng-model=\"color.calcMethod\"/>\r\n        </td>\r\n        <td>\r\n          <i class=\"fa fa-remove\" ng-click=\"$ctrl.removeColor(color.value);\"></i>\r\n        </td>\r\n      </tr>\r\n      </tbody>\r\n    </table>\r\n\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>\r\n      Fix Method\r\n    </legend>\r\n    <fieldset>\r\n      <legend>\r\n        Needle\r\n      </legend>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.needle.cost\">\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.needle.weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.needle.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Magnet\r\n      </legend>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.magnet.cost\">\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.magnet.weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.magnet.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Metal Clip\r\n      </legend>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.metal.cost\">\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.metal.weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.metal.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>\r\n      Shape Border\r\n    </legend>\r\n    <label>\r\n      Start Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.shapeBorder.cost\"/>\r\n    </label>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>Text</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.text.cost\"/>\r\n    </label>\r\n    <span>\r\n      per letter\r\n    </span>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Image</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.image.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.image.cost\"/>\r\n    </label>\r\n    <span>\r\n      per meter/height\r\n    </span>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>\r\n      Fix Method\r\n    </legend>\r\n    <fieldset>\r\n      <legend>\r\n        Needle\r\n      </legend>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.needle.cost\">\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.needle.weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.needle.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Magnet\r\n      </legend>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.magnet.cost\">\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.magnet.weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.magnet.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n    <fieldset>\r\n      <legend>\r\n        Metal Clip\r\n      </legend>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.metal.cost\">\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.metal.weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.metal.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Fix Methods</legend>\r\n    <fieldset>\r\n      <legend>\r\n        Acrylic Front\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['acrylic-front'].startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['acrylic-front'].cost\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['acrylic-front'].weight\"/>\r\n      </label>\r\n      <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['acrylic-front'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Wall Distance (included in Acrylic Front)\r\n      </legend>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].cost\"/>\r\n      </label>\r\n      <span>\r\n        per distance\r\n      </span>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].weight\"/>\r\n      </label>\r\n      <span>\r\n      per distance\r\n    </span>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod['wall-distance'].calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n\r\n  <fieldset>\r\n    <legend>Fix Methods</legend>\r\n    <fieldset>\r\n      <legend>\r\n        Polyester\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.polyester.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.polyester.cost\"/>\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.polyester.weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.polyester.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n\r\n    <fieldset>\r\n      <legend>\r\n        Mesh\r\n      </legend>\r\n      <label>\r\n        Start Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.mesh.startCost\"/>\r\n      </label>\r\n      <label>\r\n        Cost\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.mesh.cost\"/>\r\n      </label>\r\n      <label>\r\n        Weight\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.mesh.weight\"/>\r\n      </label>\r\n      <label>\r\n        calcMethod\r\n        <input type=\"text\" ng-model=\"$ctrl.pricing.fixMethod.mesh.calcMethod\"/>\r\n      </label>\r\n    </fieldset>\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"box box-primary pricing\">\r\n  <fieldset>\r\n    <legend>Price Formula</legend>\r\n    <label>\r\n      Factor\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.factor\"/>\r\n    </label>\r\n    <label>\r\n      Formula Limit\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.formula.limit\"/>\r\n    </label>\r\n  </fieldset>\r\n  <fieldset>\r\n    <legend>Material</legend>\r\n    <label>\r\n      Start cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.startCost\"/>\r\n    </label>\r\n    <label>\r\n      Material cost\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.cost\"/>\r\n    </label>\r\n    <span>\r\n      per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      Material weight\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.weight\"/>\r\n    </label>\r\n    <span>\r\n      grams per m<sup>2 </sup>\r\n    </span>\r\n    <label>\r\n      calcMethod\r\n      <input type=\"text\" ng-model=\"$ctrl.pricing.material.calcMethod\"/>\r\n    </label>\r\n  </fieldset>\r\n  <button ng-click=\"$ctrl.saveSpec()\" class=\"btn btn-lg btn-primary col-md-12\">\r\n    Save\r\n  </button>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ }
]);


/** WEBPACK FOOTER **
 ** app.bundle.js
 **/